webpackJsonp([1],{

/***/ "+7+H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClassrooms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return restrictActivities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getTopicsFromCourse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getActivityReportById; });
/* harmony export (immutable) */ __webpack_exports__["g"] = updateFiltersActionCreator;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getStudentResultById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_utils__ = __webpack_require__("6QRH");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }



var getClassrooms = function getClassrooms(productId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            response = null;
            _context.p = 1;
            _context.n = 2;
            return __WEBPACK_IMPORTED_MODULE_0__helpers_resources__["a" /* default */].getClassrooms.get({
              productId: productId
            }).withParams().send();
          case 2:
            response = _context.v;
            if (response && response.data) {
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["f" /* CLASSROOMS_ACQUIRED */],
                payload: response.data
              });
            } else {
              dispatch({
                type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["K" /* SHOW_TOAST */],
                isToastVisible: true,
                message: response && response.message
              });
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["e" /* ERROR_DETECTED */],
              payload: _t
            });
            throw _t;
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var restrictActivities = function restrictActivities(isRestricted, classId, groupId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      var response, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            response = null;
            _context2.p = 1;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["q" /* RESTRICT_ACCESS_REQUEST */]
            });
            _context2.n = 2;
            return __WEBPACK_IMPORTED_MODULE_0__helpers_resources__["a" /* default */].restrictActivities.put({
              isRestricted: isRestricted,
              classId: classId,
              groupId: groupId
            }).withBody({}).send();
          case 2:
            response = _context2.v;
            if (!(response.status === 200)) {
              _context2.n = 3;
              break;
            }
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["r" /* RESTRICT_ACCESS_SUCCESS */],
              payload: isRestricted
            });
            return _context2.a(2, response);
          case 3:
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["p" /* RESTRICT_ACCESS_FAILURE */]
            });
            return _context2.a(2, response);
          case 4:
            _context2.p = 4;
            _t2 = _context2.v;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["e" /* ERROR_DETECTED */],
              payload: _t2
            });
            throw _t2;
          case 5:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 4]]);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var getTopics = function getTopics(classId, groupId) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch) {
      var response, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            response = null;
            _context3.p = 1;
            if (!(classId && groupId)) {
              _context3.n = 4;
              break;
            }
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["s" /* TOPICS_ACQUIRED_REQUEST */]
            });
            _context3.n = 2;
            return __WEBPACK_IMPORTED_MODULE_0__helpers_resources__["a" /* default */].getAssignments.get({
              classroomId: classId,
              groupId: groupId
            }).send();
          case 2:
            response = _context3.v;
            if (!(response && response.status === 200)) {
              _context3.n = 3;
              break;
            }
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["t" /* TOPICS_ACQUIRED_SUCCESS */],
              payload: response.data
            });
            return _context3.a(2, response.data);
          case 3:
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["u" /* TOPICS_ACQUIRED_FAILURE */]
            });
            return _context3.a(2, response);
          case 4:
            return _context3.a(2, []);
          case 5:
            _context3.p = 5;
            _t3 = _context3.v;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["e" /* ERROR_DETECTED */],
              payload: _t3
            });
            throw _t3;
          case 6:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 5]]);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var getTopicsFromCourse = function getTopicsFromCourse(courseId) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch) {
      var response, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            response = null;
            _context4.p = 1;
            if (!(courseId && courseId !== -1)) {
              _context4.n = 3;
              break;
            }
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["L" /* COURSE_TOPICS_ACQUIRED_REQUEST */]
            });
            _context4.n = 2;
            return __WEBPACK_IMPORTED_MODULE_0__helpers_resources__["a" /* default */].getcourseTopics.get({
              courseId: courseId
            }).send();
          case 2:
            response = _context4.v;
            if (!(response && response.status === 200)) {
              _context4.n = 3;
              break;
            }
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["v" /* COURSE_TOPICS_ACQUIRED_SUCCESS */],
              payload: response.data
            });
            return _context4.a(2, response.data);
          case 3:
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["M" /* COURSE_TOPICS_ACQUIRED_FAILURE */]
            });
            return _context4.a(2, response);
          case 4:
            _context4.p = 4;
            _t4 = _context4.v;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["e" /* ERROR_DETECTED */],
              payload: _t4
            });
            throw _t4;
          case 5:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 4]]);
    }));
    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var getActivityReportById = function getActivityReportById(classroomId, encryptedUserProfileId, activityId, taskType) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch) {
      var response, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            _context5.p = 0;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["D" /* STUDENT_SINGLE_ACTIVITY_REPORT_REQUEST */]
            });
            _context5.n = 1;
            return __WEBPACK_IMPORTED_MODULE_0__helpers_resources__["a" /* default */].getStudentActivitiesByActivityId.post().withBody({
              classroomId: classroomId,
              encryptedUserProfileId: encryptedUserProfileId,
              activityId: activityId,
              taskType: taskType
            }).send();
          case 1:
            response = _context5.v;
            if (!(response && response.status === 200)) {
              _context5.n = 2;
              break;
            }
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["E" /* STUDENT_SINGLE_ACTIVITY_REPORT_SUCCESS */],
              payload: response.data
            });
            return _context5.a(2, response.data);
          case 2:
            return _context5.a(2, null);
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["e" /* ERROR_DETECTED */],
              payload: _t5
            });
            throw _t5;
          case 4:
            return _context5.a(2);
        }
      }, _callee5, null, [[0, 3]]);
    }));
    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
function updateFiltersActionCreator(data) {
  var _data$dateData;
  /* eslint-disable indent */
  return {
    type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["F" /* UPDATE_ASSIGNMENT_FILTERS */],
    payload: {
      dateFilter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_utils__["c" /* isDefined */])((_data$dateData = data.dateData) === null || _data$dateData === void 0 ? void 0 : _data$dateData.dateRange) ? {
        dateRange: data.dateData.dateRange
      } : undefined,
      rangeData: data.rangeData,
      dropdownValue: data.dropdownValue
    }
  };
  /* eslint-enable indent */
}
var getStudentResultById = function getStudentResultById(classroomId, encryptedUserProfileId) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(dispatch) {
      var response, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            _context6.p = 0;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["H" /* STUDENT_RESULT_REQUEST */]
            });
            _context6.n = 1;
            return __WEBPACK_IMPORTED_MODULE_0__helpers_resources__["a" /* default */].getStudentResult.post().withBody({
              classroomId: classroomId,
              encryptedUserProfileId: encryptedUserProfileId
            }).send();
          case 1:
            response = _context6.v;
            if (!(response && response.status === 200)) {
              _context6.n = 2;
              break;
            }
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["I" /* STUDENT_RESULT_SUCCESS */],
              payload: response.data
            });
            return _context6.a(2, response.data);
          case 2:
            return _context6.a(2, null);
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            dispatch({
              type: __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["e" /* ERROR_DETECTED */],
              payload: _t6
            });
            throw _t6;
          case 4:
            return _context6.a(2);
        }
      }, _callee6, null, [[0, 3]]);
    }));
    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("hKoQ")))

/***/ }),

/***/ "+yn+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_local_storage__ = __webpack_require__("//jD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled__ = __webpack_require__("lM+Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__filters_util__ = __webpack_require__("DuCv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_actions__ = __webpack_require__("+7+H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__analytics__ = __webpack_require__("uVVs");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }










var Filters = function Filters(props) {
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var _useTracking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__analytics__["d" /* useTracking */])(),
    trackClassChanged = _useTracking.trackClassChanged,
    trackGroupChanged = _useTracking.trackGroupChanged;
  var filteredStudents = function filteredStudents(students) {
    return {
      type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["a" /* FILTERED_STUDENTS */],
      payload: students
    };
  };
  var i18n = props.i18n;
  var classrooms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.classrooms;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var activeClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var activeGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var courseTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.courseTopics;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
    _useState2 = _slicedToArray(_useState, 2),
    classes = _useState2[0],
    setClassrooms = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),
    _useState4 = _slicedToArray(_useState3, 2),
    groups = _useState4[0],
    setGroups = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedClass = _useState6[0],
    setDefaultClassOption = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedGroup = _useState8[0],
    setDefaultGroupOption = _useState8[1];
  var classLabel = i18n._(
  /*i18n*/
  {
    id: "filters.class",
    defaults: "Class"
  });
  var groupLabel = i18n._(
  /*i18n*/
  {
    id: "filters.group",
    defaults: "Group"
  });
  var LAST_SELECTED_CLASS = 'LAST_SELECTED_CLASS';
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var _classes$, _newClassroom$;
    var newClassroom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__filters_util__["a" /* getClassrooms */])(classrooms);
    if ((classes === null || classes === void 0 || (_classes$ = classes[0]) === null || _classes$ === void 0 ? void 0 : _classes$.label) === (newClassroom === null || newClassroom === void 0 || (_newClassroom$ = newClassroom[0]) === null || _newClassroom$ === void 0 ? void 0 : _newClassroom$.label) && classes.size === (newClassroom === null || newClassroom === void 0 ? void 0 : newClassroom.size)) {
      return;
    }
    var lastSelectedClass = __WEBPACK_IMPORTED_MODULE_4__helpers_local_storage__["a" /* default */].getItem(LAST_SELECTED_CLASS);
    var lastSelectedGroup = __WEBPACK_IMPORTED_MODULE_4__helpers_local_storage__["a" /* default */].getItem("LAST_SELECTED_GROUP_ClASS_".concat(lastSelectedClass.value));
    if (classrooms.length) {
      if (lastSelectedClass && classrooms.filter(function (c) {
        return c.classroomId === lastSelectedClass.value;
      }).length) {
        setDefaultClassOption(lastSelectedClass);
      } else {
        var _lastSelectedClass, _lastSelectedClass2;
        lastSelectedClass = classrooms[0];
        if ((selectedClass === null || selectedClass === void 0 ? void 0 : selectedClass.value) !== ((_lastSelectedClass = lastSelectedClass) === null || _lastSelectedClass === void 0 ? void 0 : _lastSelectedClass.classroomId) || (selectedClass === null || selectedClass === void 0 ? void 0 : selectedClass.label) !== ((_lastSelectedClass2 = lastSelectedClass) === null || _lastSelectedClass2 === void 0 ? void 0 : _lastSelectedClass2.name)) {
          setDefaultClassOption({
            value: lastSelectedClass && lastSelectedClass.classroomId,
            label: lastSelectedClass && lastSelectedClass.name
          });
        }
      }
      setClassrooms(newClassroom);
      var allGroups = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__filters_util__["b" /* getGroups */])(lastSelectedClass.value || classrooms[0].classroomId, classrooms);
      setGroups(allGroups);
      if (lastSelectedGroup && allGroups.filter(function (group) {
        return group.value === lastSelectedGroup.value;
      }).length) {
        setDefaultGroupOption(lastSelectedGroup);
      } else {
        lastSelectedGroup = allGroups[0];
      }
      dispatch(filteredStudents(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__filters_util__["c" /* getStudents */])(lastSelectedClass.value || classrooms[0].classroomId, lastSelectedGroup.value || allGroups[0].value, classrooms)));
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["n" /* SET_ACTIVE_CLASS */],
        payload: lastSelectedClass.value || classrooms[0].classroomId
      });
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["o" /* SET_ACTIVE_GROUP */],
        payload: lastSelectedGroup.value
      });
    }
  }, [dispatch, classrooms, classes, selectedClass]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var courseID = -1;
    if (activeClass && activeGroup !== '-1') {
      courseID = classrooms.find(function (classroom) {
        return classroom.classroomId === activeClass;
      }).groups.find(function (group) {
        return group.groupId === activeGroup;
      }).courseId;
    }
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["x" /* UPDATE_COURSE_ID */],
      payload: {
        courseID: courseID
      }
    });
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_actions__["e" /* getTopicsFromCourse */])(courseID));
  }, [activeClass, activeGroup, dispatch, classrooms]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_actions__["b" /* getTopics */])(activeClass, activeGroup));
  }, [dispatch, activeClass, activeGroup]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (courseTopics !== undefined && Object.keys(courseTopics).length > 0) {
      var filterTopics = __WEBPACK_IMPORTED_MODULE_4__helpers_local_storage__["a" /* default */].getItem("LAST_FILTERSEARCH_SELECTION_".concat(activeClass, "_").concat(activeGroup)) || courseTopics.topics.map(function (topic) {
        return _objectSpread(_objectSpread({}, topic), {}, {
          selected: true,
          checkedNormal: true,
          checkedEasier: false,
          isHidden: false
        });
      });
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["g" /* UPDATE_SELECTED_TOPICS */],
        payload: {
          topics: courseTopics.topics,
          filterTopics: filterTopics
        }
      });
    }
  }, [dispatch, courseTopics, activeClass, activeGroup]);
  var onClassroomChange = function onClassroomChange(option) {
    trackClassChanged();
    __WEBPACK_IMPORTED_MODULE_4__helpers_local_storage__["a" /* default */].setItem(LAST_SELECTED_CLASS, option);
    setDefaultClassOption(option);
    var groupList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__filters_util__["b" /* getGroups */])(option.value, classrooms);
    setGroups(groupList);
    setDefaultGroupOption(groupList[0]);
    dispatch(filteredStudents(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__filters_util__["c" /* getStudents */])(option.value, groupList[0].value, classrooms)));
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["n" /* SET_ACTIVE_CLASS */],
      payload: option.value
    });
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["o" /* SET_ACTIVE_GROUP */],
      payload: groupList[0].value
    });
  };
  var onGroupChange = function onGroupChange(option) {
    trackGroupChanged();
    __WEBPACK_IMPORTED_MODULE_4__helpers_local_storage__["a" /* default */].setItem("LAST_SELECTED_GROUP_ClASS_".concat(selectedClass.value), option);
    setDefaultGroupOption(option);
    dispatch(filteredStudents(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__filters_util__["c" /* getStudents */])(selectedClass.value, option.value, classrooms)));
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["o" /* SET_ACTIVE_GROUP */],
      payload: option.value
    });
  };
  function GetClassFilters() {
    if (classes instanceof Array && classes.length === 1) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["a" /* InputWrapper */], {
        type: "text",
        value: classes[0].label,
        readOnly: true
      });
    }
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["DropdownMenu"], {
      key: "ddlClassrooms",
      options: classes,
      selectedOption: selectedClass || classes[0],
      onSelectOption: onClassroomChange
    });
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["b" /* FilterListWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["c" /* FilterWrapper */], {
    "data-name": "class-selector",
    "data-testid": "showClassesDropdown"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, classLabel), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GetClassFilters, null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["c" /* FilterWrapper */], {
    "data-name": "group-selector",
    "data-testid": "showGroupsDropdown"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, groupLabel), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["DropdownMenu"], {
    key: "ddlGroups",
    options: groups,
    selectedOption: selectedGroup || groups[0],
    onSelectOption: onGroupChange
  })));
};
Filters.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
Filters.whyDidYouRender = false;
/* harmony default export */ __webpack_exports__["a"] = (Filters);

/***/ }),

/***/ "/+0M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MxAnalyticsProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = useAnalyticsClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_mx_teacher_analytics_react__ = __webpack_require__("/urO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__create_client__ = __webpack_require__("bZcI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__("s1kj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__("k7gd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_locale__ = __webpack_require__("ZhO1");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }







function MxAnalyticsProvider(_ref) {
  var children = _ref.children;
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__create_client__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* getAnalyticsBuildConfig */])());
    }),
    _useState2 = _slicedToArray(_useState, 1),
    client = _useState2[0];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    client.setCommonProps(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__config__["b" /* getQueryParams */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_locale__["a" /* getLocale */])() || 'en-AU'));
    client.identify();
  }, [client]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_mx_teacher_analytics_react__["a" /* AnalyticsProvider */], {
    client: client
  }, children);
}
MxAnalyticsProvider.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

// Returns null outside the provider (e.g. isolated unit tests) so call sites
// can no-op instead of throwing.
function useAnalyticsClient() {
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__3plearning_mx_teacher_analytics_react__["b" /* useAnalytics */])();
  } catch (error) {
    return null;
  }
}

/***/ }),

/***/ "//jD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-prototype-builtins */
var storage = window.localStorage;
var LocalStorage = /*#__PURE__*/function () {
  function LocalStorage() {
    _classCallCheck(this, LocalStorage);
  }
  return _createClass(LocalStorage, null, [{
    key: "namespace",
    get: function get() {
      return this._namespace = this._namespace ? this._namespace : Date.now();
    },
    set: function set(name) {
      this._namespace = name;
    }
  }, {
    key: "getAllItems",
    value: function getAllItems() {
      try {
        return storage.getItem(this.namespace) === null ? {} : JSON.parse(storage.getItem(this.namespace));
      } catch (e) {
        return {};
      }
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      var allItems = this.getAllItems();
      var values = _extends(allItems, _defineProperty({}, key, value));
      storage.setItem("".concat(this.namespace), JSON.stringify(values));
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      var allItems = this.getAllItems();
      return allItems.hasOwnProperty(key) ? allItems[key] : '';
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      var values = _extends({}, this.getAllItems());
      delete values[key];
      storage.setItem(this.namespace, JSON.stringify(values));
    }
  }, {
    key: "removeAllItems",
    value: function removeAllItems() {
      storage.clear();
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (LocalStorage);

/***/ }),

/***/ "/26b":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, "@media only screen and (min-device-width: 768px) {\n  .course-assign---1JNZj {\n    height: calc(100% - 44px); } }\n\n.component---360Bx {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  border: 1px solid #cfd2d4;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  position: absolute; }\n\n.psr---8htfH {\n  width: 100%; }\n\n.standards---22SzJ {\n  width: 100%; }\n\n.studentGridContainer---33NCk {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: calc(100% - 240px);\n  width: calc(100% - 17px);\n  overflow-y: auto;\n  overflow-x: auto;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border: 1px solid #cfd2d4;\n  border-top: none; }\n\n.fitContentContainer---2TwvS {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content; }\n\n.footer---39vyg {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  position: fixed;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 100%;\n  padding-right: 10px;\n  z-index: 9; }\n\n.confirmFooter---tkKc_ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  position: absolute;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 99%;\n  height: 51px;\n  padding-right: 10px;\n  background-color: #cfd2d4;\n  z-index: 9999; }\n\n.leftSection---3TrLB {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 260px; }\n\n.rightSection---idTl0 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: scroll;\n  width: 100%; }\n\n.gridContainer---1yoKP {\n  height: auto;\n  min-height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0; }\n\n.actions---1B9Jv {\n  position: relative;\n  display: inline-block; }\n\n.viewKeyContainer---1O7cE {\n  position: relative; }\n\n.filterBar---bx2S8 {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  height: 70px;\n  margin-bottom: 10px;\n  width: 100%; }\n\n.filterBar---bx2S8 .search---R9QIi {\n    width: 480px; }\n\n@media screen and (max-width: 1100px) {\n    .filterBar---bx2S8 {\n      margin-bottom: 0.001px; } }\n\n.filterBar---bx2S8 .buttonsContainer---3P15_ {\n    display: -webkit-box;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-direction: normal;\n    -webkit-box-orient: vertical;\n    -moz-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -ms-flex-pack: distribute;\n    -moz-justify-content: space-around;\n    justify-content: space-around;\n    -webkit-box-align: end;\n    -ms-flex-align: end;\n    -moz-align-items: flex-end;\n    align-items: flex-end;\n    height: 70px; }\n\n.filterBar---bx2S8 .buttonsContainer---3P15_ .howThisWorks---3hN3z {\n      height: 32px;\n      padding: 4px;\n      background-color: #c3d5e1 !important;\n      border: 1px solid #c3d5e1 !important;\n      color: #3b4e5e !important; }\n\n.filterBar---bx2S8 .buttonsContainer---3P15_ .howThisWorks---3hN3z:hover {\n        background: #415667 !important;\n        border: 1px solid #415667 !important;\n        color: #fff !important; }\n\n.filterBar---bx2S8 .buttonsContainer---3P15_ .bottomButtons---3kE99 {\n      display: -webkit-box;\n      display: -moz-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n      -moz-justify-content: space-evenly;\n      justify-content: space-evenly; }\n\n.filterBar---bx2S8 .buttonsContainer---3P15_ .bottomButtons---3kE99 .button---2wNMr {\n        width: 142px;\n        height: 30px; }\n\n.filterBar---bx2S8 .buttonsContainer---3P15_ .bottomButtons---3kE99 .key---171QA {\n        height: 32px;\n        background-color: #c3d5e1 !important;\n        border: 1px solid #c3d5e1 !important;\n        color: #3b4e5e !important;\n        margin-right: 8px;\n        padding: 4px 10px; }\n\n.filterBar---bx2S8 .buttonsContainer---3P15_ .bottomButtons---3kE99 .key---171QA:hover {\n          background: #415667 !important;\n          border: 1px solid #415667 !important;\n          color: #fff !important; }\n\n.filterBar---bx2S8 .buttonsContainer---3P15_ .bottomButtons---3kE99 .key---171QA:hover * {\n            fill: #fff !important; }\n\n.filterBar---bx2S8 .buttonsContainer---3P15_ .bottomButtons---3kE99 .key---171QA [class^=\"isvg\"] {\n          height: 16px !important; }\n\n.filterBar---bx2S8 .buttonsContainer---3P15_ .bottomButtons---3kE99 .actionsActive---3lci_ {\n        background-color: #415667 !important;\n        border: 1px solid #415667 !important;\n        color: #fff !important; }\n\n.filterBar---bx2S8 .buttonsContainer---3P15_ .bottomButtons---3kE99 .actionsActive---3lci_ * {\n          fill: #fff !important; }\n\n.filterBar---bx2S8 .buttonsContainer---3P15_ .bottomButtons---3kE99 .actions---1B9Jv {\n        border-color: #415667 !important; }\n\n@media screen and (max-width: 1370px) {\n  .key---171QA {\n    width: 30px;\n    height: 34px;\n    text-indent: -999999px;\n    white-space: nowrap;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    padding-right: 23px !important;\n    font-size: 0 !important;\n    margin-right: 8px; }\n    .key---171QA [class^=\"isvg\"] {\n      position: relative;\n      left: 2px;\n      padding: 4px 0 4px 8px !important; }\n  .howThisWorks---3hN3z {\n    font-size: 0 !important;\n    margin-right: 8px; }\n    .howThisWorks---3hN3z [class^=\"isvg\"] {\n      padding: 0 4px !important;\n      height: 16px !important;\n      width: 16px !important; }\n  .buttonsContainer---3P15_ {\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    width: 130px;\n    height: 50px !important; }\n    .buttonsContainer---3P15_ .bottomButtons---3kE99 {\n      width: 100px !important; } }\n", ""]);

// exports
exports.locals = {
	"course-assign": "course-assign---1JNZj",
	"component": "component---360Bx",
	"psr": "psr---8htfH",
	"standards": "standards---22SzJ",
	"studentGridContainer": "studentGridContainer---33NCk",
	"fitContentContainer": "fitContentContainer---2TwvS",
	"footer": "footer---39vyg",
	"confirmFooter": "confirmFooter---tkKc_",
	"leftSection": "leftSection---3TrLB",
	"rightSection": "rightSection---idTl0",
	"gridContainer": "gridContainer---1yoKP",
	"actions": "actions---1B9Jv",
	"viewKeyContainer": "viewKeyContainer---1O7cE",
	"filterBar": "filterBar---bx2S8",
	"search": "search---R9QIi",
	"buttonsContainer": "buttonsContainer---3P15_",
	"howThisWorks": "howThisWorks---3hN3z",
	"bottomButtons": "bottomButtons---3kE99",
	"button": "button---2wNMr",
	"key": "key---171QA",
	"actionsActive": "actionsActive---3lci_"
};

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0oWN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StudentDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StudentName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ActivityName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoaderWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ResultsHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ResultsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return AttemptsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return AssignedActivityWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Footer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return ActivityProgressWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ActivityProgressTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ChartWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return IconWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var ModalBody = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var palette = props.theme.palette;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    width: 800px;\n    min-height: 450px;\n\n    color: ").concat(palette.primary.dark, ";\n  ");
});
var StudentDetails = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  margin-bottom: 10px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'));
var StudentName = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 21px;\n  line-height: 31px;\n"])));
var ActivityName = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 25px;\n"])));
var LoaderWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  min-height: 450px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var ResultsHeading = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n  background-color: white;\n  border: 1px solid ").concat(colours.grey[300], ";\n  border-radius: 15px 15px 0px 0px;\n  border-bottom: none;\n  height: 38px;\n  width: 148px;\n  padding-top: 5px;\n  margin-bottom: -6px;\n  z-index: 1;\n  ");
});
var ResultsWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n  border: 1px solid ").concat(colours.grey[300], ";\n  border-radius: 15px;\n  height: 100%;\n  width: 100%;\n  padding-top: 25px;\n  padding-bottom: 10px;\n  margin-top: 5px;\n");
});
var AttemptsWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  width: 100%;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-evenly'));
var AssignedActivityWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  width: 88%;\n  margin-top: 10px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var Footer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  width: 100%;\n  margin-top: 10px;\n\n  .okButton {\n    width: 100px;\n  }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('flex-end'));
var ActivityProgressWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var palette = props.theme.palette;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    margin-left: 25px;\n    color: ").concat(palette.primary.dark, ";\n  ");
});
var ActivityProgressTitle = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n\n  width: 100%;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: left;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])());
var ChartWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    border: 1px solid ".concat(colours.grey[300], ";\n    border-radius: 4px;\n    box-sizing: border-box;\n    height: 162px;\n    width: 520px;\n    overflow: hidden;\n");
});
var IconWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin-right: 10px;\n  width: 20px;\n  height: 20px;\n"])));

/***/ }),

/***/ "0uBZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return flexbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return inlineFlexbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return flexDirection; });
/* unused harmony export flexWrap */
/* unused harmony export flexFlow */
/* unused harmony export order */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return flexGrow; });
/* unused harmony export flexBasis */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return flex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return justifyContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return alignSelf; });
/* unused harmony export alignContent */
/* unused harmony export flexShrink */
// Flexbox Mixins
// http://philipwalton.github.io/solved-by-flexbox/
// https://github.com/philipwalton/solved-by-flexbox
//
// Copyright (c) 2013 Brian Franco
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to
// permit persons to whom the Software is furnished to do so, subject to
// the following conditions:
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
// IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
// CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
// SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// This is a set of mixins for those who want to mess around with flexbox
// using the native support of current browsers. For full support table
// check: http://caniuse.com/flexbox
//
// Basically this will use:
//
// * Fallback, old syntax (IE10, mobile webkit browsers - no wrapping)
// * Final standards syntax (FF, Safari, Chrome, IE11, Opera)
//
// This was inspired by:
//
// * http://dev.opera.com/articles/view/advanced-cross-browser-flexbox/
//
// With need-help from:
//
// * http://w3.org/tr/css3-flexbox/
// * http://the-echoplex.net/flexyboxes/
// * http://msdn.microsoft.com/en-us/library/ie/hh772069(v=vs.85).aspx
// * http://css-tricks.com/using-flexbox/
// * http://dev.opera.com/articles/view/advanced-cross-browser-flexbox/
// * https://developer.mozilla.org/en-us/docs/web/guide/css/flexible_boxes

//----------------------------------------------------------------------

// Flexbox Containers
//
// The 'flex' value causes an element to generate a block-level flex
// container box.
//
// The 'inline-flex' value causes an element to generate a inline-level
// flex container box.
//
// display: flex | inline-flex
//
// http://w3.org/tr/css3-flexbox/#flex-containers
//
// (Placeholder selectors for each type, for those who rather @extend)

var flexbox = function flexbox() {
  return "\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n";
};
var inlineFlexbox = function inlineFlexbox() {
  return "\n    display: -webkit-inline-box;\n    display: -webkit-inline-flex;\n    display: -moz-inline-flex;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n";
};

//----------------------------------------------------------------------

// Flexbox Direction
//
// The 'flex-direction' property specifies how flex items are placed in
// the flex container, by setting the direction of the flex container's
// main axis. This determines the direction that flex items are laid out in.
//
// Values: row | row-reverse | column | column-reverse
// Default: row
//
// http://w3.org/tr/css3-flexbox/#flex-direction-property

var flexDirection = function flexDirection(value) {
  var direction = String(value || "row").toLowerCase();
  var styles = "";
  if (direction === "row-reverse") {
    styles += "\n        -webkit-box-direction: reverse;\n        -webkit-box-orient: horizontal;\n        ";
  } else if (direction === "column") {
    styles += "\n        -webkit-box-direction: normal;\n        -webkit-box-orient: vertical;\n        ";
  } else if (direction === "column-reverse") {
    styles += "\n        -webkit-box-direction: reverse;\n        -webkit-box-orient: vertical;\n        ";
  } else {
    styles += "\n        -webkit-box-direction: normal;\n        -webkit-box-orient: horizontal;\n        ";
  }
  styles += "\n    -webkit-flex-direction: ".concat(direction, ";\n    -moz-flex-direction: ").concat(direction, ";\n    -ms-flex-direction: ").concat(direction, ";\n    flex-direction: ").concat(direction, ";\n    ");
  return styles;
};

//----------------------------------------------------------------------

// Flexbox Wrap
//
// The 'flex-wrap' property controls whether the flex container is single-line
// or multi-line, and the direction of the cross-axis, which determines
// the direction new lines are stacked in.
//
// Values: nowrap | wrap | wrap-reverse
// Default: nowrap
//
// http://w3.org/tr/css3-flexbox/#flex-wrap-property

var flexWrap = function flexWrap() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "nowrap";
  var givenValue = String(value).toLowerCase();
  var styles = "";
  if (givenValue === "nowrap") {
    styles += "\n        -ms-flex-wrap: none;\n        ";
  } else {
    styles += "\n        -ms-flex-wrap: ".concat(givenValue, ";\n        ");
  }
  styles += "\n    flex-wrap: ".concat(givenValue, ";\n    ");
  return styles;
};

//----------------------------------------------------------------------

// Flexbox Flow (shorthand)
//
// The 'flex-flow' property is a shorthand for setting the 'flex-direction'
// and 'flex-wrap' properties, which together define the flex container's
// main and cross axes.
//
// Values: <flex-direction> | <flex-wrap>
// Default: row nowrap
//
// http://w3.org/tr/css3-flexbox/#flex-flow-property

// No Webkit Box fallback.
var flexFlow = function flexFlow() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "row nowrap";
  var givenValue = String(value).toLowerCase();
  var styles = "";
  styles += "\n    -webkit-flex-flow: ".concat(value, ";\n    -moz-flex-flow: ").concat(value, ";\n    -ms-flex-flow: ").concat(value, ";\n    flex-flow: ").concat(value, ";\n    ");
  return styles;
};

// Flexbox Order
//
// The 'order' property controls the order in which flex items appear within
// their flex container, by assigning them to ordinal groups.
//
// Default: 0
//
// http://w3.org/tr/css3-flexbox/#order-property

var order = function order() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return "\n    -webkit-box-ordinal-group: ".concat(value, " + 1;\n    -webkit-order: ").concat(value, ";\n    -moz-order: ").concat(value, ";\n    -ms-flex-order: ").concat(value, ";\n    order: ").concat(value, ";\n    ");
};

// Flexbox Grow
//
// The 'flex-grow' property sets the flex grow factor. Negative numbers
// are invalid.
//
// Default: 0
//
// http://w3.org/tr/css3-flexbox/#flex-grow-property

var flexGrow = function flexGrow() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return "\n    -webkit-box-flex: ".concat(value, ";\n    -webkit-flex-grow: ").concat(value, ";\n    -moz-flex-grow: ").concat(value, ";\n    -ms-flex-positive: ").concat(value, ";\n    flex-grow: ").concat(value, ";\n    ");
};

// Flexbox Shrink
//
// The 'flex-shrink' property sets the flex shrink factor. Negative numbers
// are invalid.
//
// Default: 1
//
// http://w3.org/tr/css3-flexbox/#flex-shrink-property

var flexShrink = function flexShrink() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return "\n    -webkit-flex-shrink: ".concat(value, ";\n    -moz-flex-shrink: ").concat(value, ";\n    -ms-flex-negative: ").concat(value, ";\n    flex-shrink: ").concat(value, ";\n    ");
};

//----------------------------------------------------------------------

// Flexbox Basis
//
// The 'flex-basis' property sets the flex basis. Negative lengths are invalid.
//
// Values: Like "width"
// Default: auto
//
// http://www.w3.org/TR/css3-flexbox/#flex-basis-property

var flexBasis = function flexBasis() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "auto";
  return "\n    -webkit-flex-basis: ".concat(value, ";\n    -moz-flex-basis: ").concat(value, ";\n    -ms-flex-preferred-size: ").concat(value, ";\n    flex-basis: ").concat(value, ";\n    ");
};

// Flexbox "Flex" (shorthand)
//
// The 'flex' property specifies the components of a flexible length: the
// flex grow factor and flex shrink factor, and the flex basis. When an
// element is a flex item, 'flex' is consulted instead of the main size
// property to determine the main size of the element. If an element is
// not a flex item, 'flex' has no effect.
//
// Values: none | <flex-grow> <flex-shrink> || <flex-basis>
// Default: See individual properties (1 1 0).
//
// http://w3.org/tr/css3-flexbox/#flex-property

var flex = function flex() {
  var fg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "1";
  var fs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var fb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  // Set a variable to be used by box-flex properties
  var fgBoxflex = fg;
  var fgArr = String(fg).split(" ");
  if (fgArr.length > 1) {
    fgBoxflex = fgArr[0];
  }
  return "\n    -webkit-box-flex: ".concat(fgBoxflex, ";\n    -webkit-flex: ").concat(fg, " ").concat(fs, " ").concat(fb, ";\n    -moz-box-flex: ").concat(fgBoxflex, ";\n    -moz-flex: ").concat(fg, " ").concat(fs, " ").concat(fb, "|;\n    -ms-flex: ").concat(fg, " ").concat(fs, " ").concat(fb, ";\n    flex: ").concat(fg, " ").concat(fs, " ").concat(fb, ";\n    ");
};

//----------------------------------------------------------------------

// Flexbox Justify Content
//
// The 'justify-content' property aligns flex items along the main axis
// of the current line of the flex container. This is done after any flexible
// lengths and any auto margins have been resolved. Typically it helps distribute
// extra free space leftover when either all the flex items on a line are
// inflexible, or are flexible but have reached their maximum size. It also
// exerts some control over the alignment of items when they overflow the line.
//
// Note: 'space-*' values not supported in older syntaxes.
//
// Values: flex-start | flex-end | center | space-between | space-around
// Default: flex-start
//
// http://w3.org/tr/css3-flexbox/#justify-content-property

var justifyContent = function justifyContent() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "flex-start";
  var givenValue = String(value).toLowerCase();
  var styles = "";
  if (givenValue === "flex-start") {
    styles += "\n        -webkit-box-pack: start;\n        -ms-flex-pack: start;\n        ";
  } else if (givenValue === "flex-end") {
    styles += "\n        -webkit-box-pack: end;\n        -ms-flex-pack: end;\n        ";
  } else if (givenValue === "space-between") {
    styles += "\n        -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n        ";
  } else if (givenValue === "space-around") {
    styles += "\n        -ms-flex-pack: distribute;\n        ";
  } else {
    styles += "\n        -webkit-box-pack: ".concat(givenValue, ";\n        -ms-flex-pack: ").concat(givenValue, ";\n        ");
  }
  styles += "\n    -webkit-justify-content: ".concat(givenValue, ";\n    -moz-justify-content: ").concat(givenValue, ";\n    justify-content: ").concat(givenValue, ";\n    ");
  return styles;
};

//----------------------------------------------------------------------

// Flexbox Align Items
//
// Flex items can be aligned in the cross axis of the current line of the
// flex container, similar to 'justify-content' but in the perpendicular
// direction. 'align-items' sets the default alignment for all of the flex
// container's items, including anonymous flex items. 'align-self' allows
// this default alignment to be overridden for individual flex items. (For
// anonymous flex items, 'align-self' always matches the value of 'align-items'
// on their associated flex container.)
//
// Values: flex-start | flex-end | center | baseline | stretch
// Default: stretch
//
// http://w3.org/tr/css3-flexbox/#align-items-property

var alignItems = function alignItems() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "stretch";
  var givenValue = String(value).toLowerCase();
  var styles = "";
  if (givenValue === "flex-start") {
    styles += "\n        -webkit-box-align: start;\n        -ms-flex-align: start;\n        ";
  } else if (givenValue === "flex-end") {
    styles += "\n        -webkit-box-align: end;\n        -ms-flex-align: end;\n        ";
  } else {
    styles += "\n        -webkit-box-align: ".concat(givenValue, ";\n        -ms-flex-align: ").concat(givenValue, ";\n        ");
  }
  styles += "\n    -webkit-align-items: ".concat(givenValue, ";\n    -moz-align-items: ").concat(givenValue, ";\n    align-items: ").concat(givenValue, ";\n    ");
  return styles;
};

//----------------------------------

// Flexbox Align Self
//
// Values: auto | flex-start | flex-end | center | baseline | stretch
// Default: auto

var alignSelf = function alignSelf() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "auto";
  var givenValue = String(value).toLowerCase();
  // No Webkit Box Fallback.
  var styles = "\n    -webkit-align-self: ".concat(givenValue, ";\n    -moz-align-self: ").concat(givenValue, ";\n    ");
  if (givenValue === "flex-start") {
    styles += "\n        -ms-flex-item-align: start;\n        ";
  } else if (givenValue === "flex-end") {
    styles += "\n        -ms-flex-item-align: end;\n        ";
  } else {
    styles += "\n        -ms-flex-item-align: ".concat(givenValue, ";\n        ");
  }
  styles += "\n    align-self: ".concat(givenValue, ";\n    ");
  return styles;
};

//----------------------------------------------------------------------

// Flexbox Align Content
//
// The 'align-content' property aligns a flex container's lines within the
// flex container when there is extra space in the cross-axis, similar to
// how 'justify-content' aligns individual items within the main-axis. Note,
// this property has no effect when the flexbox has only a single line.
//
// Values: flex-start | flex-end | center | space-between | space-around | stretch
// Default: stretch
//
// http://w3.org/tr/css3-flexbox/#align-content-property

var alignContent = function alignContent() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "stretch";
  var givenValue = String(value).toLowerCase();
  // No Webkit Box Fallback.
  var styles = "\n    -webkit-align-content: ".concat(givenValue, ";\n    -moz-align-content: ").concat(givenValue, ";\n    ");
  if (givenValue === "flex-start") {
    styles += "\n        -ms-flex-line-pack: start;\n        ";
  } else if (givenValue === "flex-end") {
    styles += "\n        -ms-flex-line-pack: end;\n        ";
  } else {
    styles += "\n        -ms-flex-line-pack: ".concat(givenValue, ";\n        ");
  }
  styles += "\n    align-content: ".concat(givenValue, ";\n    ");
  return styles;
};


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1E24":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILTERED_STUDENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ERROR_DETECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_SORTED_STUDENTS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UPDATE_SORTED_ASSIGNED_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SHOW_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CLASSROOMS_ACQUIRED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_SORT_PROPERTIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return APPLY_FILTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SHOW_HIDE_SEARCH_PANEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DISPLAY_MODAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return HIDE_STANDARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_STUDENT_ASSIGNMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return GRID_CELL_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_ACTIVE_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SET_ACTIVE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return RESTRICT_ACCESS_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return RESTRICT_ACCESS_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RESTRICT_ACCESS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return TOPICS_ACQUIRED_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return TOPICS_ACQUIRED_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return TOPICS_ACQUIRED_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return COURSE_TOPICS_ACQUIRED_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return COURSE_TOPICS_ACQUIRED_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return COURSE_TOPICS_ACQUIRED_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UPDATE_COURSE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_TOPICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_SELECTED_TOPICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UPDATE_SELECTED_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TOGGLE_TOPICS_EXPAND_COLLAPSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return SET_TOPIC_TO_DIRTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return UPDATE_DATE_PREFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return QUICK_SELECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return SELECT_EQUAL_LESS_THAN_CELLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return STUDENT_SINGLE_ACTIVITY_REPORT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return STUDENT_SINGLE_ACTIVITY_REPORT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return UPDATE_ASSIGNMENT_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return CLEAR_ASSIGNMENT_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return STUDENT_RESULT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return STUDENT_RESULT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return UPDATE_STUDENT_ASSIGNMENTS_SELECTED; });
var FILTERED_STUDENTS = 'FILTERED_STUDENTS';
var ERROR_DETECTED = 'ERROR_DETECTED';
var UPDATE_SORTED_STUDENTS_LIST = 'UPDATE_SORTED_STUDENTS_LIST';
var UPDATE_SORTED_ASSIGNED_LIST = 'UPDATE_SORTED_ASSIGNED_LIST';
var SHOW_TOAST = 'SHOW_TOAST';
var CLASSROOMS_ACQUIRED = 'CLASSROOMS_ACQUIRED';
var UPDATE_SORT_PROPERTIES = 'UPDATE_SORT_PROPERTIES';
var APPLY_FILTER = 'APPLY_FILTER';
var SHOW_HIDE_SEARCH_PANEL = 'SHOW_HIDE_SEARCH_PANEL';
var DISPLAY_MODAL_INFORMATION = 'DISPLAY_MODAL_INFORMATION';
var HIDE_STANDARD = 'HIDE_STANDARD';
var UPDATE_STUDENT_ASSIGNMENT = 'UPDATE_STUDENT_ASSIGNMENT';
var GRID_CELL_SELECTION = 'GRID_CELL_SELECTION';
var SET_ACTIVE_CLASS = 'SET_ACTIVE_CLASS';
var SET_ACTIVE_GROUP = 'SET_ACTIVE_GROUP';
var RESTRICT_ACCESS_FAILURE = 'RESTRICT_ACCESS_FAILURE';
var RESTRICT_ACCESS_REQUEST = 'RESTRICT_ACCESS_REQUEST';
var RESTRICT_ACCESS_SUCCESS = 'RESTRICT_ACCESS_SUCCESS';
var TOPICS_ACQUIRED_REQUEST = 'TOPICS_ACQUIRED_REQUEST';
var TOPICS_ACQUIRED_SUCCESS = 'TOPICS_ACQUIRED_SUCCESS';
var TOPICS_ACQUIRED_FAILURE = 'TOPICS_ACQUIRED_FAILURE';
var COURSE_TOPICS_ACQUIRED_REQUEST = 'COURSE_TOPICS_ACQUIRED_REQUEST';
var COURSE_TOPICS_ACQUIRED_SUCCESS = 'COURSE_TOPICS_ACQUIRED_SUCCESS';
var COURSE_TOPICS_ACQUIRED_FAILURE = 'COURSE_TOPICS_ACQUIRED_FAILURE';
var UPDATE_COURSE_ID = 'UPDATE_COURSE_ID';
var UPDATE_TOPICS = 'UPDATE_TOPICS';
var UPDATE_SELECTED_TOPICS = 'UPDATE_SELECTED_TOPICS';
var UPDATE_SELECTED_ACTIVITIES = 'UPDATE_SELECTED_ACTIVITIES';
var TOGGLE_TOPICS_EXPAND_COLLAPSE = 'TOGGLE_TOPICS_EXPAND_COLLAPSE';
var SET_TOPIC_TO_DIRTY = 'SET_TOPIC_TO_DIRTY';
var UPDATE_DATE_PREFERENCE = 'UPDATE_DATE_PREFERENCE';
var QUICK_SELECTION = 'QUICK_SELECTION';
var SELECT_EQUAL_LESS_THAN_CELLS = 'SELECT_EQUAL_LESS_THAN_CELLS';
var STUDENT_SINGLE_ACTIVITY_REPORT_REQUEST = 'STUDENT_SINGLE_ACTIVITY_REPORT_REQUEST';
var STUDENT_SINGLE_ACTIVITY_REPORT_SUCCESS = 'STUDENT_SINGLE_ACTIVITY_REPORT_SUCCESS';
var UPDATE_ASSIGNMENT_FILTERS = 'UPDATE_ASSIGNMENT_FILTERS';
var CLEAR_ASSIGNMENT_FILTERS = 'CLEAR_ASSIGNMENT_FILTERS';
var STUDENT_RESULT_REQUEST = 'STUDENT_RESULT_REQUEST';
var STUDENT_RESULT_SUCCESS = 'STUDENT_RESULT_SUCCESS';
var UPDATE_STUDENT_ASSIGNMENTS_SELECTED = 'UPDATE_STUDENT_ASSIGNMENTS_SELECTED';

/***/ }),

/***/ "1IMA":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Hwd/");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "1KZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

/* harmony default export */ __webpack_exports__["a"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"].overrides), {}, {
  dropdownMenu: {
    menu: {
      optionPadding: '10px 8px'
    }
  },
  header: {
    colours: {
      main: {
        background: '#dbe3e9'
      },
      subtitle: {
        text: '#4e5c67'
      },
      subheader: {
        background: '#dbe3e9'
      }
    },
    spacing: 10,
    subtitle: {
      borderRadius: '0px',
      borderWidth: '0px',
      padding: '6px'
    }
  },
  button: {
    borderRadius: '0px'
  },
  modal: {
    maxWidth: '800px',
    width: '800px'
  },
  calendar: {
    colours: {
      day: {
        selected: {
          background: '#7ca2bb',
          text: '#fff'
        }
      }
    }
  }
}));

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("x4K0");


/***/ }),

/***/ "28rk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return THIS_WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LAST_WEEK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return THIS_SCHOOL_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CUSTOM_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CUSTOM_DATE_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LIFETIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DEFAULT_DATE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DATE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DEFAULT_DATE_OPTIONS_LABELS; });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var THIS_WEEK = 'This week';
var LAST_WEEK = 'Last week';
var THIS_SCHOOL_YEAR = 'This school year';
var CUSTOM_DATE = 'Custom date';
var CUSTOM_DATE_TIME = 'Date and Time';
var LIFETIME = 'Lifetime';
var DEFAULT_DATE_OPTIONS = [THIS_WEEK, LAST_WEEK, THIS_SCHOOL_YEAR, CUSTOM_DATE];
var DATE_OPTIONS = [].concat(DEFAULT_DATE_OPTIONS, [CUSTOM_DATE_TIME, LIFETIME]);
var DEFAULT_DATE_OPTIONS_LABELS = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, THIS_WEEK, THIS_WEEK), LAST_WEEK, LAST_WEEK), THIS_SCHOOL_YEAR, THIS_SCHOOL_YEAR), CUSTOM_DATE, CUSTOM_DATE);

/***/ }),

/***/ "2Dmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return StudentDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StudentName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CourseDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TabContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TabHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TabbedPanel; });
/* unused harmony export ResultContainer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoaderWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__ = __webpack_require__("Ivgr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var ModalBody = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var palette = props.theme.palette;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    min-width: 400px;\n    min-height: 400px;\n\n    color: ").concat(palette.primary.dark, ";\n  ");
});
var StudentDetails = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  margin-bottom: 10px;\n  user-select: none;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["c" /* justifyContent */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["d" /* flexDirection */])('column'));
var StudentName = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 21px;\n  line-height: 31px;\n"])));
var CourseDetails = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  font-size: 16px;\n  line-height: 25px;\n  margin: 0 10px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["e" /* inlineFlexbox */])());
var TabContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  z-index: 100;\n"])));
var TabHeading = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_1__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours,
    palette = _ThemeHelper$getTheme.palette;
  var statusColor = '';
  var selected = props.selected;
  statusColor = selected ? palette.primary.text : colours.grey[200];
  return "\n    font-size: 16px;\n    font-weight: normal;\n    background-color: ".concat(statusColor, ";\n    border: 1px solid ").concat(colours.grey[400], ";\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    ").concat(props.selected ? 'border-bottom-color: #fff;' : '', "\n    cursor: ").concat(props.selected ? 'default' : 'pointer', ";\n    height: 35px;\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["e" /* inlineFlexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["c" /* justifyContent */])('center'), "\n    padding: 5px 10px;\n    box-sizing: border-box;\n    min-width: 125px;\n\n    &:not(:last-child) {\n      margin-right: 10px;\n    }\n\n    div[class*='svgIconComponent--'] {\n      width: auto;\n      margin-right: 5px;\n      \n      path {\n        fill: #3C4E5E;\n      }\n    }\n  ");
});
var TabbedPanel = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].section(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 320px;\n"])));
var ResultContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  width: -webkit-fill-available;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["d" /* flexDirection */])('column'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var LoaderWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  min-height: 450px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["e" /* inlineFlexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["c" /* justifyContent */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["b" /* alignItems */])('center'));

/***/ }),

/***/ "2sXf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__ = __webpack_require__("Ivgr");
/* eslint-disable no-tabs */
/* eslint-disable indent */



var ModalWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_2__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme.colours;
  var bgColor = props.bgColor,
    customStyle = props.customStyle,
    contextPos = props.contextPos;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n    background: ").concat(bgColor, ";\n    color: ").concat(colours.grey[900], ";\n    position: ").concat(props.fixedParent ? 'absolute' : 'fixed', ";\n    left: ").concat(props.positionX, "px\n    top: ").concat(props.positionY, "px\n    border-radius: 8px;\n    z-index: 99;\n    box-shadow: 2px 2px 15px ").concat(colours.grey[900], ";\n    ").concat(props.modalWidth ? "width:".concat(props.modalWidth, "px;") : '', "\n    min-height: 35px;\n    cursor: default;\n    border: 1px solid ").concat(bgColor, "\n    ").concat(customStyle, "\n    ").concat(contextPos === 'right' ? "::after {\n        border-top: 8px solid transparent;\n        border-bottom: 8px solid transparent;\n        border-right: 18px solid ".concat(bgColor, ";\n        width: 15px;\n        position: fixed;\n        top: ").concat(props.positionY + 10, "px;\n        left: ").concat(props.positionArrow - 17, "px;\n        content: ' '\n        }") : "::after {\n          width: 0; \n          height: 0; \n          border-left: 8px solid transparent;\n          border-right: 8px solid transparent;        \n          border-bottom: 15px solid ".concat(bgColor, ";\n          ").concat(props.fixedParent ? "\n                position: absolute;\n                top: -10px;\n                left: ".concat(props.positionArrowFixed ? "".concat(props.positionArrowFixed, "px") : '50%', ";\n                transform: translateX(-50%);\n              ") : "\n                position: fixed;\n                top: ".concat(props.positionY - 10, "px;\n                left: ").concat(props.positionArrow - 8, "px;\n              "), "\n        content: ' '\n      }"), "\n\n\t&:hover {\n\t\tcolor: ").concat(props.hoverTextColor ? props.hoverTextColor : colours.grey[900], ";\n\t}");
});
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function () {
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n  width: 100%;\n  border-radius: 8px;\n");
});
var ContentTheme = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function () {
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n  width: 100%\n  padding: 10px;\n  color: white;\n  border-radius: 8px;\n");
});


/***/ }),

/***/ "2xSC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

/* harmony default export */ __webpack_exports__["a"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"].layout), {}, {
  borderRadius: '6px',
  spacing: 8
}));

/***/ }),

/***/ "2z6x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// For local development, we can use mock-rest-server (or a similar REST server like json-server)
//
// You should be able to use this code as is, apart from perhaps changing MOCK_SERVICE_PORT to whatever
// port you're using for your mock server.

// const MOCK_SERVICES_PORT = 4321; // TODO: 2. DEFINE THE PORT YOUR MOCK SERVER IS LISTENING ON

// const MOCK_SERVICES_HOST = 'localhost';
// const MOCK_SERVICES_URL = `http://${MOCK_SERVICES_HOST}:${MOCK_SERVICES_PORT}`;

// The app's configuration will have a base URL for each service we use.  For local testing, we define
// the configuration to point to our local server.
//
// For each resource, we have a constant for the base URL, as it would be in production. For example,
// below we have "AvatarAdminBaseUrl" which represents the base of the URL for access to all of
// the Avatar Admin application's resources.  Replace that with the resource(s) your application uses.

var localConfig = {
  BaseName: ''
};
/* harmony default export */ __webpack_exports__["a"] = (localConfig);

/***/ }),

/***/ "3Ct5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__course_assign_actions__ = __webpack_require__("+7+H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_student_list_student_list__ = __webpack_require__("cdIJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_filters_filters__ = __webpack_require__("+yn+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__course_assign_scss__ = __webpack_require__("hJ1u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__course_assign_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__course_assign_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_footer__ = __webpack_require__("5ttS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_topics__ = __webpack_require__("9sdx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_toast__ = __webpack_require__("xfNU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_assign_later_assign_later__ = __webpack_require__("w8NY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_unassign_all_modal_unassign_all_modal__ = __webpack_require__("3neS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_assignments_action_bar_assignments_action_bar__ = __webpack_require__("KUlI");















var CourseAssign = function CourseAssign(_ref) {
  var i18n = _ref.i18n;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var selectedProduct = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.product;
  }, __WEBPACK_IMPORTED_MODULE_2_react_redux__["d" /* shallowEqual */]);
  var modal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.modalContainerReducer;
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__course_assign_actions__["a" /* getClassrooms */])(selectedProduct.id));
  }, [dispatch, selectedProduct.id]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_7__course_assign_scss___default.a['course-assign']
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_7__course_assign_scss___default.a.component
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_7__course_assign_scss___default.a.leftSection
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_filters_filters__["a" /* default */], {
    i18n: i18n
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_student_list_student_list__["a" /* default */], {
    i18n: i18n
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_topics__["a" /* default */], {
    i18n: i18n
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_assignments_action_bar_assignments_action_bar__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_footer__["a" /* default */], {
    i18n: i18n
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_toast__["a" /* default */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_assign_later_assign_later__["a" /* default */], {
    i18n: i18n
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_unassign_all_modal_unassign_all_modal__["a" /* default */], {
    i18n: i18n
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["ModalManager"], {
    modals: modal,
    onClose: function onClose() {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__containers_modal_manager_modal_manager_actions__["c" /* dismissModal */])());
    }
  }));
};
CourseAssign.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (CourseAssign);

/***/ }),

/***/ "3IFr":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("eag5");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./svg-icon.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./svg-icon.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "3gQ+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".toast---kgiAS {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: \"column\";\n  -ms-flex-direction: \"column\";\n  flex-direction: \"column\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 51px;\n  visibility: visible;\n  opacity: 0;\n  -webkit-animation: fadeIn---2PfM_ 5s;\n          animation: fadeIn---2PfM_ 5s;\n  font-size: 17px;\n  z-index: 99999; }\n  .toastContent---1l5Gr {\n    padding: 15px;\n    width: 100%; }\n  .message---ryA0O {\n  -webkit-box-pack: \"center\";\n  -ms-flex-pack: \"center\";\n  -moz-justify-content: \"center\";\n  justify-content: \"center\";\n  -webkit-box-align: \"center\";\n  -ms-flex-align: \"center\";\n  -moz-align-items: \"center\";\n  align-items: \"center\";\n  color: white;\n  margin: auto;\n  cursor: pointer; }\n  @-webkit-keyframes fadeIn---2PfM_ {\n  0% {\n    opacity: 0; }\n  15% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n  @keyframes fadeIn---2PfM_ {\n  0% {\n    opacity: 0; }\n  15% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n  @media print {\n  .empty---m-1l8 {\n    display: none !important;\n    height: 0.001px !important; } }\n", ""]);

// exports
exports.locals = {
	"toast": "toast---kgiAS",
	"fadeIn": "fadeIn---2PfM_",
	"toastContent": "toastContent---1l5Gr",
	"message": "message---ryA0O",
	"empty": "empty---m-1l8"
};

/***/ }),

/***/ "3neS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__unassign_all_modal_styled__ = __webpack_require__("c+Q/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_course_assign_course_assign_actions__ = __webpack_require__("+7+H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__toast_toast_action__ = __webpack_require__("fbOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_unassign_all_modal_actions__ = __webpack_require__("XAJD");










function UnassignAllModal(props) {
  var i18n = props.i18n;
  var isOpen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.unassignModalReducer.isUnassignModalOpen;
  });
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* useDispatch */])();
  var classroomId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var groupId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  function handleSuccess() {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__containers_course_assign_course_assign_actions__["b" /* getTopics */])(classroomId, groupId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__toast_toast_action__["c" /* showToast */])(i18n._(
    /*i18n*/
    {
      id: "footer.assignSuccess",
      defaults: "Selected student activities have been assigned"
    }), 'success'));
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_9__store_unassign_all_modal_actions__["a" /* HIDE_UNASSIGN_MODAL */]
    });
  }
  function handleUnassignAll() {
    __WEBPACK_IMPORTED_MODULE_5__helpers_resources__["a" /* default */].unassignAll.put({
      classroomId: classroomId,
      groupId: groupId
    }).withBody({}).send().then(function () {
      handleSuccess();
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__toast_toast_action__["c" /* showToast */])(i18n._(
      /*i18n*/
      {
        id: "footer.unassignAllSuccess",
        defaults: "all student activities in this class group have been unassigned"
      }), 'success'));
    }, function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_types__["e" /* ERROR_DETECTED */],
        payload: err
      });
    });
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, isOpen ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__unassign_all_modal_styled__["a" /* UnassignModalOuter */], {
    "data-testid": "unassign-modal"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__unassign_all_modal_styled__["b" /* UnassignModalInner */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2", null, i18n._(
  /*i18n*/
  {
    id: "footer.unassignAllModalHeader",
    defaults: "Unassign all?"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, i18n._(
  /*i18n*/
  {
    id: "footer.unassignAllModalText",
    defaults: "All activities assigned\n              to any students in this group will be unassigned. Do you wish to\n              continue?"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Button"], {
    text: i18n._(
    /*i18n*/
    {
      id: "generic",
      defaults: "cancel"
    }),
    secondary: true,
    type: __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Button"].LOZENGE,
    onClick: function onClick() {
      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_9__store_unassign_all_modal_actions__["a" /* HIDE_UNASSIGN_MODAL */]
      });
    }
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Button"], {
    text: i18n._(
    /*i18n*/
    {
      id: "generic.submit",
      defaults: "submit"
    }),
    primary: true,
    type: __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Button"].LOZENGE,
    onClick: function onClick() {
      return handleUnassignAll();
    }
  }))) : null);
}
UnassignAllModal.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (UnassignAllModal);

/***/ }),

/***/ "4BBg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_use_analytics__ = __webpack_require__("dGCJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_portal_comms__ = __webpack_require__("lS1M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__analytics__ = __webpack_require__("uVVs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__switch_to_old_assign_scss__ = __webpack_require__("sSPr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__switch_to_old_assign_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__switch_to_old_assign_scss__);
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }








var SwitchToOldAssign = function SwitchToOldAssign(_ref) {
  var i18n = _ref.i18n;
  var _useAnalytics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_use_analytics__["b" /* useAnalytics */])(),
    track = _useAnalytics.track;
  var _useTracking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__analytics__["d" /* useTracking */])(),
    trackSwitchToOldAssign = _useTracking.trackSwitchToOldAssign;
  function handleSwitch() {
    return _handleSwitch.apply(this, arguments);
  }
  function _handleSwitch() {
    _handleSwitch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var courseAssignModuleId, oldAssignModuleId;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["b" /* getConfiguration */])('courseAssignModuleId');
          case 1:
            courseAssignModuleId = _context.v;
            _context.n = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["b" /* getConfiguration */])('oldAssignModuleId');
          case 2:
            oldAssignModuleId = _context.v;
            track('SwitchToOldAssign');
            trackSwitchToOldAssign({
              context: 'header-button'
            });
            __WEBPACK_IMPORTED_MODULE_4__helpers_portal_comms__["a" /* default */].requestModuleChange(oldAssignModuleId, courseAssignModuleId);
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }));
    return _handleSwitch.apply(this, arguments);
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"], {
    className: __WEBPACK_IMPORTED_MODULE_7__switch_to_old_assign_scss___default.a.switchToOldAssign,
    info: true,
    type: "LOZENGE",
    text: i18n._(
    /*i18n*/
    {
      id: "switchToOldAssign",
      defaults: "Switch to old Assign"
    }),
    onClick: function onClick() {
      return handleSwitch();
    }
  });
};
SwitchToOldAssign.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (SwitchToOldAssign);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("hKoQ")))

/***/ }),

/***/ "4V9u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hover_context_styled__ = __webpack_require__("hTAu");



var HoverContext = function HoverContext(props) {
  return props.show && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hover_context_styled__["a" /* ModalWrapper */], {
    "data-testid": "hover-context"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__hover_context_styled__["b" /* ContentTheme */], null, props.date));
};
HoverContext.propTypes = {
  show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (HoverContext);

/***/ }),

/***/ "4YSV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__("qmda");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__("IzlY");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }




var Checkbox = function Checkbox(props) {
  var state = props.state,
    checkboxHandler = props.checkboxHandler,
    id = props.id;
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(state),
    _useState2 = _slicedToArray(_useState, 2),
    currentState = _useState2[0],
    setCurrentState = _useState2[1];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setCurrentState(state);
  }, [state]);
  var handleChange = function handleChange() {
    if (state === __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* DISABLED */]) return;
    if (currentState === __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* UNCHECKED */] || currentState === __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* INDETERMINATE */]) {
      setCurrentState(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CHECKED */]);
      checkboxHandler(__WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CHECKED */], id);
    } else {
      setCurrentState(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* UNCHECKED */]);
      checkboxHandler(__WEBPACK_IMPORTED_MODULE_3__constants__["a" /* UNCHECKED */], id);
    }
  };
  var renderCheckbox = function renderCheckbox() {
    switch (currentState) {
      case __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* CHECKED */]:
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* IconChecked */], {
          viewBox: "0 0 24 24"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline", {
          points: "20 6 9 17 4 12"
        }));
      case __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* UNCHECKED */]:
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* IconUnchecked */], {
          "data-testid": "unchecked",
          viewBox: "0 0 24 24"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline", {
          points: "0 0"
        }));
      case __WEBPACK_IMPORTED_MODULE_3__constants__["c" /* INDETERMINATE */]:
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["c" /* IconIntermediate */], {
          viewBox: "0 0 24 24"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline", {
          points: "4 11 20 11 20 14 4 14 4 11"
        }));
      case __WEBPACK_IMPORTED_MODULE_3__constants__["d" /* DISABLED */]:
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["d" /* IconDisabled */], {
          viewBox: "0 0 24 24"
        }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline", {
          points: "0 0"
        }));
      default:
        return null;
    }
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["e" /* CheckboxContainer */], {
    onClick: handleChange,
    "data-testid": id
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["f" /* HiddenCheckbox */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["g" /* CustomCheckbox */], {
    currentState: currentState
  }, renderCheckbox()));
};
Checkbox.propTypes = {
  state: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  checkboxHandler: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])
};
Checkbox.defaultProps = {
  state: __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* UNCHECKED */],
  checkboxHandler: function checkboxHandler() {},
  id: null
};
/* harmony default export */ __webpack_exports__["a"] = (Checkbox);

/***/ }),

/***/ "4hLv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assign_later_actions__ = __webpack_require__("CPWM");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var initialState = {
  isAssignLaterModalOpen: false,
  assignLaterData: undefined
};
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__assign_later_actions__["a" /* HIDE_ASSIGN_LATER */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAssignLaterModalOpen: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__assign_later_actions__["b" /* SHOW_ASSIGN_LATER */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isAssignLaterModalOpen: true
      });
    case __WEBPACK_IMPORTED_MODULE_0__assign_later_actions__["c" /* SUBMIT_ASSIGN_LATER */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        assignLaterData: action.payload,
        isAssignLaterModalOpen: false
      });
    default:
      return _objectSpread({}, state);
  }
});

/***/ }),

/***/ "5ttS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("r+Ri");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assign_button__ = __webpack_require__("s2lQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__unassign_button__ = __webpack_require__("7wlH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_hooks_use_assignment_to_assign__ = __webpack_require__("O9G1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_hooks_use_assignment_to_unassign__ = __webpack_require__("MI7Q");








function Footer(props) {
  var i18n = props.i18n;
  var actionInProgress = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.actionInProgress;
  });
  var datePreference = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    var _state$CourseAssignRe;
    return ((_state$CourseAssignRe = state.CourseAssignReducer) === null || _state$CourseAssignRe === void 0 ? void 0 : _state$CourseAssignRe.datePreference) || [];
  });

  // Collects selected unassigned activities and its taskType from state
  var assignmentsToAssign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_hooks_use_assignment_to_assign__["a" /* default */])();

  // Collects selected assigned activities and its taskType from state
  var assignmentsToUnassign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_hooks_use_assignment_to_unassign__["a" /* default */])();
  var courseID = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeCourseID;
  });
  var classroomId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var groupId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var count = assignmentsToAssign.length + assignmentsToUnassign.length || 0;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    "data-name": "collapsed",
    className: "buttonPanel collapsed"
  }, count, ' ', count > 1 ? "".concat(i18n._(
  /*i18n*/
  {
    id: "footer.cellsSelected",
    defaults: "cells selected"
  })) : "".concat(i18n._(
  /*i18n*/
  {
    id: "footer.cellSelected",
    defaults: "cell selected"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    "data-name": "expanded",
    className: "buttonPanel expanded"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__unassign_button__["a" /* default */], {
    i18n: i18n,
    actionInProgress: actionInProgress,
    assignmentsToUnassign: assignmentsToUnassign,
    groupId: groupId,
    classroomId: classroomId
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__assign_button__["a" /* default */], {
    i18n: i18n,
    actionInProgress: actionInProgress,
    assignmentsToAssign: assignmentsToAssign,
    courseId: courseID,
    groupId: groupId,
    classroomId: classroomId,
    startDatePreference: datePreference[0],
    dueDatePreference: datePreference[1]
  }))));
}
Footer.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),

/***/ "6AC3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return circlePeri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return percentPeri; });
var circlePeri = function circlePeri(radius) {
  return 2 * Math.PI * radius;
};
var percentPeri = function percentPeri(radius, percent) {
  return circlePeri(radius) - circlePeri(radius) * (percent / 100);
};

/***/ }),

/***/ "6KtE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__product_enum__ = __webpack_require__("avc1");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var productService = /*#__PURE__*/function () {
  function productService() {
    _classCallCheck(this, productService);
  }
  return _createClass(productService, null, [{
    key: "Configure",
    value: function Configure() {
      return {
        product: {
          id: __WEBPACK_IMPORTED_MODULE_0__product_enum__["a" /* default */].MATHLETICS.id,
          name: __WEBPACK_IMPORTED_MODULE_0__product_enum__["a" /* default */].MATHLETICS.name
        }
      };
    }
  }, {
    key: "getProductNameById",
    value: function getProductNameById(id) {
      var productName = '';
      if (id) {
        for (var key in __WEBPACK_IMPORTED_MODULE_0__product_enum__["a" /* default */]) {
          if (__WEBPACK_IMPORTED_MODULE_0__product_enum__["a" /* default */][key].id === id) {
            productName = __WEBPACK_IMPORTED_MODULE_0__product_enum__["a" /* default */][key].name;
            break;
          }
        }
      }
      return productName;
    }
  }]);
}();


/***/ }),

/***/ "6QRH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["a"] = handleDefaults;
/* harmony export (immutable) */ __webpack_exports__["b"] = getConfiguration;
/* unused harmony export log */
/* harmony export (immutable) */ __webpack_exports__["c"] = isDefined;
/* harmony export (immutable) */ __webpack_exports__["e"] = getContextCoords;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return studentStatus; });
/* unused harmony export assignmentType */
/* unused harmony export MAX_STUDENT_NAME_LENGTH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MAX_CLASSNAME_LENGTH; });
/* unused harmony export MAX_ITEMS_TO_DISPLAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MAX_GROUP_NAME_LENGTH; });
/* unused harmony export DEFAULT_POLL_DELAY */
/* unused harmony export LOCALE_DEFAULT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return attachSuffix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CLASSROOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return STUDENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return MOUSE_STATE_ENTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return MOUSE_STATE_LEAVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return MOUSE_STATE_CLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return xPosCommon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return yPosCommon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return radiusCommon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return colorCommon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return widthCommon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return fillCommon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return dashOffsetCommon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return lineCapCommon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return classColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return groupColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return studentColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return doughnutWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return doughnutGap; });
/* harmony export (immutable) */ __webpack_exports__["j"] = getTruncatedName;
/* harmony export (immutable) */ __webpack_exports__["d"] = getHyphenDateFormat;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/**
 *  utitlity functions
 */
function handleDefaults(defaultObj, dynamicObj) {
  for (var key in dynamicObj) {
    defaultObj[key] = dynamicObj[key];
  }
  return defaultObj;
}

// 3P host apps get the configuration from the global window object injected by host app.
// On developers system when running the webpack server we do not have access to pppAppConfig object
// To facilitate the local development we have a fallback.
function getConfiguration(_x) {
  return _getConfiguration.apply(this, arguments);
}
function _getConfiguration() {
  _getConfiguration = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(name) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, window._env_[name]);
      }
    }, _callee);
  }));
  return _getConfiguration.apply(this, arguments);
}
function log() {}

// Until we get Nullish coalescing operator
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Nullish_coalescing_operator
function isDefined(x) {
  return x !== undefined && x !== null;
}
function getContextCoords(position, modalWidth) {
  var modalHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 260;
  var leftAlign = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var leftOffset = position.left || position.x || position.clientX;
  var innerOffsetRight = window.innerWidth - (position.right || position.clientX);
  var innerOffsetLeft = leftOffset - modalWidth;
  var coords = {};
  var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  if (leftAlign) {
    var mid = (position.top + position.bottom) / 2;
    coords.posX = position.right + 12;
    coords.posArrow = position.right;
    coords.posArrowY = mid - 8;
    coords.posY = window.innerHeight - position.bottom < 150 ? position.bottom + 5 : position.bottom - 75;
    return coords;
  }
  coords.posY = (position.bottom || position.clientY) + 5;
  var reverseArrow = coords.posY + modalHeight > windowHeight;
  coords.posArrow = leftOffset + (position.width || 2) / 2;
  if (reverseArrow) {
    var heightOffset = modalHeight + 45;
    coords.posY -= heightOffset;
  }
  if (innerOffsetRight > modalWidth && innerOffsetLeft > modalWidth) {
    coords.posX = coords.posArrow - modalWidth / 2; // center aligned
  } else if (innerOffsetLeft < modalWidth && innerOffsetRight > modalWidth) {
    coords.posX = coords.posArrow - 15; // left aligned
  } else {
    coords.posX = coords.posArrow - modalWidth + 15; // right aligned
  }
  coords.reverseArrow = reverseArrow;
  return coords;
}

/**
 *  constants
 */

var studentStatus = {
  ASSIGNED: 0,
  INPROGRESS: 1,
  PAST_DUE_DATE: 2,
  UNATTEMPTED: 3
};
var assignmentType = {
  RESTRICTED: 0,
  NON_RESTRICTED: 1
};
var MAX_STUDENT_NAME_LENGTH = 22;
var MAX_CLASSNAME_LENGTH = 20;
var MAX_ITEMS_TO_DISPLAY = 14;
var MAX_GROUP_NAME_LENGTH = 20;
var DEFAULT_POLL_DELAY = 10000;
var LOCALE_DEFAULT = 'en-AU';

/* helper method to attach suffix to the numbers */
var attachSuffix = function attachSuffix(val, i18n) {
  var j = val % 10;
  var k = val % 100;
  if (j === 1 && k !== 11) {
    return "".concat(val).concat(i18n._(
    /*i18n*/
    {
      id: "utils.suffix.st",
      defaults: "st"
    }));
  }
  if (j === 2 && k !== 12) {
    return "".concat(val).concat(i18n._(
    /*i18n*/
    {
      id: "utils.suffix.nd",
      defaults: "nd"
    }));
  }
  if (j === 3 && k !== 13) {
    return "".concat(val).concat(i18n._(
    /*i18n*/
    {
      id: "utils.suffix.rd",
      defaults: "rd"
    }));
  }
  return "".concat(val).concat(i18n._(
  /*i18n*/
  {
    id: "utils.suffix.th",
    defaults: "th"
  }));
};

/* constants used for doughnut component */
var CLASSROOM = 0;
var GROUP = 1;
var STUDENT = 2;
var MOUSE_STATE_ENTER = 'MOUSE_STATE_ENTER';
var MOUSE_STATE_LEAVE = 'MOUSE_STATE_LEAVE';
var MOUSE_STATE_CLICK = 'MOUSE_STATE_CLICK';
var xPosCommon = 80;
var yPosCommon = 80;
var radiusCommon = 70;
var colorCommon = '#e8f3f3';
var widthCommon = 12;
var fillCommon = 'transparent';
var dashOffsetCommon = 0;
var lineCapCommon = 'round';
var classColor = '#c5e0e1';
var groupColor = '#c6d4e1';
var studentColor = '#088bd3';
var doughnutWidth = widthCommon;
var doughnutGap = 6;
function getTruncatedName(name) {
  return name.length > MAX_STUDENT_NAME_LENGTH ? "".concat(name.substr(0, MAX_STUDENT_NAME_LENGTH), "...") : name;
}
function getHyphenDateFormat(date) {
  return date.replace(/\//g, '-');
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("hKoQ")))

/***/ }),

/***/ "6uc1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StudentListWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CurrentAssigned; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ListItemContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ListItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HeaderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StudentHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SvgWrapper; });
/* unused harmony export LoaderWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StudentListItemWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CheckboxWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ContextMenuAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return StudentDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return StudentDetailsRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return StudentName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return StudentGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var StudentListWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var typography = props.theme.typography;
  return "\n    min-width: 260px;\n    max-width: 260px;\n    font-family: ".concat(typography.family, ";\n    font-size: 14px;\n    left: 0;\n    background-color: white;\n    z-index: 7;\n    overflow: hidden;\n    position: -webkit-sticky;\n    position: sticky;\n");
});
var CurrentAssigned = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 5px;\n  width: 100px;\n  font-size: 12px;\n  font-weight: 400;\n  text-align: right;\n"])));
var ListItemContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    box-sizing: border-box;\n    border: 1px solid ").concat(colours.grey[400], ";\n    border-left: none;\n    border-top: none;\n    height: 33px;\n    background-color: white;\n    &:last-of-type {\n      margin-bottom: 60px;\n    }\n  ");
});
var ListItem = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _props$theme = props.theme,
    palette = _props$theme.palette,
    colours = _props$theme.colours;

  /* eslint-disable */
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'), ";\n    padding: 5px;\n    font-weight: 400;\n    color: ").concat(palette.primary.dark, ";\n    width: ").concat(props.showCheckbox === true ? "80%" : "100%", ";\n    border-right: ").concat(props.showCheckbox === true ? "2px solid ".concat(colours.grey[400]) : 'none', ";\n    height: 22px;\n    align-items: center;\n    cursor: pointer;\n    user-select: none;\n\n    #assignedActivity {\n        color: ").concat(palette.primary.dark, ";\n    }\n\n    &:hover {\n      background-color: ").concat(colours.grey[100], ";\n    }\n");
  /* eslint-enable */
});
var HeaderContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */])(ListItemContainer)(function (props) {
  var colours = props.theme.colours;
  return "\n  height: 48px;\n  border: 1px solid ".concat(colours.grey[400], ";\n  border-left: none;\n  background-color: white;\n  position: sticky;\n  top: 0;\n  max-width: 262px;\n  width: 260px;\n\n  @media screen and (max-width: 1100px) {\n    height: 38px;\n  }\n  ");
});
var StudentHeader = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'), ";\n    font-weight: 600;\n    padding: 0px 5px;\n    border-right: 2px solid ").concat(colours.grey[400], ";\n    user-select: none;\n    height: 47px;\n    width: 80%;\n\n    .title {\n        ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* inlineFlexbox */])(), ";\n        ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('flex-start'), ";\n        font-size: 12px;\n        font-weight: 400;\n        width: 120px;\n        padding-left: 5px;\n        max-height: 10px;\n        cursor: pointer;\n\n        .label {\n          padding-left: 5px;\n        }\n    }\n\n    div:nth-child(1) {\n      height: 10px;\n    }\n\n    div[class*='svgIconComponent---']: {\n        width: 20px !important;\n    }\n");
});
var SvgWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  return "\n    path {\n      fill: ".concat(props.status ? '#1981c4' : 'black', " !important;\n    }\n  ");
});
var LoaderWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  flex: 1;\n  height: 100%;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var StudentListItemWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-top: 0.01px;\n"])));
var CheckboxWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    width: 40px;\n    height: 100%;\n    background-color: ").concat(colours.grey[200], ";\n\n    > div {\n      margin: 0;\n    }\n");
});
var ContextMenuAction = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _props$theme2 = props.theme,
    colours = _props$theme2.colours,
    palette = _props$theme2.palette;
  /* eslint-disable indent */
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n  width: 100%;\n  height: 30px;\n  padding-left: 10px;\n  color: ").concat(palette.primary.dark, ";\n  border-bottom:  ").concat(!props.last ? "1px solid ".concat(colours.grey[400], ";") : 'none', ";\n  border-top: ").concat(props.first ? "1px solid ".concat(colours.grey[400], ";") : 'none', ";\n  font-size: 12px;\n  cursor: pointer;\n\n  &:hover {\n    background-color: ").concat(colours.grey[100], ";\n  }\n\n  span[class*=\"isvg\"] {\n    margin-right: 10px;\n  }\n");
  /* eslint-enable indent */
});
var StudentDetails = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _props$theme3 = props.theme,
    palette = _props$theme3.palette,
    typography = _props$theme3.typography;
  /* eslint-disable indent */
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n\n  width: 100%;\n  padding: 10px;\n  color: ").concat(palette.primary.dark, ";\n  font-size: ").concat(typography.info.size, ";\n  font-weight: ").concat(typography.info.weight, ";\n");
});
var StudentDetailsRow = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  height: 20px;\n"])));
var StudentName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */])(StudentDetailsRow)(function (props) {
  var typography = props.theme.typography;
  return "\n    font-size: ".concat(typography.info.size, ";\n    font-weight: ").concat(typography.info.weight, ";\n  ");
});
var StudentGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */])(StudentName)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));

/***/ }),

/***/ "73uf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__doughnut_chart_styled__ = __webpack_require__("sVUS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__doughnut_classroom_icon_doughnut_classroom_icon__ = __webpack_require__("sYus");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__doughnut_legend_doughnut_legend__ = __webpack_require__("vTZq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__doughnut_inner_doughnut_inner__ = __webpack_require__("9Ojl");
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }








var Doughnuts = function Doughnuts(_ref) {
  var i18n = _ref.i18n,
    displayChartData = _ref.displayChartData;
  var resultType = displayChartData.resultType,
    classroomPercent = displayChartData.classroomPercent,
    groupPercent = displayChartData.groupPercent,
    studentPercent = displayChartData.studentPercent,
    studentName = displayChartData.studentName,
    truncatedName = displayChartData.truncatedName;
  var percentages = [classroomPercent, groupPercent, studentPercent];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__doughnut_chart_styled__["a" /* DoughnutsWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__doughnut_inner_doughnut_inner__["a" /* default */], _extends({
    i18n: i18n
  }, displayChartData)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__doughnut_chart_styled__["b" /* ClassroomIconWrapper */], {
    type: resultType
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__doughnut_classroom_icon_doughnut_classroom_icon__["a" /* default */], {
    type: resultType,
    i18n: i18n
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__doughnut_chart_styled__["c" /* PercentWrapper */], {
    type: resultType,
    "data-testid": "student-percentage"
  }, percentages[resultType] ? "".concat(percentages[resultType], "%") : 'NA'), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__doughnut_chart_styled__["d" /* AttemptIconWrapper */], {
    type: resultType
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["J" /* AttemptIcon */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__doughnut_chart_styled__["e" /* LegendWrapper */], {
    type: resultType
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__doughnut_legend_doughnut_legend__["a" /* default */], {
    i18n: i18n,
    type: resultType,
    studentName: studentName,
    truncatedName: truncatedName
  })));
};
Doughnuts.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  displayChartData: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    resultType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    studentName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    truncatedName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    studentPercent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    completedActivitiesCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    totalActivitiesCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    groupPercent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    groupActivitiesCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    classroomPercent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    classActivitiesCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  })
};
/* harmony default export */ __webpack_exports__["a"] = (Doughnuts);

/***/ }),

/***/ "78xV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LineChartWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Section1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Section2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Section3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Footer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChartLinesWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ChartLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ChartPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Position; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var LineChartWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  height: 100%;\n  box-sizing: border-box;\n  padding: 2px 0;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'));
var Section1 = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  width: 100%;\n  height: 20%;\n  padding-left: 10px;\n  font-size: 10px;\n  color: #008902;\n  border-bottom: 1px dashed #008902;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('flex-start'));
var Section2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */])(Section1)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  border-bottom: 1px dashed #2452bb;\n  color: #2452bb;\n  height: 35%;\n"])));
var Section3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */])(Section1)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border-bottom: none;\n  color: #900012;\n  height: 50%;\n"])));
var Footer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */])(Section1)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 20px;\n  font-size: 11px;\n  font-weight: 600;\n  color: #000;\n  border-bottom: none;\n"])));
var ChartLinesWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  height: 100%;\n  width: 38px;\n  height: 158px;\n  font-size: 11px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'));
var ChartLine = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 1px;\n  height: 130px;\n  background-color: rgb(207, 207, 207, 0.3);\n"])));
var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  height: 135px;\n  width: inherit;\n  position: absolute;\n  box-sizing: border-box;\n  padding-right: 40px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('flex-end'));
var ChartPoint = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n\n  width: 10px;\n  height: 10px;\n  background-color: ").concat(props.color, ";\n  border-radius: 5px;\n  margin-left: -4px;\n  position: absolute;\n  bottom: ").concat(props.position - 5, "px;\n");
});
var Position = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n        color: ".concat(props.enabled ? colours.grey[700] : colours.grey[100], ";\n    ");
});

/***/ }),

/***/ "7wlH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_list__ = __webpack_require__("UPZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_actions__ = __webpack_require__("+7+H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_resources_helper__ = __webpack_require__("jhKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__toast_toast_action__ = __webpack_require__("fbOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__unassign_all_modal_store_unassign_all_modal_actions__ = __webpack_require__("XAJD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__analytics__ = __webpack_require__("uVVs");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }














function UnassignButton(props) {
  var i18n = props.i18n;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* useDispatch */])();
  var _useTracking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__analytics__["d" /* useTracking */])(),
    trackMenuAction = _useTracking.trackMenuAction;
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    isUnassignActionsOpen = _useState2[0],
    setUnassignActionsOpen = _useState2[1];
  var unassignButtonText = "".concat(i18n._(
  /*i18n*/
  {
    id: "footer.unassign",
    defaults: "Unassign"
  }), " (").concat(props.assignmentsToUnassign.length, ")");
  var unassignActionsListOptions = [{
    icon: __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["c" /* UnAssignIcon */],
    disabled: props.assignmentsToUnassign.length === 0,
    text: i18n._(
    /*i18n*/
    {
      id: "footer.unassign",
      defaults: "Unassign"
    }),
    subtext: i18n._(
    /*i18n*/
    {
      id: "footer.unassignSelectedSub",
      defaults: "Selected student activities"
    }),
    onClick: function onClick() {
      trackMenuAction({
        action: 'unassign'
      });
      handleUnassign();
    }
  }, {
    icon: __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["d" /* IconUnassignAll */],
    text: i18n._(
    /*i18n*/
    {
      id: "footer.unassignAll",
      defaults: "Unassign All"
    }),
    subtext: i18n._(
    /*i18n*/
    {
      id: "footer.unassignEverythingSub",
      defaults: "Everything for this class and group"
    }),
    onClick: function onClick() {
      trackMenuAction({
        action: 'unassign-all'
      });
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_12__unassign_all_modal_store_unassign_all_modal_actions__["b" /* SHOW_UNASSIGN_MODAL */]
      });
    }
  }];
  function handleSuccess() {
    var classroomId = props.classroomId,
      groupId = props.groupId;
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_actions__["b" /* getTopics */])(classroomId, groupId));
    setUnassignActionsOpen(false);
  }
  function handleUnassign() {
    var classroomId = props.classroomId,
      groupId = props.groupId,
      assignmentsToUnassign = props.assignmentsToUnassign;
    __WEBPACK_IMPORTED_MODULE_7__helpers_resources__["a" /* default */].unassign.put({
      classroomId: classroomId,
      groupId: groupId
    }).withBody({
      assignedTaskIdList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_resources_helper__["b" /* retrieveAssignedTaskId */])(assignmentsToUnassign)
    }).send().then(function () {
      handleSuccess();
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__toast_toast_action__["c" /* showToast */])(i18n._(
      /*i18n*/
      {
        id: "footer.unassignSuccess",
        defaults: "Selected student activities have been unassigned"
      }), 'success'));
    }, function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_9__containers_course_assign_course_assign_types__["e" /* ERROR_DETECTED */],
        payload: err
      });
    });
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "unassign"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setUnassignActionsOpen(false);
    },
    forButton: "unassignActions"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "actionsContainer",
    id: "unassignActions",
    "data-testid": "unassign-button"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"], {
    className: "button",
    disabled: props.actionInProgress,
    primary: true,
    text: unassignButtonText,
    type: __WEBPACK_IMPORTED_MODULE_2__3plearning_react_components__["Button"].LOZENGE,
    onClick: function onClick() {
      return setUnassignActionsOpen(!isUnassignActionsOpen);
    },
    alignIcon: "LEFT",
    icon: __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["c" /* UnAssignIcon */]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__actions_list__["a" /* default */], {
    options: unassignActionsListOptions,
    isOpen: isUnassignActionsOpen,
    isWide: true,
    shouldOpenUp: true
  }))));
}
UnassignButton.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  actionInProgress: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  assignmentsToUnassign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object),
  classroomId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  groupId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
/* harmony default export */ __webpack_exports__["a"] = (UnassignButton);

/***/ }),

/***/ "9Ojl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__doughnut_inner_hooks__ = __webpack_require__("rHNI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__doughnut_tooltip_doughnut_tooltip__ = __webpack_require__("e6Ie");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__doughnut_chart_styled__ = __webpack_require__("sVUS");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }






var DoughnutsInner = function DoughnutsInner(_ref) {
  var i18n = _ref.i18n,
    classroomPercent = _ref.classroomPercent,
    groupPercent = _ref.groupPercent,
    studentPercent = _ref.studentPercent,
    resultType = _ref.resultType,
    groupActivitiesCount = _ref.groupActivitiesCount,
    classActivitiesCount = _ref.classActivitiesCount,
    completedActivitiesCount = _ref.completedActivitiesCount,
    totalActivitiesCount = _ref.totalActivitiesCount;
  var _useClassroomDoughnut = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__doughnut_inner_hooks__["a" /* useClassroomDoughnuts */])({
      resultType: resultType,
      studentPercent: studentPercent,
      groupPercent: groupPercent,
      groupActivitiesCount: groupActivitiesCount,
      classroomPercent: classroomPercent
    }),
    _useClassroomDoughnut2 = _slicedToArray(_useClassroomDoughnut, 2),
    AllDoughnuts = _useClassroomDoughnut2[0],
    _useClassroomDoughnut3 = _useClassroomDoughnut2[1],
    doughnutType = _useClassroomDoughnut3.doughnutType,
    mouseState = _useClassroomDoughnut3.mouseState;
  var modalWidth = 220;
  var classContextPos = 160;
  var contextOffset = __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["o" /* doughnutWidth */] + (resultType === __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["k" /* STUDENT */] ? __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["p" /* doughnutGap */] / 2 : __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["p" /* doughnutGap */]);
  var contextModalYPos = classContextPos - doughnutType * contextOffset;
  var percentages = [classroomPercent, groupPercent, studentPercent];
  var renderTooltip = function renderTooltip() {
    switch (doughnutType) {
      case __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["k" /* STUDENT */]:
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__doughnut_chart_styled__["f" /* ContextModalContent */], {
          "data-testid": "hover-context"
        }, "".concat(percentages[doughnutType], "% "), i18n._(
        /*i18n*/
        {
          id: "doughnut-tooltip-average-from",
          defaults: "average from"
        }), " ".concat(completedActivitiesCount, " "), i18n._(
        /*i18n*/
        {
          id: "doughnut-tooltip-activities-completed-out-of",
          defaults: "activities completed out of"
        }), " ".concat(totalActivitiesCount));
      case __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["q" /* GROUP */]:
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__doughnut_chart_styled__["f" /* ContextModalContent */], {
          "data-testid": "hover-context"
        }, "".concat(percentages[doughnutType], "% "), i18n._(
        /*i18n*/
        {
          id: "doughnut-tooltip-average-from",
          defaults: "average from"
        }), " ".concat(groupActivitiesCount, " "), i18n._(
        /*i18n*/
        {
          id: "doughnut-tooltip-activities-completed",
          defaults: " activities completed"
        }));
      case __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["r" /* CLASSROOM */]:
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__doughnut_chart_styled__["f" /* ContextModalContent */], {
          "data-testid": "hover-context"
        }, "".concat(percentages[doughnutType], "% "), i18n._(
        /*i18n*/
        {
          id: "doughnut-tooltip-average-from",
          defaults: "average from"
        }), " ".concat(classActivitiesCount, " "), i18n._(
        /*i18n*/
        {
          id: "doughnut-tooltip-activities-completed",
          defaults: " activities completed"
        }));
      default:
        return null;
    }
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
    "data-testid": "content",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    height: "160",
    width: "160",
    className: "doughnut-svg"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AllDoughnuts, null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__doughnut_tooltip_doughnut_tooltip__["a" /* default */], {
    show: mouseState !== __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["s" /* MOUSE_STATE_LEAVE */],
    positionArrow: modalWidth / 2,
    positionX: 0,
    positionY: contextModalYPos,
    fixedParent: true,
    contextTheme: "standard",
    name: renderTooltip(),
    modalWidth: modalWidth
  }));
};
DoughnutsInner.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  resultType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  studentPercent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  completedActivitiesCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  totalActivitiesCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  groupPercent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  groupActivitiesCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  classroomPercent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  classActivitiesCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
/* harmony default export */ __webpack_exports__["a"] = (DoughnutsInner);

/***/ }),

/***/ "9X0T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__ = __webpack_require__("y11q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }










var QuickSelector = function QuickSelector(_ref) {
  var i18n = _ref.i18n;
  var infoRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    showContextMenu = _useState2[0],
    setShowContextMenu = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState4 = _slicedToArray(_useState3, 2),
    arrowPosition = _useState4[0],
    setArrowPosition = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState6 = _slicedToArray(_useState5, 2),
    positionXCallout = _useState6[0],
    setPositionXCallout = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState8 = _slicedToArray(_useState7, 2),
    positionYCallout = _useState8[0],
    setPositionYCallout = _useState8[1];
  var showContextModal = function showContextModal(e) {
    var _getContextCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_utils__["e" /* getContextCoords */])(e, __WEBPACK_IMPORTED_MODULE_6__context_modal__["a" /* ContextModalWidth */]),
      posX = _getContextCoords.posX,
      posArrow = _getContextCoords.posArrow;
    var _infoRef$current$getB = infoRef.current.getBoundingClientRect(),
      bottom = _infoRef$current$getB.bottom;
    setPositionYCallout(bottom);
    setPositionXCallout(posX);
    setArrowPosition(posArrow);
    setShowContextMenu(true);
  };
  var handleOnSelect = function handleOnSelect(selectionType) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_9__containers_course_assign_course_assign_types__["B" /* QUICK_SELECTION */],
      selectionType: selectionType
    });
    setShowContextMenu(false);
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["a" /* QuickSelectorWrapper */], {
    "data-testid": "quickselector"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["b" /* QuickSelectorToggleButton */], {
    onClick: showContextModal,
    ref: infoRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["B" /* Bolt */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setShowContextMenu(false);
    },
    forButton: "quickSelector"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__context_modal__["b" /* default */], {
    show: showContextMenu,
    positionArrow: arrowPosition,
    positionX: positionXCallout,
    positionY: positionYCallout
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["c" /* QuickSelectorHeader */], null, i18n._(
  /*i18n*/
  {
    id: "quickSelector.select",
    defaults: "Select..."
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["d" /* QuickSelectorRow */], {
    onClick: function onClick() {
      return handleOnSelect('allCells');
    },
    "data-testid": "quick-select-all-cells",
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["e" /* AllCellsIcon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["l" /* Select */]
  })), i18n._(
  /*i18n*/
  {
    id: "quickSelector.allCells",
    defaults: "All Cells"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["d" /* QuickSelectorRow */], {
    "data-testid": "quick-select-all-assigned",
    onClick: function onClick() {
      return handleOnSelect('allAssigned');
    },
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["f" /* ColorBlock */], {
    colorType: 'allAssigned'
  }), i18n._(
  /*i18n*/
  {
    id: "quickSelector.allAssigned",
    defaults: "All Assigned"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["d" /* QuickSelectorRow */], {
    "data-testid": "quick-select-50-or-less",
    onClick: function onClick() {
      return handleOnSelect('result50');
    },
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["f" /* ColorBlock */], {
    colorType: 'result50'
  }), i18n._(
  /*i18n*/
  {
    id: "quickSelector.results50",
    defaults: "Results <= 50%"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["d" /* QuickSelectorRow */], {
    "data-testid": "quick-select-85",
    onClick: function onClick() {
      return handleOnSelect('result85');
    },
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["f" /* ColorBlock */], {
    colorType: 'result85'
  }), i18n._(
  /*i18n*/
  {
    id: "quickSelector.results85",
    defaults: "Results >50 - 85%<"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["d" /* QuickSelectorRow */], {
    "data-testid": "quick-select-100",
    onClick: function onClick() {
      return handleOnSelect('result100');
    },
    role: "button",
    tabIndex: "-1"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["f" /* ColorBlock */], {
    colorType: 'result100'
  }), i18n._(
  /*i18n*/
  {
    id: "quickSelector.results100",
    defaults: "Results >= 85%"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__quick_selector_styled__["g" /* QuickSelectorClearSelections */], {
    onClick: function onClick() {
      return handleOnSelect('clearSelections');
    },
    role: "button",
    tabIndex: "-1"
  }, i18n._(
  /*i18n*/
  {
    id: "quickSelector.clearSelections",
    defaults: "Clear Selections"
  })))));
};
QuickSelector.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (QuickSelector);

/***/ }),

/***/ "9nCL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_inlinesvg__ = __webpack_require__("Bl3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toast_toast_action__ = __webpack_require__("fbOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_course_assign_course_assign_actions__ = __webpack_require__("+7+H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__checkbox_constants__ = __webpack_require__("IzlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assigned_list_item_assigned_list_item__ = __webpack_require__("SEp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__checkbox__ = __webpack_require__("4YSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__student_list_util__ = __webpack_require__("OG0p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__ = __webpack_require__("WjZn");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


















var AssignedList = function AssignedList(_ref) {
  var i18n = _ref.i18n,
    assignmentList = _ref.assignmentList,
    studentName = _ref.studentName;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* useDispatch */])();
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('desc'),
    _useState2 = _slicedToArray(_useState, 2),
    direction = _useState2[0],
    setDirection = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(assignmentList),
    _useState4 = _slicedToArray(_useState3, 2),
    activityList = _useState4[0],
    setActivityList = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
    _useState6 = _slicedToArray(_useState5, 2),
    unAssignedList = _useState6[0],
    setUnAssignedList = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])('direction'),
    _useState8 = _slicedToArray(_useState7, 2),
    sortingProp = _useState8[0],
    setSortingProp = _useState8[1];
  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState0 = _slicedToArray(_useState9, 2),
    selectAllValue = _useState0[0],
    setSelectAllValue = _useState0[1];
  var _useState1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isButtonDisabled = _useState10[0],
    setIsButtonDisabled = _useState10[1];
  var showToastText = i18n._(
  /*i18n*/
  {
    id: "assignedTab.unassignSuccess",
    defaults: "activities are unassigned from"
  }).concat(' ', studentName);
  var classroomId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var groupId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var sortDirection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.sortDirection;
  });
  function handleSuccess() {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_course_assign_course_assign_actions__["b" /* getTopics */])(classroomId, groupId));
  }
  var handleOnUnassign = function handleOnUnassign() {
    var listOfActivitiesToUnassign = Object.keys(unAssignedList);
    var assignedTaskIdList = listOfActivitiesToUnassign.map(function (activity) {
      var info = unAssignedList[activity];
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers_utils__["c" /* isDefined */])(info) ? info.assignedTaskId : false;
    }).filter(function (item) {
      return item !== false;
    });
    __WEBPACK_IMPORTED_MODULE_5__helpers_resources__["a" /* default */].unassign.put({
      classroomId: classroomId,
      groupId: groupId
    }).withBody({
      assignedTaskIdList: assignedTaskIdList
    }).send().then(function () {
      handleSuccess();
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toast_toast_action__["c" /* showToast */])("".concat(assignedTaskIdList.length, " ").concat(showToastText), 'success'));
    }, function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["e" /* ERROR_DETECTED */],
        payload: err
      });
    });
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_8__containers_modal_manager_modal_manager_actions__["b" /* DISMISS_MODAL */]
    });
  };
  var sortHandler = function sortHandler() {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["d" /* UPDATE_SORT_PROPERTIES */],
      direction: sortDirection === 'asc' ? 'desc' : 'asc',
      sortValue: 'activityName'
    });
    if (direction === 'asc') {
      setDirection('desc');
    } else {
      setDirection('asc');
    }
    var sortedList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__student_list_util__["a" /* customSort */])(activityList, 'activityName', sortDirection === 'asc' ? 'desc' : 'asc');
    setActivityList(sortedList);
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["c" /* UPDATE_SORTED_ASSIGNED_LIST */],
      activityList: sortedList
    });
    setSortingProp('direction');
  };
  var handleSortingArrow = function handleSortingArrow(dir, isActive) {
    var icon = dir === 'asc' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__svg_icon_svg_icon__["a" /* default */], {
      icon: __WEBPACK_IMPORTED_MODULE_14__helpers_icon_dictionary__["z" /* DownArrow */]
    }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__svg_icon_svg_icon__["a" /* default */], {
      icon: __WEBPACK_IMPORTED_MODULE_14__helpers_icon_dictionary__["A" /* UpArrow */]
    });
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["a" /* SvgWrapper */], {
      status: isActive
    }, icon);
  };

  // To select all the activities
  var selectAllCheckboxHandler = function selectAllCheckboxHandler() {
    var filteredActivityIds = _objectSpread({}, unAssignedList);
    var newSelectValue = !selectAllValue;
    for (var index in activityList) {
      if (newSelectValue) {
        filteredActivityIds[index] = activityList[index];
      } else {
        filteredActivityIds[index] = undefined;
      }
    }
    setUnAssignedList(filteredActivityIds);
    // Reverse the value of the select all
    setSelectAllValue(newSelectValue);
  };

  // To select individual activity
  var individualCheckboxHandler = function individualCheckboxHandler(actionType, index) {
    var filteredActivityIds = _objectSpread(_objectSpread({}, unAssignedList), {}, _defineProperty({}, index, actionType === 'checked' ? activityList[index] : undefined));
    setUnAssignedList(filteredActivityIds);
    var tempSelectedActivity = Object.values(filteredActivityIds).filter(function (item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers_utils__["c" /* isDefined */])(item);
    });

    // test if the checkbox conflicts with the select all
    if (activityList.length !== tempSelectedActivity.length) {
      setSelectAllValue(false);
    }
  };
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var selectedActivitiesLength = Object.values(unAssignedList).filter(function (item) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers_utils__["c" /* isDefined */])(item);
    });
    setIsButtonDisabled(selectedActivitiesLength.length === 0);
  }, [unAssignedList]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["b" /* AssignedWrapper */], {
    id: "activityList"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["c" /* ResultsWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["d" /* HeaderContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["e" /* ActivityHeader */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["f" /* CheckboxWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__checkbox__["a" /* default */], {
    id: "select-all-checkbox",
    checkboxHandler: selectAllCheckboxHandler,
    state: selectAllValue ? __WEBPACK_IMPORTED_MODULE_10__checkbox_constants__["b" /* CHECKED */] : __WEBPACK_IMPORTED_MODULE_10__checkbox_constants__["a" /* UNCHECKED */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["g" /* ActivityTitle */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    "data-testid": "assignedTab-title",
    className: "title",
    role: "button",
    tabIndex: "-1",
    onClick: sortHandler
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "label",
    "data-testid": "name-label"
  }, i18n._(
  /*i18n*/
  {
    id: "assignedTab.Activity",
    defaults: "Activity"
  })), handleSortingArrow(sortDirection, sortingProp === 'direction')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["h" /* StatusHeader */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    "data-testid": "assignedTab-status"
  }, i18n._(
  /*i18n*/
  {
    id: "assignedTab.Status",
    defaults: "Status"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["h" /* StatusHeader */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    "data-testid": "assignedTab-started"
  }, i18n._(
  /*i18n*/
  {
    id: "assignedTab.Started",
    defaults: "Started"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["h" /* StatusHeader */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    "data-testid": "assignedTab-due"
  }, i18n._(
  /*i18n*/
  {
    id: "assignedTab.Due",
    defaults: "Due"
  })))), activityList.length ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["i" /* AssignedListWrapper */], {
    "data-testid": "assigned-list"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["j" /* Body */], null, activityList.map(function (row, index) {
    var checkboxChecked = _typeof(unAssignedList[index]) === 'object';
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__assigned_list_item_assigned_list_item__["a" /* default */], {
      i18n: i18n,
      key: row.assignedTaskId,
      index: index,
      onCheckboxChange: individualCheckboxHandler,
      assignedListItem: row,
      isSelected: checkboxChecked
    });
  }))) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["k" /* NoDataView */], {
    "data-testid": "no-data-view"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_inlinesvg__["a" /* default */], {
    src: __WEBPACK_IMPORTED_MODULE_14__helpers_icon_dictionary__["E" /* StudentIcon */],
    cacheGetRequests: true
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, i18n._(
  /*i18n*/
  {
    id: "assignedTab.noDataMainParagraph",
    defaults: "There are currently no Course activities assigned to this student."
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", null, i18n._(
  /*i18n*/
  {
    id: "assignedTab.noDataSubParagraph",
    defaults: "Once assigned, you can quickly monitor the status of activities here."
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["l" /* Footer */], {
    "data-testid": "footer"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["m" /* UnAssignButtonContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__["Button"], {
    className: "unassign",
    primary: true,
    text: i18n._(
    /*i18n*/
    {
      id: "assignedTab.UnassignButton",
      defaults: "Unassign"
    }),
    type: __WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__["Button"].LOZENGE,
    onClick: handleOnUnassign,
    disabled: isButtonDisabled
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__assigned_list_styled__["n" /* OkButtonContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__["Button"], {
    className: "button",
    primary: true,
    text: i18n._(
    /*i18n*/
    {
      id: "assignedTab.OkButton",
      defaults: "OK"
    }),
    type: __WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__["Button"].LOZENGE,
    onClick: function onClick() {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_8__containers_modal_manager_modal_manager_actions__["b" /* DISMISS_MODAL */]
      });
    }
  }))));
};
AssignedList.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  assignmentList: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  studentName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (AssignedList);

/***/ }),

/***/ "9nk/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_use_analytics__ = __webpack_require__("dGCJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__("krZk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util__ = __webpack_require__("ZArm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__topic_info__ = __webpack_require__("GGmR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_actions__ = __webpack_require__("+7+H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__toast_toast_action__ = __webpack_require__("fbOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_locale__ = __webpack_require__("ZhO1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__analytics__ = __webpack_require__("uVVs");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


















function ActivityHeader(_ref) {
  var externalKey = _ref.externalKey,
    activity = _ref.activity,
    i18n = _ref.i18n,
    studentAssignmentIndexes = _ref.studentAssignmentIndexes;
  // Do not show preview or teacher notes for these activities
  var blackListedActivities = ['Are you ready?', 'Test'];
  var _useAnalytics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_use_analytics__["b" /* useAnalytics */])(),
    track = _useAnalytics.track;
  var assignFlow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__analytics__["b" /* useAssignmentFlowTracking */])('assign');
  var _useTracking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__analytics__["d" /* useTracking */])(),
    trackActivityPreview = _useTracking.trackActivityPreview,
    trackActivityTeacherNotes = _useTracking.trackActivityTeacherNotes;
  var assignmentStatuses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    var _state$CourseAssignRe;
    return (_state$CourseAssignRe = state.CourseAssignReducer) === null || _state$CourseAssignRe === void 0 ? void 0 : _state$CourseAssignRe.assignmentStatuses;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var classrooms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    var _state$CourseAssignRe2;
    return (_state$CourseAssignRe2 = state.CourseAssignReducer) === null || _state$CourseAssignRe2 === void 0 ? void 0 : _state$CourseAssignRe2.classrooms;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var courseID = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeCourseID;
  });
  var classroomId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var groupId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var studentAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return studentAssignmentIndexes.map(function (x) {
      var _state$CourseAssignRe3;
      return (_state$CourseAssignRe3 = state.CourseAssignReducer) === null || _state$CourseAssignRe3 === void 0 || (_state$CourseAssignRe3 = _state$CourseAssignRe3.assignments) === null || _state$CourseAssignRe3 === void 0 ? void 0 : _state$CourseAssignRe3.studentAssignments[x];
    });
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var datePreference = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    var _state$CourseAssignRe4;
    return ((_state$CourseAssignRe4 = state.CourseAssignReducer) === null || _state$CourseAssignRe4 === void 0 ? void 0 : _state$CourseAssignRe4.datePreference) || [];
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var isBlackListed = blackListedActivities.map(function (blackListed) {
    return activity.activityName === blackListed;
  }).reduce(function (prev, next) {
    return prev || next;
  });
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    showContextMenu = _useState2[0],
    setContextMenu = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    callOut = _useState4[0],
    setCallOut = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState6 = _slicedToArray(_useState5, 2),
    positionX = _useState6[0],
    setPositionX = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState8 = _slicedToArray(_useState7, 2),
    positionY = _useState8[0],
    setPositionY = _useState8[1];
  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState0 = _slicedToArray(_useState9, 2),
    loading = _useState0[0],
    setLoading = _useState0[1];
  var _useState1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState10 = _slicedToArray(_useState1, 2),
    positionArrow = _useState10[0],
    setPositionArrow = _useState10[1];
  var _useState11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState12 = _slicedToArray(_useState11, 2),
    positionXCallout = _useState12[0],
    setPositionXCallout = _useState12[1];
  var _useState13 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState14 = _slicedToArray(_useState13, 2),
    positionYCallout = _useState14[0],
    setPositionYCallout = _useState14[1];
  var _useState15 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState16 = _slicedToArray(_useState15, 2),
    positionArrowCallout = _useState16[0],
    setPositionArrowCallout = _useState16[1];
  var _useState17 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState18 = _slicedToArray(_useState17, 2),
    contextTheme = _useState18[0],
    setContextTheme = _useState18[1];
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var ljRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var titleRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var helpSeekingStudents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util__["a" /* getStudents */])(activity.activityId, assignmentStatuses, classrooms);
  function handleEllipsis() {
    // Multi-Line ellipsis
    if (titleRef.current.innerHTML) {
      var wordArray = titleRef.current.innerHTML.split(' ');
      while (titleRef.current.scrollHeight > titleRef.current.offsetHeight) {
        wordArray.pop();
        titleRef.current.innerHTML = "".concat(wordArray.join(' '), "...");
      }
    }
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    handleEllipsis();
  }, []);
  var showContextModal = function showContextModal() {
    var _getContextCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_utils__["e" /* getContextCoords */])(ljRef.current.getBoundingClientRect(), __WEBPACK_IMPORTED_MODULE_9__context_modal__["a" /* ContextModalWidth */]),
      posX = _getContextCoords.posX,
      posY = _getContextCoords.posY,
      posArrow = _getContextCoords.posArrow;
    setPositionY(posY);
    setPositionX(posX);
    setPositionArrow(posArrow);
    setContextMenu(true);
    setContextTheme(null);
    setCallOut(false);
  };
  var openPreviewActivity = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!isBlackListed) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            trackActivityPreview({
              activityId: activity.activityId
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_utils__["b" /* getConfiguration */])('ActivityPreviewUrl').then(function (ActivityPreviewUrl) {
              window.open("".concat(ActivityPreviewUrl).concat(activity.activityId, "?locale=").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__helpers_locale__["a" /* getLocale */])() || 'en-AU', "&token=").concat(__WEBPACK_IMPORTED_MODULE_16__helpers_resources__["a" /* default */].env.authToken), '_blank').focus();
            });
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function openPreviewActivity() {
      return _ref2.apply(this, arguments);
    };
  }();
  var openTeacherNotes = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            if (!isBlackListed) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            trackActivityTeacherNotes({
              activityId: activity.activityId
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_utils__["b" /* getConfiguration */])('ActivityTeacherGuideUrl').then(function (ActivityTeacherGuideUrl) {
              window.open("".concat(ActivityTeacherGuideUrl).concat(activity.activityId, ".pdf"), '_blank').focus();
            });
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function openTeacherNotes() {
      return _ref3.apply(this, arguments);
    };
  }();
  var showCallOut = function showCallOut() {
    if (showContextMenu) {
      return;
    }
    var _getContextCoords2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_utils__["e" /* getContextCoords */])(ljRef.current.getBoundingClientRect(), __WEBPACK_IMPORTED_MODULE_9__context_modal__["a" /* ContextModalWidth */]),
      posX = _getContextCoords2.posX,
      posY = _getContextCoords2.posY,
      posArrow = _getContextCoords2.posArrow;
    setPositionYCallout(posY);
    setPositionXCallout(posX);
    setPositionArrowCallout(posArrow);
    setContextTheme('learningJourney');
    setCallOut(true);
  };
  var hideCallOut = function hideCallOut() {
    setCallOut(false);
  };
  var handleSelect = function handleSelect(event) {
    event.stopPropagation();
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_14__containers_course_assign_course_assign_types__["m" /* GRID_CELL_SELECTION */],
      isActivity: true,
      indexes: studentAssignmentIndexes,
      studentId: 0,
      activity: activity,
      status: 'checked'
    });
    setContextMenu(false);
  };
  var handleAssign = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(event) {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            event.stopPropagation();
            if (!loading) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            setLoading(true);
            assignFlow.start({
              target: 'class',
              activityCount: 1,
              studentCount: studentAssignments.length
            });
            _context3.n = 2;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util__["b" /* assignActivityToAllStudents */])(studentAssignments, classroomId, groupId, courseID, datePreference[0], datePreference[1]).then(function (wasSuccessful) {
              setLoading(false);
              if (wasSuccessful) {
                track('ActivityAssigned');
                assignFlow.confirm({
                  target: 'class',
                  activityCount: 1,
                  studentCount: studentAssignments.length
                });
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_actions__["b" /* getTopics */])(classroomId, groupId));
                dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__toast_toast_action__["c" /* showToast */])(i18n._(
                /*i18n*/
                {
                  id: "footer.assignSuccess",
                  defaults: "Selected student activities have been assigned"
                }), 'success'));
              } else {
                dispatch({
                  type: __WEBPACK_IMPORTED_MODULE_14__containers_course_assign_course_assign_types__["e" /* ERROR_DETECTED */],
                  payload: 'Unable to assign activity to all students'
                });
              }
            });
          case 2:
            setContextMenu(false);
          case 3:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function handleAssign(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["b" /* Wrapper */], {
    onClick: showContextModal,
    ref: ljRef,
    "data-testid": "activity-header"
  }, helpSeekingStudents.length > 0 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["c" /* Help */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "iconWrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__["w" /* MessageBubble */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "number"
  }, helpSeekingStudents.length)) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["d" /* Icon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__["e" /* StandardDropdown */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["e" /* Name */], {
    "data-testid": "activity-header-name",
    ref: titleRef,
    onMouseEnter: showCallOut,
    onMouseLeave: hideCallOut
  }, activity.activityName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setContextMenu(false);
    },
    forButton: "showContextModal_".concat(activity.activityId)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__context_modal__["b" /* default */], {
    show: showContextMenu,
    positionArrow: positionArrow,
    positionX: positionX,
    positionY: positionY
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__topic_info__["a" /* default */], {
    standardName: externalKey,
    externalKey: activity.activityName,
    displayHideOption: false
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* ContextMenuAction */], {
    "data-testid": "select-all",
    role: "button",
    first: true,
    tabIndex: "-1",
    onClick: handleSelect
  }, i18n._("Select")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* ContextMenuAction */], {
    "data-testid": "assign-to-all",
    role: "button",
    tabIndex: "-1",
    onClick: handleAssign
  }, i18n._("Assign to all students")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* ContextMenuAction */], {
    "data-testid": "teacher-notes",
    role: "button",
    tabIndex: "-1",
    blackListed: isBlackListed,
    onClick: openTeacherNotes
  }, i18n._("Teacher notes")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* ContextMenuAction */], {
    "data-testid": "preview-activity",
    role: "button",
    tabIndex: "-1",
    last: true,
    blackListed: isBlackListed,
    onClick: openPreviewActivity
  }, i18n._("Preview activity"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__context_modal__["b" /* default */], {
    show: callOut,
    positionArrow: positionArrowCallout,
    positionX: positionXCallout,
    positionY: positionYCallout,
    contextTheme: contextTheme,
    name: activity.activityName
  })));
}
ActivityHeader.propTypes = {
  activity: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  externalKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  studentAssignmentIndexes: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number).isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (ActivityHeader);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("hKoQ")))

/***/ }),

/***/ "9sdx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("QPJc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__topic__ = __webpack_require__("UbpQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pulse_loader__ = __webpack_require__("oWNv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__empty_state__ = __webpack_require__("nS47");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }








var Topics = function Topics(props) {
  var _assignments$studentA;
  var showGridLoader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.showGridLoader;
  });
  var gridTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.gridTopics;
  }, __WEBPACK_IMPORTED_MODULE_2_react_redux__["d" /* shallowEqual */]);
  var assignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.assignments;
  }, __WEBPACK_IMPORTED_MODULE_2_react_redux__["d" /* shallowEqual */]);
  var isTopicCollapsed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.isTopicCollapsed;
  });
  var isTopicDirty = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.isTopicDirty;
  });
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(isTopicCollapsed),
    _useState2 = _slicedToArray(_useState, 2),
    isStandardsCollapsed = _useState2[0],
    setIsStandardsCollapsed = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(isTopicDirty),
    _useState4 = _slicedToArray(_useState3, 2),
    isStandardDirty = _useState4[0],
    setIsStandardDirty = _useState4[1];
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (isStandardsCollapsed !== isTopicCollapsed) {
      setIsStandardsCollapsed(isTopicCollapsed);
      setIsStandardDirty(false);
    }
  }, [isStandardsCollapsed, isTopicCollapsed]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (isStandardDirty !== isTopicDirty) {
      setIsStandardDirty(isTopicDirty);
    }
  }, [isStandardDirty, isTopicDirty]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var activities = (gridTopics === null || gridTopics === void 0 ? void 0 : gridTopics.length) && (gridTopics === null || gridTopics === void 0 ? void 0 : gridTopics.map(function (topic) {
      var checkedNormal = topic.checkedNormal,
        selected = topic.selected,
        coreActivities = topic.coreActivities,
        easierActivities = topic.easierActivities;
      var selectedTopic = checkedNormal ? coreActivities : easierActivities;
      return selectedTopic && selectedTopic.length && selected ? [].concat(_toConsumableArray(selectedTopic), _toConsumableArray(activities !== null && activities !== void 0 && activities.length ? activities : [])) : null;
    })) || [];
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["w" /* UPDATE_SELECTED_ACTIVITIES */],
      activities: activities
    });
  }, [dispatch, gridTopics]);
  if (showGridLoader) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* GridContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* LoaderContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__pulse_loader__["a" /* default */], null)));
  }
  if ((assignments === null || assignments === void 0 || (_assignments$studentA = assignments.studentAssignments) === null || _assignments$studentA === void 0 ? void 0 : _assignments$studentA.length) === 0) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* GridContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* LoaderContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__empty_state__["a" /* default */], {
      i18n: props.i18n
    })));
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* RightSection */], {
    onScroll: function onScroll(e) {
      if (document.getElementById('studentList')) {
        document.getElementById('studentList').scrollTop = e.target.scrollTop;
      }
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["d" /* Wrapper */], {
    id: "standards"
  }, (gridTopics === null || gridTopics === void 0 ? void 0 : gridTopics.length) && (gridTopics === null || gridTopics === void 0 ? void 0 : gridTopics.map(function (topic) {
    var topicId = topic.topicId,
      topicName = topic.topicName,
      checkedNormal = topic.checkedNormal,
      selected = topic.selected,
      coreActivities = topic.coreActivities,
      easierActivities = topic.easierActivities;
    var selectedTopic = checkedNormal ? coreActivities : easierActivities;
    if (selectedTopic && selectedTopic.length && selected) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__topic__["a" /* default */], {
        id: topicId,
        i18n: props.i18n,
        collapseAllStandards: isStandardsCollapsed,
        isTopicDirty: isStandardDirty,
        setIsStandardDirty: setIsStandardDirty,
        topicName: topicName,
        activities: selectedTopic,
        key: topicName
      });
    }
    return null;
  }))));
};
Topics.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
Topics.defaultProps = {
  gridTopics: []
};
/* harmony default export */ __webpack_exports__["a"] = (Topics);

/***/ }),

/***/ "AgQo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal_manager_actions__ = __webpack_require__("WnpN");
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }

/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__modal_manager_actions__["a" /* ACTIVATE_MODAL */]:
      {
        return [].concat(_toConsumableArray(state), [action.modal]);
      }
    case __WEBPACK_IMPORTED_MODULE_0__modal_manager_actions__["b" /* DISMISS_MODAL */]:
      {
        return state.filter(function (_, i) {
          return i !== state.length - 1;
        });
      }
    default:
      break;
  }
  return state;
});

/***/ }),

/***/ "B7He":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("awYd");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./entry-app.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./entry-app.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "BiE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var DateHelper = /*#__PURE__*/function () {
  function DateHelper() {
    _classCallCheck(this, DateHelper);
  }
  return _createClass(DateHelper, null, [{
    key: "getPreviousMonday",
    value: function getPreviousMonday(date) {
      var prevMonday = date ? new Date(date) : new Date();
      prevMonday.setDate(prevMonday.getDate() - (prevMonday.getDay() + 6) % 7);
      return prevMonday;
    }
  }, {
    key: "getThisWeekStartEnd",
    value: function getThisWeekStartEnd() {
      var formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';
      var thisMonday = DateHelper.getPreviousMonday();
      var startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(thisMonday).format(formatString);
      var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(thisMonday).add(6, 'days').format(formatString);
      return {
        startDate: startDate,
        endDate: endDate
      };
    }
  }, {
    key: "getLastWeekStartEnd",
    value: function getLastWeekStartEnd() {
      var formatString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'YYYY-MM-DD';
      var thisMonday = DateHelper.getPreviousMonday();
      var startDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(thisMonday).subtract(7, 'days').format(formatString);
      var endDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(thisMonday).subtract(1, 'days').format(formatString);
      return {
        startDate: startDate,
        endDate: endDate
      };
    }
  }]);
}();


/***/ }),

/***/ "BzJZ":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),

/***/ "CPWM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_ASSIGN_LATER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIDE_ASSIGN_LATER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SUBMIT_ASSIGN_LATER; });
// Action Types
var SHOW_ASSIGN_LATER = 'SHOW_ASSIGN_LATER';
var HIDE_ASSIGN_LATER = 'HIDE_ASSIGN_LATER';
var SUBMIT_ASSIGN_LATER = 'SUBMIT_ASSIGN_LATER';

/***/ }),

/***/ "CVOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = summarizeAssignments;
// Derives distinct activity and student counts from a list of selected grid
// cells. Each cell carries activityId and encryptedUserProfileId.
function summarizeAssignments(list) {
  var items = list || [];
  var activityIds = new Set();
  var studentIds = new Set();
  items.forEach(function (item) {
    if (item.activityId !== undefined && item.activityId !== null) {
      activityIds.add(item.activityId);
    }
    if (item.encryptedUserProfileId) {
      studentIds.add(item.encryptedUserProfileId);
    }
  });
  return {
    activityCount: activityIds.size || items.length,
    studentCount: studentIds.size
  };
}

/***/ }),

/***/ "Dr7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_mx_teacher_analytics__ = __webpack_require__("2HaB");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ASSIGNMENT = 'assignment';
var SWITCH = 'switch';
var FILTERS = 'filters';
var UI = 'ui';
var MENU = 'menu';
var ACCESS = 'access';
var ACTIVITY = 'activity';
var STUDENT = 'student';

// Mirrors the combined-assign-review event taxonomy so both assign apps emit
// comparable events. Event prop shapes are documented in ANALYTICS.md.
var appEvents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__3plearning_mx_teacher_analytics__["c" /* defineEvents */])(_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__3plearning_mx_teacher_analytics__["d" /* SHARED_EVENTS */]), {}, {
  'assignment.flow-started': {
    group: ASSIGNMENT,
    props: {}
  },
  'assignment.confirmation': {
    group: ASSIGNMENT,
    props: {}
  },
  'switch.to-old-assign': {
    group: SWITCH,
    props: {}
  },
  'filter.class-changed': {
    group: FILTERS,
    props: {}
  },
  'filter.group-changed': {
    group: FILTERS,
    props: {}
  },
  'filter.topic-applied': {
    group: FILTERS,
    props: {}
  },
  'ui.how-it-works': {
    group: UI,
    props: {}
  },
  'ui.view-key': {
    group: UI,
    props: {}
  },
  'menu.action': {
    group: MENU,
    props: {}
  },
  'access.changed': {
    group: ACCESS,
    props: {}
  },
  'activity.preview': {
    group: ACTIVITY,
    props: {}
  },
  'activity.teacher-notes': {
    group: ACTIVITY,
    props: {}
  },
  'student.menu': {
    group: STUDENT,
    props: {}
  }
}));
/* harmony default export */ __webpack_exports__["a"] = (appEvents);

/***/ }),

/***/ "DuCv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getClassrooms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getStudents; });
/* unused harmony export setDefaultValues */
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var getClassrooms = function getClassrooms() {
  var classrooms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var options = classrooms.map(function (item) {
    return {
      value: item.classroomId || '',
      label: item.name || ''
    };
  });
  return options;
};
var getGroups = function getGroups() {
  var classId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var classrooms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var classroom = classrooms.find(function (classItem) {
    return classItem.classroomId === Number(classId);
  });
  if (!classroom) classroom = classrooms[0];
  if (classroom && classroom.groups && classroom.groups instanceof Array) {
    var options = classroom.groups.map(function (item) {
      return {
        value: item.groupId,
        label: item.name
      };
    });
    options.sort(function (a, b) {
      return a.label.localeCompare(b.label);
    });
    return options;
  }
  return [];
};
var getStudents = function getStudents(classId, groupId, classrooms) {
  var classroom = classrooms.find(function (c) {
    return c.classroomId === classId;
  });
  if (groupId === '-1') {
    var students = [];
    var _iterator = _createForOfIteratorHelper(classroom.groups),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _group = _step.value;
        var _iterator2 = _createForOfIteratorHelper(_group.students),
          _step2;
        try {
          var _loop = function _loop() {
            var student = _step2.value;
            var isStudentExists = students.find(function (s) {
              return s.encryptedUserProfileId === student.encryptedUserProfileId;
            });
            if (!isStudentExists) {
              students.push(student);
            }
          };
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return students;
  }
  var group = classroom.groups.find(function (g) {
    return g.groupId === groupId;
  });
  return group.students.map(function (student) {
    return _objectSpread(_objectSpread({}, student), {}, {
      groupName: group.name,
      className: classroom.name,
      classroomId: classroom.classroomId
    });
  });
};
var setDefaultValues = function setDefaultValues(isClass, classrooms) {
  if (isClass) {
    return {
      value: classrooms[0].classroomId,
      label: classrooms[0].name
    };
  }
  return {
    value: classrooms[0].groups[0].groupId,
    label: classrooms[0].groups[0].name
  };
};


/***/ }),

/***/ "Dw/b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SearchableListWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return InputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SelectPanelWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return showElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FilterWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FilteredListWrapper; });
/* unused harmony export TopicHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var SearchContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  .clear {\n    padding: 0px 0px 0px 10px;\n    align-self: flex-end;\n  }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])());
var SearchableListWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _props$theme = props.theme,
    colours = _props$theme.colours,
    typography = _props$theme.typography;
  return "   \n        ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), "\n        border: 1px solid ").concat(colours.grey[400], ";\n        border-radius: 5px;\n        height: 34px;\n        font-family: ").concat(typography.family, ";\n        font-size: 15px;\n        outline: none;\n        margin-top: 2px;\n       \n        .searchText {\n          width: 92%;\n          margin: auto 4px;\n        }\n        \n        .searchLogo {\n          width: 8%;\n          height: 36px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          cursor: pointer;\n          \n          [class*=\"svgIconComponent\"] {\n              width: 18px;\n\n              * {\n                fill: $colour-white !important;\n              }\n          }\n        }\n      ");
});
var InputWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].input(function (props) {
  var typography = props.theme.typography;
  return " \n        height: 25px;\n        border: none;\n        font-family: ".concat(typography.family, ";\n        font-size: 15px;\n        outline: none;\n        padding-left: 4px;\n        width: 97%;\n\n        &::-webkit-input-placeholder {\n            color: lightgray;\n            font-weight: 600;\n        }\n\n        &:-ms-input-placeholder {\n            color: lightgray;\n            font-weight: 600;\n        }\n    ");
});
var SelectPanelWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _props$theme2 = props.theme,
    colours = _props$theme2.colours,
    typography = _props$theme2.typography;
  return "  \n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), "\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), "\n    z-index: 10;\n    position: absolute; \n    background-color: white;\n    width: 480px;\n    height: 400px;\n    border: 1px solid ").concat(colours.grey[200], ";\n    border-top: none;\n\n    @media(max-width: 1100px) {\n      width: 400px;\n    }\n    \n    .panelFooter {\n       ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), "\n       ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), "\n       ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'), "\n       \n       height: 60px;\n       background: #cfd2d4;\n       width: 100%;\n       \n       .uncheck {\n         margin-left: 10px;\n       }\n       \n       .apply {\n         margin-right: 10px;\n       }\n    }\n\n    .panelBody {\n       height: 340px;\n       overflow-y: scroll;\n       \n       .strand {\n         padding: 10px;\n         \n         .wrapper {\n           ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), "\n           \n           .Description {\n             width: 96%;\n           }\n           \n           .icon {\n              cursor: pointer;\n           }\n         }\n         \n         svg {\n          path {\n            fill: ").concat(colours.grey[700], " !important;\n          }\n         }\n         \n         [class*=\"svgIconComponent\"] {\n                   width: 16px;\n         }\n       }\n       \n        .line {\n           width: 95%;\n           border-top: 2px solid ").concat(colours.grey[400], ";\n         }\n       \n       .spacer {\n        padding-left: 15px;\n       }\n    }\n    \n     .unCheckAllButton {\n      width: max-content;\n      height: 30px;\n      font-family: ").concat(typography.family, ";\n      font-size: 14px;\n      font-weight: 600;\n      :hover {\n        filter: none;\n      }\n     }\n     \n     .applyButton {\n      width: max-content;\n      height: 30px;\n      :hover {\n        filter: none;\n      }\n     }\n    ");
});
var TopicHeader = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function () {
  return " \n        margin-top: 6px;\n        margin-left: 15px;\n        font-weight: bold;\n        font-size: 14px;\n\n       .spanTopicDiff{\n        float: right;\n        margin-right: 93px;\n     }\n    ";
});
var showElement = function showElement(bool) {
  return {
    display: bool ? '' : 'none'
  };
};
var FilterWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  font-size: 11px\n  width: 100%;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'));
var FilteredListWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(function (props) {
  var colours = props.theme.colours;
  return "\n    path {\n      fill: ".concat(colours.grey[600], " !important;\n    }\n  ");
});


/***/ }),

/***/ "EsWq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__("Bl3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled__ = __webpack_require__("6uc1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__checkbox__ = __webpack_require__("4YSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__ = __webpack_require__("IzlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__containers_course_assign_course_assign_actions__ = __webpack_require__("+7+H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__toast_toast_action__ = __webpack_require__("fbOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__containers_modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__student_modal_student_modal__ = __webpack_require__("lPt/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__analytics__ = __webpack_require__("uVVs");
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }



















var StudentListItem = function StudentListItem(props) {
  var student = props.student,
    mappedAssignmentIndexes = props.mappedAssignmentIndexes,
    showCheckbox = props.showCheckbox,
    i18n = props.i18n,
    dueDate = props.dueDate;
  var studentListRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var _useTracking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__analytics__["d" /* useTracking */])(),
    trackStudentMenu = _useTracking.trackStudentMenu;
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["a" /* UNCHECKED */]),
    _useState2 = _slicedToArray(_useState, 2),
    checkboxState = _useState2[0],
    setCheckboxState = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showContextMenu = _useState4[0],
    setContextMenu = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
      positionX: 0,
      positionY: 0,
      positionArrow: 0,
      positionArrowY: 0
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    contextPosition = _useState6[0],
    setContextPosition = _useState6[1];
  var fullName = "".concat(student.lastName, ", ").concat(student.firstName);
  var classroomId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var groupId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var studentInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return mappedAssignmentIndexes.map(function (x) {
      return state.CourseAssignReducer.assignments.studentAssignments[x];
    });
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var handleOnClick = function handleOnClick(cbStatus) {
    setCheckboxState(cbStatus);
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_types__["m" /* GRID_CELL_SELECTION */],
      indexes: mappedAssignmentIndexes,
      status: cbStatus
    });
    setContextMenu(false);
  };
  function handleSuccess() {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__containers_course_assign_course_assign_actions__["b" /* getTopics */])(classroomId, groupId));
    setContextMenu(false);
  }
  var handleOnUnassign = function handleOnUnassign() {
    var assignedTaskIdList = studentInfo.map(function (info) {
      var _info$assignment;
      return (_info$assignment = info.assignment) === null || _info$assignment === void 0 ? void 0 : _info$assignment.assignedTaskId;
    });
    __WEBPACK_IMPORTED_MODULE_14__helpers_resources__["a" /* default */].unassign.put({
      classroomId: classroomId,
      groupId: groupId
    }).withBody({
      assignedTaskIdList: assignedTaskIdList
    }).send().then(function () {
      handleSuccess();
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__toast_toast_action__["c" /* showToast */])(i18n._(
      /*i18n*/
      {
        id: "studentListItem.unassignSuccess",
        defaults: "Activities are unassigned from this student"
      }), 'success'));
    }, function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_types__["e" /* ERROR_DETECTED */],
        payload: err
      });
    });
  };
  function filterActivityList() {
    var activities = [];
    var selectedActivities = [];
    var filteredActivities = studentInfo.length && (studentInfo === null || studentInfo === void 0 ? void 0 : studentInfo.filter(function (selectedActivity) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_utils__["c" /* isDefined */])(selectedActivity) && !activities.includes("".concat(selectedActivity.activityId, "_").concat(selectedActivity.taskType)) && !selectedActivity.isHidden) {
        activities.push("".concat(selectedActivity.activityId, "_").concat(selectedActivity.taskType));
        if (selectedActivity.isSelected) {
          selectedActivities.push(selectedActivity);
        }
        return true;
      }
      return false;
    })) || [];
    return [filteredActivities, selectedActivities];
  }
  var getState = function getState() {
    var _filterActivityList = filterActivityList(),
      _filterActivityList2 = _slicedToArray(_filterActivityList, 2),
      filteredActivities = _filterActivityList2[0],
      selectedCells = _filterActivityList2[1];
    var state = checkboxState;
    if (!selectedCells.length && !filteredActivities.length) state = __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["a" /* UNCHECKED */];
    if (selectedCells.length >= filteredActivities.length) {
      state = __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["b" /* CHECKED */];
    }
    if (selectedCells.length > 0 && selectedCells.length < filteredActivities.length) {
      state = __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["c" /* INDETERMINATE */];
    }
    if (selectedCells.length === 0) state = __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["a" /* UNCHECKED */];
    return state;
  };
  // TODO: refactor getState to remove the exhaustive-deps warning
  // eslint-disable-next-line react-hooks/exhaustive-deps
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    setCheckboxState(getState());
  });
  var showContextModal = function showContextModal() {
    var _getContextCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_utils__["e" /* getContextCoords */])(studentListRef.current.getBoundingClientRect(), __WEBPACK_IMPORTED_MODULE_9__context_modal__["a" /* ContextModalWidth */], 300, true),
      posX = _getContextCoords.posX,
      posY = _getContextCoords.posY,
      posArrow = _getContextCoords.posArrow,
      posArrowY = _getContextCoords.posArrowY;
    setContextPosition({
      positionX: posX,
      positionY: posY,
      positionArrow: posArrow,
      positionArrowY: posArrowY
    });
    setContextMenu(!showContextMenu);
  };
  var openStudentModal = function openStudentModal(tabToOpen) {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__containers_course_assign_course_assign_actions__["d" /* getStudentResultById */])(classroomId, student.encryptedUserProfileId));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__containers_modal_manager_modal_manager_actions__["d" /* activateModal */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__student_modal_student_modal__["a" /* viewStudentResultModal */])(i18n, tabToOpen)));
  };
  var _student$id = student.id,
    id = _student$id === void 0 ? '' : _student$id;
  var classname = student.className.length > __WEBPACK_IMPORTED_MODULE_8__helpers_utils__["h" /* MAX_CLASSNAME_LENGTH */] ? "".concat(student.className.substring(0, __WEBPACK_IMPORTED_MODULE_8__helpers_utils__["h" /* MAX_CLASSNAME_LENGTH */]), "...") : student.className;
  var groupname = student.groupName.length > __WEBPACK_IMPORTED_MODULE_8__helpers_utils__["i" /* MAX_GROUP_NAME_LENGTH */] ? "".concat(student.groupName.substring(0, __WEBPACK_IMPORTED_MODULE_8__helpers_utils__["i" /* MAX_GROUP_NAME_LENGTH */]), "...") : student.groupName;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["g" /* ListItemContainer */], {
    key: "_".concat(id, "_"),
    "data-name": "student-list"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["h" /* ListItem */], {
    "data-testid": "student-list",
    showCheckbox: showCheckbox,
    onClick: showContextModal,
    ref: studentListRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    title: fullName
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_utils__["j" /* getTruncatedName */])(fullName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    id: "assignedActivity"
  }, props.assignmentCount)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["i" /* CheckboxWrapper */], null, showCheckbox === true && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__checkbox__["a" /* default */], {
    checkboxHandler: function checkboxHandler(cbStatus) {
      return handleOnClick(cbStatus);
    },
    state: checkboxState
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setContextMenu(false);
    },
    forButton: "showContextModal_".concat(id)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__context_modal__["b" /* default */], _extends({
    show: showContextMenu,
    leftAlign: true,
    flowUp: true
  }, contextPosition), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["j" /* StudentDetails */], {
    "data-testid": "student-details"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["k" /* StudentName */], {
    "data-testid": "student-name"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_utils__["j" /* getTruncatedName */])(fullName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["l" /* StudentGroup */], {
    "data-testid": "student-year"
  }, "".concat(i18n._(
  /*i18n*/
  {
    id: "StudentListItem.year",
    defaults: "Year"
  }), " ").concat(student.yearGroup, " ").concat(classname)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["m" /* StudentDetailsRow */], {
    "data-testid": "student-group"
  }, "".concat(i18n._(
  /*i18n*/
  {
    id: "StudentListItem.group",
    defaults: "Group"
  }), ": ").concat(groupname)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["m" /* StudentDetailsRow */], {
    "data-testid": "student-assignment"
  }, "".concat(i18n._(
  /*i18n*/
  {
    id: "StudentListItem.courseAssignments",
    defaults: "Course Assignments"
  }), ": ").concat(props.assignmentCount)), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_utils__["c" /* isDefined */])(dueDate) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["m" /* StudentDetailsRow */], {
    "data-testid": "next-due"
  }, "".concat(i18n._(
  /*i18n*/
  {
    id: "StudentListItem.nextDue",
    defaults: "Next Due"
  }), ": ").concat(__WEBPACK_IMPORTED_MODULE_4_moment___default()(dueDate).format('DD MMM YYYY')))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["n" /* ContextMenuAction */], {
    "data-testid": "select-student",
    role: "button",
    tabIndex: "-1",
    first: true,
    onClick: function onClick() {
      trackStudentMenu({
        action: 'select'
      });
      handleOnClick('checked');
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__["a" /* default */], {
    src: __WEBPACK_IMPORTED_MODULE_11__helpers_icon_dictionary__["l" /* Select */],
    cacheGetRequests: true
  }), i18n._(
  /*i18n*/
  {
    id: "StudentListItem.SelectStudent",
    defaults: "Select Student"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["n" /* ContextMenuAction */], {
    "data-testid": "unassign-all",
    role: "button",
    tabIndex: "-1",
    onClick: function onClick() {
      trackStudentMenu({
        action: 'unassign-all'
      });
      handleOnUnassign();
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__["a" /* default */], {
    src: __WEBPACK_IMPORTED_MODULE_11__helpers_icon_dictionary__["C" /* Unassign */],
    cacheGetRequests: true
  }), i18n._(
  /*i18n*/
  {
    id: "StudentListItem.UnassignAll",
    defaults: "Unassign All"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["n" /* ContextMenuAction */], {
    "data-testid": "student-results",
    role: "button",
    tabIndex: "-1",
    onClick: function onClick() {
      trackStudentMenu({
        action: 'results'
      });
      openStudentModal(__WEBPACK_IMPORTED_MODULE_17__student_modal_student_modal__["b" /* TABS */].RESULTS);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__["a" /* default */], {
    src: __WEBPACK_IMPORTED_MODULE_11__helpers_icon_dictionary__["m" /* Results */],
    cacheGetRequests: true
  }), i18n._(
  /*i18n*/
  {
    id: "StudentListItem.StudentResults",
    defaults: "Student Results"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["n" /* ContextMenuAction */], {
    "data-testid": "current-assignments",
    role: "button",
    tabIndex: "-1",
    onClick: function onClick() {
      trackStudentMenu({
        action: 'current-assignments'
      });
      openStudentModal(__WEBPACK_IMPORTED_MODULE_17__student_modal_student_modal__["b" /* TABS */].ASSIGNED);
    },
    last: true
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__["a" /* default */], {
    src: __WEBPACK_IMPORTED_MODULE_11__helpers_icon_dictionary__["D" /* AllAssigned */],
    cacheGetRequests: true
  }), i18n._(
  /*i18n*/
  {
    id: "StudentListItem.CurrentAssignments",
    defaults: "Current Assignments"
  })))));
};
StudentListItem.defaultProps = {
  showCheckbox: true,
  assignmentCount: 0,
  dueDate: undefined
};
StudentListItem.propTypes = {
  student: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  mappedAssignmentIndexes: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number).isRequired,
  checkboxHandler: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  showCheckbox: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  assignmentCount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  dueDate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  showModal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (StudentListItem);

/***/ }),

/***/ "FYON":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__palette__ = __webpack_require__("RPFx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__typography__ = __webpack_require__("nWgB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__colours__ = __webpack_require__("v6Wj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout__ = __webpack_require__("2xSC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__overrides__ = __webpack_require__("1KZT");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






/* harmony default export */ __webpack_exports__["a"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"]), {}, {
  palette: __WEBPACK_IMPORTED_MODULE_1__palette__["a" /* default */],
  typography: __WEBPACK_IMPORTED_MODULE_2__typography__["a" /* default */],
  colours: __WEBPACK_IMPORTED_MODULE_3__colours__["a" /* default */],
  layout: __WEBPACK_IMPORTED_MODULE_4__layout__["a" /* default */],
  overrides: __WEBPACK_IMPORTED_MODULE_5__overrides__["a" /* default */]
}));

/***/ }),

/***/ "Fvqa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextModalWidth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__("Zbcq");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }



var ContextModalWidth = 203;
var ContextModal = function ContextModal(props) {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState2 = _slicedToArray(_useState, 2),
    modalBottom = _useState2[0],
    setModalBottom = _useState2[1];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (innerHeight - props.positionY < 150) {
      setModalBottom(innerHeight - props.positionY);
    }
  }, [props.positionY]);
  return props.show && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* ModalWrapper */], {
    "data-testid": "context-modal",
    positionArrow: props.positionArrow,
    positionX: props.positionX,
    positionY: props.positionY,
    positionArrowReverse: props.flowUp,
    modalWidth: ContextModalWidth,
    modalBottom: modalBottom,
    contextTheme: props.contextTheme,
    leftAlign: props.leftAlign,
    positionArrowY: props.positionArrowY,
    transform: props.positionArrowY
  }, props.contextTheme ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* ContentTheme */], null, props.name) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["c" /* Content */], null, props.children));
};
ContextModal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  flowUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  positionX: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  positionY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  positionArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  contextTheme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  positionArrowY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  leftAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["b"] = (ContextModal);

/***/ }),

/***/ "GGmR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled__ = __webpack_require__("M+Hj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__ = __webpack_require__("vIo2");





var TopicInfo = function TopicInfo(props) {
  var standardName = props.standardName,
    ljName = props.ljName,
    externalKey = props.externalKey,
    description = props.description,
    hideStrand = props.hideStrand,
    count = props.count,
    displayHideOption = props.displayHideOption,
    subName = props.subName;
  var stepIcon = null;
  switch (count) {
    case 1:
      stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["g" /* Step1 */];
      break;
    case 2:
      stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["h" /* Step2 */];
      break;
    case 3:
      stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["i" /* Step3 */];
      break;
    case 4:
      stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["j" /* Step4 */];
      break;
    case 5:
      stepIcon = __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["k" /* Step5 */];
      break;
    default:
      break;
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["a" /* InfoWrapper */], {
    count: count
  }, displayHideOption && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["b" /* Hide */], {
    onClick: function onClick() {
      return true || hideStrand;
    }
  }, "Hide"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "headerWrapper"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "title"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "standardName"
  }, standardName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "subName"
  }, subName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "subTitle"
  }, externalKey), ljName && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "subTitle"
  }, ljName)), count ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__styled__["c" /* Icon */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__["a" /* default */], {
    className: "steps",
    icon: stepIcon
  })) : null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "description"
  }, description));
};
TopicInfo.propTypes = {
  standardName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  subName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  ljName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  externalKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  description: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  hideStrand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  displayHideOption: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
/* harmony default export */ __webpack_exports__["a"] = (TopicInfo);

/***/ }),

/***/ "Gkxh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toast_action__ = __webpack_require__("fbOh");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var initialState = {
  isToastVisible: false,
  message: '',
  messageType: ''
};
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__toast_action__["a" /* SHOW_TOAST */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isToastVisible: action.isToastVisible,
        message: action.message,
        messageType: action.messageType
      });
    case __WEBPACK_IMPORTED_MODULE_0__toast_action__["b" /* HIDE_TOAST */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isToastVisible: action.isToastVisible
      });
    default:
      return _objectSpread({}, state);
  }
});

/***/ }),

/***/ "Gylf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_toast_toast_reducer__ = __webpack_require__("Gkxh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modal_manager_modal_manager_reducer__ = __webpack_require__("AgQo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_assign_later_store_assign_later_reducer__ = __webpack_require__("4hLv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__course_assign_course_assign_reducer__ = __webpack_require__("eZUU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_unassign_all_modal_store_unassign_all_modal_reducer__ = __webpack_require__("SuGc");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var CombinedReducers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* combineReducers */])({
  product: function product(state) {
    return _objectSpread({}, state);
  },
  toastReducer: __WEBPACK_IMPORTED_MODULE_1__components_toast_toast_reducer__["a" /* default */],
  assignLaterReducer: __WEBPACK_IMPORTED_MODULE_3__components_assign_later_store_assign_later_reducer__["a" /* default */],
  modalContainerReducer: __WEBPACK_IMPORTED_MODULE_2__modal_manager_modal_manager_reducer__["a" /* default */],
  unassignModalReducer: __WEBPACK_IMPORTED_MODULE_5__components_unassign_all_modal_store_unassign_all_modal_reducer__["a" /* default */],
  CourseAssignReducer: __WEBPACK_IMPORTED_MODULE_4__course_assign_course_assign_reducer__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (CombinedReducers);

/***/ }),

/***/ "HW8V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);

function ConserveParameters(importantParams) {
  function modifyPath(path) {
    var currentParams = __WEBPACK_IMPORTED_MODULE_0_query_string__["parse"](window.location.search);
    var paramList = {};
    var paramsToAdd = false;
    importantParams.forEach(function (param) {
      if (currentParams[param]) {
        if (!path.match("(\\?|&)".concat(param, "="))) {
          paramList[param] = currentParams[param];
          paramsToAdd = true;
        }
      }
    });
    if (paramsToAdd) {
      path += path.indexOf('?') === -1 ? '?' : '&';
      path += __WEBPACK_IMPORTED_MODULE_0_query_string__["stringify"](paramList);
    }
    return path;
  }
  var oldPushState = window.history.pushState;
  var oldReplaceState = window.history.replaceState;
  window.history.pushState = function newPushState() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    args[2] = modifyPath(args[2]);
    oldPushState.apply(this, args);
  };
  window.history.replaceState = function newReplaceState() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    args[2] = modifyPath(args[2]);
    oldReplaceState.apply(this, args);
  };
}
/* harmony default export */ __webpack_exports__["a"] = (ConserveParameters);

/***/ }),

/***/ "HkKr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__("Bl3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled__ = __webpack_require__("d32L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__("KAdK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_actions__ = __webpack_require__("+7+H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__topic_info__ = __webpack_require__("GGmR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__activity_header_styled__ = __webpack_require__("krZk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toast_toast_action__ = __webpack_require__("fbOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_resources_helper__ = __webpack_require__("jhKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__containers_modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__results_modal_results_modal__ = __webpack_require__("Ph6f");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }




















var StatusCell = function StatusCell(props) {
  var _assignment, _assignment2, _result2, _result3;
  var i18n = props.i18n,
    studentInfo = props.studentInfo,
    isCollapsed = props.isCollapsed,
    hasResults = props.hasResults,
    resultAverage = props.resultAverage,
    hasAssignments = props.hasAssignments,
    activities = props.activities,
    selectedCells = props.selectedCells,
    activityName = props.activityName,
    currentStudent = props.currentStudent,
    datePreference = props.datePreference,
    courseId = props.courseId,
    classroomId = props.classroomId,
    groupId = props.groupId,
    index = props.index;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* useDispatch */])();
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setModalOpen = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState4 = _slicedToArray(_useState3, 2),
    positionX = _useState4[0],
    setPositionX = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState6 = _slicedToArray(_useState5, 2),
    positionY = _useState6[0],
    setPositionY = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState8 = _slicedToArray(_useState7, 2),
    positionArrow = _useState8[0],
    setPositionArrow = _useState8[1];
  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState0 = _slicedToArray(_useState9, 2),
    flowUp = _useState0[0],
    setShouldFlowUp = _useState0[1];
  var _useSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["c" /* useSelector */])(function (state) {
      var _state$CourseAssignRe;
      return (_state$CourseAssignRe = state.CourseAssignReducer) === null || _state$CourseAssignRe === void 0 ? void 0 : _state$CourseAssignRe.assignments.studentAssignments[index];
    }),
    assignment = _useSelector.assignment,
    result = _useSelector.result,
    isSelected = _useSelector.isSelected,
    isFiltered = _useSelector.isFiltered,
    activityId = _useSelector.activityId,
    taskType = _useSelector.taskType,
    encryptedUserProfileId = _useSelector.encryptedUserProfileId;
  if (isCollapsed) {
    assignment = studentInfo.assignment;
    result = studentInfo.result;
    isSelected = studentInfo.isSelected;
    activityId = studentInfo.activityId;
    isFiltered = studentInfo.isFiltered;
    taskType = studentInfo.taskType;
    encryptedUserProfileId = studentInfo.encryptedUserProfileId;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (isModalOpen) {
      window.addEventListener('scroll', setPosition, true);
    }
    return function () {
      return window.removeEventListener('scroll', setPosition, true);
    };
  });
  var shouldBeSelected = isCollapsed ? selectedCells > 0 : isSelected;
  var _useState1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(shouldBeSelected),
    _useState10 = _slicedToArray(_useState1, 2),
    isCellSelected = _useState10[0],
    setIsCellSelected = _useState10[1];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (shouldBeSelected !== isCellSelected) {
      setIsCellSelected(shouldBeSelected);
    }
  }, [shouldBeSelected, isCellSelected]);
  var score = result && result.score;
  var cellRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var assignStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["c" /* isDefined */])((_assignment = assignment) === null || _assignment === void 0 ? void 0 : _assignment.assignStatus) ? (_assignment2 = assignment) === null || _assignment2 === void 0 ? void 0 : _assignment2.assignStatus : __WEBPACK_IMPORTED_MODULE_7__helpers_utils__["f" /* studentStatus */][__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* UNATTEMPTED */]];
  var isAssigned = assignStatus === __WEBPACK_IMPORTED_MODULE_7__helpers_utils__["f" /* studentStatus */].ASSIGNED || assignStatus === __WEBPACK_IMPORTED_MODULE_7__helpers_utils__["f" /* studentStatus */].INPROGRESS || assignStatus === __WEBPACK_IMPORTED_MODULE_7__helpers_utils__["f" /* studentStatus */].PAST_DUE_DATE || hasAssignments;
  var resultSummary = function resultSummary() {
    if (resultAverage >= 0 && isCollapsed && hasResults) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["a" /* Result */], {
        isFiltered: isFiltered,
        hasResults: hasResults,
        isCollapsed: isCollapsed,
        percentage: score,
        isAssigned: isAssigned
      }, "".concat(resultAverage.toFixed(1), "%"));
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["c" /* isDefined */])(score)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["a" /* Result */], {
        isFiltered: isFiltered,
        hasResults: hasResults,
        isCollapsed: isCollapsed,
        percentage: score,
        isAssigned: isAssigned
      }, "".concat(score, "%"));
    }
    return null;
  };
  var cellClickHandler = function cellClickHandler() {
    if (isFiltered) {
      return;
    }
    if (isCollapsed) {
      setIsCellSelected(!isCellSelected);
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_15__containers_course_assign_course_assign_types__["J" /* UPDATE_STUDENT_ASSIGNMENTS_SELECTED */],
        payload: {
          activities: activities,
          encryptedUserProfileId: encryptedUserProfileId
        }
      });
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["c" /* isDefined */])(score)) {
      showContextModal();
    } else {
      selectCell();
    }
  };
  function selectCell() {
    setIsCellSelected(!isCellSelected);
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_15__containers_course_assign_course_assign_types__["l" /* UPDATE_STUDENT_ASSIGNMENT */],
      index: index
    });
    setModalOpen(false);
  }

  // Select all less than or equal to cell result
  function selectAllBelow() {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["c" /* isDefined */])(score)) {
      return;
    }
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_15__containers_course_assign_course_assign_types__["C" /* SELECT_EQUAL_LESS_THAN_CELLS */],
      result: score,
      currentStudent: currentStudent
    });
    setModalOpen(false);
  }
  function setPosition() {
    var _getContextCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["e" /* getContextCoords */])(cellRef.current.getBoundingClientRect(), __WEBPACK_IMPORTED_MODULE_10__context_modal__["a" /* ContextModalWidth */]),
      posX = _getContextCoords.posX,
      posY = _getContextCoords.posY,
      posArrow = _getContextCoords.posArrow,
      reverseArrow = _getContextCoords.reverseArrow;
    setPositionY(posY);
    setPositionX(posX);
    setPositionArrow(posArrow);
    setShouldFlowUp(reverseArrow);
  }
  function showContextModal() {
    setPosition();
    setModalOpen(!isModalOpen);
  }
  function getAssignmentDates() {
    var _assignment3, _result;
    if (assignment && (_assignment3 = assignment) !== null && _assignment3 !== void 0 && _assignment3.startDate) {
      var _assignment4;
      return "".concat(i18n._("Generic.Assigned", {}, {
        defaults: "Assigned"
      }), " ").concat(__WEBPACK_IMPORTED_MODULE_2_moment___default()(assignment.startDate).format('DD-MMM'), " - ").concat((_assignment4 = assignment) !== null && _assignment4 !== void 0 && _assignment4.dueDate ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(assignment.dueDate).format('DD-MMM') : i18n._("Generic.NoDueDate", {}, {
        defaults: "no due date"
      }));
    }
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()((_result = result) === null || _result === void 0 ? void 0 : _result.completionDate).format('DD-MMM');
  }
  function handleSuccess(reassignment) {
    /* eslint-disable indent */
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__toast_toast_action__["c" /* showToast */])(i18n._(reassignment ?
    /*i18n*/
    {
      id: "footer.reassignSuccess",
      defaults: "Selected student activities have been reassigned"
    } :
    /*i18n*/
    {
      id: "footer.unassignSuccess",
      defaults: "Selected student activities have been unassigned"
    }), 'success'));
    /* eslint-enable indent */
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_actions__["b" /* getTopics */])(classroomId, groupId));
    setModalOpen(false);
  }
  function unassignCell() {
    __WEBPACK_IMPORTED_MODULE_13__helpers_resources__["a" /* default */].unassign.put({
      classroomId: classroomId,
      groupId: groupId
    }).withBody({
      assignedTaskIdList: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers_resources_helper__["b" /* retrieveAssignedTaskId */])([studentInfo])
    }).send().then(function () {
      return handleSuccess(false);
    }, function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_15__containers_course_assign_course_assign_types__["e" /* ERROR_DETECTED */],
        payload: err
      });
    });
  }
  function reassign() {
    var startDatePreference = datePreference[0];
    var dueDatePreference = datePreference[1];
    /* eslint-disable indent */
    var startDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["c" /* isDefined */])(startDatePreference) ? __WEBPACK_IMPORTED_MODULE_2_moment___default()("".concat(startDatePreference[0], " ").concat(startDatePreference[1])).toISOString() : undefined;
    var dueDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["c" /* isDefined */])(dueDatePreference) ? __WEBPACK_IMPORTED_MODULE_2_moment___default()("".concat(dueDatePreference[0], " ").concat(dueDatePreference[1])).toISOString() : undefined;
    /* eslint-enable indent */

    __WEBPACK_IMPORTED_MODULE_13__helpers_resources__["a" /* default */].assign.post({
      classroomId: classroomId,
      groupId: groupId
    }).withBody(_objectSpread({
      courseId: courseId,
      startDate: startDate,
      dueDate: dueDate,
      hasDueDate: dueDatePreference !== undefined
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__helpers_resources_helper__["a" /* mapSelectedActivitiesToReq */])([studentInfo]))).send().then(function () {
      return handleSuccess(true);
    }, function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_15__containers_course_assign_course_assign_types__["e" /* ERROR_DETECTED */],
        payload: err
      });
    });
  }
  function RenderHandler(renderProps) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["c" /* isDefined */])(score) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__helpers_hoc_close_outside_click_handler__["a" /* default */], {
      callback: function callback() {
        return setModalOpen(false);
      },
      forButton: "StatusCell"
    }, renderProps === null || renderProps === void 0 ? void 0 : renderProps.children, ' ') : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, renderProps === null || renderProps === void 0 ? void 0 : renderProps.children);
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RenderHandler, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["b" /* Cell */], {
    "data-testid": "StatusCell_".concat(encryptedUserProfileId, "_").concat(activityId, "_").concat(taskType),
    onClick: cellClickHandler,
    status: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["b" /* getStatus */])(assignStatus),
    percentage: isCollapsed ? resultAverage : score,
    key: "statusCell_".concat(activityId, "_").concat(taskType),
    isSelected: isCellSelected,
    isCollapsed: isCollapsed,
    isAssigned: isAssigned,
    hasResults: hasResults,
    isFiltered: isFiltered,
    isCellSelected: isCellSelected
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["c" /* ConversationStatus */], {
    ref: cellRef
  }, resultSummary()), isModalOpen ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__context_modal__["b" /* default */], {
    show: isModalOpen,
    flowUp: flowUp,
    positionArrow: positionArrow,
    positionX: positionX,
    positionY: positionY
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__topic_info__["a" /* default */], {
    displayHideOption: false,
    standardName: "".concat(currentStudent.firstName, " ").concat(currentStudent.lastName),
    subName: activityName,
    externalKey: getAssignmentDates(),
    ljName: "".concat((_result2 = result) === null || _result2 === void 0 ? void 0 : _result2.attempts, " ").concat(((_result3 = result) === null || _result3 === void 0 ? void 0 : _result3.attempts) > 1 ? i18n._("StatusCell.Attempts", {}, {
      defaults: "attempts"
    }) : i18n._("StatusCell.Attempt", {}, {
      defaults: "attempt"
    }))
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__activity_header_styled__["a" /* ContextMenuAction */], {
    "data-testid": "select-cell",
    role: "button",
    first: true,
    tabIndex: "-1",
    onClick: function onClick(e) {
      e.stopPropagation();
      selectCell();
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__["a" /* default */], {
    src: __WEBPACK_IMPORTED_MODULE_17__helpers_icon_dictionary__["l" /* Select */],
    cacheGetRequests: true
  }), i18n._("StatusCell.SelectCell", {}, {
    defaults: "Select cell"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__activity_header_styled__["a" /* ContextMenuAction */], {
    "data-testid": "select-all-less-than",
    role: "button",
    first: true,
    tabIndex: "-1",
    onClick: function onClick(e) {
      e.stopPropagation();
      selectAllBelow();
    }
  }, /* eslint-disable indent */"".concat(i18n._("StatusCell.SelectLessThan", {}, {
    defaults: "Select all <="
  }), " ").concat(score, "%") /* eslint-enable indent */), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__activity_header_styled__["a" /* ContextMenuAction */], {
    "data-testid": "unassign-from-student",
    role: "button",
    first: true,
    tabIndex: "-1",
    blackListed: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["c" /* isDefined */])(studentInfo.assignment),
    onClick: function onClick(e) {
      e.stopPropagation();
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["c" /* isDefined */])(studentInfo.assignment)) {
        unassignCell();
      }
    }
  }, "".concat(i18n._("StatusCell.Unassign", {}, {
    defaults: "Unassign from student"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__activity_header_styled__["a" /* ContextMenuAction */], {
    "data-testid": "reassign",
    role: "button",
    first: true,
    tabIndex: "-1",
    blackListed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["c" /* isDefined */])(studentInfo.assignment),
    onClick: function onClick(e) {
      e.stopPropagation();
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["c" /* isDefined */])(studentInfo.assignment)) {
        reassign();
      }
    }
  }, "".concat(i18n._("StatusCell.Reassign", {}, {
    defaults: "Reassign"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__activity_header_styled__["a" /* ContextMenuAction */], {
    "data-testid": "ViewResults",
    role: "button",
    last: true,
    tabIndex: "-1",
    onClick: function onClick() {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_actions__["c" /* getActivityReportById */])(classroomId, encryptedUserProfileId, activityId, taskType));
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__containers_modal_manager_modal_manager_actions__["d" /* activateModal */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__results_modal_results_modal__["a" /* viewResultsModal */])(i18n, isAssigned)));
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__["a" /* default */], {
    src: __WEBPACK_IMPORTED_MODULE_17__helpers_icon_dictionary__["m" /* Results */],
    cacheGetRequests: true
  }), "".concat(i18n._("StatusCell.viewResults", {}, {
    defaults: "View Results"
  })))) : null)));
};
StatusCell.propTypes = {
  studentInfo: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activityName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  isCollapsed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hasResults: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hasAssignments: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  resultAverage: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  selectedCells: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  currentStudent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
  datePreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  courseId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  classroomId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  groupId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
};
StatusCell.defaultProps = {
  isCollapsed: false,
  hasAssignments: false,
  activityIds: [],
  selectedCells: 0,
  index: 0
};
/* harmony default export */ __webpack_exports__["a"] = (StatusCell);

/***/ }),

/***/ "Hwd/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".pulseLoader---1hT4p {\n  display: inline-block;\n  position: relative;\n  width: 64px;\n  min-height: 15px; }\n  .pulseLoader---1hT4p div {\n    position: absolute;\n    top: 35%;\n    width: 11px;\n    height: 11px;\n    border-radius: 50%;\n    background: #d7dbdd;\n    -webkit-animation-timing-function: cubic-bezier(0, 1, 1, 0);\n            animation-timing-function: cubic-bezier(0, 1, 1, 0); }\n  .pulseLoader---1hT4p div:nth-child(1) {\n    left: 6px;\n    -webkit-animation: lds-ellipsis1---1ols3 0.6s infinite;\n            animation: lds-ellipsis1---1ols3 0.6s infinite; }\n  .pulseLoader---1hT4p div:nth-child(2) {\n    left: 6px;\n    -webkit-animation: lds-ellipsis2---2Y-4_ 0.6s infinite;\n            animation: lds-ellipsis2---2Y-4_ 0.6s infinite; }\n  .pulseLoader---1hT4p div:nth-child(3) {\n    left: 26px;\n    -webkit-animation: lds-ellipsis2---2Y-4_ 0.6s infinite;\n            animation: lds-ellipsis2---2Y-4_ 0.6s infinite; }\n  .pulseLoader---1hT4p div:nth-child(4) {\n    left: 45px;\n    -webkit-animation: lds-ellipsis3---Udi2C 0.6s infinite;\n            animation: lds-ellipsis3---Udi2C 0.6s infinite; }\n  @-webkit-keyframes lds-ellipsis1---1ols3 {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n  @keyframes lds-ellipsis1---1ols3 {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n  @-webkit-keyframes lds-ellipsis3---Udi2C {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0); } }\n  @keyframes lds-ellipsis3---Udi2C {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0); } }\n  @-webkit-keyframes lds-ellipsis2---2Y-4_ {\n  0% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); }\n  100% {\n    -webkit-transform: translate(19px, 0);\n            transform: translate(19px, 0); } }\n  @keyframes lds-ellipsis2---2Y-4_ {\n  0% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); }\n  100% {\n    -webkit-transform: translate(19px, 0);\n            transform: translate(19px, 0); } }\n", ""]);

// exports
exports.locals = {
	"pulseLoader": "pulseLoader---1hT4p",
	"lds-ellipsis1": "lds-ellipsis1---1ols3",
	"lds-ellipsis2": "lds-ellipsis2---2Y-4_",
	"lds-ellipsis3": "lds-ellipsis3---Udi2C"
};

/***/ }),

/***/ "Ivgr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var ThemeHelper = /*#__PURE__*/function () {
  function ThemeHelper() {
    _classCallCheck(this, ThemeHelper);
  }
  return _createClass(ThemeHelper, null, [{
    key: "getTheme",
    value:
    /**
     * If props contains no theme object or the theme object is empty, returns the base theme
     * Otherwise recursively merges props.theme on top of base theme
     */
    function getTheme(props) {
      return props.theme;
    }
  }, {
    key: "getDefaultTheme",
    value: function getDefaultTheme() {
      return __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"];
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (ThemeHelper);

/***/ }),

/***/ "IzlY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNCHECKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INDETERMINATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DISABLED; });
var CHECKED = 'checked';
var UNCHECKED = 'unchecked';
var INDETERMINATE = 'indeterminate';
var DISABLED = 'disabled';

/***/ }),

/***/ "JT4Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("TQbn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__status_cell__ = __webpack_require__("HkKr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__grid_header__ = __webpack_require__("bC9D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_utils__ = __webpack_require__("6QRH");
/* eslint-disable react/no-array-index-key */







var Grid = function Grid(props) {
  var activities = props.activities,
    mappedAssignmentIndexes = props.mappedAssignmentIndexes;
  var sortedStudents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.sortedStudents;
  }, __WEBPACK_IMPORTED_MODULE_2_react_redux__["d" /* shallowEqual */]);
  var datePreference = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    var _state$CourseAssignRe, _state$CourseAssignRe2;
    return ((_state$CourseAssignRe = state.CourseAssignReducer) === null || _state$CourseAssignRe === void 0 || (_state$CourseAssignRe = _state$CourseAssignRe.datePreference) === null || _state$CourseAssignRe === void 0 ? void 0 : _state$CourseAssignRe.length) > 0 ? (_state$CourseAssignRe2 = state.CourseAssignReducer) === null || _state$CourseAssignRe2 === void 0 ? void 0 : _state$CourseAssignRe2.datePreference : [undefined, undefined];
  }, __WEBPACK_IMPORTED_MODULE_2_react_redux__["d" /* shallowEqual */]);
  var courseId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeCourseID;
  });
  var classroomId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var groupId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var studentAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.assignments.studentAssignments;
  }, __WEBPACK_IMPORTED_MODULE_2_react_redux__["d" /* shallowEqual */]);

  // This is a costly render, lets not do it until all data is available
  var hasLoaded = (studentAssignments === null || studentAssignments === void 0 ? void 0 : studentAssignments.length) > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_utils__["c" /* isDefined */])(datePreference) && (sortedStudents === null || sortedStudents === void 0 ? void 0 : sortedStudents.length) > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_utils__["c" /* isDefined */])(courseId) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_utils__["c" /* isDefined */])(activities) && activities.length && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_utils__["c" /* isDefined */])(classroomId) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_utils__["c" /* isDefined */])(groupId);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* GridContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__grid_header__["a" /* default */], {
    activities: activities,
    mappedAssignmentIndexes: mappedAssignmentIndexes
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* CellContainer */], null, hasLoaded && activities.map(function (activity, activityIndex) {
    var activityId = activity.activityId,
      activityName = activity.activityName,
      taskType = activity.taskType;
    /* eslint-disable react/jsx-indent */
    /* eslint-disable prettier/prettier */
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* GridColumn */], {
      key: "".concat(activityId, "_").concat(taskType)
    }, mappedAssignmentIndexes === null || mappedAssignmentIndexes === void 0 ? void 0 : mappedAssignmentIndexes[activityName].map(function (index) {
      var currentStudent = studentAssignments[index];
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__status_cell__["a" /* default */], {
        i18n: props.i18n,
        activityName: activity.activityName,
        isFiltered: currentStudent.isFiltered || false,
        currentStudent: currentStudent.student,
        key: "".concat(activityId, "_").concat(activityIndex, "_").concat(currentStudent.encryptedUserProfileId),
        studentInfo: currentStudent,
        index: index,
        datePreference: datePreference,
        courseId: courseId,
        classroomId: classroomId,
        groupId: groupId
      });
    }));
    /* eslint-enable react/jsx-indent */
    /* eslint-enable prettier/prettier */
  })));
};
Grid.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  mappedAssignmentIndexes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};
Grid.whyDidYouRender = false;
/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),

/***/ "JTAn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("wTCj");




var CourseName = function CourseName(_ref) {
  var i18n = _ref.i18n;
  var activeClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var activeGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var courseName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    var _state$CourseAssignRe;
    return (_state$CourseAssignRe = state.CourseAssignReducer.classrooms) === null || _state$CourseAssignRe === void 0 || (_state$CourseAssignRe = _state$CourseAssignRe.find(function (classroom) {
      return classroom.classroomId === activeClass;
    })) === null || _state$CourseAssignRe === void 0 || (_state$CourseAssignRe = _state$CourseAssignRe.groups.find(function (group) {
      return group.groupId === activeGroup;
    })) === null || _state$CourseAssignRe === void 0 ? void 0 : _state$CourseAssignRe.courseName;
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* CourseNameWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* CourseNameLabel */], null, i18n._(
  /*i18n*/
  {
    id: "coursename",
    defaults: "Course Name"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* CourseNameTitle */], {
    "data-testid": "filter-course-name"
  }, courseName));
};
CourseName.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (CourseName);

/***/ }),

/***/ "K2dO":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("t3Qr");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./filter-bar.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./filter-bar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "KAdK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ASSIGNED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INPROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAST_DUE_DATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UNATTEMPTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStatus; });
/* unused harmony export getTeacherAuthToken */
/* unused harmony export canOpenMLE */
/* unused harmony export isCellClickable */
/* unused harmony export getPercentageCompleted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("6QRH");


var ASSIGNED = 'ASSIGNED';
var INPROGRESS = 'INPROGRESS';
var PAST_DUE_DATE = 'PAST_DUE_DATE';
var UNATTEMPTED = 'UNATTEMPTED';
var getStatus = function getStatus(code) {
  switch (code) {
    case 0:
      return ASSIGNED;
    case 1:
      return INPROGRESS;
    case 2:
      return PAST_DUE_DATE;
    case 3:
      return UNATTEMPTED;
    default:
      break;
  }
  return code;
};
var getTeacherAuthToken = function getTeacherAuthToken() {
  var authToken = __WEBPACK_IMPORTED_MODULE_0__helpers_resources__["a" /* default */].env.authToken;
  return authToken;
};
var canOpenMLE = function canOpenMLE(teacher, student) {
  switch (student) {
    case __WEBPACK_IMPORTED_MODULE_1__helpers_utils__["f" /* studentStatus */].INCORRECT:
    case __WEBPACK_IMPORTED_MODULE_1__helpers_utils__["f" /* studentStatus */].PARTIAL:
    case __WEBPACK_IMPORTED_MODULE_1__helpers_utils__["f" /* studentStatus */].CORRECT:
      return true;
    default:
      break;
  }
  return false;
};
var isCellClickable = function isCellClickable(student) {
  var status = getStatus(student);
  if (status === UNATTEMPTED) {
    return false;
  }
  switch (status) {
    case UNATTEMPTED:
      return true;
    default:
      return false;
  }
};
var getPercentageCompleted = function getPercentageCompleted(completedSteps, totalSteps) {
  if (completedSteps === undefined || totalSteps === undefined) return 0;
  if (completedSteps === 0 || totalSteps === 0) return 0;
  if (totalSteps === completedSteps) return 100;
  var percentage = totalSteps / completedSteps * 100;
  return percentage;
};


/***/ }),

/***/ "KUlI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_inlinesvg__ = __webpack_require__("Bl3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_maximise_svg__ = __webpack_require__("cLZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_maximise_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_maximise_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_minimise_svg__ = __webpack_require__("Do0+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_minimise_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_minimise_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assignments_action_bar_scss__ = __webpack_require__("llTh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assignments_action_bar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assignments_action_bar_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hooks_use_assignments_action_bar__ = __webpack_require__("bvYO");







var AssignmentsActionBar = function AssignmentsActionBar(props) {
  var _useAssignmentsAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__hooks_use_assignments_action_bar__["a" /* default */])(),
    isCollapsed = _useAssignmentsAction.isCollapsed,
    toggleIsCollapsed = _useAssignmentsAction.toggleIsCollapsed;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_5__assignments_action_bar_scss___default.a.footer, " ").concat(isCollapsed ? __WEBPACK_IMPORTED_MODULE_5__assignments_action_bar_scss___default.a.collapsedContainer : __WEBPACK_IMPORTED_MODULE_5__assignments_action_bar_scss___default.a.expandedContainer)
  }, isCollapsed && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_5__assignments_action_bar_scss___default.a.icon,
    role: "button",
    "data-testid": "expand-action-bar-button",
    tabIndex: "-1",
    onClick: toggleIsCollapsed
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_inlinesvg__["a" /* default */], {
    src: __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_maximise_svg___default.a,
    cacheGetRequests: true
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, props.children), !isCollapsed && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_5__assignments_action_bar_scss___default.a.icon, " ").concat(__WEBPACK_IMPORTED_MODULE_5__assignments_action_bar_scss___default.a.iconCollapsed),
    role: "button",
    "data-testid": "collapse-action-bar-button",
    tabIndex: "-1",
    onClick: toggleIsCollapsed
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_inlinesvg__["a" /* default */], {
    src: __WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_minimise_svg___default.a,
    cacheGetRequests: true
  })));
};
AssignmentsActionBar.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (AssignmentsActionBar);

/***/ }),

/***/ "L/pw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStudents */
/* unused harmony export getTopicsAndStandards */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getFilteredTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return updateStrandAndStandards; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return updateActivitySelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return updateStrands; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return updateCheckedStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return updateGridCells; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getSelectedStandardCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return updateSelectedTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return updateHiddenTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return updateAssignmentStatusByTopic; });
/* harmony export (immutable) */ __webpack_exports__["n"] = checkIfAssignmentPassesFilter;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return contactTechSupportMessage; });
/* harmony export (immutable) */ __webpack_exports__["l"] = sortStudentAssignments;
/* harmony export (immutable) */ __webpack_exports__["a"] = sortStudentAssignmentsByName;
/* harmony export (immutable) */ __webpack_exports__["m"] = updateStudentAssignmentsHidden;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lingui_core__ = __webpack_require__("mbfA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lingui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lingui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utils__ = __webpack_require__("6QRH");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }





// Get students from list of classrooms
var getStudents = function getStudents(classrooms) {
  if (classrooms.length > 0) {
    var classroom = classrooms[0];
    var group = classroom.groups[0];
    return group.students;
  }
  return [];
};
var getTopicsAndStandards = function getTopicsAndStandards(genericCourses) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])(genericCourses) || genericCourses.length === 0) return [];
  var standardTopic = [];
  var topicTree = genericCourses.topics.map(function (topic) {
    if (topic.type.toLowerCase() === 'standard') {
      standardTopic.push(_objectSpread(_objectSpread({}, topic), {}, {
        displayName: "".concat(topic.externalKey.toUpperCase(), " ").concat(topic.name).trim(),
        selected: true
      }));
    } else if (topic.type.toLowerCase() === 'strand') {
      return _objectSpread(_objectSpread({}, topic), {}, {
        displayName: topic.name,
        selected: true,
        childTopics: topic.childTopics.map(function (st) {
          return _objectSpread(_objectSpread({}, st), {}, {
            displayName: "".concat(st.externalKey.toUpperCase(), " ").concat(st.name).trim(),
            selected: true
          });
        }),
        isExpand: !!topic.childTopics.find(function (s) {
          return s.selected;
        })
      });
    }
    return undefined;
  }).filter(function (topic) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])(topic);
  });
  if (standardTopic.length > 0) {
    topicTree.push({
      id: -1,
      displayName: 'All Standards',
      childTopics: standardTopic,
      selected: true
    });
  }
  if (standardTopic.length === 0 && topicTree.length > 0) {
    var _topicTree$0$childTop, _topicTree$0$childTop2;
    topicTree[0].selected = true;
    topicTree[0].childTopics = (_topicTree$0$childTop = topicTree[0].childTopics) === null || _topicTree$0$childTop === void 0 ? void 0 : _topicTree$0$childTop.map(function (ct) {
      return _objectSpread(_objectSpread({}, ct), {}, {
        selected: true
      });
    });
    topicTree[0].isExpand = ((_topicTree$0$childTop2 = topicTree[0].childTopics) === null || _topicTree$0$childTop2 === void 0 ? void 0 : _topicTree$0$childTop2.length) > 0;
  }
  return topicTree;
};
var getFilteredTopics = function getFilteredTopics(searchTerm, topics) {
  return topics.map(function (topic) {
    return _objectSpread(_objectSpread({}, topic), {}, {
      isHidden: searchTerm ? !(topic.topicName.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0) : false
    });
  });
};
var updateStrandAndStandards = function updateStrandAndStandards(id, checked, topics) {
  if (!id) {
    return topics;
  }
  return topics.map(function (val) {
    return _objectSpread(_objectSpread({}, val), {}, {
      selected: val.topicId === parseInt(id, 10) ? checked === 'checked' : val === null || val === void 0 ? void 0 : val.selected
    });
  });
};
var updateActivitySelection = function updateActivitySelection(id, topics, checkedNormal, checkedEasier) {
  if (!id) {
    return topics;
  }
  return topics.map(function (topic) {
    if (topic.topicId === parseInt(id, 10)) {
      return _objectSpread(_objectSpread({}, topic), {}, {
        checkedNormal: checkedNormal,
        checkedEasier: checkedEasier
      });
    }
    return topic;
  });
};
var updateStrands = function updateStrands(checked, topics) {
  return topics.map(function (topic) {
    return _objectSpread(_objectSpread({}, topic), {}, {
      selected: checked,
      childTopics: topic.childTopics.map(function (ct) {
        return _objectSpread(_objectSpread({}, ct), {}, {
          selected: checked
        });
      }),
      isExpand: topic.childTopics.length > 0 && checked
    });
  });
};
var updateCheckedStatus = function updateCheckedStatus(checked, topics) {
  return topics.map(function (topic) {
    return _objectSpread(_objectSpread({}, topic), {}, {
      selected: checked
    });
  });
};
var updateGridCells = function updateGridCells(indexes, assignments, status) {
  indexes.forEach(function (index) {
    if (!assignments.studentAssignments[index].isHidden) {
      assignments.studentAssignments[index] = _objectSpread(_objectSpread({}, assignments.studentAssignments[index]), {}, {
        isSelected: status === 'checked'
      });
    }
  });
  return (assignments === null || assignments === void 0 ? void 0 : assignments.studentAssignments) || [];
};
var getSelectedStandardCount = function getSelectedStandardCount(topics) {
  var selectedTopicCount = 0;
  topics.forEach(function (topic) {
    if (topic.selected) {
      selectedTopicCount += 1;
    }
  });
  return selectedTopicCount;
};
var updateSelectedTopics = function updateSelectedTopics(updateTopics) {
  if (!updateTopics) {
    return {
      updateTopics: updateTopics,
      selectedTopicCount: 0
    };
  }
  var selectedTopicCount = 0;
  var newTopics = updateTopics.map(function (topic) {
    if (topic.selected) {
      selectedTopicCount += 1;
    }
    return _objectSpread(_objectSpread({}, topic), {}, {
      selected: true,
      checkedNormal: true,
      checkedEasier: false,
      isHidden: false
    });
  });
  return {
    updateTopics: newTopics,
    selectedTopicCount: selectedTopicCount
  };
};
var updateHiddenTopics = function updateHiddenTopics(filteredTopics, updateTopics) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])(updateTopics)) {
    return {
      updateTopics: updateTopics,
      selectedTopicCount: 0
    };
  }
  var selectedTopicCount = 0;
  var newUpdateTopics = updateTopics.map(function (topic) {
    var filterTopic = filteredTopics.find(function (selTopic) {
      return selTopic.topicId === topic.topicId;
    });
    if (filterTopic) {
      if (filterTopic.selected) {
        selectedTopicCount += 1;
      }
      return _objectSpread(_objectSpread({}, topic), {}, {
        selected: filterTopic.selected,
        checkedNormal: filterTopic.checkedNormal,
        checkedEasier: filterTopic.checkedEasier,
        isHidden: filterTopic.isHidden
      });
    }
    selectedTopicCount += 1;
    return _objectSpread(_objectSpread({}, topic), {}, {
      selected: true,
      checkedNormal: true,
      checkedEasier: false,
      isHidden: false
    });
  });
  return {
    updateTopics: newUpdateTopics,
    selectedTopicCount: selectedTopicCount
  };
};
var updateAssignmentStatusByTopic = function updateAssignmentStatusByTopic(activities, studentId, studentAssignments) {
  if ((studentAssignments === null || studentAssignments === void 0 ? void 0 : studentAssignments.length) > 0 && (activities === null || activities === void 0 ? void 0 : activities.length) > 0) {
    return studentAssignments.map(function (s) {
      var findActivity = activities.find(function (activity) {
        return s.encryptedUserProfileId === studentId && s.activityId === activity.activityId && s.taskType === activity.taskType;
      });
      var isSelected = s.isSelected;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])(findActivity)) {
        isSelected = s.isSelected ? undefined : true;
      }
      return _objectSpread(_objectSpread({}, s), {}, {
        isSelected: isSelected
      });
    });
  }
  return studentAssignments;
};
function checkIfAssignmentPassesFilter(studentAssignment, payload) {
  var _studentAssignment$re, _studentAssignment$as, _studentAssignment$re3, _payload$rangeData;
  var passesFilter = true;
  // Score can very rarely be null, which counts as non-attempted, even though there is attempts...
  var hasAttempt = (studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$re = studentAssignment.result) === null || _studentAssignment$re === void 0 ? void 0 : _studentAssignment$re.completionDate) && (studentAssignment === null || studentAssignment === void 0 ? void 0 : studentAssignment.result.attempts) > 0 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])(studentAssignment === null || studentAssignment === void 0 ? void 0 : studentAssignment.result.score);
  var hasAssignment = studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$as = studentAssignment.assignment) === null || _studentAssignment$as === void 0 ? void 0 : _studentAssignment$as.startDate;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])(payload.dateFilter)) {
    var _studentAssignment$as2, _studentAssignment$re2;
    if (!hasAttempt && !hasAssignment) {
      return _objectSpread(_objectSpread({}, studentAssignment), {}, {
        isFiltered: true
      });
    }
    var _payload$dateFilter$d = payload.dateFilter.dateRange,
      startDate = _payload$dateFilter$d.startDate,
      endDate = _payload$dateFilter$d.endDate;
    var isInRange = function isInRange(date) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])(date) && __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).isBetween(startDate, endDate, undefined, '[)');
    };
    var assignmentPassesFilter = isInRange(studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$as2 = studentAssignment.assignment) === null || _studentAssignment$as2 === void 0 ? void 0 : _studentAssignment$as2.startDate);
    var resultPassesFilter = isInRange(studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$re2 = studentAssignment.result) === null || _studentAssignment$re2 === void 0 ? void 0 : _studentAssignment$re2.completionDate);
    passesFilter = assignmentPassesFilter || resultPassesFilter;
  }
  var passesRange = true;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])(studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$re3 = studentAssignment.result) === null || _studentAssignment$re3 === void 0 ? void 0 : _studentAssignment$re3.score)) {
    var _studentAssignment$re4, _studentAssignment$re5, _studentAssignment$re6, _studentAssignment$re7;
    if ((studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$re4 = studentAssignment.result) === null || _studentAssignment$re4 === void 0 ? void 0 : _studentAssignment$re4.score) <= 50) {
      passesRange = payload.rangeData.zeroToFifty;
    } else if ((studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$re5 = studentAssignment.result) === null || _studentAssignment$re5 === void 0 ? void 0 : _studentAssignment$re5.score) > 50 && (studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$re6 = studentAssignment.result) === null || _studentAssignment$re6 === void 0 ? void 0 : _studentAssignment$re6.score) < 85) {
      passesRange = payload.rangeData.fiftyToEightyFive;
    } else if ((studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$re7 = studentAssignment.result) === null || _studentAssignment$re7 === void 0 ? void 0 : _studentAssignment$re7.score) >= 85) {
      passesRange = payload.rangeData.overEightyFive;
    }
  }
  var passesDropDownValue = true;
  if (payload.dropdownValue.selectedOption === 'AO') {
    var _studentAssignment$re8, _studentAssignment$re9;
    passesDropDownValue = (studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$re8 = studentAssignment.result) === null || _studentAssignment$re8 === void 0 ? void 0 : _studentAssignment$re8.isAssignedResult) && (studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$re9 = studentAssignment.result) === null || _studentAssignment$re9 === void 0 ? void 0 : _studentAssignment$re9.score) !== null;
  }
  if (((_payload$rangeData = payload.rangeData) === null || _payload$rangeData === void 0 ? void 0 : _payload$rangeData.assigned) === false) {
    passesFilter = passesFilter && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])(studentAssignment.assignment);
  }
  passesFilter = passesFilter && passesRange && passesDropDownValue;
  return _objectSpread(_objectSpread({}, studentAssignment), {}, {
    isFiltered: !passesFilter
  });
}
var contactTechSupport = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
  href: "http://www.3plearning.com/contact/"
}, __WEBPACK_IMPORTED_MODULE_1__lingui_core__["i18n"]._(
/*i18n*/
{
  id: "help.contactSupport",
  defaults: "Please contact Tech Support"
}));
var errorDetails = __WEBPACK_IMPORTED_MODULE_1__lingui_core__["i18n"]._(
/*i18n*/
{
  id: "help.errorDetails",
  defaults: "with details of what happened and we will work to get you back on track."
});
var contactTechSupportMessage = "".concat(__WEBPACK_IMPORTED_MODULE_1__lingui_core__["i18n"]._(
/*i18n*/
{
  id: "help.errorOccurred",
  defaults: "Oops an error has occurred. "
}), "\n").concat(contactTechSupport, "\n").concat(errorDetails);
function sortStudentAssignments(studentAssignments, sortedStudents, selectedActivities) {
  var orderedArr = [];
  sortedStudents.forEach(function (sorted) {
    studentAssignments.forEach(function (currentStudent) {
      var isHidden = false;
      if (!selectedActivities.some(function (selectedActivity) {
        return (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.length) > 0 && selectedActivity.find(function (x) {
          return x.activityId === currentStudent.activityId && x.taskType === currentStudent.taskType;
        });
      })) {
        isHidden = true;
      } else {
        isHidden = false;
      }
      if (currentStudent.encryptedUserProfileId === sorted.encryptedUserProfileId) {
        orderedArr.push(_objectSpread(_objectSpread({}, currentStudent), {}, {
          student: sorted,
          isHidden: isHidden
        }));
      }
    });
  });
  return orderedArr;
}
function sortStudentAssignmentsByName(studentAssignments, sortedStudents) {
  var orderedArr = [];
  sortedStudents.forEach(function (sorted) {
    studentAssignments.forEach(function (currentStudent) {
      if (currentStudent.encryptedUserProfileId === sorted.encryptedUserProfileId) {
        orderedArr.push(_objectSpread(_objectSpread({}, currentStudent), {}, {
          student: sorted
        }));
      }
    });
  });
  return orderedArr;
}
function updateStudentAssignmentsHidden(studentAssignments, selectedActivities) {
  var orderedArr = studentAssignments.map(function (currentStudent) {
    if (!selectedActivities.some(function (selectedActivity) {
      return (selectedActivity === null || selectedActivity === void 0 ? void 0 : selectedActivity.length) > 0 && selectedActivity.find(function (x) {
        return x.activityId === currentStudent.activityId && x.taskType === currentStudent.taskType;
      });
    })) {
      return _objectSpread(_objectSpread({}, currentStudent), {}, {
        isHidden: true
      });
    }
    return _objectSpread(_objectSpread({}, currentStudent), {}, {
      isHidden: false
    });
  });
  return orderedArr;
}

/***/ }),

/***/ "M+Hj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Hide; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var InfoWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var palette = props.theme.palette;
  return "\n        ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n        ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('flex-start'), ";\n        flex-direction: column;\n        background: ").concat(palette.primary.text, ";\n        color: ").concat(palette.primary.dark, ";\n        width: 100%;\n        \n        div {\n          padding: 10px;\n          font-family: inherit;\n          font-size: 12px;\n          width: 100%;\n          box-sizing: border-box;\n        }\n        .description {\n          padding-top: 0;\n        }\n        \n        .headerWrapper {\n          ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n          ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('row'), ";\n          .standardName {\n            font-weight: 600;\n          }\n          .title {\n            ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n          }\n          .subTitle {\n            padding-top: 5px;\n            white-space: pre-wrap;\n          }\n          * {\n            padding: 0;\n          }\n        }\n");
});
var Icon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 37px;\n  min-height: 37px;\n  padding-left: 15px !important;\n  margin-top: 5px;\n  text-align: right;\n"])));
var Hide = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(function (props) {
  var colours = props.theme.colours;
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('left'), ";  \n  \n  cursor: pointer;\n  border-bottom: 1px solid ").concat(colours.grey[400], ";\n  padding: 8px;\n  font-family: inherit;\n  font-size: 12px;\n  width: 100%;\n  box-sizing: border-box;\n  ");
});


/***/ }),

/***/ "MI7Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useAssignmentsToUnassign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("6QRH");


function useAssignmentsToUnassign() {
  var assignmentsToUnassign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.assignments.studentAssignments && state.CourseAssignReducer.assignments.studentAssignments.filter(function (assignment) {
      return assignment.isSelected && assignment.assignment && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* isDefined */])(assignment.assignment.assignStatus);
    }) || [];
  });
  return assignmentsToUnassign;
}

/***/ }),

/***/ "ML6N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__student_result_cell_styled__ = __webpack_require__("bW/0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__ = __webpack_require__("S0Yi");




var StudentResultCell = function StudentResultCell(_ref) {
  var title = _ref.title,
    value = _ref.value,
    icon = _ref.icon;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_cell_styled__["a" /* StudentResultCellWrapper */], {
    "data-testid": "student-result-cell"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_cell_styled__["b" /* Title */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_cell_styled__["c" /* IconWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__["a" /* default */], {
    icon: icon
  })), title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_cell_styled__["d" /* Content */], null, value));
};
StudentResultCell.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired]),
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
StudentResultCell.defaultProps = {
  container: false,
  icon: ''
};
/* harmony default export */ __webpack_exports__["a"] = (StudentResultCell);

/***/ }),

/***/ "MlP1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date_picker__ = __webpack_require__("x7/N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled__ = __webpack_require__("ObO6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__checkbox__ = __webpack_require__("4YSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__ = __webpack_require__("IzlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_course_assign_course_assign_actions__ = __webpack_require__("+7+H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_utils__ = __webpack_require__("6QRH");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }











var Legend = function Legend(props) {
  var i18n = props.i18n,
    isVisible = props.isVisible,
    onApply = props.onApply;
  var SELECT_RANGE = i18n._(
  /*i18n*/
  {
    id: "viewKey.selectDateRange",
    defaults: "Select Date Range"
  });
  var showResultsList = [{
    value: 'LA',
    label: i18n._(
    /*i18n*/
    {
      id: "viewKey.latestAttempt",
      defaults: "Latest attempt"
    })
  }, {
    value: 'AO',
    label: i18n._(
    /*i18n*/
    {
      id: "viewKey.assignedOnly",
      defaults: "Assigned only"
    })
  }];
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
    _useState2 = _slicedToArray(_useState, 2),
    assigned = _useState2[0],
    setAssigned = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isZeroToFiftyChecked = _useState4[0],
    setZeroToFiftyChecked = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isFiftyToEightyFiveChecked = _useState6[0],
    setFiftyToEightyFiveChecked = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isOverEightyFiveChecked = _useState8[0],
    setOverEightyFiveChecked = _useState8[1];
  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
      value: 'LA',
      label: i18n._(
      /*i18n*/
      {
        id: "viewKey.latestAttempt",
        defaults: "Latest attempt"
      })
    }),
    _useState0 = _slicedToArray(_useState9, 2),
    selectionResult = _useState0[0],
    setSelectionResult = _useState0[1];
  var dateObj = new Date();
  var currentYear = dateObj.getFullYear();
  var currentMonth = dateObj.getMonth() + 1;
  var currentDay = dateObj.getDate();
  var today = "".concat(currentYear, "-").concat(currentMonth, "-").concat(currentDay);
  // Two years ago to one year in the future
  var rangeStartDate = "".concat(currentYear - 2, "-").concat(currentMonth, "-").concat(currentDay);
  var rangeEndDate = "".concat(currentYear + 1, "-").concat(currentMonth, "-").concat(currentDay);
  var _useState1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined),
    _useState10 = _slicedToArray(_useState1, 2),
    dateOptions = _useState10[0],
    setDateOptions = _useState10[1];
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var activeClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var activeGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var assignUnassignedButtonClicked = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.shouldClearFilter;
  });
  var clearFilter = function clearFilter() {
    setDateOptions(undefined);
    setSelectionResult({
      value: 'LA',
      label: i18n._(
      /*i18n*/
      {
        id: "viewKey.latestAttempt",
        defaults: "Latest attempt"
      })
    });
    setAssigned(true);
    setZeroToFiftyChecked(true);
    setFiftyToEightyFiveChecked(true);
    setOverEightyFiveChecked(true);
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_types__["G" /* CLEAR_ASSIGNMENT_FILTERS */]
    });
    onApply();
  };
  var memoizedCallback = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(clearFilter, []);
  var lastSelectedClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(activeClass);
  var lastSelectedGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(activeGroup);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (assignUnassignedButtonClicked) {
      memoizedCallback();
    }
  }, [memoizedCallback, assignUnassignedButtonClicked]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (lastSelectedClass.current !== activeClass || lastSelectedGroup.current !== activeGroup) {
      memoizedCallback();
    }
    lastSelectedClass.current = activeClass;
    lastSelectedGroup.current = activeGroup;
  }, [memoizedCallback, activeClass, activeGroup]);
  if (!isVisible) return null;
  var onDateChangeHandler = function onDateChangeHandler(selectedRangeType, startDate, endDate) {
    setDateOptions({
      startDate: startDate,
      endDate: endDate
    });
  };
  var datePickerLabels = _defineProperty(_defineProperty({}, __WEBPACK_IMPORTED_MODULE_4__date_picker__["a" /* default */].CUSTOM_DATE, i18n._(
  /*i18n*/
  {
    id: "viewKey.customDate",
    defaults: "Custom date"
  })), SELECT_RANGE, i18n._(
  /*i18n*/
  {
    id: "viewKey.selectDateRange",
    defaults: "Select Date Range"
  }));
  var datePickerProps = {
    academicYear: {
      startDate: rangeStartDate,
      endDate: rangeEndDate
    },
    currentDate: {
      startDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_utils__["c" /* isDefined */])(dateOptions) ? dateOptions.startDate : today,
      endDate: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_utils__["c" /* isDefined */])(dateOptions) ? dateOptions.endDate : today,
      type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_utils__["c" /* isDefined */])(dateOptions) ? __WEBPACK_IMPORTED_MODULE_4__date_picker__["a" /* default */].CUSTOM_DATE : SELECT_RANGE
    },
    weeklyRangeOnly: false,
    options: [SELECT_RANGE, __WEBPACK_IMPORTED_MODULE_4__date_picker__["a" /* default */].CUSTOM_DATE],
    labels: datePickerLabels,
    onDateChange: onDateChangeHandler
  };
  var applyFilter = function applyFilter() {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_course_assign_course_assign_actions__["g" /* updateFiltersActionCreator */])({
      dateData: {
        dateRange: dateOptions
      },
      rangeData: {
        assigned: assigned,
        zeroToFifty: isZeroToFiftyChecked,
        fiftyToEightyFive: isFiftyToEightyFiveChecked,
        overEightyFive: isOverEightyFiveChecked
      },
      dropdownValue: {
        selectedOption: selectionResult.value
      }
    }));
    onApply();
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["a" /* LegendWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["b" /* DateRange */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["c" /* Title */], {
    className: "headerText"
  }, i18n._(
  /*i18n*/
  {
    id: "viewKey.label.filter",
    defaults: "Key/Filter"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["c" /* Title */], null, i18n._(
  /*i18n*/
  {
    id: "viewKey.label.showCells",
    defaults: "Show cells within date range:"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__date_picker__["a" /* default */], _extends({}, datePickerProps, {
    labels: datePickerLabels
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["d" /* Clear */], {
    onClick: function onClick() {
      return setDateOptions(undefined);
    }
  }, i18n._(
  /*i18n*/
  {
    id: "viewKey.clear",
    defaults: "clear"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["e" /* Results */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["c" /* Title */], null, i18n._(
  /*i18n*/
  {
    id: "viewKey.label.showResults",
    defaults: "Show results\u2026"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    "data-testid": "showResultsDropdown"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["DropdownMenu"], {
    key: "showResults",
    "data-name": "showResults",
    options: showResultsList,
    selectedOption: selectionResult || showResultsList[0],
    onSelectOption: function onSelectOption(option) {
      setSelectionResult(option);
    }
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["c" /* Title */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "label"
  }, i18n._(
  /*i18n*/
  {
    id: "viewKey.label.studentProgress",
    defaults: "Student Progress"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "item"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["f" /* CheckboxWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__checkbox__["a" /* default */], {
    id: "assigned-checkbox",
    checkboxHandler: function checkboxHandler() {
      setAssigned(!assigned);
    },
    state: assigned ? __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["b" /* CHECKED */] : __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["a" /* UNCHECKED */],
    className: "listCheckbox"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["g" /* ColorBlock */], {
    color: "#dae7d3",
    "data-name": "assigned"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: "assigned"
  }, i18n._(
  /*i18n*/
  {
    id: "viewKey.label.assigned",
    defaults: "Assigned"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "item"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["f" /* CheckboxWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__checkbox__["a" /* default */], {
    id: "zeroToFifty-checkbox",
    checkboxHandler: function checkboxHandler() {
      setZeroToFiftyChecked(!isZeroToFiftyChecked);
    },
    state: isZeroToFiftyChecked ? __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["b" /* CHECKED */] : __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["a" /* UNCHECKED */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["g" /* ColorBlock */], {
    color: "#900012",
    "data-name": "progress_1"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: "progress_1"
  }, i18n._(
  /*i18n*/
  {
    id: "viewKey.label.0-50",
    defaults: "0 - 50% Correct"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "item"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["f" /* CheckboxWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__checkbox__["a" /* default */], {
    id: "fiftyToEightyFive-checkbox",
    checkboxHandler: function checkboxHandler() {
      setFiftyToEightyFiveChecked(!isFiftyToEightyFiveChecked);
    },
    state: isFiftyToEightyFiveChecked ? __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["b" /* CHECKED */] : __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["a" /* UNCHECKED */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["g" /* ColorBlock */], {
    color: "#314eb5",
    "data-name": "progress_2"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: "progress_2"
  }, i18n._(
  /*i18n*/
  {
    id: "viewKey.label.50-85",
    defaults: "50 - 85% Correct"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "item"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["f" /* CheckboxWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__checkbox__["a" /* default */], {
    id: "overEightyFive-checkbox",
    checkboxHandler: function checkboxHandler() {
      setOverEightyFiveChecked(!isOverEightyFiveChecked);
    },
    state: isOverEightyFiveChecked ? __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["b" /* CHECKED */] : __WEBPACK_IMPORTED_MODULE_7__checkbox_constants__["a" /* UNCHECKED */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["g" /* ColorBlock */], {
    color: "#4bda40",
    "data-name": "progress_3"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: "progress_3"
  }, i18n._(
  /*i18n*/
  {
    id: "viewKey.label.85-100",
    defaults: "85 - 100% Correct"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["h" /* ButtonWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"], {
    alignIcon: "LEFT",
    onClick: clearFilter,
    text: i18n._(
    /*i18n*/
    {
      id: "viewKey.label.clear",
      defaults: "Clear"
    }),
    secondary: true,
    type: __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"].LOZENGE
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"], {
    alignIcon: "RIGHT",
    onClick: applyFilter,
    text: i18n._(
    /*i18n*/
    {
      id: "viewKey.label.apply",
      defaults: "Apply"
    }),
    primary: true,
    type: __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"].LOZENGE
  })));
};
Legend.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  isVisible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  css: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  onApply: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
Legend.defaultProps = {
  isVisible: false
};
/* harmony default export */ __webpack_exports__["a"] = (Legend);

/***/ }),

/***/ "N5/L":
/***/ (function(module, exports) {

module.exports = {
  // The application name, to be used when asking the configuration system for settings
  appName: 'CourseAssignHost',
  // TODO: 1. Set this to the name of the host application
  // Packages shipped as modern ES (ESM / arrow functions / class fields) that
  // webpack 2's ES5 parser and UglifyJS cannot handle, so babel must transpile
  // them too.
  childApplications: ['@3plearning/routing-conserve-parameters', '@3plearning/mx-teacher-analytics', '@3plearning/teacher-totter', 'posthog-js']
};

/***/ }),

/***/ "O9G1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useAssignmentsToAssign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("6QRH");


function useAssignmentsToAssign() {
  var assignmentsToAssign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.assignments.studentAssignments && state.CourseAssignReducer.assignments.studentAssignments.filter(function (assignment) {
      return assignment.isSelected && (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* isDefined */])(assignment.assignment) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* isDefined */])(assignment.assignment.assignStatus));
    }) || [];
  });
  return assignmentsToAssign;
}

/***/ }),

/***/ "OG0p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sortAscToDesc */
/* unused harmony export sortDescToAsc */
/* unused harmony export sortActivityAscToDesc */
/* unused harmony export sortActivityDescToAsc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return customSort; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_orderBy__ = __webpack_require__("Ba3q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_orderBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_orderBy__);

var sortAscToDesc = function sortAscToDesc(x, y) {
  var a = x.firstName.toUpperCase();
  var b = y.firstName.toUpperCase();
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};
var sortDescToAsc = function sortDescToAsc(x, y) {
  var a = x.firstName.toUpperCase();
  var b = y.firstName.toUpperCase();
  if (a < b) return 1;
  if (a > b) return -1;
  return 0;
};
var sortActivityDescToAsc = function sortActivityDescToAsc(x, y) {
  var a = parseInt(x.assignmentCount, 10);
  var b = parseInt(y.assignmentCount, 10);
  if (a < b) return 1;
  if (a > b) return -1;
  return 0;
};
var sortActivityAscToDesc = function sortActivityAscToDesc(x, y) {
  var a = parseInt(x.assignmentCount, 10);
  var b = parseInt(y.assignmentCount, 10);
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};
var customSort = function customSort() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var primaryField = arguments.length > 1 ? arguments[1] : undefined;
  var sortDirection = arguments.length > 2 ? arguments[2] : undefined;
  var orderedList = __WEBPACK_IMPORTED_MODULE_0_lodash_orderBy___default()(list, function (item) {
    return isNaN(item[primaryField]) ? item[primaryField].toLowerCase() : item[primaryField];
  }, [sortDirection]);
  return orderedList;
};


/***/ }),

/***/ "ObO6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LegendWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ColorBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Results; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CheckboxWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DateRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ButtonWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Clear; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var LegendWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(function (props) {
  var palette = props.theme.palette;
  return "\n    position: absolute;\n    margin-top: 10px;\n    right: -40px;\n    padding: 0 10px 10px;\n    min-width: 200px;\n    background-color: white;\n    z-index: 9;\n    box-shadow: 4px 2px 6px;\n    border-radius: 4px;\n    font-size: 14px;\n  \n    [class*='svgIconComponent--'] {\n      height: 24px !important;\n    }\n  \n    .item {\n      ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* inlineFlexbox */])(), ";\n      ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n  \n      margin-bottom: 10px;\n      background-color: #f4f9f1;\n      border-radius: 5px;\n      padding: 4px;\n      width: 97%;\n    }\n  \n    ::after {\n      width: 0;\n      height: 0;\n      border-left: 8px solid transparent;\n      border-right: 8px solid transparent;\n      border-bottom: 15px solid #fff;\n      position: absolute;\n      top: -15px;\n      right: 95px;\n      content: ' ';\n      z-index: 9;\n    }\n  \n    .headerText {\n      color: #000000;\n      font-weight: 700;\n      margin-bottom: -15px;\n    }\n  \n    & div[class*='ButtonWrapper'] {\n      height: 40px;\n      &:first-of-type { \n        margin-right: 20px;\n        color: white;\n        padding: 15px;\n        background-color: ").concat(palette.secondary.main, ";\n      }\n    }\n  ");
});
var Title = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 14px;\n  margin: 20px 0 0;\n  color: #3b4e5d;\n  height: 25px;\n  line-height: 16px;\n  padding-bottom: 10px;\n  &:first-of-type {\n    padding-bottom: 0;\n  }\n"])));
var ColorBlock = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* inlineFlexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    width: 23px;\n    height: 23px;\n    background-color: ").concat(props.color, ";\n    border: 1px solid #cfd2d4;\n\n    margin: 0 10px;\n\n    .icon {\n      width: 15px;\n    }\n");
});
var Results = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin: 10px 0;\n"])));
var CheckboxWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  height: 100%;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var DateRange = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  [class*='-DropdownMenuWrapper'] {\n    width: 98%;\n  }\n"])));
var ButtonWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n  ", ";\n  width: 100px;\n  margin: 8px auto 5px;\n\n  * {\n    font-size: inherit !important;\n    text-indent: initial !important;\n  }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'));
var Clear = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  text-align: right;\n  padding: 2px 5px 0 0;\n  margin-bottom: -10px;\n  cursor: pointer;\n  text-decoration: underline;\n"])));


/***/ }),

/***/ "PY2a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DownloadData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_exceljs__ = __webpack_require__("+SRO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_exceljs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_exceljs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver__ = __webpack_require__("t4zo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__excelstyles__ = __webpack_require__("xOeK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__excelconstants__ = __webpack_require__("kVqA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("6QRH");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var DownloadData = /*#__PURE__*/function () {
  function DownloadData() {
    _classCallCheck(this, DownloadData);
  }
  return _createClass(DownloadData, null, [{
    key: "generateSheet",
    value: function generateSheet(wsData, gridTopics, i18n) {
      var workbook = new __WEBPACK_IMPORTED_MODULE_0_exceljs__["Workbook"]();
      var sheetName = 'Sheet1';
      var sheet = workbook.addWorksheet(sheetName);
      wsData.forEach(function (topic, key) {
        var row = sheet.addRow(topic);
        if (key === __WEBPACK_IMPORTED_MODULE_4__excelconstants__["a" /* ROW_2 */]) {
          row.font = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["a" /* fontWithBold */];
        } else if (key === __WEBPACK_IMPORTED_MODULE_4__excelconstants__["b" /* ROW_3 */]) {
          row.font = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["b" /* fontWithBoldGray */];
        } else {
          row.font = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["c" /* font */];
        }
      });
      sheet = this.formatHeaderRow(gridTopics, sheet);
      sheet = this.formatResultRow(wsData, gridTopics, sheet);
      sheet = this.formatSheet(sheet, wsData, i18n);
      return workbook;
    }
  }, {
    key: "formatSheet",
    value: function formatSheet(sheet, wsData, i18n) {
      sheet.getCell(wsData.length, 1).value = i18n._(
      /*i18n*/
      {
        id: "downloadexcel.sheet.classAverage",
        defaults: "Class Average"
      });
      sheet.getCell('A1').font = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["d" /* headerFont */];
      sheet.getCell(wsData.length, __WEBPACK_IMPORTED_MODULE_4__excelconstants__["c" /* CELL_2 */]).value = '';
      sheet.getCell(wsData.length, __WEBPACK_IMPORTED_MODULE_4__excelconstants__["d" /* CELL_3 */]).value = '';
      sheet.getCell(wsData.length, __WEBPACK_IMPORTED_MODULE_4__excelconstants__["d" /* CELL_3 */]).border = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["e" /* cellTopBottomBorder */];
      sheet.getCell(wsData.length, __WEBPACK_IMPORTED_MODULE_4__excelconstants__["e" /* CELL_4 */]).value = '';
      sheet.getColumn(__WEBPACK_IMPORTED_MODULE_4__excelconstants__["f" /* COLUMN_1 */]).width = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["f" /* studentDetailColWidth */];
      sheet.getColumn(__WEBPACK_IMPORTED_MODULE_4__excelconstants__["g" /* COLUMN_2 */]).width = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["f" /* studentDetailColWidth */];
      sheet.mergeCells('A1:B1');
      sheet.columns.forEach(function (column, key) {
        if (key > __WEBPACK_IMPORTED_MODULE_4__excelconstants__["g" /* COLUMN_2 */]) column.width = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["g" /* columnWidth */];
      });
      if (wsData && wsData.length > 0) {
        sheet.getCell(wsData.length, wsData[wsData.length - __WEBPACK_IMPORTED_MODULE_4__excelconstants__["h" /* CELL_1 */]].length).border = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["h" /* cellTopBottomRightBorder */];
      }
      sheet.getRow(4).height = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["i" /* columnHeightTopics */];
      sheet.getCell('A4').font = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["j" /* subHeaderFont */];
      sheet.getCell('B4').font = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["j" /* subHeaderFont */];
      sheet.getCell('C4').font = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["j" /* subHeaderFont */];
      return sheet;
    }
  }, {
    key: "formatHeaderRow",
    value: function formatHeaderRow(gridTopics, sheet) {
      // merging topic headers columns
      var mergeCellRow = __WEBPACK_IMPORTED_MODULE_4__excelconstants__["i" /* MERGE_CELL_ROW */];
      var mergeCellStart = __WEBPACK_IMPORTED_MODULE_4__excelconstants__["j" /* MERGE_CELL_START */];
      var mergeCellEnd = __WEBPACK_IMPORTED_MODULE_4__excelconstants__["k" /* MERGE_CELL_END */];
      var cellCounter = __WEBPACK_IMPORTED_MODULE_4__excelconstants__["l" /* CELL_COUNTER */];
      gridTopics.find(function (sTopic) {
        if (sTopic.selected) {
          var activities = sTopic.checkedNormal ? sTopic.coreActivities : sTopic.easierActivities;
          mergeCellEnd = activities ? activities.length : 0;
          mergeCellEnd += cellCounter;
          sheet.mergeCells(mergeCellRow, mergeCellStart, mergeCellRow, mergeCellEnd);
          sheet.getCell(mergeCellRow, mergeCellStart).alignment = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["k" /* mergeCellAlign */];
          sheet.getCell(__WEBPACK_IMPORTED_MODULE_4__excelconstants__["m" /* ROW_1 */], mergeCellEnd).border = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["l" /* cellRightBorder */];
          sheet.getCell(__WEBPACK_IMPORTED_MODULE_4__excelconstants__["a" /* ROW_2 */], mergeCellEnd).border = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["l" /* cellRightBorder */];
          sheet.getCell(__WEBPACK_IMPORTED_MODULE_4__excelconstants__["b" /* ROW_3 */], mergeCellEnd).border = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["l" /* cellRightBorder */];
          sheet.getCell(__WEBPACK_IMPORTED_MODULE_4__excelconstants__["n" /* ROW_4 */], mergeCellEnd).border = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["l" /* cellRightBorder */];
          mergeCellStart = mergeCellEnd + __WEBPACK_IMPORTED_MODULE_4__excelconstants__["h" /* CELL_1 */];
          cellCounter = mergeCellEnd;
        }
        return null;
      });
      return sheet;
    }
  }, {
    key: "formatResultRow",
    value: function formatResultRow(wsData, gridTopics, sheet) {
      if (wsData.length > __WEBPACK_IMPORTED_MODULE_4__excelconstants__["e" /* CELL_4 */]) {
        var mergeCellEnd = __WEBPACK_IMPORTED_MODULE_4__excelconstants__["k" /* MERGE_CELL_END */];
        var cellCounter = __WEBPACK_IMPORTED_MODULE_4__excelconstants__["l" /* CELL_COUNTER */];
        wsData.forEach(function (sDetails, key) {
          if (sDetails && key > __WEBPACK_IMPORTED_MODULE_4__excelconstants__["b" /* ROW_3 */] && key < wsData.length) {
            gridTopics.find(function (sTopic) {
              if (sTopic.selected) {
                var activities = sTopic.checkedNormal ? sTopic.coreActivities : sTopic.easierActivities;
                mergeCellEnd = activities ? activities.length : 0;
                sheet.getCell(key + __WEBPACK_IMPORTED_MODULE_4__excelconstants__["h" /* CELL_1 */], mergeCellEnd + cellCounter).border = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["l" /* cellRightBorder */];
                cellCounter += mergeCellEnd;
                return null;
              }
              return null;
            });
            cellCounter = __WEBPACK_IMPORTED_MODULE_4__excelconstants__["l" /* CELL_COUNTER */];
            if (key === wsData.length - __WEBPACK_IMPORTED_MODULE_4__excelconstants__["h" /* CELL_1 */]) {
              sDetails.forEach(function (cellDetails, cellIndex) {
                if (cellDetails) {
                  sheet.getCell(key + __WEBPACK_IMPORTED_MODULE_4__excelconstants__["h" /* CELL_1 */], cellIndex + __WEBPACK_IMPORTED_MODULE_4__excelconstants__["h" /* CELL_1 */]).border = __WEBPACK_IMPORTED_MODULE_3__excelstyles__["e" /* cellTopBottomBorder */];
                }
              });
            }
          }
        });
      }
      return sheet;
    }
  }, {
    key: "downloadExcel",
    value: function () {
      var _downloadExcel = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(wsData, i18n, gridTopics, setDownloadProgressFlag) {
        var workbook, fileName, buffer, fileType, blob;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              workbook = this.generateSheet(wsData, gridTopics, i18n); // Creating XLSX file
              fileName = i18n._(
              /*i18n*/
              {
                id: "downloadexcel.filename",
                defaults: "A&R Courses.xlsx"
              });
              _context.n = 1;
              return workbook.xlsx.writeBuffer();
            case 1:
              buffer = _context.v;
              fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              blob = new Blob([buffer], {
                type: fileType
              });
              __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_file_saver__["saveAs"])(blob, fileName);
              setDownloadProgressFlag(false);
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function downloadExcel(_x, _x2, _x3, _x4) {
        return _downloadExcel.apply(this, arguments);
      }
      return downloadExcel;
    }()
  }, {
    key: "processDataForExcel",
    value: function processDataForExcel(assignments, i18n, gridTopics, filteredStudents, activeClass, activeGroup, setDownloadProgressFlag) {
      var wsData = [[i18n._(
      /*i18n*/
      {
        id: "downloadexcel.sheet.header",
        defaults: "Course activity assignments and results"
      })], [i18n._(
      /*i18n*/
      {
        id: "downloadexcel.sheet.extractedon",
        defaults: "Extracted {0}",
        values: {
          0: __WEBPACK_IMPORTED_MODULE_2_moment___default()(new Date(), 'DD/MM/YYY').format('DD MMM YYYY')
        }
      })]];
      var _this$getHeaderRows = this.getHeaderRows(assignments, i18n, gridTopics, activeClass, activeGroup, filteredStudents),
        headerRow = _this$getHeaderRows.headerRow,
        activityRow = _this$getHeaderRows.activityRow,
        studentRow = _this$getHeaderRows.studentRow,
        resultRow = _this$getHeaderRows.resultRow;
      wsData.push(headerRow);
      wsData.push(activityRow);
      studentRow.forEach(function (studentDetails) {
        wsData.push(studentDetails);
      });
      wsData.push(resultRow);
      this.downloadExcel(wsData, i18n, gridTopics, setDownloadProgressFlag);
    }
  }, {
    key: "getHeaderRows",
    value: function getHeaderRows(assignments, i18n, gridTopics, activeClass, activeGroup, filteredStudents) {
      var headerRow = [activeClass, activeGroup, '', ''];
      var activityRow = [i18n._(
      /*i18n*/
      {
        id: "downloadexcel.sheet.surnameheader",
        defaults: "Student Surname"
      }), i18n._(
      /*i18n*/
      {
        id: "downloadexcel.sheet.nameheader",
        defaults: "Student First Name"
      }), i18n._(
      /*i18n*/
      {
        id: "downloadexcel.sheet.assignmentheader",
        defaults: "# Current Assignments"
      }), ''];
      gridTopics.find(function (sTopic) {
        if (sTopic.selected) {
          var activities = sTopic.checkedNormal ? sTopic.coreActivities : sTopic.easierActivities;
          activities.forEach(function (activity, key) {
            if (key === 0 && activity) {
              headerRow.push(sTopic.topicName);
            } else {
              headerRow.push('');
            }
            activityRow.push(activity.activityName);
          });
        }
        return null;
      });
      var _this$getStudentDetai = this.getStudentDetails(filteredStudents, assignments, gridTopics),
        studentRow = _this$getStudentDetai.studentRow,
        resultRow = _this$getStudentDetai.resultRow;
      return {
        headerRow: headerRow,
        activityRow: activityRow,
        studentRow: studentRow,
        resultRow: resultRow
      };
    }
  }, {
    key: "getStudentDetails",
    value: function getStudentDetails(filteredStudents, assignments, gridTopics) {
      var _this = this;
      var studentRow = [];
      var studentDetailsRow = [];
      filteredStudents.map(function (currentStudent) {
        var _assignments$totalAss;
        studentDetailsRow.push(currentStudent.lastName, currentStudent.firstName, ((_assignments$totalAss = assignments.totalAssignments.filter(function (assign) {
          return assign.encryptedUserProfileId === currentStudent.encryptedUserProfileId;
        })[0]) === null || _assignments$totalAss === void 0 ? void 0 : _assignments$totalAss.assignedActivityTotal) || 0, '');
        gridTopics.find(function (sTopic) {
          if (sTopic.selected) {
            var activities = sTopic.checkedNormal ? sTopic.coreActivities : sTopic.easierActivities;
            activities.forEach(function (activity) {
              var student = assignments.studentAssignments && assignments.studentAssignments.find(function (item) {
                return activity.activityId === item.activityId && activity.taskType === item.taskType && item.encryptedUserProfileId === currentStudent.encryptedUserProfileId;
              });
              if (student && student.result) {
                studentDetailsRow.push(student.result.score);
              } else if (student && student.assignment) {
                if (student.assignment.assignStatus && (student.assignment.assignStatus === __WEBPACK_IMPORTED_MODULE_5__helpers_utils__["f" /* studentStatus */].ASSIGNED || student.assignment.assignStatus === __WEBPACK_IMPORTED_MODULE_5__helpers_utils__["f" /* studentStatus */].INPROGRESS || student.assignment.assignStatus === __WEBPACK_IMPORTED_MODULE_5__helpers_utils__["f" /* studentStatus */].PAST_DUE_DATE)) {
                  studentDetailsRow.push('A');
                } else {
                  studentDetailsRow.push('');
                }
              } else {
                studentDetailsRow.push('');
              }
            });
          }
          return null;
        });
        studentRow.push(studentDetailsRow);
        studentDetailsRow = [];
        return null;
      });
      var resultRow = studentRow.reduce(function (r, a) {
        return a.map(function (b, i) {
          return parseInt(r[i] || 0, 10) + b;
        });
      }, []);
      if (resultRow && resultRow.length > 0) {
        resultRow.forEach(function (result, key) {
          var studentScores = _this.getStudentScores(studentRow, key);
          var count = 0;
          studentScores.forEach(function (score) {
            // converting score to integer to check its type to get count of score per student
            if (!isNaN(parseInt(score, 10))) {
              count += 1;
            }
            return null;
          });
          if (result && result > 0 && count > 0) {
            resultRow[key] = parseFloat(result / count).toFixed(1);
          } else {
            resultRow[key] = '0';
          }
        });
      }
      return {
        studentRow: studentRow,
        resultRow: resultRow
      };
    }
  }]);
}();
_defineProperty(DownloadData, "getStudentScores", function (studentDetails, id) {
  return studentDetails.map(function (x) {
    return x[id];
  });
});

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("hKoQ")))

/***/ }),

/***/ "Ph6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return viewResultsModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__results_styled__ = __webpack_require__("0oWN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pulse_loader__ = __webpack_require__("oWNv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__result_cell_results_cell__ = __webpack_require__("luI0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__line_chart_line_chart__ = __webpack_require__("wY8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__ = __webpack_require__("S0Yi");












var ResultsModal = function ResultsModal(_ref) {
  var i18n = _ref.i18n,
    isAssigned = _ref.isAssigned;
  var wraperRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var isLoadingResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.isLoadingResults;
  });
  var activityReport = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.singleActivityReport;
  });
  if (isLoadingResults) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["a" /* ModalBody */], {
      ref: wraperRef
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["b" /* LoaderWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__pulse_loader__["a" /* default */], null)));
  }
  var AssignedActivity = function AssignedActivity() {
    var _activityReport$recen, _activityReport$recen2, _activityReport$recen3;
    return isAssigned ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__result_cell_results_cell__["a" /* default */], {
      container: true,
      title: i18n._(
      /*i18n*/
      {
        id: "results.\"assignedPeriod",
        defaults: "Assigned Period"
      }),
      icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["n" /* Period */]
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__result_cell_results_cell__["a" /* default */], {
      icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["o" /* AssignStart */],
      title: i18n._(
      /*i18n*/
      {
        id: "results.start",
        defaults: "Start"
      }),
      value: __WEBPACK_IMPORTED_MODULE_4_moment___default()(activityReport === null || activityReport === void 0 || (_activityReport$recen = activityReport.recentAssignment) === null || _activityReport$recen === void 0 ? void 0 : _activityReport$recen.startDate).format('D MMM YYYY h:mm A')
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__result_cell_results_cell__["a" /* default */], {
      icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["p" /* AssignEnd */],
      title: i18n._(
      /*i18n*/
      {
        id: "results.due",
        defaults: "Due"
      }),
      value: __WEBPACK_IMPORTED_MODULE_4_moment___default()(activityReport === null || activityReport === void 0 || (_activityReport$recen2 = activityReport.recentAssignment) === null || _activityReport$recen2 === void 0 ? void 0 : _activityReport$recen2.dueDate).format('D MMM YYYY h:mm A')
    })) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__result_cell_results_cell__["a" /* default */], {
      container: true,
      title: i18n._(
      /*i18n*/
      {
        id: "results.\"completed",
        defaults: "Completed"
      }),
      icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["n" /* Period */]
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__result_cell_results_cell__["a" /* default */], {
      icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["o" /* AssignStart */],
      title: i18n._(
      /*i18n*/
      {
        id: "results.\"lastActivity",
        defaults: "Last Activity"
      }),
      value: __WEBPACK_IMPORTED_MODULE_4_moment___default()(activityReport === null || activityReport === void 0 || (_activityReport$recen3 = activityReport.recentResults[0]) === null || _activityReport$recen3 === void 0 ? void 0 : _activityReport$recen3.completionDate).format('D MMM YYYY h:mm A')
    }));
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["a" /* ModalBody */], {
    ref: wraperRef,
    "data-testid": "result-modal"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["c" /* StudentDetails */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["d" /* StudentName */], {
    "data-testid": "student-name"
  }, activityReport.studentFirstName, " ", activityReport.studentLastName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["e" /* ActivityName */], {
    "data-testid": "activity-name"
  }, activityReport.activityName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["f" /* ResultsHeading */], {
    "data-testid": "results"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["g" /* IconWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["m" /* Results */]
  })), i18n._(
  /*i18n*/
  {
    id: "Results",
    defaults: "Results"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["h" /* ResultsWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["i" /* AttemptsWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__result_cell_results_cell__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["q" /* Attempts */],
    title: i18n._(
    /*i18n*/
    {
      id: "results.attempts",
      defaults: "Attempts"
    }),
    value: activityReport.totalAttempts
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__result_cell_results_cell__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["r" /* Lowest */],
    title: i18n._(
    /*i18n*/
    {
      id: "results.lowestAttempt",
      defaults: "Lowest Attempt"
    }),
    value: "".concat(activityReport.lowestScore, "%")
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__result_cell_results_cell__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["s" /* Latest */],
    title: i18n._(
    /*i18n*/
    {
      id: "results.lastAttempt",
      defaults: "Last Attempt"
    }),
    value: "".concat(activityReport.lastScore, "%")
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__result_cell_results_cell__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["t" /* Highest */],
    title: i18n._(
    /*i18n*/
    {
      id: "results.highestAttempt",
      defaults: "Highest Attempt"
    }),
    value: "".concat(activityReport.highestScore, "%")
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["j" /* AssignedActivityWrapper */], null, AssignedActivity(), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["k" /* ActivityProgressWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["l" /* ActivityProgressTitle */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["g" /* IconWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_10__helpers_icon_dictionary__["u" /* Progress */]
  })), i18n._(
  /*i18n*/
  {
    id: "results.activityProgress",
    defaults: "Activity Progress"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["m" /* ChartWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__line_chart_line_chart__["a" /* default */], {
    results: activityReport === null || activityReport === void 0 ? void 0 : activityReport.recentResults,
    i18n: i18n
  }))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__results_styled__["n" /* Footer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"], {
    className: "okButton",
    "data-testid": "ok-button",
    primary: true,
    type: __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"].LOZENGE,
    text: i18n._(
    /*i18n*/
    {
      id: "results.ok",
      defaults: "OK"
    }),
    onClick: function onClick() {
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_modal_manager_modal_manager_actions__["c" /* dismissModal */])());
    }
  })));
};
var viewResultsModal = function viewResultsModal(i18n, isAssigned) {
  return {
    content: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ResultsModal, {
      i18n: i18n,
      isAssigned: isAssigned
    }),
    id: 0,
    buttons: []
  };
};
ResultsModal.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  isAssigned: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};
/* unused harmony default export */ var _unused_webpack_default_export = (ResultsModal);

/***/ }),

/***/ "QPJc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Wrapper; });
/* unused harmony export EmptyWrapper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RightSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoaderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n   ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n\n  \n    position: relative;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n    border-top: 1px solid ").concat(colours.grey[400], ";\n    height: fit-content;\n    margin-bottom: 35px;\n\n    &::-webkit-scrollbar {\n      height: 0.05px !important;\n      scrollbar-width: 0.05px !important;\n    }\n\n    &::-ms-scrollbar {\n      height: 0.05px !important;\n      scrollbar-width: 0.05px !important;\n    }\n");
});
var EmptyWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    width: 100%;\n    height: 188px;\n    position: relative;\n    left: 260px;\n    border-top: 1px solid ".concat(colours.grey[400], ";\n    border-right: 1px solid ").concat(colours.grey[400], ";\n");
});
var RightSection = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  overflow: scroll;\n  width: calc(100% - 260px);\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])());
var LoaderContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  flex: 1;\n  margin-top: 200px;\n  margin-left: 25%;\n  position: fixed;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('baseline'));
var GridContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n        ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n        ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n\n        width: 100%;\n        height: fit-content;\n\n        .cell {\n            width: 82px;\n            height: 40px;\n            background: ").concat(colours.grey[300], ";\n          }\n    ");
});

/***/ }),

/***/ "RPFx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

/* harmony default export */ __webpack_exports__["a"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"] === null || __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"] === void 0 ? void 0 : __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"].palette), {}, {
  primary: {
    light: '#eaf9f9',
    main: '#415667',
    dark: '#415667',
    text: '#ffffff'
  },
  secondary: {
    light: '#7fa7c2',
    main: '#7fa7c2',
    dark: '#3b4e5e',
    text: '#000'
  },
  error: {
    light: '#bf2c30',
    main: '#b01e22',
    dark: '#6f1315',
    text: '#fff'
  },
  warning: {
    light: '#cb4b1a',
    main: '#c63a04',
    dark: '#942c04',
    text: '#fff'
  }
}));

/***/ }),

/***/ "S0Yi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_styleable__ = __webpack_require__("KJcn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_styleable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_styleable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__ = __webpack_require__("Bl3B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_core_scss__ = __webpack_require__("nIya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_core_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_core_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_icon_scss__ = __webpack_require__("3IFr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_icon_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__svg_icon_scss__);






var SvgIcon = function SvgIcon(_ref) {
  var _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? '' : _ref$icon;
  var svg = icon ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_inlinesvg__["a" /* default */], {
    src: icon,
    cacheGetRequests: true
  }) : '';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_5__svg_icon_scss___default.a.svgIconComponent
  }, svg);
};
SvgIcon.propTypes = {
  icon: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_react_styleable___default()(__WEBPACK_IMPORTED_MODULE_5__svg_icon_scss___default.a)(SvgIcon));

/***/ }),

/***/ "SEp0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assigned_list_item_styled__ = __webpack_require__("wLwV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assigned_list_assigned_list_styled__ = __webpack_require__("WjZn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkbox__ = __webpack_require__("4YSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__checkbox_constants__ = __webpack_require__("IzlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_utils__ = __webpack_require__("6QRH");








var AssignedListItem = function AssignedListItem(_ref) {
  var i18n = _ref.i18n,
    isSelected = _ref.isSelected,
    index = _ref.index,
    onCheckboxChange = _ref.onCheckboxChange,
    assignedListItem = _ref.assignedListItem;
  function status() {
    switch (assignedListItem.assignStatus) {
      case 0:
        return 'Coming up';
      case 1:
        return 'In progress';
      case 2:
        return 'Overdue';
      case 3:
        return 'Not attempted';
      default:
        break;
    }
    return false;
  }
  var dueDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["c" /* isDefined */])(assignedListItem.dueDate) ? __WEBPACK_IMPORTED_MODULE_2_moment___default()(assignedListItem.dueDate).format('DD-MMM-YYYY') : i18n._(
  /*i18n*/
  {
    id: "assignedTab.noDueDate",
    defaults: "No due date"
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__assigned_list_item_styled__["a" /* AssignedListItemWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__assigned_list_assigned_list_styled__["f" /* CheckboxWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__checkbox__["a" /* default */], {
    checkboxHandler: onCheckboxChange,
    state: isSelected ? __WEBPACK_IMPORTED_MODULE_6__checkbox_constants__["b" /* CHECKED */] : __WEBPACK_IMPORTED_MODULE_6__checkbox_constants__["a" /* UNCHECKED */],
    id: index
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    title: assignedListItem.activityName,
    "data-testid": "assigned-activity-name"
  }, assignedListItem.activityName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    title: assignedListItem.assignStatus,
    "data-testid": "assigned-activity-status"
  }, status()), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    title: assignedListItem.startDate,
    "data-testid": "assigned-activity-startdate"
  }, __WEBPACK_IMPORTED_MODULE_2_moment___default()(assignedListItem.startDate).format('DD-MMM-YYYY')), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    title: assignedListItem.dueDate,
    "data-testid": "assigned-activity-duedate"
  }, dueDate));
};
AssignedListItem.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isSelected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  onCheckboxChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  assignedListItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (AssignedListItem);

/***/ }),

/***/ "SgkA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BasicApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__("O27J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_thunk__ = __webpack_require__("bEzl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_logger__ = __webpack_require__("oSVy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__3plearning_lingui_cdn__ = __webpack_require__("siuH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__3plearning_lingui_cdn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__3plearning_lingui_cdn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux__ = __webpack_require__("2KeS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__combined_reducers__ = __webpack_require__("Gylf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_product_service__ = __webpack_require__("6KtE");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }











var BasicApp = /*#__PURE__*/function () {
  function BasicApp(element, dynamicOptions) {
    _classCallCheck(this, BasicApp);
    _defineProperty(this, "render", function () {});
    BasicApp.configure();
    this.element = element;
    this.options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["a" /* handleDefaults */])({}, dynamicOptions);
    this.renderElement();
  }
  return _createClass(BasicApp, [{
    key: "renderElement",
    value:
    // Implementation details.  You should not need to change any code past this point.

    function renderElement() {
      var _this = this;
      var env = "production" || 'development';

      // Create the store with middlewares
      var middlewares = [__WEBPACK_IMPORTED_MODULE_2_redux_thunk__["a" /* default */]];
      if (env === 'development') {
        middlewares.push(__WEBPACK_IMPORTED_MODULE_4_redux_logger___default.a);
        // eslint-disable-next-line global-require
        var whyDidYouRender = __webpack_require__("CqNl");
        whyDidYouRender(__WEBPACK_IMPORTED_MODULE_0_react___default.a, {
          trackAllPureComponents: true
        });
      }
      var enhancers = [__WEBPACK_IMPORTED_MODULE_6_redux__["a" /* applyMiddleware */].apply(void 0, middlewares)];

      // If Redux DevTools Extension is installed use it, otherwise use Redux compose
      /* eslint-disable no-underscore-dangle */
      var composeEnhancers =  false ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : __WEBPACK_IMPORTED_MODULE_6_redux__["b" /* compose */];
      /* eslint-enable */
      var initialState = __WEBPACK_IMPORTED_MODULE_10__helpers_product_service__["a" /* default */].Configure();
      var store = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_redux__["c" /* createStore */])(__WEBPACK_IMPORTED_MODULE_8__combined_reducers__["a" /* default */], initialState, composeEnhancers.apply(void 0, enhancers));
      function linguiLocales() {
        var query = window.location.search.slice(1);
        var match = query.match(/\blocale=([-a-zA-Z]+)\b/);
        var locale = match ? match[1] : 'en-AU';
        return [locale];
      }
      var locales = linguiLocales();

      // getConfiguration is async, so resolve the base URL before passing it to
      // getI18N; otherwise a Promise is coerced into the catalog URL as
      // "[object Object]" and the fetch 404s.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_utils__["b" /* getConfiguration */])('LocalisationCdnBaseUrl').then(function (linguiCdnBaseUrl) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__3plearning_lingui_cdn__["getI18N"])(linguiCdnBaseUrl, locales).then(function (i18n) {
          __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(_this.render(store, i18n), document.querySelector(_this.element));
        });
      });
      __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(this.render(store), document.querySelector(this.element));
    }
  }], [{
    key: "configure",
    value: function configure() {
      // How we want to configure things depends on where this app is running,
      // and where the services we want to access live.
      //
      // 1. When running on a developer's machine, using a mock server, we want
      //    to use a hard-coded config from
      //
      //       helpers/local-resource-config.js
      //
      // 2. When running on a developer's machine, but we want to use back-end
      //    services on demo, QA or live, we want to get the configuration from
      //    the configuration of the host app.
      //
      // 3. When running on demo, QA or live, the configuration will be injected
      //    based on the host app's configuration, but can be overridden by query
      //    parameters.
      //
      // We determine which situation we have by looking at the window location
      // URL and the query parameters, and whether there is a pppAppConfig property
      // on the window object.

      var location = window.location;
      var runningOnDeveloperMachine = /^https?:\/\/(localhost|0.0.0.0)/.test(location);
      var queryParams = location.search;
      var query = queryParams.replace('?', '');
      var params = __WEBPACK_IMPORTED_MODULE_3_querystring___default.a.parse(query);
      if (runningOnDeveloperMachine) {
        BasicApp.configureForDeveloperMachine(params);
      } else {
        BasicApp.configureForRemoteHost(params);
      }
    }
  }, {
    key: "configureForDeveloperMachine",
    value: function configureForDeveloperMachine(params) {
      var envName = params.env;
      if (!envName) {
        // eslint-disable-next-line no-console
        console.log('BasicApp.configureForDeveloperMachine() - you did not provide an "env" query' + ' parameter, so I am assuming you want to talk to live.');
        envName = 'live';
      }
      var credentials = BasicApp.getCredentials(params);
      if (envName === 'local' || BasicApp.weHaveUsableCredentials(credentials)) {
        __WEBPACK_IMPORTED_MODULE_9__helpers_resources__["a" /* default */].initialise(envName, credentials);
      }
    }
  }, {
    key: "configureForRemoteHost",
    value: function configureForRemoteHost(params) {
      // eslint-disable-next-line no-underscore-dangle
      var config = window._env_;
      var envName = config.env || 'live';
      var credentials = BasicApp.getCredentials(params);
      if (!config.BaseName) {
        // eslint-disable-next-line no-console
        console.log('BasicApp.configureForRemoteHost() - your pppAppConfig does not' + ' include a BaseName item; we will assume it should be blank.');
        config.BaseName = '';
      }
      if (BasicApp.weHaveUsableCredentials(credentials)) {
        __WEBPACK_IMPORTED_MODULE_9__helpers_resources__["a" /* default */].initialise(envName, credentials);
        __WEBPACK_IMPORTED_MODULE_9__helpers_resources__["a" /* default */].env.setConfiguration(config);
      }
    }
  }, {
    key: "getCredentials",
    value: function getCredentials(params) {
      var credentials = {};
      var items = ['authToken', 'username', 'password'];
      for (var paramName in params) {
        var value = params[paramName];
        var _iterator = _createForOfIteratorHelper(items),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (paramName.toLowerCase() === item.toLowerCase()) {
              credentials[item] = value;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return credentials;
    }
  }, {
    key: "weHaveUsableCredentials",
    value: function weHaveUsableCredentials(credentials) {
      var usableCredentials = false;
      if (credentials.authToken) {
        usableCredentials = true;
      } else if (credentials.username && credentials.password) {
        usableCredentials = true;
      }
      if (!usableCredentials) {
        // eslint-disable-next-line no-console
        console.error('EntryApp.configureForDeveloperMachine() - to execute, we need either an authToken or' + ' a username/password pair.  After combining data from window.pppAppConfig and the query' + ' parameters, I still do not have what I need. The app will probably not function correctly if' + ' it requires any 3P resources.');
      }
      return usableCredentials;
    }
  }]);
}();


/***/ }),

/***/ "SuGc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__unassign_all_modal_actions__ = __webpack_require__("XAJD");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var initialState = {
  isUnassignModalOpen: false
};
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__unassign_all_modal_actions__["a" /* HIDE_UNASSIGN_MODAL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isUnassignModalOpen: false
      });
    case __WEBPACK_IMPORTED_MODULE_0__unassign_all_modal_actions__["b" /* SHOW_UNASSIGN_MODAL */]:
      return _objectSpread(_objectSpread({}, state), {}, {
        isUnassignModalOpen: true
      });
    default:
      return _objectSpread({}, state);
  }
});

/***/ }),

/***/ "TQbn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GridContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CellContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GridColumn; });
/* unused harmony export LoaderContainer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CBContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var LoaderContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  flex: 1;\n  margin-top: 60px;\n  margin-left: 25%;\n  position: fixed;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('baseline'));
var GridContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n        ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n        ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n\n        width: 100%;\n        height: fit-content;\n\n        .cell {\n            width: 82px;\n            height: 40px;\n            background: ").concat(colours.grey[300], ";\n          }\n    ");
});
var CellContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n\n    position: relative;\n    top: 0;\n    border-bottom: 1px solid ").concat(colours.grey[400], ";\n");
});
var GridColumn = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'));
var Header = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].header(function (props) {
  var colours = props.theme.colours;
  return "\n        ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n\n        position: sticky;\n        top: 192px;\n        z-index: 1;\n        height: 47px;\n        min-height: 47px;\n        background-color: ").concat(colours.grey[200], ";\n\n        @media screen and (max-width: 1100px) {\n          min-height: 37px;\n          height: 37px;\n          top: 0;\n        }\n");
});
var CBContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    border-right: 1px solid ").concat(colours.grey[400], ";\n    border-left: 1px solid ").concat(colours.grey[400], ";\n    background-color: ").concat(colours.grey[200], ";\n    min-width: 52px;\n    height: 47px;\n\n    @media screen and (max-width: 1100px) {\n      height: 37px;\n    }\n\n    > div {\n      margin: 0;\n    }\n");
});


/***/ }),

/***/ "Tj2k":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, "/* React Core CSS */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block; }\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block;\n  vertical-align: baseline; }\naudio:not([controls]) {\n  display: none;\n  height: 0; }\n[hidden],\ntemplate {\n  display: none; }\na {\n  background-color: transparent; }\na:active,\na:hover {\n  outline: 0; }\nabbr[title] {\n  border-bottom: none;\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted; }\nb,\nstrong {\n  font-weight: inherit; }\nb,\nstrong {\n  font-weight: bolder; }\ndfn {\n  font-style: italic; }\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0; }\nmark {\n  background-color: #ff0;\n  color: #000; }\nsmall {\n  font-size: 80%; }\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline; }\nsup {\n  top: -0.5em; }\nsub {\n  bottom: -0.25em; }\nimg {\n  border: 0; }\nsvg:not(:root) {\n  overflow: hidden; }\nfigure {\n  margin: 1em 40px; }\nhr {\n  -webkit-box-sizing: content-box;\n          box-sizing: content-box;\n  height: 0;\n  overflow: visible; }\npre {\n  overflow: auto; }\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace;\n  font-size: 1em; }\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit;\n  margin: 0; }\nbutton {\n  overflow: visible; }\nbutton,\nselect {\n  text-transform: none; }\nbutton,\ninput[type=\"reset\"],\ninput[type=\"submit\"] {\n  -webkit-appearance: button;\n  cursor: pointer; }\nbutton[disabled] {\n  cursor: default; }\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner {\n  border: 0;\n  padding: 0; }\nbutton:-moz-focusring,\ninput:-moz-focusring {\n  outline: 1px dotted ButtonText; }\ninput {\n  line-height: normal; }\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  padding: 0; }\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto; }\ninput[type=\"search\"] {\n  -webkit-appearance: textfield; }\ninput[type=\"search\"]::-webkit-search-cancel-button,\ninput[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; }\nfieldset {\n  border: 1px solid #c0c0c0;\n  margin: 0 2px;\n  padding: 0.35em 0.625em 0.75em; }\nlegend {\n  border: 0;\n  padding: 0; }\ntextarea {\n  overflow: auto; }\noptgroup {\n  font-weight: bold; }\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font-family: inherit;\n  vertical-align: baseline; }\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block; }\nol,\nul {\n  list-style: none; }\nblockquote,\nq {\n  quotes: none; }\nblockquote::before,\nblockquote::after,\nq::before,\nq::after {\n  content: \"\";\n  content: none; }\ntable {\n  border-collapse: collapse;\n  border-spacing: 0; }\nbody {\n  font-family: poppins, Arial, sans-serif;\n  font-size: 16px;\n  line-height: 1.42857143;\n  color: #484848;\n  background-color: #eef2f5;\n  margin: 0;\n  padding: 0;\n  overflow: hidden; }\nbutton:focus,\n[role=\"button\"]:focus {\n  outline: 0; }\n.text-center {\n  text-align: center; }\nh1 {\n  font-size: 30px;\n  font-weight: 500; }\n@font-face {\n  font-family: 'poppins';\n  src: url(\"//west.cdn.mathletics.com/html/fonts/Poppins/Poppins_400.ttf\") format(\"truetype\"); }\n", ""]);

// exports


/***/ }),

/***/ "UPZi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_list_scss__ = __webpack_require__("pihV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_list_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__actions_list_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__ = __webpack_require__("S0Yi");




var ActionsList = function ActionsList(props) {
  var options = props.options,
    shouldOpenUp = props.shouldOpenUp,
    isWide = props.isWide,
    isOpen = props.isOpen;
  function renderList() {
    var listClassName = "".concat(__WEBPACK_IMPORTED_MODULE_2__actions_list_scss___default.a.actionsList, " ").concat(shouldOpenUp ? __WEBPACK_IMPORTED_MODULE_2__actions_list_scss___default.a['actionsList--flow-up'] : '', " ").concat(isWide ? __WEBPACK_IMPORTED_MODULE_2__actions_list_scss___default.a['actionsList--wide'] : '');
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
      className: listClassName,
      "data-testid": isOpen ? 'action-list--open' : 'action-list--closed'
    }, ((options === null || options === void 0 ? void 0 : options.length) && options || []).map(function (option, index) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
        className: option.disabled ? __WEBPACK_IMPORTED_MODULE_2__actions_list_scss___default.a['actionsList--disabled'] : '',
        key: "".concat(option.text, "_").concat(option.subtext)
      }, option.icon && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__["a" /* default */], {
        icon: option.icon
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: __WEBPACK_IMPORTED_MODULE_2__actions_list_scss___default.a.actionsListText,
        "data-testid": "actions-list-option--".concat(index),
        role: "button",
        tabIndex: "0",
        onClick: !options.disabled && option.onClick
      }, option === null || option === void 0 ? void 0 : option.text, option.subtext && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: __WEBPACK_IMPORTED_MODULE_2__actions_list_scss___default.a['actionsList__text--small']
      }, option.subtext))));
    }));
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, isOpen ? renderList() : null);
};
ActionsList.propTypes = {
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object).isRequired,
  isWide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  shouldOpenUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
ActionsList.defaultProps = {
  shouldOpenUp: false
};
/* harmony default export */ __webpack_exports__["a"] = (ActionsList);

/***/ }),

/***/ "UbpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__("vXY1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__activity_header__ = __webpack_require__("9nk/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__topic_info__ = __webpack_require__("GGmR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__collapsed__ = __webpack_require__("ann7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__grid_collapsed__ = __webpack_require__("UgNX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__("JT4Y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
















var Topic = function Topic(_ref) {
  var id = _ref.id,
    topicName = _ref.topicName,
    i18n = _ref.i18n,
    collapseAllStandards = _ref.collapseAllStandards,
    isTopicDirty = _ref.isTopicDirty,
    activities = _ref.activities;
  var iconRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var infoRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* useDispatch */])();
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    showContextMenu = _useState2[0],
    setContextMenu = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showCallOutMenu = _useState4[0],
    setCallOutMenu = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState6 = _slicedToArray(_useState5, 2),
    positionX = _useState6[0],
    setPositionX = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState8 = _slicedToArray(_useState7, 2),
    positionY = _useState8[0],
    setPositionY = _useState8[1];
  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(collapseAllStandards),
    _useState0 = _slicedToArray(_useState9, 2),
    isCollapsed = _useState0[0],
    setIsCollapsed = _useState0[1];
  var _useState1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState10 = _slicedToArray(_useState1, 2),
    positionArrow = _useState10[0],
    setPositionArrow = _useState10[1];
  var _useState11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState12 = _slicedToArray(_useState11, 2),
    positionXCallout = _useState12[0],
    setPositionXCallout = _useState12[1];
  var _useState13 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState14 = _slicedToArray(_useState13, 2),
    positionYCallout = _useState14[0],
    setPositionYCallout = _useState14[1];
  var _useState15 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState16 = _slicedToArray(_useState15, 2),
    positionArrowCallout = _useState16[0],
    setPositionArrowCallout = _useState16[1];
  var _useState17 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState18 = _slicedToArray(_useState17, 2),
    contextTheme = _useState18[0],
    setContextTheme = _useState18[1];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    if (!isTopicDirty) {
      setIsCollapsed(collapseAllStandards);
    }
  }, [collapseAllStandards, isTopicDirty]);
  var mappedAssignmentsSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_reselect__["createSelector"])(function (state) {
    var _state$CourseAssignRe;
    return ((_state$CourseAssignRe = state.CourseAssignReducer) === null || _state$CourseAssignRe === void 0 || (_state$CourseAssignRe = _state$CourseAssignRe.assignments) === null || _state$CourseAssignRe === void 0 ? void 0 : _state$CourseAssignRe.studentAssignments) || [];
  }, function () {
    return activities;
  }, function (studentAssignments, selectorActivities) {
    var nameObj = {};
    selectorActivities.forEach(function (activity) {
      studentAssignments.forEach(function (studentAssignment, index) {
        if (studentAssignment.activityId === activity.activityId && studentAssignment.taskType === activity.taskType) {
          var nameArr = nameObj[activity.activityName];
          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_utils__["c" /* isDefined */])(nameArr)) {
            nameObj[activity.activityName].push(index);
          } else {
            nameObj[activity.activityName] = [index];
          }
        }
      });
    });
    return nameObj;
  });
  var mappedAssignmentIndexes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(mappedAssignmentsSelector, __WEBPACK_IMPORTED_MODULE_3_react_redux__["d" /* shallowEqual */]);
  var showDropdown = function showDropdown() {
    var _getContextCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_utils__["e" /* getContextCoords */])(iconRef.current.getBoundingClientRect(), __WEBPACK_IMPORTED_MODULE_9__context_modal__["a" /* ContextModalWidth */]),
      posX = _getContextCoords.posX,
      posY = _getContextCoords.posY,
      posArrow = _getContextCoords.posArrow;
    setPositionY(posY);
    setPositionX(posX);
    setPositionArrow(posArrow);
    setContextTheme(null);
    setCallOutMenu(false);
    setContextMenu(false);
  };
  var hideStandardBlock = function hideStandardBlock() {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_15__containers_course_assign_course_assign_types__["N" /* HIDE_STANDARD */],
      id: id
    });
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_15__containers_course_assign_course_assign_types__["k" /* DISPLAY_MODAL_INFORMATION */],
      key: -1
    });
  };
  var handleExpandCollapse = function handleExpandCollapse(state) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_15__containers_course_assign_course_assign_types__["z" /* SET_TOPIC_TO_DIRTY */]
    });
    setIsCollapsed(state);
  };
  var showCallOut = function showCallOut(e) {
    var _getContextCoords2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_utils__["e" /* getContextCoords */])(e, __WEBPACK_IMPORTED_MODULE_9__context_modal__["a" /* ContextModalWidth */]),
      posX = _getContextCoords2.posX,
      posArrow = _getContextCoords2.posArrow;
    var _infoRef$current$getB = infoRef.current.getBoundingClientRect(),
      bottom = _infoRef$current$getB.bottom;
    setPositionYCallout(bottom + 12);
    setPositionXCallout(posX);
    setPositionArrowCallout(posArrow);
    setContextTheme('standard');
    setCallOutMenu(true);
  };
  var hideCallOut = function hideCallOut() {
    setCallOutMenu(false);
  };
  var ActivityHeaders = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return activities && activities.map(function (activity) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__activity_header__["a" /* default */], {
        externalKey: topicName,
        i18n: i18n,
        activity: activity,
        studentAssignmentIndexes: mappedAssignmentIndexes === null || mappedAssignmentIndexes === void 0 ? void 0 : mappedAssignmentIndexes[activity.activityName],
        key: activity.activityName
      });
    });
  },
  // studentAssignmentIndexes will change each time, causing expensive rendering
  // using only activities for dependency is fine, as when activities change the studentAssignmentIndexes will change
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [activities, i18n, topicName]);
  if (isCollapsed) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* CollapsedWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__collapsed__["a" /* default */], {
      handleOnExpand: function handleOnExpand() {
        return handleExpandCollapse(false);
      },
      topicName: topicName,
      id: id
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__grid_collapsed__["a" /* default */], {
      topicId: id,
      i18n: i18n,
      activities: activities
    }));
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["b" /* Wrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["c" /* FixedWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["d" /* StandardWrapper */], {
    activities: activities.length,
    className: "standard",
    id: "showContextModal"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["e" /* Icon */], {
    className: "leftAlign",
    ref: iconRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_5__helpers_icon_dictionary__["e" /* StandardDropdown */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["f" /* Info */], {
    role: "button",
    tabIndex: "-1",
    onClick: showDropdown,
    activities: activities.length,
    onMouseEnter: showCallOut,
    onMouseLeave: hideCallOut,
    ref: infoRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["g" /* Content */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["h" /* TopicName */], null, topicName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["e" /* Icon */], {
    role: "button",
    tabIndex: "-1",
    onClick: function onClick() {
      return handleExpandCollapse(true);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_5__helpers_icon_dictionary__["f" /* CollapseButton */]
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["i" /* ActivityHeaderWrapper */], null, ActivityHeaders)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], {
    i18n: i18n,
    activities: activities,
    mappedAssignmentIndexes: mappedAssignmentIndexes
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setContextMenu(false);
    },
    forButton: "showContextModal_".concat(id)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__context_modal__["b" /* default */], {
    show: showContextMenu,
    positionArrow: positionArrow,
    positionX: positionX,
    positionY: positionY
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__topic_info__["a" /* default */], {
    standardName: topicName,
    hideStrand: hideStandardBlock,
    displayHideOption: true
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__context_modal__["b" /* default */], {
    show: showCallOutMenu,
    positionArrow: positionArrowCallout,
    positionX: positionXCallout,
    positionY: positionYCallout,
    contextTheme: contextTheme,
    name: topicName
  })));
};
Topic.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  topicName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  collapseAllStandards: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isTopicDirty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired
};
Topic.defaultProps = {
  externalKey: ''
};
Topic.whyDidYouRender = false;
/* harmony default export */ __webpack_exports__["a"] = (Topic);

/***/ }),

/***/ "UgNX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("aiz3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__status_cell__ = __webpack_require__("HkKr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("6QRH");






var CollapsedGrid = function CollapsedGrid(_ref) {
  var activities = _ref.activities,
    topicId = _ref.topicId,
    i18n = _ref.i18n;
  var assignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.assignments;
  });
  var sortedStudents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.sortedStudents;
  });
  var datePreference = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    var _state$CourseAssignRe, _state$CourseAssignRe2;
    return ((_state$CourseAssignRe = state.CourseAssignReducer) === null || _state$CourseAssignRe === void 0 || (_state$CourseAssignRe = _state$CourseAssignRe.datePreference) === null || _state$CourseAssignRe === void 0 ? void 0 : _state$CourseAssignRe.length) > 0 ? (_state$CourseAssignRe2 = state.CourseAssignReducer) === null || _state$CourseAssignRe2 === void 0 ? void 0 : _state$CourseAssignRe2.datePreference : [undefined, undefined];
  });
  var courseId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeCourseID;
  });
  var classroomId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var groupId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* Wrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* Header */], null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* GridColumn */], null, sortedStudents.map(function (sortedStudent) {
    var resultSum = 0;
    var cellsWithResult = 0;
    var hasAssignments = false;
    var selectedCells = 0;
    var encryptedUserProfileId = sortedStudent.encryptedUserProfileId;
    var students = assignments.studentAssignments.filter(function (student) {
      if (student.encryptedUserProfileId === encryptedUserProfileId) {
        activities.forEach(function (activity) {
          if (student.activityId === activity.activityId && student.taskType === activity.taskType) {
            var _student$result;
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["c" /* isDefined */])(student === null || student === void 0 || (_student$result = student.result) === null || _student$result === void 0 ? void 0 : _student$result.score)) {
              cellsWithResult++;
              resultSum += student.result.score;
            }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["c" /* isDefined */])(student.assignment)) {
              hasAssignments = true;
            }
            if (student.isSelected) {
              selectedCells++;
            }
          }
        });
        return true;
      }
      return false;
    });
    var resultAverage = cellsWithResult > 0 ? resultSum / cellsWithResult : 0;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["d" /* CellContainer */], {
      key: encryptedUserProfileId
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__status_cell__["a" /* default */], {
      i18n: i18n,
      activities: activities,
      topicId: topicId,
      key: encryptedUserProfileId,
      studentInfo: students[0],
      currentStudent: sortedStudent,
      hasAssignments: hasAssignments,
      hasResults: cellsWithResult > 0,
      resultAverage: resultAverage,
      selectedCells: selectedCells,
      isCollapsed: true,
      datePreference: datePreference,
      courseId: courseId,
      classroomId: classroomId,
      groupId: groupId
    }));
  })));
};
CollapsedGrid.propTypes = {
  activities: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  topicId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
CollapsedGrid.defaultProps = {
  activityIds: []
};
/* harmony default export */ __webpack_exports__["a"] = (CollapsedGrid);

/***/ }),

/***/ "VioT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss__ = __webpack_require__("xnkI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__checkbox__ = __webpack_require__("4YSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__("6QRH");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var SelectableListItem = /*#__PURE__*/function (_Component) {
  function SelectableListItem(props) {
    var _this;
    _classCallCheck(this, SelectableListItem);
    _this = _callSuper(this, SelectableListItem, [props]);
    _defineProperty(_this, "onSelection", function (cbState, cbId) {
      return _this.props.onChange(cbState, cbId);
    });
    var checked = props.checked;
    _this.state = {
      checked: checked,
      checkedNormal: _this.props.checkedNormal,
      checkedEasier: _this.props.checkedEasier
    };
    _this.onRDBChange = _this.onRDBChange.bind(_this);
    return _this;
  }
  _inherits(SelectableListItem, _Component);
  return _createClass(SelectableListItem, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.checked !== this.props.checked) {
        this.setState({
          checked: nextProps.checked
        });
      }
      this.setState({
        checkedNormal: this.props.checkedNormal,
        checkedEasier: this.props.checkedEasier
      });
    }
  }, {
    key: "onRDBChange",
    value: function onRDBChange(value) {
      if (value.indexOf('rdbNormal') >= 0) {
        this.props.onRadioselect(value.split('_')[1], true, false);
      }
      if (value.indexOf('rdbEasier') >= 0) {
        this.props.onRadioselect(value.split('_')[1], false, true);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        id = _this$props.id,
        name = _this$props.name,
        i18n = _this$props.i18n;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: id
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_3__index_scss___default.a.info
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_3__index_scss___default.a.checkbox
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__checkbox__["a" /* default */], {
        state: this.state.checked,
        checkboxHandler: function checkboxHandler(cbState, cbId) {
          return _this2.onSelection(cbState, cbId);
        },
        id: id.toString()
      }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        title: name,
        className: __WEBPACK_IMPORTED_MODULE_3__index_scss___default.a.description
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["j" /* getTruncatedName */])(name)), SelectableListItem.getRadiobuttons(this.props, this.onRDBChange, this.props.checkedNormal, this.props.checkedEasier, this.props.easierActivitiesCount, this.props.isChecked, i18n))));
    }
  }], [{
    key: "getRadiobuttons",
    value: function getRadiobuttons(item, onChange, checkedNormal, checkedEasier, easierActivitiesCount, isChecked, i18n) {
      var disabled = easierActivitiesCount === 0 || !isChecked;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: __WEBPACK_IMPORTED_MODULE_3__index_scss___default.a.difficultyspan
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Radio"], {
        "data-testid": "core",
        name: "rdbDiff_".concat(item.id),
        value: "rdbNormal_".concat(item.id),
        selected: checkedNormal,
        disabled: disabled,
        onSelect: function onSelect(value) {
          return onChange(value);
        },
        label: i18n._(
        /*i18n*/
        {
          id: "selectableListItem.core",
          defaults: "Core"
        })
      })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: __WEBPACK_IMPORTED_MODULE_3__index_scss___default.a.difficultyspan
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Radio"], {
        "data-testid": "easier",
        name: "rdbDiff_".concat(item.id),
        value: "rdbEasier_".concat(item.id),
        selected: checkedEasier,
        disabled: disabled,
        onSelect: function onSelect(value) {
          return onChange(value);
        },
        label: i18n._(
        /*i18n*/
        {
          id: "selectableListItem.easier",
          defaults: "Easier"
        })
      })));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
SelectableListItem.propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  checked: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  easierActivitiesCount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  checkedNormal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  checkedEasier: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  onRadioselect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  isChecked: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (SelectableListItem);

/***/ }),

/***/ "WE0W":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".footer---2Dx5B {\n  background: #94b4c9;\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  min-height: 32px;\n  min-height: 2rem;\n  min-width: 408px;\n  min-width: 25.5rem;\n  padding: 5px 36px;\n  padding: 5px 2.25rem;\n  border-radius: 10px 10px 0 0;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  -webkit-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  font-size: 12px;\n  font-size: 0.75rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  z-index: 4; }\n\n.collapsedContainer---3vd-w {\n  left: 85%;\n  margin: 0;\n  width: auto;\n  -webkit-transition: all 0.3s ease-out;\n  transition: all 0.3s ease-out;\n  padding: 3px 30px;\n  min-width: 136px;\n  min-width: 8.5rem; }\n\n.collapsedContainer---3vd-w *[data-name^=\"expanded\"] {\n    display: none !important; }\n\n.expandedContainer---1x533 *[data-name^=\"collapsed\"] {\n  display: none !important; }\n\nbutton {\n  height: 30px;\n  width: 30px; }\n\n.icon---f0h5_ {\n  position: absolute;\n  top: 8px;\n  left: 10px;\n  min-width: 16px;\n  min-height: 16px;\n  cursor: pointer; }\n\n.icon---f0h5_ svg {\n    width: 16px;\n    height: 16px; }\n\n.iconCollapsed---BDQYr {\n  right: 10px;\n  left: auto; }\n", ""]);

// exports
exports.locals = {
	"footer": "footer---2Dx5B",
	"collapsedContainer": "collapsedContainer---3vd-w",
	"expandedContainer": "expandedContainer---1x533",
	"icon": "icon---f0h5_",
	"iconCollapsed": "iconCollapsed---BDQYr"
};

/***/ }),

/***/ "Wi6H":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("BzJZ");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js?modules=false!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/index.js!./_variables.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js?modules=false!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/index.js!./_variables.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "WjZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return AssignedListWrapper; });
/* unused harmony export Header */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Body; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Footer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return OkButtonContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UnAssignButtonContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NoDataView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AssignedWrapper; });
/* unused harmony export ListItemContainer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HeaderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ActivityHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ActivityTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SvgWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CheckboxWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return StatusHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ResultsWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_helpers_common__ = __webpack_require__("ZmnC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__ = __webpack_require__("Ivgr");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }




var AssignedListWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  \n  margin: 0;\n  height: 100%;\n  width: 100%;\n  overflow-x: hidden;\n  overflow-y: scroll;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'));
var Header = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(function (props) {
  var _ThemeHelper$getTheme = __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__["a" /* default */].getTheme(props),
    typography = _ThemeHelper$getTheme.typography;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["f" /* alignSelf */])('flex-start'), "\n\n    font-size: ").concat(typography.modalTitle.size, ";\n    margin: 1em 25px 0.5em 25px;\n  ");
});
var Body = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _ThemeHelper$getTheme2 = __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__["a" /* default */].getTheme(props),
    typography = _ThemeHelper$getTheme2.typography;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), "\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), "\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["g" /* flexGrow */])('1'), "\n    font-size: ").concat(typography.size, ";\n  ");
});
var Footer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n\n  margin-top: 10px;\n  width: 100%;\n\n  > div {\n    ", "\n  }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["h" /* flex */])('1 0 0'));
var OkButtonContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  .button {\n    height: 29px;\n    width: 86px;\n    border-radius: 14.5px;\n    font-size: 11px;\n    padding: 0;\n    margin-left: auto;\n  }\n"])));
var UnAssignButtonContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  .unassign {\n    height: 29px;\n    width: 86px;\n    border-radius: 14.5px;\n    font-size: 11px;\n    padding: 0;\n    margin: 0 auto;\n  }\n"])));
var NoDataView = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _ThemeHelper$getTheme3 = __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__["a" /* default */].getTheme(props),
    typography = _ThemeHelper$getTheme3.typography,
    colours = _ThemeHelper$getTheme3.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), "\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), "\n\n    svg {\n      margin-top: 20px;\n      width: 50px;\n      height: 50px;\n      path {\n        fill: ").concat(colours.grey[400], ";\n      }\n    }\n\n    p {\n      margin: 0 auto;\n    }\n\n    p:nth-of-type(2) {\n      width: 60%;\n      margin-top: 20px;\n    }\n\n    width: auto;\n    font-family: ").concat(typography.family, ";\n    font-size: 14px;\n");
});
var AssignedWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var typography = props.theme.typography;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), "\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), "\n\n    width: auto;\n    height: 100%;\n    font-family: ").concat(typography.family, ";\n    font-size: 14px;\n    left: 0;\n    background-color: white;\n    z-index: 7;\n    position: -webkit-sticky;\n    position: sticky;\n");
});
var ListItemContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  box-sizing: border-box;\n  background-color: white;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var HeaderContainer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */])(ListItemContainer)(function () {
  return "\n  padding-bottom: 10px;\n  position: sticky;\n  top: 0;\n  width: 100%;\n  z-index: 1;\n\n  ";
});
var ActivityHeader = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _ThemeHelper$getTheme4 = __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme4.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('flex-start'), ";\n    font-weight: 600;\n    padding: 0px 8px;\n    user-select: none;\n    height: 21px;\n    width: 60%;\n\n    svg {\n      path {\n        fill: ").concat(colours.grey[700], ";\n      }\n    }\n\n    .title {\n      ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* inlineFlexbox */])(), ";\n      ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n      ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('flex-start'), ";\n      ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_common__["a" /* widthFillAvailable */])(), ";\n\n      font-weight: 400;\n      padding: 5px;\n      max-height: 10px;\n      cursor: pointer;\n      \n      svg {\n        path {\n          fill: ").concat(colours.grey[700], ";\n        }\n      }\n\n      .label {\n        margin-left: 10px;\n        border-bottom: 2px solid ").concat(colours.grey[200], ";\n      }\n    }\n\n      [class*=\"svgIconComponent\"] {\n        width: 10px !important;\n        margin-bottom: 4px;\n        margin-left: 8px;\n      }\n    }\n  ");
});
var ActivityTitle = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])());
var SvgWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _ThemeHelper$getTheme5 = __WEBPACK_IMPORTED_MODULE_3__themes_theme_helper__["a" /* default */].getTheme(props),
    colours = _ThemeHelper$getTheme5.colours;
  return "\n    path {\n      fill: ".concat(props.status ? colours.grey[1000] : 'black', " !important;\n    }\n  ");
});
var CheckboxWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n    \n    > :first-child {\n      width: 16px;\n      height: 16px;\n    }\n    div {\n      width: 14px;\n      height: 14px;\n      border: 1px solid ").concat(colours.grey[200], ";\n      border-radius: 2px;\n    }\n");
});
var StatusHeader = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    width: 25%;\n\n    span{\n      border-bottom: 2px solid ".concat(colours.grey[200], ";\n    }\n");
});
var ResultsWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), "\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["g" /* flexGrow */])('1'), "\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_common__["a" /* widthFillAvailable */])(), "\n  \n    margin-top: -1px;\n    border: 1px solid ").concat(colours.grey[300], ";\n    border-radius: 15px;\n    padding: 25px 10px 10px 20px;\n    min-height: 0;\n  ");
});

/***/ }),

/***/ "WnpN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVATE_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DISMISS_MODAL; });
/* harmony export (immutable) */ __webpack_exports__["d"] = activateModal;
/* harmony export (immutable) */ __webpack_exports__["c"] = dismissModal;
var ACTIVATE_MODAL = 'ACTIVATE_MODAL';
var DISMISS_MODAL = 'DISMISS_MODAL';
function activateModal(modal) {
  return {
    type: ACTIVATE_MODAL,
    modal: modal
  };
}
function dismissModal() {
  return {
    type: DISMISS_MODAL
  };
}

/***/ }),

/***/ "WyKg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssignLaterModalOuter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AssignLaterModalInner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var AssignLaterModalOuter = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function () {
  return "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  z-index: 10;\n  top: 0px;\n  background-color: rgba(0; 0; 0; 0.5);\n  left: 0px;\n  align-items: center\n";
});
var AssignLaterModalInner = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 320px;\n  height: 200px;\n  background-color: white;\n  border-radius: 4px;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  & div[class*='ButtonWrapper'] {\n    border-radius: 4px;\n  }\n"])));

/***/ }),

/***/ "XAJD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SHOW_UNASSIGN_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HIDE_UNASSIGN_MODAL; });
// Action Types
var SHOW_UNASSIGN_MODAL = 'SHOW_UNASSIGN_MODAL';
var HIDE_UNASSIGN_MODAL = 'HIDE_UNASSIGN_MODAL';

/***/ }),

/***/ "XvAE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__("RH2O");

var useSelectedAssignmentsCount = function useSelectedAssignmentsCount() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react_redux__["c" /* useSelector */])(function (state) {
    var assignments = state.CourseAssignReducer.assignments.studentAssignments || [];
    return assignments.reduce(function (prev, assignment) {
      return prev + (!!assignment.isSelected && 1);
    }, 0);
  });
};
/* harmony default export */ __webpack_exports__["a"] = (useSelectedAssignmentsCount);

/***/ }),

/***/ "YbxQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Container = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  font-size: 12px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),

/***/ "ZArm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony export (immutable) */ __webpack_exports__["b"] = assignActivityToAllStudents;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStudents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_resources_helper__ = __webpack_require__("jhKF");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }



function assignActivityToAllStudents(_x, _x2, _x3, _x4, _x5, _x6) {
  return _assignActivityToAllStudents.apply(this, arguments);
}
function _assignActivityToAllStudents() {
  _assignActivityToAllStudents = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(studentAssignments, classroomId, groupId, courseId, startDatePreference, dueDatePreference) {
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          return _context.a(2, __WEBPACK_IMPORTED_MODULE_1__helpers_resources__["a" /* default */].assign.post({
            classroomId: classroomId,
            groupId: groupId
          }).withBody(_objectSpread({
            courseId: courseId,
            startDate: startDatePreference && __WEBPACK_IMPORTED_MODULE_0_moment___default()("".concat(startDatePreference[0], " ").concat(startDatePreference[1])).toISOString(),
            dueDate: dueDatePreference && __WEBPACK_IMPORTED_MODULE_0_moment___default()("".concat(dueDatePreference[0], " ").concat(dueDatePreference[1])).toISOString(),
            hasDueDate: dueDatePreference !== undefined
          }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__helpers_resources_helper__["a" /* mapSelectedActivitiesToReq */])(studentAssignments))).send().then(function () {
            return true;
          }, function () {
            return false;
          }));
      }
    }, _callee);
  }));
  return _assignActivityToAllStudents.apply(this, arguments);
}
var getStudents = function getStudents(ljId, data, classrooms) {
  var assignmentStatuses = data.length ? data.filter(function (d) {
    return d.learningJourneyId === ljId && d.needsAttention;
  }) : [];
  var students = [];
  if (assignmentStatuses.length > 0) {
    var studentIds = assignmentStatuses.map(function (val) {
      return val.studentProfileId;
    });
    var _iterator = _createForOfIteratorHelper(classrooms),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var classroom = _step.value;
        var _iterator2 = _createForOfIteratorHelper(classroom.groups),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var group = _step2.value;
            var _iterator3 = _createForOfIteratorHelper(group.students),
              _step3;
            try {
              var _loop = function _loop() {
                  var student = _step3.value;
                  if (studentIds.indexOf(student.id) !== -1 && !students.find(function (s) {
                    return s.id === student.id;
                  })) {
                    students.push({
                      id: student.id,
                      firstName: student.firstName,
                      lastName: student.lastName
                    });
                  }
                  if (students.length === assignmentStatuses.length) {
                    return {
                      v: students
                    };
                  }
                },
                _ret;
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                _ret = _loop();
                if (_ret) return _ret.v;
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return students;
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("hKoQ")))

/***/ }),

/***/ "Zbcq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("6QRH");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var ModalWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var contextTheme = props.contextTheme;
  var bgColor = contextTheme ? '#3B4E5E' : 'white';

  /* eslint-disable indent */
  return "\n        display: flex;\n        align-items: center;\n        background: ".concat(bgColor, ";\n        position: fixed;\n        left: ").concat(props.positionX, "px;\n        border-radius: 8px;\n        z-index: 99;\n        box-shadow: 4px 2px 6px;\n        overflow: hidden\n        width:").concat(props.modalWidth, "px;\n        min-height: 50px;\n        cursor: default;\n        border: 1px solid ").concat(bgColor, ";\n        ").concat(props.modalBottom ? "bottom: ".concat(props.modalBottom, "px;") : "top: ".concat(props.positionY, "px"), "\n        ").concat(props.positionArrowReverse ? "" : "::before {\n                    width: 0; \n                    height: 0; \n                    border-left: 8px solid transparent;\n                    border-right: 8px solid transparent;        \n                    border-bottom: 15px solid ".concat(bgColor, ";\n                    position: fixed;\n                    top: ").concat(props.positionY - 10, "px;\n                    left: ").concat(props.positionArrow - 8, "px;\n                    content: ' ';\n                }"), "\n        ").concat(props.leftAlign ? "::after {\n              width: 0; \n              height: 0; \n              border-left: 8px solid transparent;\n              border-right: 8px solid transparent;        \n              border-bottom: 15px solid ".concat(bgColor, ";\n              position: fixed;\n              top: ").concat(props.positionArrowY, "px;\n              left: ").concat(props.positionArrow, "px;\n              content: ' ';\n              transform: ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["c" /* isDefined */])(props.transform) ? 'rotate(-90deg)' : 'none') : "", "\n        ");

  /* eslint-enable indent */
});
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  flex-direction: column;\n  width: 100%;\n"])));
var ContentTheme = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex-direction: column;\n  width: 100%;\n  padding: 10px;\n  color: white;\n"])));


/***/ }),

/***/ "ZhO1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export i18nSetup */
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lingui_core__ = __webpack_require__("mbfA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lingui_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lingui_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_querystring__);


function i18nSetup(catalogs, localeOverride) {
  // get locale from query parameter, default to en-AU
  var locale = localeOverride || getLocale() || 'en-AU';
  if (catalogs[locale] === undefined) {
    locale = 'en-AU';
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lingui_core__["setupI18n"])({
    language: locale,
    catalogs: catalogs
  });
}
function getLocale() {
  var queryParams = window.location.search;
  var query = queryParams.replace('?', '');
  var params = __WEBPACK_IMPORTED_MODULE_1_querystring___default.a.parse(query);
  return params.locale;
}

/***/ }),

/***/ "ZmVe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__ = __webpack_require__("k21X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__ = __webpack_require__("S0Yi");




var StudentResultTable = function StudentResultTable(_ref) {
  var i18n = _ref.i18n,
    data = _ref.data,
    quality = _ref.quality,
    icon = _ref.icon;
  var displayQualities;
  var noDataMessage;
  var headerCell;
  if (quality === 'Strength') {
    displayQualities = data.topActivities;
    noDataMessage = i18n._(
    /*i18n*/
    {
      id: "studentResultTable.weaknessNoDataMessage",
      defaults: "The activities the student excelled at most will be shown here."
    });
    headerCell = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["a" /* DataRow */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["b" /* HeaderContainer */], {
      key: data.activityId,
      icon: icon
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["c" /* HeaderText */], {
      "data-testid": "strength-header"
    }, i18n._(
    /*i18n*/
    {
      id: "studentResultTable.strength",
      defaults: "Excelling most at"
    })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__["a" /* default */], {
      icon: icon
    })));
  } else {
    displayQualities = data.bottomActivities;
    noDataMessage = i18n._(
    /*i18n*/
    {
      id: "studentResultTable.strengthsNoDataMessage",
      defaults: "The activities the student struggled most with will be displayed here."
    });
    headerCell = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["a" /* DataRow */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["b" /* HeaderContainer */], {
      key: data.activityId
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["c" /* HeaderText */], {
      "data-testid": "weakness-header"
    }, i18n._(
    /*i18n*/
    {
      id: "studentResultTable.weakness",
      defaults: "Needs most help with"
    })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__["a" /* default */], {
      icon: icon
    })));
  }
  var bodyCell = displayQualities && displayQualities.length > 0 ? displayQualities.map(function (item) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["a" /* DataRow */], {
      key: item.activityId,
      "data-testid": "activitiesTable"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["d" /* DataValue */], {
      title: item.activityName
    }, item.activityName), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["d" /* DataValue */], {
      title: item.topicName
    }, item.topicName));
  }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["e" /* NoDataView */], {
    "data-testid": "noDataView"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, noDataMessage));
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["f" /* ResultContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["g" /* HeaderCell */], null, headerCell), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__student_result_table_styled__["h" /* BodyCell */], null, bodyCell));
};
StudentResultTable.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  quality: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (StudentResultTable);

/***/ }),

/***/ "ZmnC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export borderRadius */
/* unused harmony export borderShadow */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return widthFillAvailable; });
var borderRadius = function borderRadius() {
  var $value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "1px";
  return "\n    -webkit-border-radius: ".concat(value, ";\n    -moz-border-radius: ").concat(value, ";\n    border-radius: ").concat(value, ";\n");
};
var borderShadow = function borderShadow(top, left, blur, color) {
  var inset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "";
  return "\n    -webkit-box-shadow:".concat(top, " ").concat(left, " ").concat(blur, " ").concat(color, " #{").concat(inset, "};\n    -moz-box-shadow:").concat(top, " ").concat(left, " ").concat(blur, " ").concat(color, " #{").concat(inset, "};\n    box-shadow:").concat(top, " ").concat(left, " ").concat(blur, " ").concat(color, " #{").concat(inset, "};\n");
};
var widthFillAvailable = function widthFillAvailable() {
  return "\n    width: 100%;\n    width: -webkit-fill-available;\n    width: -moz-available;\n    width: fill-available;\n";
};


/***/ }),

/***/ "aFup":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Description; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  width: 400px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'));
var Text = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  margin-left: 65px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var Heading = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: 18px;\n  font-weight: 400;\n  margin-bottom: 15px;\n"])));
var Description = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 13px;\n  width: 295px;\n"])));


/***/ }),

/***/ "abke":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_local_storage__ = __webpack_require__("//jD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled__ = __webpack_require__("Dw/b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__selectable_list_item__ = __webpack_require__("VioT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__checkbox_constants__ = __webpack_require__("IzlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__analytics__ = __webpack_require__("uVVs");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }













var FilterDropDownList = function FilterDropDownList(props) {
  var i18n = props.i18n,
    onApply = props.onApply;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var _useTracking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__analytics__["d" /* useTracking */])(),
    trackTopicApplied = _useTracking.trackTopicApplied;
  var hideShowSearchPanel = function hideShowSearchPanel(status) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_11__containers_course_assign_course_assign_types__["j" /* SHOW_HIDE_SEARCH_PANEL */],
      status: status
    });
  };
  var updateTopics = function updateTopics(actionType, id, checked, term, checkedNormal, checkedEasier) {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_11__containers_course_assign_course_assign_types__["h" /* UPDATE_TOPICS */],
      id: id,
      checked: checked,
      searchTerm: term,
      actionType: actionType,
      checkedNormal: checkedNormal,
      checkedEasier: checkedEasier
    });
  };
  var activeClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var activeGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var showSearchPanel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.showSearchPanel;
  });
  var selectedTopicCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.selectedTopicCount;
  });
  var selectedCourseTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.selectedCourseTopics;
  });
  var applyChanges = function applyChanges() {
    var lsKey = "LAST_FILTERSEARCH_SELECTION_".concat(activeClass, "_").concat(activeGroup);
    __WEBPACK_IMPORTED_MODULE_4__helpers_local_storage__["a" /* default */].setItem(lsKey, selectedCourseTopics);
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_11__containers_course_assign_course_assign_types__["i" /* APPLY_FILTER */]
    });
  };
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchTerm = _useState2[0],
    setSearchTerm = _useState2[1];
  var searchTextbox = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var label = i18n._(
  /*i18n*/
  {
    id: "filterDropdownList.filterByTopics",
    defaults: "Showing {selectedTopicCount} of {0} items, click here to filter",
    values: {
      0: selectedCourseTopics.length,
      selectedTopicCount: selectedTopicCount
    }
  });
  var selectButtonLabel = selectedTopicCount !== 0 ? i18n._(
  /*i18n*/
  {
    id: "filterDropdownList.unSelectAll",
    defaults: "Unselect all"
  }) : i18n._(
  /*i18n*/
  {
    id: "filterDropdownList.selectAll",
    defaults: "Select all"
  });
  var handleClick = function handleClick() {
    if (selectedCourseTopics.length) {
      hideShowSearchPanel(true);
      searchTextbox.current.placeholder = i18n._(
      /*i18n*/
      {
        id: "filterDropdownList.searchphText",
        defaults: "Type here to search"
      });
    }
  };
  var handleOnChange = function handleOnChange(e) {
    var searchText = e.target.value;
    setSearchTerm(searchText);
    updateTopics('onSearch', '', false, searchText);
    if (!searchText) {
      searchTextbox.current.placeholder = i18n._(
      /*i18n*/
      {
        id: "filterDropdownList.searchStandards",
        defaults: "Type here to search for Standards"
      });
    }
  };
  var uncheckAll = function uncheckAll() {
    if (selectedTopicCount !== 0) {
      updateTopics('uncheckAll');
    } else {
      updateTopics('checkAll');
    }
  };
  var applyFilter = function applyFilter() {
    trackTopicApplied({
      topicCount: selectedTopicCount
    });
    hideShowSearchPanel(false);
    applyChanges();
    searchTextbox.current.placeholder = label;
    onApply();
  };
  var onSelect = function onSelect(checked, id) {
    updateTopics('selection', id, checked, searchTerm);
  };
  var onRadioSelect = function onRadioSelect(id, checkedNormal, checkedEasier) {
    updateTopics('radioupdate', id, '', searchTerm, checkedNormal, checkedEasier);
  };
  var getCheckedState = function getCheckedState(item) {
    if (item.selected) {
      return __WEBPACK_IMPORTED_MODULE_10__checkbox_constants__["b" /* CHECKED */];
    }
    return __WEBPACK_IMPORTED_MODULE_10__checkbox_constants__["a" /* UNCHECKED */];
  };
  var renderTopicsItems = function renderTopicsItems() {
    if (selectedCourseTopics) {
      return selectedCourseTopics.map(function (item) {
        if (!item.isHidden) {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
            key: item.topicId
          }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "strand"
          }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "wrapper"
          }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: "Description"
          }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__selectable_list_item__["a" /* default */], {
            i18n: i18n,
            id: item.topicId,
            checked: getCheckedState(item),
            name: item.topicName,
            onChange: onSelect,
            easierActivitiesCount: item.easierActivities.length,
            checkedNormal: item.checkedNormal,
            checkedEasier: item.checkedEasier,
            onRadioselect: onRadioSelect,
            isChecked: item.selected
          })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("hr", {
            className: "line"
          }));
        }
        return null;
      });
    }
    return null;
  };
  var focusSearchTextbox = function focusSearchTextbox() {
    searchTextbox.current.placeholder = label;
    if (showSearchPanel) {
      hideShowSearchPanel(false);
    }
  };
  var msgNoFilterApplies = i18n._(
  /*i18n*/
  {
    id: "filterDropdownList.noFilterApplied",
    defaults: "No filters have been applied - showing all topics"
  });
  var msgFilterApplies = i18n._(
  /*i18n*/
  {
    id: "filterDropdownList.filterApplied",
    defaults: "Filters have been applied - click search bar to see which topics have been excluded"
  });
  var logoTitle = selectedTopicCount === selectedCourseTopics.length ? msgNoFilterApplies : msgFilterApplies;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: focusSearchTextbox,
    forButton: "searchPanel"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    id: "searchPanel"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["a" /* SearchContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["b" /* FilterWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label", {
    htmlFor: "filter"
  }, i18n._(
  /*i18n*/
  {
    id: "filterDropdownList.topicfilter",
    defaults: "Topic Filter"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["c" /* SearchableListWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "searchText"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["d" /* InputWrapper */], {
    ref: searchTextbox,
    type: "text",
    onClick: handleClick,
    onChange: handleOnChange,
    value: searchTerm,
    placeholder: label,
    "data-name": "filter"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "searchLogo",
    title: logoTitle
  }, selectedTopicCount === selectedCourseTopics.length ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["P" /* FilterOutlineIcon */]
  }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["e" /* FilteredListWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["U" /* FilterIcon */]
  })))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["f" /* SelectPanelWrapper */], {
    style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__styled__["g" /* showElement */])(showSearchPanel)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "panelBody"
  }, renderTopicsItems()), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "panelFooter"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "uncheck"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"], {
    className: "unCheckAllButton",
    disabled: !selectedCourseTopics.length,
    text: selectButtonLabel,
    type: __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"].LOZENGE,
    onClick: uncheckAll
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "apply"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"], {
    className: "applyButton",
    disabled: !selectedCourseTopics.length,
    primary: true,
    text: i18n._(
    /*i18n*/
    {
      id: "filterDropdownList.applyFilter",
      defaults: "Apply filter"
    }),
    type: __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"].LOZENGE,
    onClick: applyFilter
  }))))))));
};
FilterDropDownList.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  onApply: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
/* harmony default export */ __webpack_exports__["a"] = (FilterDropDownList);

/***/ }),

/***/ "aiz3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CellContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GridColumn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n\n  min-height: calc(100% - 192px);\n  border: 1px solid ").concat(colours.grey[400], ";;\n  background-color: ").concat(colours.grey[200], ";\n");
});
var Header = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].header(function (props) {
  var colours = props.theme.colours;
  return "\n        ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n\n        position: sticky;\n        top: 192px;\n        z-index: 1;\n        width: 54px;\n        height: 47px;\n        min-height: 47px;\n        background-color: ").concat(colours.grey[400], ";\n        border-right: 1px solid ").concat(colours.grey[500], ";\n        box-sizing: border-box;\n\n        @media screen and (max-width: 1100px) {\n          min-height: 37px;\n          height: 37px;\n          top: 0;\n        }\n");
});
var CellContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'));
var GridColumn = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'));


/***/ }),

/***/ "ann7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("p6XH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__topic_info__ = __webpack_require__("GGmR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }











var TopicCollapsed = function TopicCollapsed(_ref) {
  var handleOnExpand = _ref.handleOnExpand,
    topicName = _ref.topicName,
    id = _ref.id;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var myRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    showInfo = _useState2[0],
    setInfo = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState4 = _slicedToArray(_useState3, 2),
    positionX = _useState4[0],
    setPositionX = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState6 = _slicedToArray(_useState5, 2),
    positionY = _useState6[0],
    setPositionY = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState8 = _slicedToArray(_useState7, 2),
    positionArrow = _useState8[0],
    setPositionArrow = _useState8[1];
  var _useState9 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState0 = _slicedToArray(_useState9, 2),
    positionXCallout = _useState0[0],
    setPositionXCallout = _useState0[1];
  var _useState1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState10 = _slicedToArray(_useState1, 2),
    positionYCallout = _useState10[0],
    setPositionYCallout = _useState10[1];
  var _useState11 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState12 = _slicedToArray(_useState11, 2),
    positionArrowCallout = _useState12[0],
    setPositionArrowCallout = _useState12[1];
  var _useState13 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState14 = _slicedToArray(_useState13, 2),
    callOut = _useState14[0],
    setCallOut = _useState14[1];
  var standardRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var _useState15 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),
    _useState16 = _slicedToArray(_useState15, 2),
    contextTheme = _useState16[0],
    setContextTheme = _useState16[1];
  var showDropdown = function showDropdown() {
    var _getContextCoords = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_utils__["e" /* getContextCoords */])(myRef.current.getBoundingClientRect(), __WEBPACK_IMPORTED_MODULE_6__context_modal__["a" /* ContextModalWidth */]),
      posX = _getContextCoords.posX,
      posY = _getContextCoords.posY,
      posArrow = _getContextCoords.posArrow;
    setPositionY(posY);
    setPositionX(posX);
    setPositionArrow(posArrow);
    setCallOut(false);
    setInfo(false);
  };
  var hideStandardBlock = function hideStandardBlock() {
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_10__containers_course_assign_course_assign_types__["N" /* HIDE_STANDARD */],
      id: id
    });
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_10__containers_course_assign_course_assign_types__["k" /* DISPLAY_MODAL_INFORMATION */],
      key: -1
    });
  };
  var showCallOut = function showCallOut() {
    var _getContextCoords2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__helpers_utils__["e" /* getContextCoords */])(standardRef.current.getBoundingClientRect(), __WEBPACK_IMPORTED_MODULE_6__context_modal__["a" /* ContextModalWidth */]),
      posX = _getContextCoords2.posX,
      posY = _getContextCoords2.posY,
      posArrow = _getContextCoords2.posArrow;
    setPositionYCallout(posY);
    setPositionXCallout(posX);
    setPositionArrowCallout(posArrow);
    setContextTheme('standard');
    setCallOut(true);
  };
  var hideCallOut = function hideCallOut() {
    setCallOut(false);
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* Wrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* Collapse */], {
    role: "button",
    tabIndex: "0",
    onClick: function onClick() {
      return handleOnExpand(false);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_5__helpers_icon_dictionary__["v" /* ExpandButton */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* Info */], {
    role: "button",
    onClick: showDropdown,
    ref: standardRef,
    onMouseEnter: showCallOut,
    onMouseLeave: hideCallOut
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["d" /* Content */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["e" /* TopicName */], null, topicName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["f" /* Icon */], {
    ref: myRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_5__helpers_icon_dictionary__["e" /* StandardDropdown */]
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setInfo(false);
    },
    forButton: "showContextModal_".concat(id)
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__context_modal__["b" /* default */], {
    show: showInfo,
    positionArrow: positionArrow,
    positionX: positionX,
    positionY: positionY
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__topic_info__["a" /* default */], {
    standardName: topicName,
    hideStrand: hideStandardBlock,
    displayHideOption: true
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__context_modal__["b" /* default */], {
    show: callOut,
    positionArrow: positionArrowCallout,
    positionX: positionXCallout,
    positionY: positionYCallout,
    contextTheme: contextTheme,
    name: topicName
  })));
};
TopicCollapsed.propTypes = {
  handleOnExpand: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  topicName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
TopicCollapsed.defaultProps = {
  handleOnExpand: function handleOnExpand() {},
  topicName: ''
};
/* harmony default export */ __webpack_exports__["a"] = (TopicCollapsed);

/***/ }),

/***/ "avc1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return productEnum; });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var productEnum = /*#__PURE__*/_createClass(function productEnum() {
  _classCallCheck(this, productEnum);
});
_defineProperty(productEnum, "MATHLETICS", {
  id: 1,
  name: 'Mathletics'
});
_defineProperty(productEnum, "SPELLODROME", {
  id: 3,
  name: 'Spellodrome'
});
_defineProperty(productEnum, "INTOSICENCE", {
  id: 6,
  name: 'Intoscience'
});
_defineProperty(productEnum, "PHONICS", {
  id: 8,
  name: 'Phonics'
});
_defineProperty(productEnum, "MATLETICA", {
  id: 9,
  name: 'Mathletics Play'
});


/***/ }),

/***/ "awYd":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".app---3vTSy {\n  height: calc(100vh - 44px);\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column; }\n  @media only screen and (min-device-width: 768px) and (max-device-width: 1112px) and (-webkit-min-device-pixel-ratio: 2) {\n    .app---3vTSy {\n      height: calc(100vh - 88px); } }\n  .header---3WHby,\n.footer---NcHZ2 {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -webkit-box-flex: 0;\n      -ms-flex-positive: 0;\n          flex-grow: 0; }\n  .header---3WHby p,\n  .footer---NcHZ2 p {\n    font-size: 16px !important;\n    font-weight: 500 !important;\n    padding-top: 5px;\n    padding-left: 6px !important; }\n  .header---3WHby {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  background-color: #dbe3e9; }\n  .header---3WHby h1 {\n    font-size: 20px;\n    font-size: 1.25rem; }\n  .header---3WHby [class*=\"TitleContainer\"] {\n    padding: 0 20px; }\n  .header---3WHby [class*=\"SubHeader\"] {\n    padding: 0; }\n  .container-wrapper---3U5Hh {\n  height: 100%;\n  position: relative;\n  margin-bottom: 0.01px !important;\n  border-radius: 5px 5px 0.01px 0.01px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 0 !important;\n  overflow-x: hidden;\n  overflow-y: hidden; }\n  @media screen and (max-width: 1100px) {\n    .container-wrapper---3U5Hh {\n      margin: 0.001px !important;\n      padding: 0 10px !important; } }\n  .footer---NcHZ2 > * {\n  margin: 0 8px; }\n  .buttonsContainer---36eUY {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center; }\n", ""]);

// exports
exports.locals = {
	"app": "app---3vTSy",
	"header": "header---3WHby",
	"footer": "footer---NcHZ2",
	"container-wrapper": "container-wrapper---3U5Hh",
	"buttonsContainer": "buttonsContainer---36eUY"
};

/***/ }),

/***/ "bC9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("TQbn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__checkbox__ = __webpack_require__("4YSV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__checkbox_constants__ = __webpack_require__("IzlY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }







var GridHeader = function GridHeader(props) {
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_5__checkbox_constants__["a" /* UNCHECKED */]),
    _useState2 = _slicedToArray(_useState, 2),
    checkboxState = _useState2[0],
    setCheckboxState = _useState2[1];
  var activities = props.activities,
    mappedAssignmentIndexes = props.mappedAssignmentIndexes;
  function handleOnClick(activity, cbStatus) {
    setCheckboxState(cbStatus);
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_6__containers_course_assign_course_assign_types__["m" /* GRID_CELL_SELECTION */],
      indexes: mappedAssignmentIndexes === null || mappedAssignmentIndexes === void 0 ? void 0 : mappedAssignmentIndexes[activity.activityName],
      status: cbStatus
    });
  }
  var getState = function getState() {
    var filteredActivities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var state = checkboxState;
    var selectedCells = filteredActivities.filter(function (_ref) {
      var isSelected = _ref.isSelected;
      return isSelected;
    });
    if (!selectedCells.length && !filteredActivities.length) state = __WEBPACK_IMPORTED_MODULE_5__checkbox_constants__["a" /* UNCHECKED */];
    if (selectedCells.length >= filteredActivities.length) {
      state = __WEBPACK_IMPORTED_MODULE_5__checkbox_constants__["b" /* CHECKED */];
    }
    if (selectedCells.length > 0 && selectedCells.length < filteredActivities.length) {
      state = __WEBPACK_IMPORTED_MODULE_5__checkbox_constants__["c" /* INDETERMINATE */];
    }
    if (selectedCells.length === 0) state = __WEBPACK_IMPORTED_MODULE_5__checkbox_constants__["a" /* UNCHECKED */];
    return state;
  };
  function HeaderCheckboxes(_ref2) {
    var activity = _ref2.activity,
      indexes = _ref2.indexes;
    var studentAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
      return indexes.map(function (x) {
        return state.CourseAssignReducer.assignments.studentAssignments[x];
      });
    }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["d" /* CBContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__checkbox__["a" /* default */], {
      checkboxHandler: function checkboxHandler(cbStatus) {
        return handleOnClick(activity, cbStatus);
      },
      state: getState(studentAssignments)
    }));
  }
  HeaderCheckboxes.propTypes = {
    activity: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    indexes: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number).isRequired
  };
  var displayCheckboxes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    return activities.map(function (activity) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderCheckboxes, {
        activity: activity
        // eslint-disable-next-line react/prop-types
        ,
        key: "".concat(activity.activityId, "_").concat(activity.activityName),
        indexes:
        // eslint-disable-next-line react/prop-types
        (mappedAssignmentIndexes === null || mappedAssignmentIndexes === void 0 ? void 0 : mappedAssignmentIndexes[activity.activityName]) || []
      });
    });
  }, [activities, mappedAssignmentIndexes]);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["e" /* Header */], null, displayCheckboxes());
};
GridHeader.propTypes = {
  activities: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired,
  mappedAssignmentIndexes: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};
GridHeader.defaultProps = {
  activityIds: []
};
/* harmony default export */ __webpack_exports__["a"] = (GridHeader);

/***/ }),

/***/ "bW/0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StudentResultCellWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var StudentResultCellWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var palette = props.theme.palette;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    width: 200px;\n    height: 70px;\n\n    color: ").concat(palette.primary.dark, ";\n  ");
});
var Title = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n\n  width: 100%;\n  font-size: 12px;\n  font-weight: 800;\n  text-align: left;\n  text-rendering: geometricPrecision;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])());
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n  width: 100%;\n  height: 25px;\n  font-size: 12px;\n  border: 1px solid ").concat(colours.grey[300], ";\n  border-radius: 4px;\n  padding-top: 3px;\n");
});
var IconWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-right: 10px;\n  margin-bottom: 2px;\n  width: 20px;\n  height: 20px;\n"])));

/***/ }),

/***/ "bZcI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildAnalyticsClient;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_mx_teacher_analytics__ = __webpack_require__("2HaB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__("Dr7+");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }


var APP_NAME = 'course-assign';
var TEACHER_TOTTER_PRODUCT = 'mathletics';
var CORE_GROUP = 'core';
function resolveEnabledGroups(trackingGroups) {
  if (!trackingGroups) {
    return null;
  }
  var groups = trackingGroups.split(',').map(function (group) {
    return group.trim();
  }).filter(Boolean);
  return [].concat(_toConsumableArray(groups), [CORE_GROUP]);
}

// A failed build falls back to teacher-totter off so analytics never breaks the
// app (the package throws if teacher-totter is enabled without a sync URL).
function buildAnalyticsClient(config) {
  var environment = config.environment,
    posthogEnabled = config.posthogEnabled,
    trackingGroups = config.trackingGroups,
    teacherTotterEnabled = config.teacherTotterEnabled,
    teacherTotterSyncUrl = config.teacherTotterSyncUrl,
    identityGatewayUrl = config.identityGatewayUrl,
    getAppAuthToken = config.getAppAuthToken;
  var posthog = posthogEnabled ? {
    enabled: true
  } : {
    enabled: false
  };
  var analyticsConfig = {
    app: APP_NAME,
    environment: environment || 'production',
    providers: {
      posthog: posthog,
      teacherTotter: {
        enabled: Boolean(teacherTotterEnabled && teacherTotterSyncUrl),
        syncUrl: teacherTotterSyncUrl,
        product: TEACHER_TOTTER_PRODUCT,
        getAuthToken: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__3plearning_mx_teacher_analytics__["a" /* createIdentityJwtTokenGetter */])({
          identityGatewayUrl: identityGatewayUrl,
          getAppAuthToken: getAppAuthToken
        })
      }
    },
    enabledFeatureGroups: resolveEnabledGroups(trackingGroups),
    events: __WEBPACK_IMPORTED_MODULE_1__events__["a" /* default */]
  };
  try {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__3plearning_mx_teacher_analytics__["b" /* createAnalytics */])(analyticsConfig);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[analytics] Initialisation failed; continuing with teacher-totter disabled.', error);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__3plearning_mx_teacher_analytics__["b" /* createAnalytics */])(_objectSpread(_objectSpread({}, analyticsConfig), {}, {
      providers: _objectSpread(_objectSpread({}, analyticsConfig.providers), {}, {
        teacherTotter: _objectSpread(_objectSpread({}, analyticsConfig.providers.teacherTotter), {}, {
          enabled: false
        })
      })
    }));
  }
}

/***/ }),

/***/ "bvYO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_hooks_use_selected_assignments_count_use_selected_assignments_count__ = __webpack_require__("XvAE");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


var useAssignmentsActionBar = function useAssignmentsActionBar() {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
    _useState2 = _slicedToArray(_useState, 2),
    isCollapsed = _useState2[0],
    setIsCollapsed = _useState2[1];
  var selectedAssignmentsCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers_hooks_use_selected_assignments_count_use_selected_assignments_count__["a" /* default */])();
  var prevSelectedAssignmentsCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(0);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var firstAssignmentSelected = prevSelectedAssignmentsCount.current === 0 && selectedAssignmentsCount > 0;
    var lastAssignmentDeselected = prevSelectedAssignmentsCount.current > 0 && selectedAssignmentsCount === 0;
    if (firstAssignmentSelected) {
      setIsCollapsed(false);
    } else if (lastAssignmentDeselected) {
      setIsCollapsed(true);
    }
    prevSelectedAssignmentsCount.current = selectedAssignmentsCount;
  }, [selectedAssignmentsCount]);
  var toggleIsCollapsed = function toggleIsCollapsed() {
    setIsCollapsed(!isCollapsed);
  };
  return {
    isCollapsed: isCollapsed,
    toggleIsCollapsed: toggleIsCollapsed
  };
};
/* harmony default export */ __webpack_exports__["a"] = (useAssignmentsActionBar);

/***/ }),

/***/ "c+Q/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnassignModalOuter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UnassignModalInner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");

var UnassignModalOuter = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function () {
  return "\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  z-index: 10;\n  top: 0px;\n  background-color: rgba(0; 0; 0; 0.5);\n  left: 0px;\n  align-items: center\n";
});
var UnassignModalInner = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var palette = props.theme.palette;
  return "\n      padding: 10px;\n      width: 320px;\n      height: 200px;\n      background-color: white;\n      border-radius: 4px;\n      margin: auto;\n      display: flex;\n      flex-wrap: wrap;\n      justify-content: center;\n      text-align: center;\n\n      & div[class*=\"ButtonWrapper\"] {\n        height: 30px;\n        &:first-of-type {\n          margin-right: 20px;\n          color: white;\n          padding: 15px;\n          background-color: ".concat(palette.secondary.main, "\n        }\n      }\n  ");
});

/***/ }),

/***/ "cdIJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect__ = __webpack_require__("bndy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styled__ = __webpack_require__("6uc1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__student_list_util__ = __webpack_require__("OG0p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__student_list_item__ = __webpack_require__("EsWq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__quick_selector_quick_selector__ = __webpack_require__("9X0T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_utils__ = __webpack_require__("6QRH");












var StudentList = function StudentList(_ref) {
  var i18n = _ref.i18n;
  var sortedStudents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.sortedStudents;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var mappedAssignmentsSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])(function (state) {
    var _state$CourseAssignRe;
    return (_state$CourseAssignRe = state.CourseAssignReducer) === null || _state$CourseAssignRe === void 0 || (_state$CourseAssignRe = _state$CourseAssignRe.assignments) === null || _state$CourseAssignRe === void 0 ? void 0 : _state$CourseAssignRe.studentAssignments;
  }, function (studentAssignments) {
    var userObj = {};
    studentAssignments.forEach(function (studentAssignment, index) {
      var userArr = userObj[studentAssignment.encryptedUserProfileId];
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers_utils__["c" /* isDefined */])(userArr)) {
        userObj[studentAssignment.encryptedUserProfileId].push(index);
      } else {
        userObj[studentAssignment.encryptedUserProfileId] = [index];
      }
    });
    return userObj;
  });
  var mappedAssignmentIndexes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(mappedAssignmentsSelector, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var sortDirection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.sortDirection;
  });
  var isLoading = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.isLoading;
  });
  var totalAssignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.assignments.totalAssignments;
  }, __WEBPACK_IMPORTED_MODULE_1_react_redux__["d" /* shallowEqual */]);
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var nameLabel = "".concat(i18n._(
  /*i18n*/
  {
    id: "studentList.students",
    defaults: "Students"
  }), " (").concat(sortedStudents.length || 0, ")");
  var sortHandler = function sortHandler() {
    var updatedSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_10__containers_course_assign_course_assign_types__["d" /* UPDATE_SORT_PROPERTIES */],
      direction: updatedSortDirection,
      sortValue: 'lastName'
    });
    var sortedList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__student_list_util__["a" /* customSort */])(sortedStudents, 'lastName', updatedSortDirection);
    dispatch({
      type: __WEBPACK_IMPORTED_MODULE_10__containers_course_assign_course_assign_types__["b" /* UPDATE_SORTED_STUDENTS_LIST */],
      students: sortedList
    });
  };
  var handleSortingArrow = function handleSortingArrow(dir) {
    var icon = dir === 'asc' ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__svg_icon_svg_icon__["a" /* default */], {
      icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["z" /* DownArrow */]
    }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__svg_icon_svg_icon__["a" /* default */], {
      icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["A" /* UpArrow */]
    });
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["a" /* SvgWrapper */], {
      status: true
    }, icon);
  };
  var studentList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return sortedStudents.map(function (student) {
      var _filteredStudent$;
      var filteredStudent = totalAssignments && totalAssignments.filter(function (assignments) {
        return assignments.encryptedUserProfileId === student.encryptedUserProfileId;
      });
      var assignmentCount = (filteredStudent === null || filteredStudent === void 0 ? void 0 : filteredStudent.length) && filteredStudent[0].assignedActivityTotal;
      var dueDate = filteredStudent === null || filteredStudent === void 0 || (_filteredStudent$ = filteredStudent[0]) === null || _filteredStudent$ === void 0 ? void 0 : _filteredStudent$.nextDueDate;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__student_list_item__["a" /* default */], {
        i18n: i18n,
        assignmentCount: assignmentCount,
        dueDate: dueDate,
        student: student,
        mappedAssignmentIndexes: (mappedAssignmentIndexes === null || mappedAssignmentIndexes === void 0 ? void 0 : mappedAssignmentIndexes[student.encryptedUserProfileId]) || [],
        key: "_".concat(student.encryptedUserProfileId)
      });
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [sortedStudents, dispatch, i18n, totalAssignments]);
  if (isLoading) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["b" /* StudentListWrapper */], {
    id: "studentList"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["c" /* HeaderContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["d" /* StudentHeader */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "title",
    role: "button",
    tabIndex: "-1",
    onClick: sortHandler,
    "data-testid": "toggle-sort"
  }, handleSortingArrow(sortDirection), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: "label",
    "data-testid": "name-label"
  }, nameLabel)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["e" /* CurrentAssigned */], {
    "data-testid": "assigned-label"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, i18n._(
  /*i18n*/
  {
    id: "studentList.currentlyAssigned",
    defaults: "Currently Assigned"
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__quick_selector_quick_selector__["a" /* default */], {
    i18n: i18n
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__styled__["f" /* StudentListItemWrapper */], null, studentList));
};
StudentList.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
StudentList.whyDidYouRender = false;
/* harmony default export */ __webpack_exports__["a"] = (StudentList);

/***/ }),

/***/ "cz0L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__filter_dropdownlist__ = __webpack_require__("abke");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__course_name__ = __webpack_require__("JTAn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter_bar_scss__ = __webpack_require__("K2dO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__filter_bar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__filter_bar_scss__);





var ShowFilter = function ShowFilter(props) {
  var i18n = props.i18n,
    isOpen = props.isOpen,
    onApply = props.onApply;
  if (!isOpen) return null;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_4__filter_bar_scss___default.a.search,
    "data-testid": "show-filter"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__course_name__["a" /* default */], {
    i18n: i18n
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__filter_dropdownlist__["a" /* default */], {
    i18n: i18n,
    onApply: onApply
  }));
};
ShowFilter.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onApply: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
ShowFilter.isOpen = false;
/* harmony default export */ __webpack_exports__["a"] = (ShowFilter);

/***/ }),

/***/ "d32L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Cell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ConversationStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Result; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_variables_scss__ = __webpack_require__("Wi6H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("KAdK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utils__ = __webpack_require__("6QRH");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
/* eslint-disable indent */





var Cell = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var statusColor = '';
  var status = props.status,
    percentage = props.percentage,
    isSelected = props.isSelected,
    isCollapsed = props.isCollapsed,
    isAssigned = props.isAssigned,
    isCellSelected = props.isCellSelected,
    hasResults = props.hasResults,
    isFiltered = props.isFiltered;
  var hoverBackgroundColor = null;
  var colours = props.theme.colours;
  var assignmentSelected = '#dae7d3';
  var unattemptedSelected = '#b2e4ff';
  switch (status) {
    case __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* UNATTEMPTED */]:
      {
        statusColor = isSelected ? unattemptedSelected : '#fff';
        hoverBackgroundColor = '#e5e5e5';
        break;
      }
    case __WEBPACK_IMPORTED_MODULE_2__utils__["c" /* ASSIGNED */]:
    case __WEBPACK_IMPORTED_MODULE_2__utils__["d" /* PAST_DUE_DATE */]:
    case __WEBPACK_IMPORTED_MODULE_2__utils__["e" /* INPROGRESS */]:
      {
        statusColor = isSelected ? assignmentSelected : '#dae7d3';
        hoverBackgroundColor = '#c3cfbd';
        break;
      }
    default:
      {
        statusColor = '#fff';
        break;
      }
  }
  statusColor = isCellSelected ? '#b2e4ff' : statusColor;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_utils__["c" /* isDefined */])(percentage) && !isAssigned) {
    switch (true) {
      case percentage >= 0 && percentage <= 50:
        {
          statusColor = '#900012';
          break;
        }
      case percentage > 50 && percentage <= 85:
        {
          statusColor = '#2452BB';
          break;
        }
      case percentage > 85 && percentage <= 100:
        {
          statusColor = '#008902';
          break;
        }
      default:
        break;
    }
  }
  var getBackgroundColor = function getBackgroundColor() {
    if (isFiltered && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_utils__["c" /* isDefined */])(percentage)) {
      return colours.grey[100];
    }
    if (isCollapsed) {
      if (isAssigned) {
        statusColor = '#dae7d3';
      } else if (!hasResults) {
        statusColor = '#fff';
      }
    }
    return statusColor;
  };
  return "\n    width: 54px;\n    min-height: 33px;\n    max-height: 33px;\n    box-sizing: border-box;\n    background-color: ".concat(getBackgroundColor(), ";\n    opacity: ").concat(isFiltered ? 0.2 : 1, ";\n    border: ").concat(isSelected || isCellSelected ? '2px solid #00A5FF' : "1px solid ".concat(colours.grey[400]), ";\n    cursor: pointer;\n    &: hover {\n    background-color: ").concat(hoverBackgroundColor, ";\n  }\n  ");
});
var ConversationStatus = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  position: relative;\n  width: 54px;\n  height: 28px;\n\n  div[class*='svgIconComponent--'] {\n    padding-top: 6px;\n    margin-left: -17px;\n  }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__styles_helpers_flexbox__["e" /* inlineFlexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__styles_helpers_flexbox__["c" /* justifyContent */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var Result = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var percentage = props.percentage,
    hasResults = props.hasResults,
    isAssigned = props.isAssigned,
    isFiltered = props.isFiltered;
  return "\n  color: ".concat((hasResults || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_utils__["c" /* isDefined */])(percentage)) && isAssigned ? 'black' : 'white', ";\n  opacity; ").concat(isFiltered ? 0.2 : 1, ";\n  font-size: 14px;\n  padding-top: 3px;\n  padding-right: 3px;\n  ");
});


/***/ }),

/***/ "dBs8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StudentAccessWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AccessSwitchWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RestrictedWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Heading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Description; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DescriptionStrong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DescriptionWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return IconUnrestricted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return IconContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var StudentAccessWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
var AccessSwitchWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'), ";\n\n  width: 203px;\n  height: 32px;\n  margin-top: 3px;  \n  background-color: #ffbe39;\n  color: ").concat(colours.grey[900], ";\n\n  cursor: pointer;\n  box-sizing: border-box;\n  border-radius: 2px;\n");
});
var Title = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  font-size: 13px;\n  border-right: 1px solid rgba(0, 0, 0, 0.25);\n  width: calc(100% - 27px);\n  height: 100%;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'));
var IconWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  padding: 0 5px;\n  width: 25px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'));
var RestrictedWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('row'), ";\n    cursor: pointer;\n    padding: 10px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.25);\n    background-color: #ffbe39;\n    color: ").concat(colours.grey[800], "\n  ");
});
var Heading = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 11.5px;\n  font-weight: 600;\n"])));
var Description = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 11px;\n"])));
var DescriptionStrong = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  display: inline;\n"])));
var DescriptionWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 80%;\n  font-size: 11px;\n"])));
var IconUnrestricted = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), ";\n\n  border: 1px solid ").concat(colours.custom[800], ";\n  border-radius: 5px;\n  width: 25px;\n  height: 25px;\n  margin: 5px 3px;\n  padding: 3px;\n");
});
var IconContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  margin-left: 3px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'));

/***/ }),

/***/ "e6Ie":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ContextModalWidth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__doughnut_tooltip_styled__ = __webpack_require__("2sXf");



var ContextModalWidth = 203;
var ContextModal = function ContextModal(props) {
  var bgColor = 'white';
  var hoverTextColor;
  if (props.contextTheme === 'standard') {
    bgColor = '#3B4E5E';
    hoverTextColor = 'white';
  } else if (props.contextTheme === 'learningJourney') {
    bgColor = '#4F5C67';
  }
  var modalWidth = !props.unrestrictedWidth && ContextModalWidth;
  return props.show && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__doughnut_tooltip_styled__["a" /* ModalWrapper */], {
    positionArrow: props.positionArrow,
    positionArrowFixed: props.positionArrowFixed,
    positionX: props.positionX,
    positionY: props.positionY,
    modalWidth: props.modalWidth ? props.modalWidth : modalWidth,
    bgColor: bgColor,
    hoverTextColor: hoverTextColor,
    customStyle: props.customStyle,
    fixedParent: props.fixedParent,
    contextPos: props.contextPos
  }, props.contextTheme ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__doughnut_tooltip_styled__["b" /* ContentTheme */], {
    "data-testid": "name"
  }, props.name) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__doughnut_tooltip_styled__["c" /* Content */], {
    "data-testid": "content"
  }, props.children));
};
ContextModal.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  positionX: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  positionY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  positionArrow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  positionArrowFixed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  contextTheme: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  customStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  contextPos: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  unrestrictedWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  fixedParent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  modalWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
/* harmony default export */ __webpack_exports__["a"] = (ContextModal);

/***/ }),

/***/ "eH9W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DisplayHighlightsContainer; });
/* unused harmony export ResultsHeading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResultsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AttemptsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DisplayResultsContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HighlightContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Footer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return IconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ChartWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DisplayHighlights; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_helpers_common__ = __webpack_require__("ZmnC");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var ResultContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  height: 100%;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_common__["a" /* widthFillAvailable */])());
var DisplayHighlightsContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  text-align: left;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-evenly'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_common__["a" /* widthFillAvailable */])());
var ResultsHeading = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n  \n    background-color: white;\n    border: 1px solid ").concat(colours.grey[300], ";\n    border-radius: 15px 15px 0px 0px;\n    border-bottom: none;\n    height: 38px;\n    width: 148px;\n    padding-top: 5px;\n    margin-bottom: -6px;\n    z-index: 1;\n    ");
});
var ResultsWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["g" /* flexGrow */])('1'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_common__["a" /* widthFillAvailable */])(), ";\n\n    margin-top: -1px;\n    border: 1px solid ").concat(colours.grey[300], ";\n    border-radius: 15px;\n    padding: 25px 10px 10px 20px;\n  ");
});
var AttemptsWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  width: 70%;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-evenly'));
var DisplayResultsContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  width: 100%;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-evenly'));
var HighlightContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n  border-radius: 4px 4px 0 0;\n  border: 1px solid ".concat(colours.grey[300], ";\n  height: fit-content;\n");
});
var Footer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  width: 100%;\n  margin-top: 10px;\n\n  .okButton {\n    height: 29px;\n    width: 86px;\n    border-radius: 14.5px;\n    font-size: 11px;\n    padding: 0;\n  }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('flex-end'));
var IconWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  margin-right: 10px;\n  width: 20px;\n  height: 20px;\n"])));
var ChartWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  width: 250px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-evenly'));
var DisplayHighlights = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n\n  width: 83%;\n  height: 22px;\n  font-size: 12px;\n  font-weight: 800;\n  text-align: left;\n  text-rendering: geometricPrecision;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])());

/***/ }),

/***/ "eZUU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export initialState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__("kvU2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_student_list_student_list_util__ = __webpack_require__("OG0p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_portal_comms__ = __webpack_require__("lS1M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__course_assign_util__ = __webpack_require__("L/pw");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }






var initialState = {
  isLoading: false,
  isLoadingStudentData: false,
  classrooms: [],
  filteredStudents: [],
  selectedStudentIds: [],
  studentsAssignmentStatus: [],
  studentsAssignmentCount: [],
  sortedStudents: [],
  sortDirection: 'asc',
  sortValue: 'lastName',
  showGridLoader: true,
  unsavedChanges: false,
  pausePolling: false,
  selectedCells: [],
  publications: [],
  genericCourses: [],
  publicationCourses: [],
  topics: [],
  selectedTopics: [],
  strands: [],
  selectedCourse: -1,
  assignmentStatuses: [],
  showSearchPanel: false,
  displayModalKey: -1,
  studentAssignments: [],
  actionInProgress: false,
  selectedLJIds: [],
  studentUnAssignments: [],
  selectedStandardCount: 0,
  standardCount: 0,
  activeClass: null,
  activeGroup: null,
  courseTopics: [],
  gridTopics: [],
  selectedCourseTopics: [],
  assignments: {
    isRestricted: true,
    totalAssignments: [],
    studentAssignments: []
  },
  selectedActivities: [],
  isTopicCollapsed: false,
  isTopicDirty: false,
  isLoadingResults: false,
  singleActivityReport: {},
  shouldClearFilter: false,
  studentResult: {}
};
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["a" /* FILTERED_STUDENTS */]:
      {
        var sortDirection = state.sortDirection,
          sortValue = state.sortValue;
        var sortedStudents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_student_list_student_list_util__["a" /* customSort */])(action.payload, sortValue, sortDirection);
        var orderedArr = [];
        var studentAssignments = state.assignments.studentAssignments;
        sortedStudents.forEach(function (sorted) {
          studentAssignments.forEach(function (currentStudent) {
            if (currentStudent.encryptedUserProfileId === sorted.encryptedUserProfileId) {
              orderedArr.push(_objectSpread(_objectSpread({}, currentStudent), {}, {
                student: sorted
              }));
            }
          });
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          filteredStudents: sortedStudents,
          sortedStudents: sortedStudents,
          showGridLoader: true,
          selectedStudentIds: [],
          studentAssignments: [],
          studentUnAssignments: [],
          selectedLJIds: [],
          pausePolling: false,
          assignments: _objectSpread(_objectSpread({}, state.assignments), {}, {
            studentAssignments: orderedArr
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["b" /* UPDATE_SORTED_STUDENTS_LIST */]:
      {
        var _sortDirection = state.sortDirection,
          _sortValue = state.sortValue;
        var _sortedStudents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_student_list_student_list_util__["a" /* customSort */])(action.students, _sortValue, _sortDirection);
        var _studentAssignments = state.assignments.studentAssignments;
        return _objectSpread(_objectSpread({}, state), {}, {
          sortedStudents: _sortedStudents,
          assignments: _objectSpread(_objectSpread({}, state.assignments), {}, {
            studentAssignments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["a" /* sortStudentAssignmentsByName */])(_studentAssignments, _sortedStudents)
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["c" /* UPDATE_SORTED_ASSIGNED_LIST */]:
      {
        var _sortDirection2 = state.sortDirection,
          _sortValue2 = state.sortValue;
        var sortedList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__components_student_list_student_list_util__["a" /* customSort */])(action.assignedList, _sortValue2, _sortDirection2);
        return _objectSpread(_objectSpread({}, state), {}, {
          sortedList: sortedList
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["d" /* UPDATE_SORT_PROPERTIES */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          sortDirection: action.direction,
          sortValue: action.sortValue
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["e" /* ERROR_DETECTED */]:
      {
        __WEBPACK_IMPORTED_MODULE_4__helpers_portal_comms__["a" /* default */].serverError(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["b" /* contactTechSupportMessage */]);
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["f" /* CLASSROOMS_ACQUIRED */]:
      {
        __WEBPACK_IMPORTED_MODULE_4__helpers_portal_comms__["a" /* default */].loadingSpinnerOff();
        return _objectSpread(_objectSpread({}, state), {}, {
          classrooms: action.payload.classroomList || [],
          isLoading: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["g" /* UPDATE_SELECTED_TOPICS */]:
      {
        var updateTopics;
        var selectedTopicCount;
        if (action.payload.filterTopics) {
          var _updateHiddenTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["c" /* updateHiddenTopics */])(action.payload.filterTopics, action.payload.topics);
          updateTopics = _updateHiddenTopics.updateTopics;
          selectedTopicCount = _updateHiddenTopics.selectedTopicCount;
        } else {
          var _updateSelectedTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["d" /* updateSelectedTopics */])(action.payload.topics);
          updateTopics = _updateSelectedTopics.updateTopics;
          selectedTopicCount = _updateSelectedTopics.selectedTopicCount;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          courseTopics: {},
          selectedCourseTopics: updateTopics,
          gridTopics: __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(updateTopics),
          selectedTopicCount: selectedTopicCount
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["h" /* UPDATE_TOPICS */]:
      {
        var selectedCourseTopics = state.selectedCourseTopics;
        var id = action.id,
          checked = action.checked,
          searchTerm = action.searchTerm,
          actionType = action.actionType,
          checkedNormal = action.checkedNormal,
          checkedEasier = action.checkedEasier;
        var clonedCourseTopics = __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(selectedCourseTopics);
        var updatedTopicData = [];
        var updatedCourseTopics = [];
        switch (actionType) {
          case 'selection':
            {
              updatedCourseTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["e" /* updateStrandAndStandards */])(id, checked, clonedCourseTopics);
              if (searchTerm && searchTerm !== '') {
                updatedTopicData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["f" /* getFilteredTopics */])(searchTerm, updatedCourseTopics);
              } else {
                updatedTopicData = __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(updatedCourseTopics);
              }
              break;
            }
          case 'radioupdate':
            {
              updatedTopicData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["g" /* updateActivitySelection */])(id, clonedCourseTopics, checkedNormal, checkedEasier);
              break;
            }
          case 'uncheckAll':
            updatedCourseTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["h" /* updateCheckedStatus */])(false, clonedCourseTopics);
            updatedTopicData = updatedCourseTopics;
            break;
          case 'checkAll':
            updatedCourseTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["h" /* updateCheckedStatus */])(true, clonedCourseTopics);
            updatedTopicData = updatedCourseTopics;
            break;
          case 'reset':
            updatedCourseTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["i" /* updateStrands */])(true, clonedCourseTopics);
            updatedTopicData = updatedCourseTopics;
            break;
          default:
            updatedTopicData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["f" /* getFilteredTopics */])(searchTerm, clonedCourseTopics);
            break;
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedCourseTopics: updatedTopicData,
          selectedTopicCount: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["j" /* getSelectedStandardCount */])(updatedTopicData)
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["i" /* APPLY_FILTER */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedCourseTopics: state.selectedCourseTopics,
          gridTopics: __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(state.selectedCourseTopics),
          selectedTopicCount: state.selectedTopicCount
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["j" /* SHOW_HIDE_SEARCH_PANEL */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          showSearchPanel: action.status,
          strands: state.strands.map(function (strand) {
            return _objectSpread(_objectSpread({}, strand), {}, {
              isExpand: !!strand.childTopics.find(function (s) {
                return s.selected;
              })
            });
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["k" /* DISPLAY_MODAL_INFORMATION */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          displayModalKey: action.key
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["l" /* UPDATE_STUDENT_ASSIGNMENT */]:
      {
        var _assignments$studentA;
        var assignments = state.assignments;
        var index = action.index;
        assignments.studentAssignments[index] = _objectSpread(_objectSpread({}, assignments.studentAssignments[index]), {}, {
          isSelected: !((_assignments$studentA = assignments.studentAssignments[index]) !== null && _assignments$studentA !== void 0 && _assignments$studentA.isSelected) ? true : undefined
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          assignments: _objectSpread(_objectSpread({}, assignments), {}, {
            studentAssignments: assignments.studentAssignments
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["m" /* GRID_CELL_SELECTION */]:
      {
        var indexes = action.indexes,
          status = action.status;
        var _assignments = state.assignments;
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: false,
          assignments: _objectSpread(_objectSpread({}, _assignments), {}, {
            studentAssignments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["k" /* updateGridCells */])(indexes, _assignments, status)
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["n" /* SET_ACTIVE_CLASS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeClass: action.payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["o" /* SET_ACTIVE_GROUP */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeGroup: action.payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["p" /* RESTRICT_ACCESS_FAILURE */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["q" /* RESTRICT_ACCESS_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["r" /* RESTRICT_ACCESS_SUCCESS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: false,
          assignments: _objectSpread(_objectSpread({}, state.assignments), {}, {
            isRestricted: action.payload
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["s" /* TOPICS_ACQUIRED_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["t" /* TOPICS_ACQUIRED_SUCCESS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: false,
          showGridLoader: false,
          assignments: _objectSpread(_objectSpread({}, action.payload), {}, {
            studentAssignments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["l" /* sortStudentAssignments */])(action.payload.studentAssignments, state.sortedStudents, state.selectedActivities)
          }),
          shouldClearFilter: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["u" /* TOPICS_ACQUIRED_FAILURE */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          actionInProgress: false,
          shouldClearFilter: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["v" /* COURSE_TOPICS_ACQUIRED_SUCCESS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          courseTopics: action.payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["w" /* UPDATE_SELECTED_ACTIVITIES */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedActivities: action.activities || [],
          assignments: _objectSpread(_objectSpread({}, state.assignments), {}, {
            studentAssignments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["m" /* updateStudentAssignmentsHidden */])(state.assignments.studentAssignments, action.activities || [])
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["x" /* UPDATE_COURSE_ID */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          activeCourseID: action.payload.courseID
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["y" /* TOGGLE_TOPICS_EXPAND_COLLAPSE */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isTopicCollapsed: action.setTopicsCollapsed,
          isTopicDirty: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["z" /* SET_TOPIC_TO_DIRTY */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isTopicDirty: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["A" /* UPDATE_DATE_PREFERENCE */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          datePreference: action.payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["B" /* QUICK_SELECTION */]:
      {
        var _studentAssignments2 = state.assignments.studentAssignments;
        if (!action.selectionType) {
          return _objectSpread({}, state);
        }
        var newAssignments = [];
        switch (action.selectionType) {
          case 'allCells':
            _studentAssignments2.forEach(function (assignment) {
              if (!assignment.isHidden) {
                newAssignments.push(_objectSpread(_objectSpread({}, assignment), {}, {
                  isSelected: true
                }));
              } else {
                newAssignments.push(assignment);
              }
            });
            break;
          case 'allAssigned':
            _studentAssignments2.forEach(function (filteredAssignment) {
              if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])(filteredAssignment.assignment) && !filteredAssignment.isHidden) {
                newAssignments.push(_objectSpread(_objectSpread({}, filteredAssignment), {}, {
                  isSelected: true
                }));
              } else {
                newAssignments.push(filteredAssignment);
              }
            });
            break;
          case 'result50':
            _studentAssignments2.forEach(function (assignment) {
              var _assignment$result;
              if (!assignment.isHidden && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])((_assignment$result = assignment.result) === null || _assignment$result === void 0 ? void 0 : _assignment$result.score) && assignment.result.score <= 50) {
                newAssignments.push(_objectSpread(_objectSpread({}, assignment), {}, {
                  isSelected: true
                }));
              } else {
                newAssignments.push(assignment);
              }
            });
            break;
          case 'result85':
            _studentAssignments2.forEach(function (assignment) {
              var _assignment$result2;
              if (!assignment.isHidden && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])((_assignment$result2 = assignment.result) === null || _assignment$result2 === void 0 ? void 0 : _assignment$result2.score) && assignment.result.score > 50 && assignment.result.score < 85) {
                newAssignments.push(_objectSpread(_objectSpread({}, assignment), {}, {
                  isSelected: true
                }));
              } else {
                newAssignments.push(assignment);
              }
            });
            break;
          case 'result100':
            _studentAssignments2.forEach(function (assignment) {
              var _assignment$result3;
              if (!assignment.isHidden && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])((_assignment$result3 = assignment.result) === null || _assignment$result3 === void 0 ? void 0 : _assignment$result3.score) && assignment.result.score >= 85) {
                newAssignments.push(_objectSpread(_objectSpread({}, assignment), {}, {
                  isSelected: true
                }));
              } else {
                newAssignments.push(assignment);
              }
            });
            break;
          case 'clearSelections':
            _studentAssignments2.forEach(function (assignment) {
              if (!assignment.isHidden) {
                newAssignments.push(_objectSpread(_objectSpread({}, assignment), {}, {
                  isSelected: undefined
                }));
              } else {
                newAssignments.push(assignment);
              }
            });
            break;
          default:
            return _objectSpread({}, state);
        }
        return _objectSpread(_objectSpread({}, state), {}, {
          assignments: _objectSpread(_objectSpread({}, state.assignments), {}, {
            studentAssignments: newAssignments
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["C" /* SELECT_EQUAL_LESS_THAN_CELLS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          assignments: _objectSpread(_objectSpread({}, state.assignments), {}, {
            studentAssignments: state.assignments.studentAssignments.map(function (studentAssignment) {
              var _studentAssignment$re, _studentAssignment$re2;
              return _objectSpread(_objectSpread({}, studentAssignment), {}, {
                isSelected: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["c" /* isDefined */])(studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$re = studentAssignment.result) === null || _studentAssignment$re === void 0 ? void 0 : _studentAssignment$re.score) && (studentAssignment === null || studentAssignment === void 0 || (_studentAssignment$re2 = studentAssignment.result) === null || _studentAssignment$re2 === void 0 ? void 0 : _studentAssignment$re2.score) <= action.result && studentAssignment.encryptedUserProfileId === action.currentStudent.encryptedUserProfileId ? true : studentAssignment.isSelected
              });
            })
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["D" /* STUDENT_SINGLE_ACTIVITY_REPORT_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingResults: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["E" /* STUDENT_SINGLE_ACTIVITY_REPORT_SUCCESS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingResults: false,
          singleActivityReport: action.payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["F" /* UPDATE_ASSIGNMENT_FILTERS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          assignments: _objectSpread(_objectSpread({}, state.assignments), {}, {
            studentAssignments: state.assignments.studentAssignments.map(function (studentAssignment) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["n" /* checkIfAssignmentPassesFilter */])(studentAssignment, action.payload);
            })
          })
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["G" /* CLEAR_ASSIGNMENT_FILTERS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          assignments: _objectSpread(_objectSpread({}, state.assignments), {}, {
            studentAssignments: state.assignments.studentAssignments.map(function (studentAssignment) {
              return _objectSpread(_objectSpread({}, studentAssignment), {}, {
                isFiltered: false
              });
            })
          }),
          shouldClearFilter: false
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["H" /* STUDENT_RESULT_REQUEST */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingResults: true
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["I" /* STUDENT_RESULT_SUCCESS */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoadingResults: false,
          studentResult: action.payload
        });
      }
    case __WEBPACK_IMPORTED_MODULE_1__course_assign_types__["J" /* UPDATE_STUDENT_ASSIGNMENTS_SELECTED */]:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          assignments: _objectSpread(_objectSpread({}, state.assignments), {}, {
            studentAssignments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__course_assign_util__["o" /* updateAssignmentStatusByTopic */])(action.payload.activities, action.payload.encryptedUserProfileId, state.assignments.studentAssignments)
          })
        });
      }
    default:
      return state;
  }
});

/***/ }),

/***/ "eag5":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".svgIconComponent---qOa8m {\n  display: block;\n  pointer-events: none;\n  width: 12px; }\n", ""]);

// exports
exports.locals = {
	"svgIconComponent": "svgIconComponent---qOa8m"
};

/***/ }),

/***/ "f4QT":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".switchToOldAssign---3gcB4 {\n  height: 30px;\n  margin-right: 30px; }\n  @media screen and (max-width: 1100px) {\n    .switchToOldAssign---3gcB4 {\n      height: 40px;\n      width: 140px; } }\n", ""]);

// exports
exports.locals = {
	"switchToOldAssign": "switchToOldAssign---3gcB4"
};

/***/ }),

/***/ "fbOh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHOW_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return showToast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HIDE_TOAST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return hideToast; });
var SHOW_TOAST = 'SHOW_TOAST';
var showToast = function showToast(message, messageType) {
  return {
    type: SHOW_TOAST,
    isToastVisible: true,
    message: message,
    messageType: messageType
  };
};
var HIDE_TOAST = 'HIDE_TOAST';
var hideToast = function hideToast() {
  return {
    type: HIDE_TOAST,
    isToastVisible: false
  };
};

/***/ }),

/***/ "gdXn":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".info---2W9_S {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex; }\n\n.checkbox---1MPHD {\n  width: 100%;\n  padding-left: 5px; }\n\n.checkbox---1MPHD .chklabel---2gVYc {\n  display: -webkit-inline-box;\n  display: -moz-inline-flex;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  width: 16px;\n  height: 16px;\n  border: 1px solid #cdcdcd;\n  margin-top: 4px; }\n\n.checkbox---1MPHD .name---2pP0F {\n  display: none; }\n\n.checkbox---1MPHD .description---2LbkP {\n  padding-left: 10px;\n  padding-top: 3px;\n  color: #555;\n  font-family: Poppins, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n\n.name---2pP0F + label {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px;\n  -webkit-appearance: none;\n  cursor: pointer;\n  width: 5%; }\n\n.name---2pP0F:checked + label::after {\n  background-color: white !important;\n  content: \"\\F00C\";\n  color: black;\n  font-family: \"FontAwesome\";\n  font-size: 16px; }\n\n.difficultyspan---1nvFs {\n  float: right;\n  margin-right: 8px; }\n", ""]);

// exports
exports.locals = {
	"info": "info---2W9_S",
	"checkbox": "checkbox---1MPHD",
	"chklabel": "chklabel---2gVYc",
	"name": "name---2pP0F",
	"description": "description---2LbkP",
	"difficultyspan": "difficultyspan---1nvFs"
};

/***/ }),

/***/ "hJ1u":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("/26b");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./course-assign.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./course-assign.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "hTAu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ContentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");


var ModalWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n        ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n        ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n        ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), ";\n\n        background: white;\n        position: absolute;\n        left: -47px;\n        top: -20px;\n        z-index: 99;\n        overflow: hidden\n        width: 100px;\n        height: 20px;\n        border: 2px solid ").concat(colours.grey[400], ";\n");
});
var ContentTheme = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    color: ".concat(colours.grey[600], ";\n  ");
});

/***/ }),

/***/ "hp56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useAssignmentFlowTracking;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__use_tracking__ = __webpack_require__("lykz");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


function useAssignmentFlowTracking(type) {
  var _useTracking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__use_tracking__["a" /* default */])(),
    trackAssignmentFlowStarted = _useTracking.trackAssignmentFlowStarted,
    trackAssignmentConfirmed = _useTracking.trackAssignmentConfirmed;
  var startedAtRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (details) {
    startedAtRef.current = Date.now();
    trackAssignmentFlowStarted(_objectSpread({
      type: type
    }, details));
  }, [trackAssignmentFlowStarted, type]);
  var durationMs = function durationMs() {
    return startedAtRef.current === null ? 0 : Date.now() - startedAtRef.current;
  };
  var confirm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (details) {
    trackAssignmentConfirmed(_objectSpread(_objectSpread({
      type: type
    }, details), {}, {
      durationMs: durationMs()
    }));
  }, [trackAssignmentConfirmed, type]);
  return {
    start: start,
    confirm: confirm
  };
}

/***/ }),

/***/ "iV3T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_resource__ = __webpack_require__("P7H2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__local_resource_config__ = __webpack_require__("2z6x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_app_app_config__ = __webpack_require__("N5/L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_app_app_config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__containers_app_app_config__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-console */




var BasicResources = /*#__PURE__*/function () {
  function BasicResources() {
    _classCallCheck(this, BasicResources);
  }
  return _createClass(BasicResources, null, [{
    key: "initialise",
    value: function initialise(envName, credentials) {
      var env = __WEBPACK_IMPORTED_MODULE_0__3plearning_resource___default()({
        name: envName,
        application: __WEBPACK_IMPORTED_MODULE_2__containers_app_app_config__["appName"],
        // eslint-disable-next-line no-underscore-dangle
        config: window._env_
      });
      var location = window.location;
      var runningOnDeveloperMachine = /^https?:\/\/localhost/.test(location);
      if (runningOnDeveloperMachine) {
        if (envName === 'local') {
          // This implies we'll be hitting the mock REST server,
          // which does not require authentication.

          env.bypassAuthentication();
          env.setConfiguration(__WEBPACK_IMPORTED_MODULE_1__local_resource_config__["a" /* default */]);
        } else if (credentials.authToken) {
          env.authToken = credentials.authToken;
        } else {
          env.setCredentials(credentials.username, credentials.password);
        }
      } else if (credentials.authToken) {
        env.authToken = credentials.authToken;
      } else if (credentials.username && credentials.password) {
        env.username = credentials.username;
        env.password = credentials.password;
      } else {
        // The caller should have provided a valid set of credentials, so
        // hopefully this will never happen.

        console.log('BasicResources.initialise() - to execute, we need either an authToken or' + ' a username/password pair.  The credentials object that was provided does not' + ' contain either.  So, expect things to fail badly :-(.');
      }
      return env;
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (BasicResources);

/***/ }),

/***/ "jhKF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* unused harmony export MOMENT_DEFAULT_FORMAT */
/* unused harmony export MOMENT_DATE_FORMAT */
/* unused harmony export MOMENT_TIME_FORMAT */
/* unused harmony export START_TIME */
/* unused harmony export getDataFromResponse */
/* unused harmony export getDateFromStartPreference */
/* unused harmony export getDateFromDuePreference */
/* harmony export (immutable) */ __webpack_exports__["a"] = mapSelectedActivitiesToReq;
/* harmony export (immutable) */ __webpack_exports__["b"] = retrieveAssignedTaskId;
/* harmony export (immutable) */ __webpack_exports__["c"] = getDatePreference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resources__ = __webpack_require__("viEY");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }



var MOMENT_DEFAULT_FORMAT = 'DD/MMM/YYYY HH:mm';
var MOMENT_DATE_FORMAT = 'DD/MMM/YYYY';
var MOMENT_TIME_FORMAT = 'HH:mm';
var START_TIME = '00:00';
function getDataFromResponse(res) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* isDefined */])(res) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* isDefined */])(res.data) ? res.data : undefined;
}
function getDateFromStartPreference(preference) {
  switch (preference) {
    // Start of next day
    case '1':
      return [__WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, 'day').format(MOMENT_DATE_FORMAT), START_TIME];
    // The next Monday, at midnight
    case '2':
      return [__WEBPACK_IMPORTED_MODULE_0_moment___default()().day(8).format(MOMENT_DATE_FORMAT), START_TIME];
    // Now
    case '0':
      return [__WEBPACK_IMPORTED_MODULE_0_moment___default()().format(MOMENT_DATE_FORMAT), __WEBPACK_IMPORTED_MODULE_0_moment___default()().format(MOMENT_TIME_FORMAT)];
    default:
      return undefined;
  }
}
function getDateFromDuePreference(startDate, preference) {
  startDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* getHyphenDateFormat */])(startDate);
  switch (preference) {
    // Due in one hour
    case '1':
      return [__WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).add(1, 'hour').format(MOMENT_DATE_FORMAT), __WEBPACK_IMPORTED_MODULE_0_moment___default()().add(1, 'hour').format(MOMENT_TIME_FORMAT)];
    // Due in one day
    case '2':
      return [__WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).add(1, 'day').format(MOMENT_DATE_FORMAT), __WEBPACK_IMPORTED_MODULE_0_moment___default()().set({
        hours: 17,
        minutes: 0
      }).format(MOMENT_TIME_FORMAT)];
    // Due in 2 days
    case '3':
      return [__WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).add(2, 'days').format(MOMENT_DATE_FORMAT), __WEBPACK_IMPORTED_MODULE_0_moment___default()().set({
        hours: 17,
        minutes: 0
      }).format(MOMENT_TIME_FORMAT)];
    // Due in one week
    case '4':
      return [__WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).add(1, 'week').format(MOMENT_DATE_FORMAT), __WEBPACK_IMPORTED_MODULE_0_moment___default()().set({
        hours: 17,
        minutes: 0
      }).format(MOMENT_TIME_FORMAT)];
    // Due in two weeks
    case '5':
      return [__WEBPACK_IMPORTED_MODULE_0_moment___default()(startDate).add(2, 'weeks').format(MOMENT_DATE_FORMAT), __WEBPACK_IMPORTED_MODULE_0_moment___default()().set({
        hours: 17,
        minutes: 0
      }).format(MOMENT_TIME_FORMAT)];
    // No due date
    case '0':
    default:
      return undefined;
  }
}
function mapSelectedActivitiesToReq(selectedActivities) {
  var activityMap = new Map();
  var requestObj = {
    studentWithActivities: []
  };
  selectedActivities.forEach(function (activity) {
    var currentMap = activityMap.get(activity.encryptedUserProfileId) || [];
    activityMap.set(activity.encryptedUserProfileId, [].concat(_toConsumableArray(currentMap), [{
      activityTaskId: activity.activityId,
      taskType: activity.taskType
    }]));
  });
  activityMap.forEach(function (value, key) {
    requestObj.studentWithActivities.push({
      encryptedUserProfileId: key,
      activitiesToAssign: value
    });
  });
  return requestObj;
}
function retrieveAssignedTaskId(selectedAssignments) {
  return selectedAssignments.map(function (selectedAssignment) {
    return selectedAssignment.assignment.assignedTaskId;
  });
}
function getDatePreference() {
  return _getDatePreference.apply(this, arguments);
}
function _getDatePreference() {
  _getDatePreference = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var datePreference;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          datePreference = [];
          _context.n = 1;
          return __WEBPACK_IMPORTED_MODULE_2__resources__["a" /* default */].getStartDatePreference.get().send().then(function (startRes) {
            var startData = getDataFromResponse(startRes);
            if (startData) {
              var startPreference = getDateFromStartPreference(startData.preferredValue);
              datePreference.push(startPreference);
              __WEBPACK_IMPORTED_MODULE_2__resources__["a" /* default */].getDueDatePreference.get().send().then(function (dueRes) {
                var dueData = getDataFromResponse(dueRes);
                if (dueData) {
                  datePreference.push(getDateFromDuePreference(startPreference[0], dueData.preferredValue));
                }
              });
            }
          });
        case 1:
          return _context.a(2, datePreference);
      }
    }, _callee);
  }));
  return _getDatePreference.apply(this, arguments);
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("hKoQ")))

/***/ }),

/***/ "jzvl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_portal_comms__ = __webpack_require__("lS1M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__show_filter__ = __webpack_require__("cz0L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_locale__ = __webpack_require__("ZhO1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_list__ = __webpack_require__("UPZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__legend__ = __webpack_require__("MlP1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss__ = __webpack_require__("K2dO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__filter_bar_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_resources_helper__ = __webpack_require__("jhKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__student_access_student_access__ = __webpack_require__("mr6W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__analytics__ = __webpack_require__("uVVs");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }


















// Only import download-excel if not Internet Explorer,
// as this module breaks the whole application on IE11
var isIE = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
var DownloadExcel = isIE ? undefined : __webpack_require__("PY2a").default;
function FilterBar(_ref) {
  var i18n = _ref.i18n;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* useDispatch */])();
  var _useTracking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__analytics__["d" /* useTracking */])(),
    trackHowItWorks = _useTracking.trackHowItWorks,
    trackViewKey = _useTracking.trackViewKey,
    trackMenuAction = _useTracking.trackMenuAction;
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLegendVisible = _useState2[0],
    setLegendVisible = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showActionsList = _useState4[0],
    setActionsList = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showFilter = _useState6[0],
    setShowFilter = _useState6[1];
  var _useState7 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isDownloadInProgress = _useState8[0],
    setDownloadProgressFlag = _useState8[1];
  var gridTopics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.gridTopics;
  }, __WEBPACK_IMPORTED_MODULE_3_react_redux__["d" /* shallowEqual */]);
  var assignments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.assignments;
  }, __WEBPACK_IMPORTED_MODULE_3_react_redux__["d" /* shallowEqual */]);
  var classrooms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.classrooms;
  });
  var activeClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var activeGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var filteredStudents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.filteredStudents;
  });
  var girlIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])([]);
  function hideLegend() {
    setLegendVisible(false);
  }
  function hideFilter() {
    setShowFilter(false);
  }
  var exportExcel = function exportExcel() {
    if (isIE) {
      return;
    }
    setDownloadProgressFlag(true);
    var activeClassDetails = classrooms.find(function (currentClass) {
      return currentClass.classroomId === activeClass;
    });
    var activeClassName = activeClassDetails ? activeClassDetails.name : '';
    var activeGroupDetails = activeClassDetails.groups.find(function (groupDetails) {
      return groupDetails.groupId === activeGroup;
    });
    var activeGroupName = activeGroupDetails ? activeGroupDetails.name : '';
    DownloadExcel.processDataForExcel(assignments, i18n, gridTopics, filteredStudents, activeClassName, activeGroupName, setDownloadProgressFlag);
  };
  /* eslint-disable indent */
  // Only show option if not internet explorer
  // Internet Explorer will break if the exceljs module is imported
  var exportExcelItem = isIE ? [] : [{
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["M" /* ExcelExportIcon */],
    text: i18n._(
    /*i18n*/
    {
      id: "courseAssign.actions.exportExcel",
      defaults: "Export to Excel"
    }),
    onClick: function onClick() {
      trackMenuAction({
        action: 'export-excel'
      });
      exportExcel();
      setActionsList(false);
    },
    disabled: isDownloadInProgress
  }];
  /* eslint-enable indent */

  var actionsListOptions = [].concat(exportExcelItem, [{
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["N" /* Expand */],
    text: i18n._(
    /*i18n*/
    {
      id: "courseAssign.actions.expandAll",
      defaults: "Expand all"
    }),
    onClick: function onClick() {
      trackMenuAction({
        action: 'expand-all'
      });
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_types__["y" /* TOGGLE_TOPICS_EXPAND_COLLAPSE */],
        setTopicsCollapsed: false
      });
      setActionsList(false);
    }
  }, {
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["O" /* CollapseAllIcon */],
    text: i18n._(
    /*i18n*/
    {
      id: "courseAssign.actions.collapseAll",
      defaults: "Collapse all"
    }),
    onClick: function onClick() {
      trackMenuAction({
        action: 'collapse-all'
      });
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_types__["y" /* TOGGLE_TOPICS_EXPAND_COLLAPSE */],
        setTopicsCollapsed: true
      });
      setActionsList(false);
    }
  }]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__helpers_utils__["b" /* getConfiguration */])('girlIdsForInfoModal').then(function (value) {
      return girlIds.current = JSON.parse(value) || [];
    });
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_resources_helper__["c" /* getDatePreference */])().then(function (datePreference) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_types__["A" /* UPDATE_DATE_PREFERENCE */],
        payload: datePreference
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var invokeInfoModal = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            trackHowItWorks();
            __WEBPACK_IMPORTED_MODULE_4__helpers_portal_comms__["a" /* default */].requestInfoModal(girlIds.current);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function invokeInfoModal() {
      return _ref2.apply(this, arguments);
    };
  }();
  var showHowThisWorks = function showHowThisWorks() {
    var locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__helpers_locale__["a" /* getLocale */])();
    if (locale && locale.toLowerCase() === 'es-mx') {
      return null;
    }
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Button"], {
      alignIcon: "LEFT",
      className: __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.howThisWorks,
      onClick: invokeInfoModal,
      icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["I" /* Info */],
      text: i18n._(
      /*i18n*/
      {
        id: "courseAssign.button.hdtw",
        defaults: "How does this work?"
      }),
      primary: true,
      type: __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Button"].LOZENGE
    });
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.filterBar
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.actions,
    "data-testid": "show-filter-button"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setShowFilter(false);
    },
    forButton: "showFilter"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Button"], {
    className: "".concat(__WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.showFilter, " ").concat(__WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.keyActive, " ").concat(showFilter && __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.actionsActive),
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["P" /* FilterOutlineIcon */],
    onClick: function onClick() {
      return setShowFilter(!showFilter);
    },
    primary: true,
    text: i18n._(
    /*i18n*/
    {
      id: "courseAssign.button.topicSelector",
      defaults: "Topic Selector"
    }),
    type: __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Button"].LOZENGE
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    id: "showFilter"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__show_filter__["a" /* default */], {
    isOpen: showFilter,
    i18n: i18n,
    onApply: function onApply() {
      return hideFilter();
    }
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.buttonsContainer
  }, girlIds.current.length === 0 ? null : showHowThisWorks(), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.bottomButtons
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    id: "legendButton",
    onClick: function onClick() {},
    role: "button",
    tabIndex: "0",
    className: __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.viewKeyContainer
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Button"], {
    alignIcon: "LEFT",
    className: __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.key,
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["Q" /* Visible */],
    onClick: function onClick() {
      trackViewKey();
      setLegendVisible(!isLegendVisible);
    },
    primary: true,
    text: i18n._(
    /*i18n*/
    {
      id: "courseAssign.button.viewKey",
      defaults: "View Key"
    }),
    type: __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Button"].LOZENGE
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return hideLegend();
    },
    forButton: "legendButton"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__legend__["a" /* default */], {
    i18n: i18n,
    isVisible: isLegendVisible,
    css: __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a,
    onApply: function onApply() {
      return hideLegend();
    }
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setActionsList(false);
    },
    forButton: "actionsButton"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.actions
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Button"], {
    alignIcon: "LEFT",
    className: "".concat(__WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.key, " ").concat(__WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.keyActive, " ").concat(showActionsList && __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.actionsActive),
    icon: __WEBPACK_IMPORTED_MODULE_7__helpers_icon_dictionary__["R" /* MoreIcon */],
    onClick: function onClick() {
      return setActionsList(!showActionsList);
    },
    primary: true,
    text: i18n._(
    /*i18n*/
    {
      id: "courseAssign.button.actions",
      defaults: "Actions"
    }),
    type: __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Button"].LOZENGE
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__actions_list__["a" /* default */], {
    options: actionsListOptions,
    isOpen: showActionsList
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_11__filter_bar_scss___default.a.toggleWrapper
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__student_access_student_access__["a" /* default */], {
    i18n: i18n
  })))));
}
FilterBar.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (FilterBar);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("hKoQ")))

/***/ }),

/***/ "k21X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NoDataView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HeaderText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HeaderContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DataValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HeaderCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BodyCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ResultContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var DataRow = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('flex-start'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n\n    border-bottom: 1px solid ").concat(colours.grey[300], ";\n  ");
});
var NoDataView = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function () {
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n\n    text-align: center;\n    padding: 20px 10px;\n  ");
});
var HeaderText = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-left: 5px;\n"])));
var HeaderContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  width: 95%;\n  font-weight: 900;\n  text-rendering: geometricPrecision;\n  svg {\n    width: 12px;\n  }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var DataValue = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 10px;\n  display: block;\n\n  width: 50%;\n  padding: 2px 0 2px 5px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var HeaderCell = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: bold;\n  padding: 2px 0;\n"])));
var BodyCell = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 10px;\n"])));
var ResultContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  max-height: 200px;\n  width: 200px;\n  font-size: 12px;\n"])));

/***/ }),

/***/ "k2Tf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__student_result_cell_student_result_cell__ = __webpack_require__("ML6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__student_result_table_student_result_table__ = __webpack_require__("ZmVe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_modal_manager_modal_manager_actions__ = __webpack_require__("WnpN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__doughnut_chart_doughnut_chart__ = __webpack_require__("73uf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__student_result_styled__ = __webpack_require__("eH9W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_icon_dictionary__ = __webpack_require__("vIo2");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }













var StudentResult = function StudentResult(props) {
  var i18n = props.i18n,
    chartData = props.chartData,
    studentReport = props.studentReport;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var lastResultDate = studentReport.lastResultDate,
    timeSpentOnActivities = studentReport.recentActivitiesTotalDuration;
  var fullName = "".concat(studentReport.studentFirstName, " ").concat(studentReport.studentLastName);

  /* eslint-disable indent */
  var lastResultDateText = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_utils__["c" /* isDefined */])(lastResultDate) ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(studentReport.lastResultDate).format('hh:mmA  - DD MMM YYYY') : i18n._(
  /*i18n*/
  {
    id: "studentresultmodal.noCompletedActivities",
    defaults: "No completed activities"
  });
  /* eslint-enable indent */

  var timeSpentOnActivitiesText;
  if (timeSpentOnActivities) {
    var formatted = __WEBPACK_IMPORTED_MODULE_4_moment___default()().startOf('day').seconds(timeSpentOnActivities).format('H:mm:ss');
    var _formatted$split = formatted.split(':'),
      _formatted$split2 = _slicedToArray(_formatted$split, 3),
      hrs = _formatted$split2[0],
      mins = _formatted$split2[1],
      secs = _formatted$split2[2];
    if (hrs !== '0') {
      timeSpentOnActivitiesText = "".concat(hrs, "h ").concat(mins, "m");
    } else if (mins !== '00') {
      timeSpentOnActivitiesText = "".concat(mins, "m ").concat(secs, "s");
    } else {
      timeSpentOnActivitiesText = "".concat(secs, "s");
    }
  } else {
    timeSpentOnActivitiesText = i18n._(
    /*i18n*/
    {
      id: "studentresultmodal.noTimeRecorded",
      defaults: "No time recorded"
    });
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_result_styled__["a" /* ResultContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_result_styled__["b" /* ResultsWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_result_styled__["c" /* ChartWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__doughnut_chart_doughnut_chart__["a" /* default */], {
    i18n: i18n,
    displayChartData: {
      resultType: __WEBPACK_IMPORTED_MODULE_9__helpers_utils__["k" /* STUDENT */],
      studentName: fullName,
      truncatedName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_utils__["j" /* getTruncatedName */])(fullName),
      studentPercent: studentReport.averageLastAttemptScore || 0,
      completedActivitiesCount: studentReport.completedCourseActivitiesCount || 0,
      totalActivitiesCount: studentReport.totalCourseActivitiesCount || 0,
      groupPercent: chartData.groupAverageScore || 0,
      groupActivitiesCount: chartData.groupCompletedActivitiesCount || 0,
      classroomPercent: chartData.classroomAverageScore || 0,
      classActivitiesCount: chartData.classroomCompletedActivitiesCount || 0
    }
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_result_styled__["d" /* AttemptsWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_result_styled__["e" /* DisplayResultsContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__student_result_cell_student_result_cell__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_12__helpers_icon_dictionary__["F" /* Time */],
    title: i18n._(
    /*i18n*/
    {
      id: "studentresultmodal.timeOnActivities",
      defaults: "Time On Activities"
    }),
    value: timeSpentOnActivitiesText
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__student_result_cell_student_result_cell__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_12__helpers_icon_dictionary__["G" /* LastActivity */],
    title: i18n._(
    /*i18n*/
    {
      id: "studentresultmodal.lastCompletedActivity",
      defaults: "Last Completed Activity"
    }),
    value: lastResultDateText
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_result_styled__["f" /* DisplayHighlightsContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_result_styled__["g" /* DisplayHighlights */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_result_styled__["h" /* IconWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_12__helpers_icon_dictionary__["H" /* Highlights */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null, i18n._(
  /*i18n*/
  {
    id: "studentresultmodal.highlights",
    defaults: "Highlights"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_result_styled__["e" /* DisplayResultsContainer */], {
    "data-testid": "highlights"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_result_styled__["i" /* HighlightContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__student_result_table_student_result_table__["a" /* default */], {
    i18n: i18n,
    data: studentReport,
    quality: "Weakness",
    icon: __WEBPACK_IMPORTED_MODULE_12__helpers_icon_dictionary__["I" /* Info */]
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_result_styled__["i" /* HighlightContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__student_result_table_student_result_table__["a" /* default */], {
    i18n: i18n,
    data: studentReport,
    quality: "Strength",
    icon: __WEBPACK_IMPORTED_MODULE_12__helpers_icon_dictionary__["I" /* Info */]
  })))))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_result_styled__["j" /* Footer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"], {
    className: "okButton",
    "data-testid": "ok-button",
    primary: true,
    type: __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"].LOZENGE,
    text: i18n._(
    /*i18n*/
    {
      id: "studentresultmodal.okbutton",
      defaults: "OK"
    }),
    onClick: function onClick() {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_7__containers_modal_manager_modal_manager_actions__["b" /* DISMISS_MODAL */]
      });
    }
  })));
};
StudentResult.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  chartData: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  studentReport: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (StudentResult);

/***/ }),

/***/ "k7gd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getQueryParams;
/* harmony export (immutable) */ __webpack_exports__["a"] = getAnalyticsBuildConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__("OAwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);

function getEnv() {
  // eslint-disable-next-line no-underscore-dangle
  return typeof window !== 'undefined' && window._env_ || {};
}
function getQueryParams() {
  if (typeof window === 'undefined') {
    return {};
  }
  return __WEBPACK_IMPORTED_MODULE_0_query_string__["parse"](window.location.search);
}
function isTrue(value) {
  return value === true || value === 'true';
}

// 3E schools are identified by the isOneRosterActivatedSchool flag, matching
// combined-assign-review. Change this if 3E uses a different signal.
function is3ESchool() {
  return getQueryParams().isOneRosterActivatedSchool === 'true';
}
function getAnalyticsBuildConfig() {
  var env = getEnv();
  return {
    environment: env.env || 'production',
    posthogEnabled: isTrue(env.POSTHOG_ENABLED),
    trackingGroups: undefined,
    teacherTotterEnabled: isTrue(env.TEACHER_TOTTER_ENABLED) && is3ESchool(),
    teacherTotterSyncUrl: env.TEACHER_TOTTER_SYNC_URL,
    identityGatewayUrl: env.IDENTITY_GATEWAY_URL,
    getAppAuthToken: function getAppAuthToken() {
      return getQueryParams().userToken || null;
    }
  };
}

/***/ }),

/***/ "kUIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__context_modal__ = __webpack_require__("Fvqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("dBs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__ = __webpack_require__("S0Yi");






var StudentAccessMenu = function StudentAccessMenu(_ref) {
  var showMenu = _ref.showMenu,
    positionX = _ref.positionX,
    positionY = _ref.positionY,
    isRestricted = _ref.isRestricted,
    i18n = _ref.i18n,
    handleChange = _ref.handleChange,
    setContextMenu = _ref.setContextMenu;
  var changeRestriction = function changeRestriction(setRestriction) {
    setContextMenu(false);
    handleChange(setRestriction);
  };
  var openHeader = i18n._(
  /*i18n*/
  {
    id: "studentAccessMenu.openAccess",
    defaults: "Student Open Access"
  });
  var closedHeader = i18n._(
  /*i18n*/
  {
    id: "studentAccess.studentsOnTask",
    defaults: "Students On Task"
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__context_modal__["b" /* default */], {
    show: showMenu,
    flowUp: true,
    modalBottom: true,
    positionX: positionX,
    positionY: positionY
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["e" /* RestrictedWrapper */], {
    "data-testid": "unrestricted-wrapper",
    onClick: function onClick() {
      return changeRestriction(false);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["f" /* DescriptionWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["g" /* Heading */], {
    "data-testid": "unrestricted-header"
  }, openHeader), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["h" /* Description */], {
    "data-testid": "unrestricted-description"
  }, i18n._(
  /*i18n*/
  {
    id: "studentAccess.accessToMathleticsFirst",
    defaults: "Students have "
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["i" /* DescriptionStrong */], null, i18n._(
  /*i18n*/
  {
    id: "studentAccess.independent",
    defaults: "independent"
  })), i18n._(
  /*i18n*/
  {
    id: "studentAccess.accessToMathleticsLast",
    defaults: " access to all areas of Mathletics."
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["j" /* IconContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["k" /* IconUnrestricted */], {
    "data-testid": "button-update-restriction",
    isRestricted: isRestricted
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["T" /* UnlockIcon */]
  })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["e" /* RestrictedWrapper */], {
    "data-testid": "restricted-wrapper",
    onClick: function onClick() {
      return changeRestriction(true);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["f" /* DescriptionWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["g" /* Heading */], {
    "data-testid": "restricted-header"
  }, closedHeader), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["h" /* Description */], {
    "data-testid": "restricted-description"
  }, i18n._(
  /*i18n*/
  {
    id: "studentAccess.restrictedBody",
    defaults: "Students are restricted to assigned activities showing in their To Do list. Students can still access Meritopia"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["j" /* IconContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["k" /* IconUnrestricted */], {
    isRestricted: isRestricted
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_4__helpers_icon_dictionary__["S" /* LockIcon */]
  }))))));
};
StudentAccessMenu.propTypes = {
  showMenu: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  isRestricted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  positionX: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  positionY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  handleChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  setContextMenu: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (StudentAccessMenu);

/***/ }),

/***/ "kVqA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MERGE_CELL_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MERGE_CELL_START; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return MERGE_CELL_END; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CELL_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COLUMN_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COLUMN_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CELL_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CELL_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CELL_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CELL_4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ROW_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROW_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROW_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ROW_4; });
var MERGE_CELL_ROW = 3;
var MERGE_CELL_START = 5;
var MERGE_CELL_END = 0;
var CELL_COUNTER = 4;
var COLUMN_1 = 1;
var COLUMN_2 = 2;
var CELL_1 = 1;
var CELL_2 = 2;
var CELL_3 = 3;
var CELL_4 = 4;
var ROW_1 = 1;
var ROW_2 = 2;
var ROW_3 = 3;
var ROW_4 = 4;

/***/ }),

/***/ "krZk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Name; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Help; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextMenuAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column-reverse'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    background-color: #eaf9f9;\n    border-right: 1px solid ").concat(colours.grey[400], ";\n    height: 100%;\n    min-width: 53px;\n    max-width: 53px;\n    position: relative;\n    cursor: pointer;\n    overflow: hidden;\n");
});
var Name = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var palette = props.theme.palette;
  return "\n    -webkit-transform: rotate(-90deg);\n    -moz-transform: rotate(-90deg);\n    -ms-transform: rotate(-90deg);\n    -o-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n    transform-origin: (0,0);\n\n    box-sizing: border-box;\n    padding-left: 7px;\n    padding-right: 5px;\n    height: 52px;\n    width: 128px;\n    margin: 38px 0;\n    font-size: 12px;\n    color: ".concat(palette.primary.dark, ";\n");
});
var Icon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  height: 20px;\n  cursor: pointer;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var Help = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  cursor: pointer;\n  width: 100%;\n  height: 20px;\n  text-align: center;\n\n  [class^='svgIconComponent'] {\n    width: 23px;\n  }\n\n  .iconWrapper {\n    ", ";\n    ", ";\n\n    width: 100%;\n  }\n\n  .number {\n    position: relative;\n    color: red;\n    font-weight: 600;\n    text-align: center;\n    left: -26px;\n    top: -2px;\n  }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'));
var ContextMenuAction = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _props$theme = props.theme,
    colours = _props$theme.colours,
    palette = _props$theme.palette;
  var blacklistStyle = props.blackListed ? "background-color: white !important;\n      opacity: 0.2;" : " \n    cursor: pointer;\n    &:hover {\n      background-color: ".concat(colours.grey[200], " !important;\n      color: ").concat(palette.secondary.dark, ";\n  ");
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n  \n  width: 100%;\n  height: 30px;\n  padding-left: 10px;\n  color: ").concat(palette.primary.dark, ";\n  border-bottom:  ").concat(!props.last ? "1px solid ".concat(colours.grey[400], ";") : 'none', ";\n  border-top: ").concat(props.first ? "1px solid ".concat(colours.grey[400], ";") : 'none', ";\n\n  span[class*=\"isvg\"] {\n    margin-right: 10px;\n  }\n  ").concat(blacklistStyle, "\n");
});


/***/ }),

/***/ "lM+Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FilterListWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FilterWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var FilterListWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    min-height: 190px;\n    height: 190px;\n    padding: 0 4px;\n    border-right: none;\n    font-size: 14px;\n    width: 250px;\n    background-color: white;\n    border: 1px solid ".concat(colours.grey[400], ";\n\n    @media screen and (max-width: 1100px) {\n      min-height: 180px;\n      height: 180px;\n    }\n");
});
var FilterWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 10px;\n\n  @media screen and (max-width: 1100px) {\n    padding: 5px 10px;\n  }\n"])));
var InputWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].input(function (props) {
  var _props$theme = props.theme,
    typography = _props$theme.typography,
    palette = _props$theme.palette;
  return " \n        height: 30px;\n        font-family: ".concat(typography.family, ";\n        font-size: 14px;\n        padding-left: 4px;\n        width: 97%;\n        border-radius: 5px;\n        outline: none;\n        border: 1px solid #cfd2d4;\n        color: ").concat(palette.primary.dark, ";\n    ");
});


/***/ }),

/***/ "lPt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return viewStudentResultModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pulse_loader__ = __webpack_require__("oWNv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__student_result_student_result__ = __webpack_require__("k2Tf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__student_assigned_assigned_list_assigned_list__ = __webpack_require__("9nCL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__student_modal_styled__ = __webpack_require__("2Dmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }












var TABS = {
  RESULTS: 'RESULTS',
  ASSIGNED: 'ASSIGNED'
};
var StudentResultModal = function StudentResultModal(_ref) {
  var i18n = _ref.i18n,
    currentActiveTab = _ref.currentActiveTab;
  var wraperRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({}),
    _useState2 = _slicedToArray(_useState, 2),
    chartData = _useState2[0],
    setChartData = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(currentActiveTab),
    _useState4 = _slicedToArray(_useState3, 2),
    activeTab = _useState4[0],
    setActiveTab = _useState4[1];
  var isLoadingResults = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.isLoadingResults;
  });
  var studentReport = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.studentResult;
  });
  var classroomId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var groupId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var classroomList = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.classrooms;
  });
  var classId = classroomList.filter(function (item) {
    return item.classroomId === classroomId;
  });
  var groupName = classId[0].groups.filter(function (item) {
    return item.groupId === groupId;
  });
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    __WEBPACK_IMPORTED_MODULE_4__helpers_resources__["a" /* default */].getChartResult.get({
      classroomId: classroomId,
      groupId: groupId
    }).send().then(function (response) {
      setChartData(response.data);
    }, function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_7__containers_course_assign_course_assign_types__["e" /* ERROR_DETECTED */],
        payload: err
      });
    });
  }, [classroomId, groupId, dispatch]);
  var fullName = "".concat(studentReport.studentFirstName, " ").concat(studentReport.studentLastName);
  if (isLoadingResults) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_modal_styled__["a" /* ModalBody */], {
      ref: wraperRef
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_modal_styled__["b" /* LoaderWrapper */], {
      "data-testid": "Loader"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__pulse_loader__["a" /* default */], null)));
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_modal_styled__["a" /* ModalBody */], {
    ref: wraperRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_modal_styled__["c" /* StudentDetails */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_modal_styled__["d" /* StudentName */], {
    title: fullName,
    "data-testid": "resultmodal-student-name"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_utils__["j" /* getTruncatedName */])(fullName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_modal_styled__["e" /* CourseDetails */], {
    "data-testid": "resultmodal-groupname"
  }, "Group name - ", groupName[0].name), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_modal_styled__["e" /* CourseDetails */], {
    "data-testid": "resultmodal-coursename"
  }, "Course name - ", groupName[0].courseName)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_modal_styled__["f" /* TabContainer */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_modal_styled__["g" /* TabHeading */], {
    "data-testid": "resultmodal-display-results",
    selected: activeTab === TABS.RESULTS,
    onClick: function onClick() {
      setActiveTab(TABS.RESULTS);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_8__helpers_icon_dictionary__["m" /* Results */]
  }), i18n._(
  /*i18n*/
  {
    id: "studentModal.Results",
    defaults: "Results"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_modal_styled__["g" /* TabHeading */], {
    "data-testid": "resultmodal-display-assigned",
    selected: activeTab === TABS.ASSIGNED,
    onClick: function onClick() {
      setActiveTab(TABS.ASSIGNED);
    }
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_8__helpers_icon_dictionary__["E" /* StudentIcon */]
  }), i18n._(
  /*i18n*/
  {
    id: "studentModal.Assigned",
    defaults: "Assigned"
  }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__student_modal_styled__["h" /* TabbedPanel */], null, activeTab === TABS.RESULTS && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__student_result_student_result__["a" /* default */], {
    "data-testid": "student-result",
    i18n: i18n,
    studentReport: studentReport,
    chartData: chartData
  }), activeTab === TABS.ASSIGNED && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__student_assigned_assigned_list_assigned_list__["a" /* default */], {
    i18n: i18n,
    assignmentList: studentReport.assignments,
    studentName: fullName
  })));
};
var viewStudentResultModal = function viewStudentResultModal(i18n, activeTab) {
  return {
    content: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StudentResultModal, {
      i18n: i18n,
      currentActiveTab: activeTab
    }),
    id: 0,
    buttons: []
  };
};
StudentResultModal.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  currentActiveTab: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired
};
/* unused harmony default export */ var _unused_webpack_default_export = (StudentResultModal);

/***/ }),

/***/ "lS1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PortalCommunication; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service__ = __webpack_require__("UTT2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var PortalCommunication = /*#__PURE__*/function () {
  function PortalCommunication() {
    _classCallCheck(this, PortalCommunication);
  }
  return _createClass(PortalCommunication, null, [{
    key: "loadingSpinnerOff",
    value: function loadingSpinnerOff() {
      __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default.a.requestLoadingSpinner(false);
    }

    // invoke this method to let the 3p-portal know
    // that we want to navigate to current module landing screen
  }, {
    key: "navigateToLandingScreen",
    value: function navigateToLandingScreen() {
      var moduleName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default.a.requestNavigateToLanding(moduleName);
    }
  }, {
    key: "serverError",
    value: function serverError(error) {
      __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default.a.requestServerError(error);
    }
  }, {
    key: "requestModuleChange",
    value: function requestModuleChange(moduleId, sourceModuleId) {
      __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default.a.requestModuleChange(moduleId, sourceModuleId);
    }
  }, {
    key: "requestLoadingSpinner",
    value: function requestLoadingSpinner(bool) {
      __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default.a.requestLoadingSpinner(bool);
    }
  }, {
    key: "requestInfoModal",
    value: function requestInfoModal(girlIds) {
      __WEBPACK_IMPORTED_MODULE_0__3plearning_mathletics_portal_communication_service___default.a.requestDucsModal(girlIds);
    }
  }]);
}();


/***/ }),

/***/ "llTh":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("WE0W");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./assignments-action-bar.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./assignments-action-bar.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "luI0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__result_cell_styled__ = __webpack_require__("y90/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__ = __webpack_require__("S0Yi");




var ResultCell = function ResultCell(_ref) {
  var title = _ref.title,
    value = _ref.value,
    container = _ref.container,
    children = _ref.children,
    icon = _ref.icon;
  if (container) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__result_cell_styled__["a" /* ResultContainerWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__result_cell_styled__["b" /* Title */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__result_cell_styled__["c" /* IconWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__["a" /* default */], {
      icon: icon
    })), title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__result_cell_styled__["d" /* ContainerContent */], null, children));
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__result_cell_styled__["e" /* ResultCellWrapper */], {
    "data-testid": "result-cell"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__result_cell_styled__["b" /* Title */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__result_cell_styled__["c" /* IconWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__svg_icon_svg_icon__["a" /* default */], {
    icon: icon
  })), title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__result_cell_styled__["f" /* Content */], null, value));
};
ResultCell.propTypes = {
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired]),
  container: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
ResultCell.defaultProps = {
  container: false,
  icon: ''
};
/* harmony default export */ __webpack_exports__["a"] = (ResultCell);

/***/ }),

/***/ "lykz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTracking;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mx_analytics_provider__ = __webpack_require__("/+0M");


function useTracking() {
  var client = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__mx_analytics_provider__["b" /* useAnalyticsClient */])();
  var track = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (name, props) {
    if (!client) return;
    client.track(name, props);
  }, [client]);
  var trackAssignmentFlowStarted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (props) {
    track('assignment.flow-started', {
      type: props.type,
      target: props.target,
      activity_count: props.activityCount,
      student_count: props.studentCount
    });
  }, [track]);
  var trackAssignmentConfirmed = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (props) {
    track('assignment.confirmation', {
      type: props.type,
      target: props.target,
      activity_count: props.activityCount,
      student_count: props.studentCount,
      duration_ms: props.durationMs
    });
  }, [track]);
  var trackSwitchToOldAssign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (props) {
    track('switch.to-old-assign', {
      context: props && props.context || null
    });
  }, [track]);
  var trackClassChanged = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    track('filter.class-changed', {});
  }, [track]);
  var trackGroupChanged = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    track('filter.group-changed', {});
  }, [track]);
  var trackTopicApplied = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (props) {
    track('filter.topic-applied', {
      topic_count: props.topicCount
    });
  }, [track]);
  var trackHowItWorks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    track('ui.how-it-works', {});
  }, [track]);
  var trackViewKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function () {
    track('ui.view-key', {});
  }, [track]);
  var trackMenuAction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (props) {
    track('menu.action', {
      action: props.action
    });
  }, [track]);
  var trackAccessChanged = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (props) {
    track('access.changed', {
      restricted: props.restricted
    });
  }, [track]);
  var trackActivityPreview = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (props) {
    track('activity.preview', {
      activity_id: props.activityId
    });
  }, [track]);
  var trackActivityTeacherNotes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (props) {
    track('activity.teacher-notes', {
      activity_id: props.activityId
    });
  }, [track]);
  var trackStudentMenu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function (props) {
    track('student.menu', {
      action: props.action
    });
  }, [track]);
  return {
    trackAssignmentFlowStarted: trackAssignmentFlowStarted,
    trackAssignmentConfirmed: trackAssignmentConfirmed,
    trackSwitchToOldAssign: trackSwitchToOldAssign,
    trackClassChanged: trackClassChanged,
    trackGroupChanged: trackGroupChanged,
    trackTopicApplied: trackTopicApplied,
    trackHowItWorks: trackHowItWorks,
    trackViewKey: trackViewKey,
    trackMenuAction: trackMenuAction,
    trackAccessChanged: trackAccessChanged,
    trackActivityPreview: trackActivityPreview,
    trackActivityTeacherNotes: trackActivityTeacherNotes,
    trackStudentMenu: trackStudentMenu
  };
}

/***/ }),

/***/ "mr6W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__ = __webpack_require__("S0Yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled__ = __webpack_require__("dBs8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__student_access_menu__ = __webpack_require__("kUIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_actions__ = __webpack_require__("+7+H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__analytics__ = __webpack_require__("uVVs");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }










var StudentAccess = function StudentAccess(_ref) {
  var i18n = _ref.i18n;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var _useTracking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__analytics__["d" /* useTracking */])(),
    trackAccessChanged = _useTracking.trackAccessChanged;
  var studentAccessRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    showContextMenu = _useState2[0],
    setContextMenu = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState4 = _slicedToArray(_useState3, 2),
    positionXCallout = _useState4[0],
    setPositionXCallout = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState6 = _slicedToArray(_useState5, 2),
    positionYCallout = _useState6[0],
    setPositionYCallout = _useState6[1];
  var isRestricted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.assignments.isRestricted;
  });
  var activeClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var activeGroup = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var handleChangeRestriction = function handleChangeRestriction(switchState) {
    if (activeClass && activeGroup !== '-1') {
      trackAccessChanged({
        restricted: switchState
      });
      dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__containers_course_assign_course_assign_actions__["f" /* restrictActivities */])(switchState, activeClass, activeGroup));
    }
  };
  var showContextModal = function showContextModal() {
    var _studentAccessRef$cur = studentAccessRef.current.getBoundingClientRect(),
      bottom = _studentAccessRef$cur.bottom,
      x = _studentAccessRef$cur.x;
    setPositionYCallout(bottom);
    setPositionXCallout(x);
    setContextMenu(!showContextMenu);
  };
  var icon = isRestricted ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["S" /* LockIcon */]
  }) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_3__helpers_icon_dictionary__["T" /* UnlockIcon */]
  });
  var title = isRestricted ? i18n._(
  /*i18n*/
  {
    id: "studentAccess.studentsOnTask",
    defaults: "Students on Task"
  }) : i18n._(
  /*i18n*/
  {
    id: "studentAccess.studentOpenAccess",
    defaults: "Student Open Access"
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setContextMenu(false);
    },
    forButton: "studentAccess"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["a" /* StudentAccessWrapper */], {
    ref: studentAccessRef
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["b" /* AccessSwitchWrapper */], {
    isRestricted: isRestricted,
    "data-testid": "student-access",
    onClick: showContextModal
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["c" /* Title */], {
    "data-testid": "student-access-title"
  }, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__styled__["d" /* IconWrapper */], null, icon)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__student_access_menu__["a" /* default */], {
    isRestricted: isRestricted,
    showMenu: showContextMenu,
    positionX: positionXCallout,
    positionY: positionYCallout,
    i18n: i18n,
    handleChange: handleChangeRestriction,
    setContextMenu: setContextMenu
  })));
};
StudentAccess.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (StudentAccess);

/***/ }),

/***/ "nIya":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Tj2k");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../node_modules/css-loader/index.js?modules=false!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/index.js!./core.scss", function() {
			var newContent = require("!!../node_modules/css-loader/index.js?modules=false!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/index.js!./core.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "nS47":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styled__ = __webpack_require__("aFup");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__ = __webpack_require__("S0Yi");





var EmptyState = function EmptyState(_ref) {
  var i18n = _ref.i18n;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["a" /* Wrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["x" /* QuestionMarkLeft */]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["b" /* Text */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["c" /* Heading */], null, i18n._("Nothing to see?")), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__styled__["d" /* Description */], null, i18n._("Select some topics and standards in the search bar above, and get ready to assign your heart out!"))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
    icon: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["y" /* QuestionMarkRight */]
  }));
};
EmptyState.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (EmptyState);

/***/ }),

/***/ "nWgB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__palette__ = __webpack_require__("RPFx");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


/* harmony default export */ __webpack_exports__["a"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"].typography), {}, {
  title: {
    size: '30px',
    weight: 500
  },
  subtitle: {
    size: '16px',
    weight: 600,
    colour: __WEBPACK_IMPORTED_MODULE_1__palette__["a" /* default */].primary.main
  },
  heading: {
    size: '21px'
  },
  modalTitle: {
    size: '20px'
  },
  body: {
    size: '14px'
  },
  button: {
    size: '11px'
  },
  info: {
    size: '13px',
    weight: 600
  },
  cell: {
    size: '9px'
  }
}));

/***/ }),

/***/ "nqPn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }

var DatePickerWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  font-size: '14px';\n  font-family: 'poppins, Arial, sans-serif';\n"])));
/* harmony default export */ __webpack_exports__["a"] = (DatePickerWrapper);

/***/ }),

/***/ "oWNv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_scss__ = __webpack_require__("1IMA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__index_scss__);


var PulseLoader = function PulseLoader() {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_1__index_scss___default.a.pulseLoader
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", null));
};
/* harmony default export */ __webpack_exports__["a"] = (PulseLoader);

/***/ }),

/***/ "p6XH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Collapse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TopicName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Info; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  box-sizing: border-box;\n  font-size: 12px;\n  position: sticky;\n  top: 2px;\n  background-color: #c3d5e1;\n  width: 54px;\n  min-width: 54px;\n  min-height: 190px;\n  max-height: 190px;\n  @media screen and (max-width: 1100px) {\n    min-height: 180px;\n    max-height: 180px;\n  }\n  z-index: 2;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'));
var Icon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  cursor: pointer;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'));
var Collapse = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  cursor: pointer;\n  height: 40px;\n\n  [class^='svgIconComponent'] {\n    width: 23px !important;\n  }\n\n  &:hover {\n    path {\n      fill: #3b4e5e !important;\n    }\n  }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'));
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(function (props) {
  var colours = props.theme.colours;
  return "\n      ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n      ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n  \n      color: ").concat(colours.grey[800], ";\n      width: 120px;\n      height: 100px;\n      transform: rotate(270deg);\n      margin-top: 10px;\n      cursor: pointer;\n  ");
});
var TopicName = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var palette = props.theme.palette;
  return "\n      text-overflow: ellipsis;\n      overflow: hidden;\n      white-space: nowrap;\n      color: ".concat(palette.primary.dark, ";\n  ");
});
var Info = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  height: 150px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'));


/***/ }),

/***/ "pihV":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("uZu/");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./actions-list.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./actions-list.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "qmda":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CheckboxContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HiddenCheckbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CustomCheckbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconChecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconIntermediate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IconUnchecked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return IconDisabled; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var CheckboxContainer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  margin: 0 auto;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["e" /* inlineFlexbox */])());
var HiddenCheckbox = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].input.attrs({
  type: 'checkbox'
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clippath: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])));
var CustomCheckbox = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var palette = props.theme.palette;
  var primary = palette.primary;
  var currentState = props.currentState;
  return "\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    border-radius: 3px;\n    transition: all 150ms;\n    background: ".concat(currentState === 'checked' ? '#00a5ff' : 'white', ";\n    border: 1px solid ").concat(primary.light, ";\n    cursor: pointer;\n\n    ").concat(HiddenCheckbox, ":focus + & {\n        box-shadow: 0 0 0 3px ").concat(primary.light, ";\n    }\n  ");
});
var IconChecked = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].svg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  fill: none;\n  stroke: white;\n  stroke-width: 3px;\n"])));
var IconIntermediate = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].svg(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background: #00a5ff;\n  fill: white;\n  stroke: white;\n"])));
var IconDisabled = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].svg(function (props) {
  var colours = props.theme.colours;
  return "\n  background: ".concat(colours.grey[200], ";\n  fill: ").concat(colours.grey[200], ";\n  stroke: ").concat(colours.grey[200], ";\n  cursor: default;\n");
});
var IconUnchecked = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].svg(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background: white;\n"])));


/***/ }),

/***/ "r+Ri":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");


var FooterWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function () {
  return "   \n    background: #94b4c9;\n    padding: 0 5px;\n    border-radius: 10px 10px 0 0;\n    \n    .buttonPanel {\n       ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), "\n       ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), "\n       ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), "\n\n       height: 100%;\n       \n       .unassign {\n         padding-right: 20px;\n       }\n\n       .actionsContainer {\n         position: relative;\n         ul {\n           right: -1rem;\n         }\n       }\n\n       .button {\n         height: 30px;\n       }\n    }\n\n    .collapsed {\n      width: auto;\n      padding: 0;\n      font-weight: 700;\n    }\n");
});
/* harmony default export */ __webpack_exports__["a"] = (FooterWrapper);

/***/ }),

/***/ "rHNI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useClassroomDoughnuts; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__doughnut_inner_utils__ = __webpack_require__("6AC3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_utils__ = __webpack_require__("6QRH");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }




var dashArrayCommon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__doughnut_inner_utils__["a" /* circlePeri */])(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["t" /* radiusCommon */]);
var RawDoughnut = function RawDoughnut(_ref) {
  var _ref$xPos = _ref.xPos,
    xPos = _ref$xPos === void 0 ? __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["u" /* xPosCommon */] : _ref$xPos,
    _ref$yPos = _ref.yPos,
    yPos = _ref$yPos === void 0 ? __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["v" /* yPosCommon */] : _ref$yPos,
    _ref$radius = _ref.radius,
    radius = _ref$radius === void 0 ? __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["t" /* radiusCommon */] : _ref$radius,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["w" /* colorCommon */] : _ref$color,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["x" /* widthCommon */] : _ref$width,
    _ref$fill = _ref.fill,
    fill = _ref$fill === void 0 ? __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["y" /* fillCommon */] : _ref$fill,
    _ref$dashArray = _ref.dashArray,
    dashArray = _ref$dashArray === void 0 ? dashArrayCommon : _ref$dashArray,
    _ref$dashOffset = _ref.dashOffset,
    dashOffset = _ref$dashOffset === void 0 ? __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["z" /* dashOffsetCommon */] : _ref$dashOffset,
    _ref$lineCap = _ref.lineCap,
    lineCap = _ref$lineCap === void 0 ? __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["A" /* lineCapCommon */] : _ref$lineCap,
    _ref$onMouseEnter = _ref.onMouseEnter,
    onMouseEnter = _ref$onMouseEnter === void 0 ? function () {} : _ref$onMouseEnter,
    _ref$onMouseLeave = _ref.onMouseLeave,
    onMouseLeave = _ref$onMouseLeave === void 0 ? function () {} : _ref$onMouseLeave,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    pointer = _ref.pointer;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onClick: onClick,
    transform: "rotate(270 ".concat(xPos, " ").concat(yPos, ")"),
    cx: xPos,
    cy: yPos,
    r: radius,
    stroke: color,
    strokeWidth: width,
    fill: fill,
    strokeDasharray: dashArray,
    strokeDashoffset: dashOffset,
    strokeLinecap: lineCap,
    style: {
      cursor: pointer ? 'pointer' : 'default'
    }
  });
};
RawDoughnut.propTypes = {
  xPos: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  yPos: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  color: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  fill: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dashArray: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  dashOffset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  lineCap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  pointer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

// eslint-disable-next-line import/prefer-default-export
var useClassroomDoughnuts = function useClassroomDoughnuts(_ref2) {
  var _ref2$resultType = _ref2.resultType,
    resultType = _ref2$resultType === void 0 ? __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["r" /* CLASSROOM */] : _ref2$resultType,
    classroomPercent = _ref2.classroomPercent,
    groupPercent = _ref2.groupPercent,
    studentPercent = _ref2.studentPercent;
  var gap = resultType === __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["k" /* STUDENT */] ? __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["p" /* doughnutGap */] / 2 : __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["p" /* doughnutGap */];
  var groupRadius = __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["t" /* radiusCommon */] - __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["x" /* widthCommon */] - gap;
  var groupDashArray = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__doughnut_inner_utils__["a" /* circlePeri */])(groupRadius);
  var studentRadius = groupRadius - __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["x" /* widthCommon */] - gap;
  var studentDashArray = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__doughnut_inner_utils__["a" /* circlePeri */])(studentRadius);
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
      doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["r" /* CLASSROOM */],
      mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["s" /* MOUSE_STATE_LEAVE */]
    }),
    _useState2 = _slicedToArray(_useState, 2),
    doughnutData = _useState2[0],
    setDoughnutData = _useState2[1];
  var ClassDoughnuts = function ClassDoughnuts() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RawDoughnut, {
      onMouseEnter: function onMouseEnter() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["r" /* CLASSROOM */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["B" /* MOUSE_STATE_ENTER */]
        });
      },
      onMouseLeave: function onMouseLeave() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["r" /* CLASSROOM */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["s" /* MOUSE_STATE_LEAVE */]
        });
      },
      onClick: function onClick() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["r" /* CLASSROOM */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["C" /* MOUSE_STATE_CLICK */]
        });
      },
      pointer: true
    }), classroomPercent > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RawDoughnut, {
      color: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["l" /* classColor */],
      dashOffset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__doughnut_inner_utils__["b" /* percentPeri */])(__WEBPACK_IMPORTED_MODULE_3__helpers_utils__["t" /* radiusCommon */], classroomPercent),
      onMouseEnter: function onMouseEnter() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["r" /* CLASSROOM */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["B" /* MOUSE_STATE_ENTER */]
        });
      },
      onMouseLeave: function onMouseLeave() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["r" /* CLASSROOM */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["s" /* MOUSE_STATE_LEAVE */]
        });
      },
      onClick: function onClick() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["r" /* CLASSROOM */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["C" /* MOUSE_STATE_CLICK */]
        });
      },
      pointer: true
    }));
  };
  var GroupDoughnuts = function GroupDoughnuts() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RawDoughnut, {
      radius: groupRadius,
      dashArray: groupDashArray,
      onMouseEnter: function onMouseEnter() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["q" /* GROUP */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["B" /* MOUSE_STATE_ENTER */]
        });
      },
      onMouseLeave: function onMouseLeave() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["q" /* GROUP */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["s" /* MOUSE_STATE_LEAVE */]
        });
      },
      onClick: function onClick() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["q" /* GROUP */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["C" /* MOUSE_STATE_CLICK */]
        });
      },
      pointer: true
    }), groupPercent > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RawDoughnut, {
      color: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["m" /* groupColor */],
      radius: groupRadius,
      dashArray: groupDashArray,
      dashOffset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__doughnut_inner_utils__["b" /* percentPeri */])(groupRadius, groupPercent),
      onMouseEnter: function onMouseEnter() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["q" /* GROUP */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["B" /* MOUSE_STATE_ENTER */]
        });
      },
      onMouseLeave: function onMouseLeave() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["q" /* GROUP */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["s" /* MOUSE_STATE_LEAVE */]
        });
      },
      onClick: function onClick() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["q" /* GROUP */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["C" /* MOUSE_STATE_CLICK */]
        });
      },
      pointer: true
    }));
  };
  var StudentDoughnuts = function StudentDoughnuts() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RawDoughnut, {
      radius: studentRadius,
      dashArray: studentDashArray,
      onMouseEnter: function onMouseEnter() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["k" /* STUDENT */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["B" /* MOUSE_STATE_ENTER */]
        });
      },
      onMouseLeave: function onMouseLeave() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["k" /* STUDENT */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["s" /* MOUSE_STATE_LEAVE */]
        });
      },
      onClick: function onClick() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["k" /* STUDENT */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["C" /* MOUSE_STATE_CLICK */]
        });
      },
      pointer: true
    }), studentPercent > 0 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RawDoughnut, {
      color: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["n" /* studentColor */],
      radius: studentRadius,
      dashArray: studentDashArray,
      dashOffset: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__doughnut_inner_utils__["b" /* percentPeri */])(studentRadius, studentPercent),
      onMouseEnter: function onMouseEnter() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["k" /* STUDENT */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["B" /* MOUSE_STATE_ENTER */]
        });
      },
      onMouseLeave: function onMouseLeave() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["k" /* STUDENT */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["s" /* MOUSE_STATE_LEAVE */]
        });
      },
      onClick: function onClick() {
        return setDoughnutData({
          doughnutType: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["k" /* STUDENT */],
          mouseState: __WEBPACK_IMPORTED_MODULE_3__helpers_utils__["C" /* MOUSE_STATE_CLICK */]
        });
      },
      pointer: true
    }));
  };
  var AllDoughnuts = function AllDoughnuts() {
    switch (resultType) {
      case 0:
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClassDoughnuts, null);
      case 1:
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClassDoughnuts, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GroupDoughnuts, null));
      case 2:
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClassDoughnuts, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GroupDoughnuts, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StudentDoughnuts, null));
      default:
        return null;
    }
  };
  return [AllDoughnuts, doughnutData];
};

/***/ }),

/***/ "s1kj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildIdentityProps;
function mapUserProfileType(type) {
  switch (type) {
    case '2':
      return 'teacher';
    case '3':
      return 'admin';
    default:
      return 'unknown';
  }
}

// Identity is assembled from the query params the host injects. course-assign
// does not always carry a userProfileId in dev, so we fall back to username as
// the distinct id. In hosted environments the host should pass userProfileId so
// the id lines up with combined-assign-review for cross-app comparison.
function buildIdentityProps(params, locale) {
  return {
    locale: locale,
    countryCode: params.countryCode || '',
    userProfileId: params.userProfileId || params.username || '',
    userProfileType: mapUserProfileType(params.userProfileType || ''),
    marketRegionId: params.marketRegionId || params.regionId || ''
  };
}

/***/ }),

/***/ "s2lQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_use_analytics__ = __webpack_require__("dGCJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_list__ = __webpack_require__("UPZi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_hoc_close_outside_click_handler__ = __webpack_require__("t+mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_resources_helper__ = __webpack_require__("jhKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_actions__ = __webpack_require__("+7+H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__toast_toast_action__ = __webpack_require__("fbOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__analytics__ = __webpack_require__("uVVs");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
















function AssignButton(props) {
  var i18n = props.i18n;
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* useDispatch */])();
  var _useAnalytics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_use_analytics__["b" /* useAnalytics */])(),
    track = _useAnalytics.track;
  var assignFlow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__analytics__["b" /* useAssignmentFlowTracking */])('assign');
  var _useTracking = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__analytics__["d" /* useTracking */])(),
    trackMenuAction = _useTracking.trackMenuAction;
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAssignActionsOpen = _useState2[0],
    setAssignActionsOpen = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isAssigning = _useState4[0],
    setIsAssigning = _useState4[1];
  var assignButtonText = "".concat(i18n._(
  /*i18n*/
  {
    id: "footer.assign",
    defaults: "Assign"
  }), " (").concat(props.assignmentsToAssign.length, ")");
  function displayPreference() {
    return "".concat(props.startDatePreference[0], " - ").concat(props.dueDatePreference !== undefined ? props.dueDatePreference[0] : i18n._(
    /*i18n*/
    {
      id: "footer.assignNoDueDate",
      defaults: "Assign with no due date"
    }));
  }
  function handleSuccess() {
    var classroomId = props.classroomId,
      groupId = props.groupId;
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_actions__["b" /* getTopics */])(classroomId, groupId));
    setAssignActionsOpen(false);
    setIsAssigning(false);
    track('ActivityAssigned');
    assignFlow.confirm(_objectSpread({
      target: 'students'
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__analytics__["c" /* summarizeAssignments */])(props.assignmentsToAssign)));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__toast_toast_action__["c" /* showToast */])(i18n._(
    /*i18n*/
    {
      id: "footer.assignSuccess",
      defaults: "Selected student activities have been assigned"
    }), 'success'));
  }
  function handleAssign() {
    if (isAssigning) {
      return;
    }
    var classroomId = props.classroomId,
      groupId = props.groupId,
      courseId = props.courseId,
      startDatePreference = props.startDatePreference,
      dueDatePreference = props.dueDatePreference,
      assignmentsToAssign = props.assignmentsToAssign;
    trackMenuAction({
      action: 'assign-now'
    });
    assignFlow.start(_objectSpread({
      target: 'students'
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__analytics__["c" /* summarizeAssignments */])(assignmentsToAssign)));
    setIsAssigning(true);
    setAssignActionsOpen(false);
    __WEBPACK_IMPORTED_MODULE_9__helpers_resources__["a" /* default */].assign.post({
      classroomId: classroomId,
      groupId: groupId
    }).withBody(_objectSpread({
      courseId: courseId,
      startDate: startDatePreference && __WEBPACK_IMPORTED_MODULE_4_moment___default()("".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_utils__["d" /* getHyphenDateFormat */])(startDatePreference[0]), " ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_utils__["d" /* getHyphenDateFormat */])(startDatePreference[1]))).toISOString(),
      dueDate: dueDatePreference && __WEBPACK_IMPORTED_MODULE_4_moment___default()("".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_utils__["d" /* getHyphenDateFormat */])(dueDatePreference[0]), " ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__helpers_utils__["d" /* getHyphenDateFormat */])(dueDatePreference[1]))).toISOString(),
      hasDueDate: dueDatePreference !== undefined
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__helpers_resources_helper__["a" /* mapSelectedActivitiesToReq */])(assignmentsToAssign))).send().then(function () {
      return handleSuccess();
    }, function (err) {
      setIsAssigning(false);
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_11__containers_course_assign_course_assign_types__["e" /* ERROR_DETECTED */],
        payload: err
      });
    });
  }
  var assignActionsListOptions = [{
    icon: __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__["a" /* IconAssignLater */],
    disabled: isAssigning,
    text: i18n._(
    /*i18n*/
    {
      id: "footer.assignLater",
      defaults: "Assign Later"
    }),
    subtext: i18n._(
    /*i18n*/
    {
      id: "footer.assignLaterSubtext",
      defaults: "Modify assign dates"
    }),
    onClick: function onClick() {
      trackMenuAction({
        action: 'assign-later'
      });
      dispatch({
        type: 'SHOW_ASSIGN_LATER'
      });
    }
  }, {
    icon: __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__["b" /* AssignIcon */],
    text: i18n._(
    /*i18n*/
    {
      id: "footer.assignNow",
      defaults: "Assign Now"
    }),
    disabled: isAssigning,
    subtext: props.startDatePreference !== undefined ? displayPreference() : i18n._(
    /*i18n*/
    {
      id: "footer.assignNoDueDate",
      defaults: "Assign with no due date"
    }),
    onClick: handleAssign
  }];
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "assign"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__helpers_hoc_close_outside_click_handler__["a" /* default */], {
    callback: function callback() {
      return setAssignActionsOpen(false);
    },
    forButton: "assignActions"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "actionsContainer",
    id: "assignActions",
    "data-testid": "assign-button"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"], {
    className: "button",
    disabled: props.assignmentsToAssign.length === 0,
    primary: true,
    "data-testid": "assign-button",
    text: assignButtonText,
    type: __WEBPACK_IMPORTED_MODULE_3__3plearning_react_components__["Button"].LOZENGE,
    onClick: function onClick() {
      return setAssignActionsOpen(!isAssignActionsOpen);
    },
    alignIcon: "LEFT",
    icon: __WEBPACK_IMPORTED_MODULE_6__helpers_icon_dictionary__["b" /* AssignIcon */]
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__actions_list__["a" /* default */], {
    options: assignActionsListOptions,
    isOpen: isAssignActionsOpen,
    isAssigning: true,
    isWide: true,
    shouldOpenUp: true
  })))));
}
AssignButton.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  classroomId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  courseId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  groupId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  startDatePreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  dueDatePreference: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string),
  assignmentsToAssign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object)
};
/* harmony default export */ __webpack_exports__["a"] = (AssignButton);

/***/ }),

/***/ "s4Vw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("3gQ+");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "sSPr":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("f4QT");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./switch-to-old-assign.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./switch-to-old-assign.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "sVUS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DoughnutsWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClassroomIconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PercentWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AttemptIconWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LegendWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ContextModalContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }



var DoughnutsWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function () {
  return "\n  position: relative;\n  width: 250px;\n\n  .doughnut-svg {\n    position: relative;\n    z-index: 10;\n  }\n";
});
var ClassroomIconWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  return "\n  position: absolute\n  top: ".concat(props.type === __WEBPACK_IMPORTED_MODULE_1__helpers_utils__["k" /* STUDENT */] ? 50 : 42, "px;\n  width: 100%;\n  text-align: center;\n  z-index: 5;\n");
});
var PercentWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  return "\n  position: absolute;\n  top: ".concat(props.type === __WEBPACK_IMPORTED_MODULE_1__helpers_utils__["k" /* STUDENT */] ? 65 : 60, "px;\n  width: 100%;\n  text-align: center;\n  z-index: 6;\n  font-size: ").concat(props.type === __WEBPACK_IMPORTED_MODULE_1__helpers_utils__["k" /* STUDENT */] ? 24 : 34, "px;\n  font-weight: bold;\n  letter-spacing: -1px;\n");
});
var AttemptIconWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  position: absolute\n  top: 94px;\n  width: 100%;\n  z-index: 5;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["c" /* justifyContent */])('center'));
var LegendWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  return "\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  font-size: 12px;\n  ".concat(props.type === __WEBPACK_IMPORTED_MODULE_1__helpers_utils__["k" /* STUDENT */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__styles_helpers_flexbox__["d" /* flexDirection */])('column') : '', "\n\n  .legend-shell {\n    display: flex;\n    align-items: center;\n    flex: 1;\n    user-select: none;\n\n    .color-indi {\n      width: 16px;\n      height: 16px;\n      border-radius: 15px;\n    }\n  \n    .class {\n      background-color: ").concat(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["l" /* classColor */], ";\n    }\n  \n    .group {\n      background-color: ").concat(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["m" /* groupColor */], ";\n    }\n\n    .student {\n      background-color: ").concat(__WEBPACK_IMPORTED_MODULE_1__helpers_utils__["n" /* studentColor */], ";\n    }\n\n    div[class*='svgIconComponent--'] {\n      width: 30px;\n    }\n");
});

var ContextModalContent = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: white;\n  font-size: 12px;\n"])));

/***/ }),

/***/ "sYus":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__ = __webpack_require__("vIo2");



var DoughnutsClassroomIcon = function DoughnutsClassroomIcon(_ref) {
  var type = _ref.type;
  var icons = [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["K" /* ClassIcon */],
    alt: "class icon"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["L" /* GroupIcon */],
    alt: "group icon"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img", {
    src: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["E" /* StudentIcon */],
    alt: "student icon"
  })];
  return icons[type];
};
DoughnutsClassroomIcon.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
/* harmony default export */ __webpack_exports__["a"] = (DoughnutsClassroomIcon);

/***/ }),

/***/ "t+mt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OutsideClickHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);


function OutsideClickHandler(props) {
  var children = props.children,
    callback = props.callback,
    forButton = props.forButton;
  var wrapperRef = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  useOutsideAlerter(wrapperRef, callback, forButton);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    ref: wrapperRef
  }, children);
}
OutsideClickHandler.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  callback: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  forButton: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
function useOutsideAlerter(ref, callback, forButton) {
  function handleClickOutside(event) {
    var target = event.target;
    if (ref.current && !ref.current.contains(target) && !isIgnoredItem(target)) {
      callback();
    }
    function isIgnoredItem(t) {
      var parent = t.parentNode;
      return forButton === t.id || parent && isIgnoredItem(parent);
    }
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  });
}

/***/ }),

/***/ "t3Qr":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".component---3fc4z {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: calc(100% - 23px);\n  height: calc(100% - 100px);\n  border: 1px solid #cfd2d4;\n  position: absolute; }\n\n.psr---Msw5h {\n  width: 100%; }\n\n.standards---1kJg8 {\n  width: 100%; }\n\n.studentGridContainer---2qz9p {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  height: calc(100% - 240px);\n  width: calc(100% - 17px);\n  overflow-y: auto;\n  overflow-x: auto;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  border: 1px solid #cfd2d4;\n  border-top: none; }\n\n.fitContentContainer---3z8uv {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content; }\n\n.footer---1GyGv {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  position: fixed;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 100%;\n  padding-right: 10px;\n  z-index: 9; }\n\n.confirmFooter---28kPQ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  position: absolute;\n  bottom: 0.1px;\n  left: 0.1px;\n  width: 99%;\n  height: 51px;\n  padding-right: 10px;\n  background-color: #cfd2d4;\n  z-index: 9999; }\n\n.leftSection---38_CO {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: vertical;\n  -moz-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 260px; }\n\n.rightSection---9cPFb {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  overflow: scroll;\n  width: 100%; }\n\n.gridContainer---3pvLX {\n  height: auto;\n  min-height: 100%;\n  width: 100%;\n  position: relative;\n  top: 0; }\n\n.actions---Z47AN {\n  position: relative;\n  display: inline-block;\n  margin-right: 5px; }\n\n.viewKeyContainer---iiZMu {\n  position: relative; }\n\n.filterBar---2QpLJ {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  -moz-justify-content: space-between;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  min-width: 364px; }\n\n.filterBar---2QpLJ .search---1SKPF {\n    width: 480px;\n    z-index: 10;\n    position: absolute;\n    top: 45px;\n    background: #fff;\n    height: 150px;\n    border-radius: 6px;\n    border: 1px solid #cfd2d4;\n    padding: 5px 22px;\n    -webkit-transform: translateX(-38%);\n            transform: translateX(-38%);\n    -webkit-box-shadow: 5px 5px 3px 0 #cfd2d4;\n            box-shadow: 5px 5px 3px 0 #cfd2d4;\n    display: -webkit-box;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-direction: normal;\n    -webkit-box-orient: vertical;\n    -moz-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: space-evenly;\n    -ms-flex-pack: space-evenly;\n    -moz-justify-content: space-evenly;\n    justify-content: space-evenly; }\n\n.filterBar---2QpLJ .search---1SKPF::before {\n      width: 0;\n      height: 0;\n      border-left: 6px solid transparent;\n      border-right: 6px solid transparent;\n      border-bottom: 15px solid #fff;\n      position: fixed;\n      top: -10px;\n      left: 50%;\n      content: ' '; }\n\n.filterBar---2QpLJ [class^=\"isvg\"] {\n    height: 16px !important; }\n\n.filterBar---2QpLJ .showFilter---8cQLN {\n    height: 30px;\n    background-color: #c3d5e1;\n    border: 1px solid #c3d5e1;\n    color: #3b4e5e;\n    padding: 5px 25px 5px 8px;\n    font-size: 12px; }\n\n.filterBar---2QpLJ .showFilter---8cQLN::after {\n      border-style: solid;\n      border-width: 0 2px 2px 0;\n      content: '';\n      display: inline-block;\n      height: 6px;\n      position: relative;\n      left: 12px;\n      top: -3px;\n      -webkit-transform: rotate(45deg);\n              transform: rotate(45deg);\n      width: 6px; }\n\n.filterBar---2QpLJ .showFilter---8cQLN:hover, .filterBar---2QpLJ .showFilter---8cQLN.actionsActive---1dlNc {\n      background: #415667;\n      border: 1px solid #415667;\n      color: #fff; }\n\n.filterBar---2QpLJ .showFilter---8cQLN:hover path, .filterBar---2QpLJ .showFilter---8cQLN.actionsActive---1dlNc path {\n        stroke: #fff; }\n\n.filterBar---2QpLJ .showFilter---8cQLN [class^=\"isvg\"] path {\n      fill: none !important; }\n\n@media screen and (max-width: 1100px) {\n    .filterBar---2QpLJ {\n      margin-bottom: 0.001px; } }\n\n.filterBar---2QpLJ .buttonsContainer---2ffks {\n    display: -webkit-box;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: distribute;\n    -moz-justify-content: space-around;\n    justify-content: space-around;\n    -webkit-box-align: end;\n    -ms-flex-align: end;\n    -moz-align-items: flex-end;\n    align-items: flex-end; }\n\n.filterBar---2QpLJ .buttonsContainer---2ffks .howThisWorks---2nrCK {\n      margin-right: 5px;\n      height: 30px;\n      padding: 5px 16px 5px 8px;\n      background-color: #c3d5e1;\n      border: 1px solid #c3d5e1;\n      color: #3b4e5e;\n      font-size: 12px;\n      -ms-flex-item-align: center;\n          align-self: center; }\n\n.filterBar---2QpLJ .buttonsContainer---2ffks .howThisWorks---2nrCK:hover {\n        background: #415667;\n        border: 1px solid #415667;\n        color: #fff;\n        -webkit-filter: none;\n                filter: none; }\n\n.filterBar---2QpLJ .buttonsContainer---2ffks .bottomButtons---2JB4w {\n      display: -webkit-box;\n      display: -moz-flex;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-pack: space-evenly;\n      -ms-flex-pack: space-evenly;\n      -moz-justify-content: space-evenly;\n      justify-content: space-evenly;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      -moz-align-items: center;\n      align-items: center; }\n\n.filterBar---2QpLJ .buttonsContainer---2ffks .bottomButtons---2JB4w .button---I9VrJ {\n        width: 142px;\n        height: 30px; }\n\n.filterBar---2QpLJ .buttonsContainer---2ffks .bottomButtons---2JB4w .key----L5-5 {\n        height: 30px;\n        background-color: #c3d5e1;\n        border: 1px solid #c3d5e1;\n        color: #3b4e5e;\n        margin-right: 8px;\n        padding: 5px 16px 5px 8px;\n        font-size: 12px; }\n\n.filterBar---2QpLJ .buttonsContainer---2ffks .bottomButtons---2JB4w .key----L5-5:hover {\n          background: #415667;\n          border: 1px solid #415667;\n          color: #fff; }\n\n.filterBar---2QpLJ .buttonsContainer---2ffks .bottomButtons---2JB4w .key----L5-5:hover * {\n            fill: #fff; }\n\n.filterBar---2QpLJ .buttonsContainer---2ffks .bottomButtons---2JB4w .actionsActive---1dlNc {\n        background-color: #415667;\n        border: 1px solid #415667;\n        color: #fff; }\n\n.filterBar---2QpLJ .buttonsContainer---2ffks .bottomButtons---2JB4w .actionsActive---1dlNc * {\n          fill: #fff; }\n\n.filterBar---2QpLJ .buttonsContainer---2ffks .bottomButtons---2JB4w .actions---Z47AN {\n        border-color: #415667; }\n\n@media screen and (max-width: 1370px) {\n  .filterBar---2QpLJ .search---1SKPF {\n    -webkit-transform: translateX(-254px);\n            transform: translateX(-254px); }\n  .key----L5-5 {\n    width: 30px;\n    padding: 0 !important;\n    font-size: 0 !important; }\n    .key----L5-5 + div span {\n      right: -80px !important; }\n    .key----L5-5 [class^=\"isvg\"] {\n      padding: 0 !important; }\n  .howThisWorks---2nrCK {\n    font-size: 0 !important;\n    padding: 5px !important;\n    width: 30px; }\n    .howThisWorks---2nrCK [class^=\"isvg\"] {\n      padding: 0 !important; }\n  .buttonsContainer---2ffks {\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    height: 50px !important; }\n  .showFilter---8cQLN {\n    font-size: 0 !important;\n    width: 30px;\n    padding: 0 !important; }\n    .showFilter---8cQLN::after {\n      display: none !important; }\n    .showFilter---8cQLN [class^=\"isvg\"] {\n      padding: 0 !important; } }\n\n.toggleWrapper---1-RpN {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-direction: normal;\n  -webkit-box-orient: horizontal;\n  -moz-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  margin-right: 10px;\n  height: 50px; }\n", ""]);

// exports
exports.locals = {
	"component": "component---3fc4z",
	"psr": "psr---Msw5h",
	"standards": "standards---1kJg8",
	"studentGridContainer": "studentGridContainer---2qz9p",
	"fitContentContainer": "fitContentContainer---3z8uv",
	"footer": "footer---1GyGv",
	"confirmFooter": "confirmFooter---28kPQ",
	"leftSection": "leftSection---38_CO",
	"rightSection": "rightSection---9cPFb",
	"gridContainer": "gridContainer---3pvLX",
	"actions": "actions---Z47AN",
	"viewKeyContainer": "viewKeyContainer---iiZMu",
	"filterBar": "filterBar---2QpLJ",
	"search": "search---1SKPF",
	"showFilter": "showFilter---8cQLN",
	"actionsActive": "actionsActive---1dlNc",
	"buttonsContainer": "buttonsContainer---2ffks",
	"howThisWorks": "howThisWorks---2nrCK",
	"bottomButtons": "bottomButtons---2JB4w",
	"button": "button---I9VrJ",
	"key": "key----L5-5",
	"toggleWrapper": "toggleWrapper---1-RpN"
};

/***/ }),

/***/ "uVVs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mx_analytics_provider__ = __webpack_require__("/+0M");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__mx_analytics_provider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__use_tracking__ = __webpack_require__("lykz");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__use_tracking__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__use_assignment_flow_tracking__ = __webpack_require__("hp56");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__use_assignment_flow_tracking__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assignment_summary__ = __webpack_require__("CVOX");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__assignment_summary__["a"]; });





/***/ }),

/***/ "uZu/":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, ".actionsList---2kC7w {\n  position: absolute;\n  background: #415667 !important;\n  color: #fff !important;\n  border-radius: 0.6em;\n  z-index: 99;\n  right: 5px;\n  margin-top: 5px;\n  width: 152px;\n  width: 9.5rem;\n  overflow: hidden; }\n  .actionsList__text--small---VM82b {\n    font-size: 12px; }\n  .actionsList--wide---Dng4B {\n    width: 192px;\n    width: 12rem; }\n  .actionsList--wide---Dng4B .actionsListText---HtYhY {\n      margin-left: 'auto';\n      margin-right: 'auto'; }\n  .actionsList--flow-up---2AEvP {\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: 5px; }\n  .actionsList---2kC7w * {\n    fill: #fff !important; }\n  .actionsList---2kC7w li {\n    display: -webkit-box;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-direction: normal;\n    -webkit-box-orient: horizontal;\n    -moz-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -moz-align-items: center;\n    align-items: center;\n    min-height: 28px;\n    cursor: pointer;\n    padding: 8px;\n    border-bottom: 1px solid #999b9d; }\n  .actionsList---2kC7w li svg {\n      width: 22px !important;\n      height: 22px !important; }\n  .actionsList---2kC7w li div[class*=\"svgIconComponent---\"] {\n      width: 22px !important;\n      height: 22px !important; }\n  .actionsList---2kC7w li:last-child {\n      border: none; }\n  .actionsList---2kC7w li:hover {\n      background-color: #c3d5e1 !important;\n      color: #415667 !important; }\n  .actionsList---2kC7w li:hover * {\n        fill: #415667 !important; }\n  .actionsList---2kC7w .actionsListText---HtYhY {\n    margin-left: 14px;\n    font-size: 14px; }\n  .actionsList---2kC7w .actionsList--disabled---34Dsn {\n    pointer-events: none;\n    opacity: 0.6; }\n", ""]);

// exports
exports.locals = {
	"actionsList": "actionsList---2kC7w",
	"actionsList__text--small": "actionsList__text--small---VM82b",
	"actionsList--wide": "actionsList--wide---Dng4B",
	"actionsListText": "actionsListText---HtYhY",
	"actionsList--flow-up": "actionsList--flow-up---2AEvP",
	"actionsList--disabled": "actionsList--disabled---34Dsn"
};

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v6Wj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

/* harmony default export */ __webpack_exports__["a"] = (_objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__3plearning_react_components__["defaultTheme"].colours), {}, {
  grey: {
    100: '#e7e9ea',
    200: '#e1e1e1',
    300: '#d6d6d6',
    400: '#cfd2d4',
    500: '#999b9d',
    600: '#808080',
    700: '#777',
    800: '#595959',
    900: '#484848'
  },
  custom: {
    100: '#ffffff',
    200: '#eaf9f9',
    300: '#e6e9ea',
    400: '#c2c2c2',
    500: '#c3d5e1',
    600: '#94b4c9',
    700: '#94b4c9',
    800: '#3b4e5e',
    900: '#000000'
  }
}));

/***/ }),

/***/ "vIo2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_3p_teacheradmin_assets_assets_icons_ico_rocket_svg__ = __webpack_require__("qfDu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__3plearning_3p_teacheradmin_assets_assets_icons_ico_rocket_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__3plearning_3p_teacheradmin_assets_assets_icons_ico_rocket_svg__);
/* unused harmony reexport Rocket */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_3p_teacheradmin_assets_assets_icons_arrow_down_svg__ = __webpack_require__("/4Ah");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_3p_teacheradmin_assets_assets_icons_arrow_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__3plearning_3p_teacheradmin_assets_assets_icons_arrow_down_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_1__3plearning_3p_teacheradmin_assets_assets_icons_arrow_down_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_3p_teacheradmin_assets_assets_icons_arrow_up_svg__ = __webpack_require__("kTqw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__3plearning_3p_teacheradmin_assets_assets_icons_arrow_up_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__3plearning_3p_teacheradmin_assets_assets_icons_arrow_up_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_2__3plearning_3p_teacheradmin_assets_assets_icons_arrow_up_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_svg__ = __webpack_require__("i+Fm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_svg__);
/* unused harmony reexport Question */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_icons_ico_dot_svg__ = __webpack_require__("ODC2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_icons_ico_dot_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__3plearning_3p_teacheradmin_assets_assets_icons_ico_dot_svg__);
/* unused harmony reexport Submitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__3plearning_3p_teacheradmin_assets_assets_icons_ico_tick_svg__ = __webpack_require__("Z1mS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__3plearning_3p_teacheradmin_assets_assets_icons_ico_tick_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__3plearning_3p_teacheradmin_assets_assets_icons_ico_tick_svg__);
/* unused harmony reexport Reviewed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_blank_svg__ = __webpack_require__("g1H5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_blank_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_blank_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_6__3plearning_3p_teacheradmin_assets_assets_icons_ico_question_blank_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__3plearning_3p_teacheradmin_assets_assets_icons_icon_forward_svg__ = __webpack_require__("FP8j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__3plearning_3p_teacheradmin_assets_assets_icons_icon_forward_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__3plearning_3p_teacheradmin_assets_assets_icons_icon_forward_svg__);
/* unused harmony reexport Forward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__3plearning_3p_teacheradmin_assets_assets_icons_icon_back_svg__ = __webpack_require__("0dCu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__3plearning_3p_teacheradmin_assets_assets_icons_icon_back_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__3plearning_3p_teacheradmin_assets_assets_icons_icon_back_svg__);
/* unused harmony reexport Back */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__3plearning_3p_teacheradmin_assets_assets_icons_icon_present_svg__ = __webpack_require__("0UoL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__3plearning_3p_teacheradmin_assets_assets_icons_icon_present_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__3plearning_3p_teacheradmin_assets_assets_icons_icon_present_svg__);
/* unused harmony reexport PreviewIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__3plearning_3p_teacheradmin_assets_assets_icons_icon_teach_notes_svg__ = __webpack_require__("DfRv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__3plearning_3p_teacheradmin_assets_assets_icons_icon_teach_notes_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__3plearning_3p_teacheradmin_assets_assets_icons_icon_teach_notes_svg__);
/* unused harmony reexport NotesIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__3plearning_3p_teacheradmin_assets_assets_icons_icon_dropdown_svg__ = __webpack_require__("z7ov");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__3plearning_3p_teacheradmin_assets_assets_icons_icon_dropdown_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__3plearning_3p_teacheradmin_assets_assets_icons_icon_dropdown_svg__);
/* unused harmony reexport DropdownIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__3plearning_3p_teacheradmin_assets_assets_icons_icon_search_svg__ = __webpack_require__("koc0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__3plearning_3p_teacheradmin_assets_assets_icons_icon_search_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__3plearning_3p_teacheradmin_assets_assets_icons_icon_search_svg__);
/* unused harmony reexport SearchIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_svg__ = __webpack_require__("vMm+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_13__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_outline_svg__ = __webpack_require__("wSIX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_outline_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_outline_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_14__3plearning_3p_teacheradmin_assets_assets_icons_icon_filter_outline_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__3plearning_3p_teacheradmin_assets_assets_icons_icon_more_svg__ = __webpack_require__("uzN6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__3plearning_3p_teacheradmin_assets_assets_icons_icon_more_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__3plearning_3p_teacheradmin_assets_assets_icons_icon_more_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_15__3plearning_3p_teacheradmin_assets_assets_icons_icon_more_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__3plearning_3p_teacheradmin_assets_assets_icons_ico_excel_svg__ = __webpack_require__("NtnF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__3plearning_3p_teacheradmin_assets_assets_icons_ico_excel_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__3plearning_3p_teacheradmin_assets_assets_icons_ico_excel_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_16__3plearning_3p_teacheradmin_assets_assets_icons_ico_excel_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__3plearning_3p_teacheradmin_assets_assets_icons_ico_collapse_svg__ = __webpack_require__("Fnus");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__3plearning_3p_teacheradmin_assets_assets_icons_ico_collapse_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__3plearning_3p_teacheradmin_assets_assets_icons_ico_collapse_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_17__3plearning_3p_teacheradmin_assets_assets_icons_ico_collapse_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_visible_svg__ = __webpack_require__("+wqE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_visible_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_visible_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_18__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_visible_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_svg__ = __webpack_require__("W5D1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_svg__);
/* unused harmony reexport Crown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_medium_svg__ = __webpack_require__("Kc/j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_medium_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_crown_medium_svg__);
/* unused harmony reexport CrownMedium */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_info_svg__ = __webpack_require__("9wCb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_info_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_info_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_21__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_info_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_standard_dropdown_svg__ = __webpack_require__("bC5U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_standard_dropdown_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_standard_dropdown_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_22__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_standard_dropdown_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_1_svg__ = __webpack_require__("6ywA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_1_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_23__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_1_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_2_svg__ = __webpack_require__("XP6K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_2_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_24__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_2_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_3_svg__ = __webpack_require__("sO5X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_3_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_25__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_3_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_4_svg__ = __webpack_require__("A0HV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_4_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_26__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_4_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_5_svg__ = __webpack_require__("sY2n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_5_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_27__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_step_5_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_left_svg__ = __webpack_require__("hjwG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_left_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_left_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_28__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_left_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_right_svg__ = __webpack_require__("11tP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_right_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_right_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_29__3plearning_3p_teacheradmin_assets_assets_UPF_images_img_question_marks_right_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_collapse_column_svg__ = __webpack_require__("eXo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_collapse_column_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_collapse_column_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_30__3plearning_3p_teacheradmin_assets_assets_UPF_icons_btn_collapse_column_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_large_svg__ = __webpack_require__("kmmW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_large_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_large_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_31__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_large_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_collapse_dark_svg__ = __webpack_require__("8u+W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_collapse_dark_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_collapse_dark_svg__);
/* unused harmony reexport Collapse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_dark_svg__ = __webpack_require__("NaYz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_dark_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_dark_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_33__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_expand_dark_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_1_svg__ = __webpack_require__("JXZx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_1_svg__);
/* unused harmony reexport Gem1 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_2_svg__ = __webpack_require__("l+aX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_2_svg__);
/* unused harmony reexport Gem2 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_3_svg__ = __webpack_require__("nIML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_3_svg__);
/* unused harmony reexport Gem3 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_4_svg__ = __webpack_require__("dj9Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_4_svg__);
/* unused harmony reexport Gem4 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_5_svg__ = __webpack_require__("MQpP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_gem_5_svg__);
/* unused harmony reexport Gem5 */
/* unused harmony reexport PreviewInfoIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_preview_svg__ = __webpack_require__("ibnS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_preview_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_preview_svg__);
/* unused harmony reexport PreviewDemoIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_assign_svg__ = __webpack_require__("gOC2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_assign_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_assign_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_40__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_assign_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_unassign_svg__ = __webpack_require__("ysx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_unassign_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_unassign_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_41__3plearning_3p_teacheradmin_assets_assets_UPF_icons_ico_unassign_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__3plearning_3p_teacheradmin_assets_assets_icons_icon_locked_color_svg__ = __webpack_require__("TgKa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__3plearning_3p_teacheradmin_assets_assets_icons_icon_locked_color_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__3plearning_3p_teacheradmin_assets_assets_icons_icon_locked_color_svg__);
/* unused harmony reexport IconLocked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlocked_color_svg__ = __webpack_require__("FXiH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlocked_color_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlocked_color_svg__);
/* unused harmony reexport IconUnlocked */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__3plearning_3p_teacheradmin_assets_assets_icons_icon_plus_svg__ = __webpack_require__("unWD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__3plearning_3p_teacheradmin_assets_assets_icons_icon_plus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__3plearning_3p_teacheradmin_assets_assets_icons_icon_plus_svg__);
/* unused harmony reexport IconPlus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__3plearning_3p_teacheradmin_assets_assets_icons_ico_assignlater_svg__ = __webpack_require__("8oBE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__3plearning_3p_teacheradmin_assets_assets_icons_ico_assignlater_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__3plearning_3p_teacheradmin_assets_assets_icons_ico_assignlater_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_45__3plearning_3p_teacheradmin_assets_assets_icons_ico_assignlater_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassignall_svg__ = __webpack_require__("xUnp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassignall_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassignall_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_46__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassignall_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__3plearning_3p_teacheradmin_assets_assets_icons_ico_vidhelp_svg__ = __webpack_require__("F0TD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__3plearning_3p_teacheradmin_assets_assets_icons_ico_vidhelp_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__3plearning_3p_teacheradmin_assets_assets_icons_ico_vidhelp_svg__);
/* unused harmony reexport VideoHelp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__3plearning_3p_teacheradmin_assets_assets_icons_ico_bolt_svg__ = __webpack_require__("vvfS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__3plearning_3p_teacheradmin_assets_assets_icons_ico_bolt_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__3plearning_3p_teacheradmin_assets_assets_icons_ico_bolt_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_48__3plearning_3p_teacheradmin_assets_assets_icons_ico_bolt_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__3plearning_3p_teacheradmin_assets_assets_icons_ico_select_svg__ = __webpack_require__("7YQw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__3plearning_3p_teacheradmin_assets_assets_icons_ico_select_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__3plearning_3p_teacheradmin_assets_assets_icons_ico_select_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_49__3plearning_3p_teacheradmin_assets_assets_icons_ico_select_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__3plearning_3p_teacheradmin_assets_assets_icons_ico_highest_svg__ = __webpack_require__("p5XJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__3plearning_3p_teacheradmin_assets_assets_icons_ico_highest_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__3plearning_3p_teacheradmin_assets_assets_icons_ico_highest_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_50__3plearning_3p_teacheradmin_assets_assets_icons_ico_highest_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__3plearning_3p_teacheradmin_assets_assets_icons_ico_period_svg__ = __webpack_require__("JaM+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__3plearning_3p_teacheradmin_assets_assets_icons_ico_period_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__3plearning_3p_teacheradmin_assets_assets_icons_ico_period_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_51__3plearning_3p_teacheradmin_assets_assets_icons_ico_period_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__3plearning_3p_teacheradmin_assets_assets_icons_ico_progress_svg__ = __webpack_require__("lWAG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__3plearning_3p_teacheradmin_assets_assets_icons_ico_progress_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__3plearning_3p_teacheradmin_assets_assets_icons_ico_progress_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_52__3plearning_3p_teacheradmin_assets_assets_icons_ico_progress_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__3plearning_3p_teacheradmin_assets_assets_icons_ico_lowest_svg__ = __webpack_require__("/ry3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__3plearning_3p_teacheradmin_assets_assets_icons_ico_lowest_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__3plearning_3p_teacheradmin_assets_assets_icons_ico_lowest_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_53__3plearning_3p_teacheradmin_assets_assets_icons_ico_lowest_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__3plearning_3p_teacheradmin_assets_assets_icons_ico_assign_start_svg__ = __webpack_require__("GOEc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__3plearning_3p_teacheradmin_assets_assets_icons_ico_assign_start_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__3plearning_3p_teacheradmin_assets_assets_icons_ico_assign_start_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_54__3plearning_3p_teacheradmin_assets_assets_icons_ico_assign_start_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__3plearning_3p_teacheradmin_assets_assets_icons_ico_assign_end_svg__ = __webpack_require__("ar8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__3plearning_3p_teacheradmin_assets_assets_icons_ico_assign_end_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__3plearning_3p_teacheradmin_assets_assets_icons_ico_assign_end_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_55__3plearning_3p_teacheradmin_assets_assets_icons_ico_assign_end_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__3plearning_3p_teacheradmin_assets_assets_icons_ico_attempts_svg__ = __webpack_require__("fjH/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__3plearning_3p_teacheradmin_assets_assets_icons_ico_attempts_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__3plearning_3p_teacheradmin_assets_assets_icons_ico_attempts_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_56__3plearning_3p_teacheradmin_assets_assets_icons_ico_attempts_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__3plearning_3p_teacheradmin_assets_assets_icons_ico_results_svg__ = __webpack_require__("W+9S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__3plearning_3p_teacheradmin_assets_assets_icons_ico_results_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__3plearning_3p_teacheradmin_assets_assets_icons_ico_results_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_57__3plearning_3p_teacheradmin_assets_assets_icons_ico_results_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__3plearning_3p_teacheradmin_assets_assets_icons_ico_latest_svg__ = __webpack_require__("JgJq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__3plearning_3p_teacheradmin_assets_assets_icons_ico_latest_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__3plearning_3p_teacheradmin_assets_assets_icons_ico_latest_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_58__3plearning_3p_teacheradmin_assets_assets_icons_ico_latest_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__3plearning_3p_teacheradmin_assets_assets_icons_ico_participation_svg__ = __webpack_require__("Ryuq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__3plearning_3p_teacheradmin_assets_assets_icons_ico_participation_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__3plearning_3p_teacheradmin_assets_assets_icons_ico_participation_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_59__3plearning_3p_teacheradmin_assets_assets_icons_ico_participation_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__3plearning_3p_teacheradmin_assets_assets_icons_ico_time_svg__ = __webpack_require__("PkTN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__3plearning_3p_teacheradmin_assets_assets_icons_ico_time_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__3plearning_3p_teacheradmin_assets_assets_icons_ico_time_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_60__3plearning_3p_teacheradmin_assets_assets_icons_ico_time_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__3plearning_3p_teacheradmin_assets_assets_icons_ico_last_activity_svg__ = __webpack_require__("4VlO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__3plearning_3p_teacheradmin_assets_assets_icons_ico_last_activity_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__3plearning_3p_teacheradmin_assets_assets_icons_ico_last_activity_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_61__3plearning_3p_teacheradmin_assets_assets_icons_ico_last_activity_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__3plearning_3p_teacheradmin_assets_assets_icons_ico_all_assigned_svg__ = __webpack_require__("3TsF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__3plearning_3p_teacheradmin_assets_assets_icons_ico_all_assigned_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__3plearning_3p_teacheradmin_assets_assets_icons_ico_all_assigned_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_62__3plearning_3p_teacheradmin_assets_assets_icons_ico_all_assigned_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassign_svg__ = __webpack_require__("5i2N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassign_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassign_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_63__3plearning_3p_teacheradmin_assets_assets_icons_ico_unassign_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__3plearning_3p_teacheradmin_assets_assets_icons_ico_class_svg__ = __webpack_require__("p1S/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__3plearning_3p_teacheradmin_assets_assets_icons_ico_class_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__3plearning_3p_teacheradmin_assets_assets_icons_ico_class_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_64__3plearning_3p_teacheradmin_assets_assets_icons_ico_class_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__3plearning_3p_teacheradmin_assets_assets_icons_ico_group_svg__ = __webpack_require__("5qXz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__3plearning_3p_teacheradmin_assets_assets_icons_ico_group_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__3plearning_3p_teacheradmin_assets_assets_icons_ico_group_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_65__3plearning_3p_teacheradmin_assets_assets_icons_ico_group_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__3plearning_3p_teacheradmin_assets_assets_icons_icon_assessments_svg__ = __webpack_require__("OHJl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__3plearning_3p_teacheradmin_assets_assets_icons_icon_assessments_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__3plearning_3p_teacheradmin_assets_assets_icons_icon_assessments_svg__);
/* unused harmony reexport AssessmentsIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__3plearning_3p_teacheradmin_assets_assets_assign_icons_ico_student_svg__ = __webpack_require__("VO0O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__3plearning_3p_teacheradmin_assets_assets_assign_icons_ico_student_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__3plearning_3p_teacheradmin_assets_assets_assign_icons_ico_student_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_67__3plearning_3p_teacheradmin_assets_assets_assign_icons_ico_student_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__3plearning_3p_teacheradmin_assets_assets_icons_ico_attempt_svg__ = __webpack_require__("675q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__3plearning_3p_teacheradmin_assets_assets_icons_ico_attempt_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__3plearning_3p_teacheradmin_assets_assets_icons_ico_attempt_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_68__3plearning_3p_teacheradmin_assets_assets_icons_ico_attempt_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__3plearning_3p_teacheradmin_assets_assets_icons_icon_lock_svg__ = __webpack_require__("ytev");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__3plearning_3p_teacheradmin_assets_assets_icons_icon_lock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__3plearning_3p_teacheradmin_assets_assets_icons_icon_lock_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_69__3plearning_3p_teacheradmin_assets_assets_icons_icon_lock_svg___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlock_svg__ = __webpack_require__("h4lv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlock_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_70__3plearning_3p_teacheradmin_assets_assets_icons_icon_unlock_svg___default.a; });



















// UPF specific icons























































/***/ }),

/***/ "vTZq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__ = __webpack_require__("vIo2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__doughnut_legend_styled__ = __webpack_require__("YbxQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__ = __webpack_require__("S0Yi");





var DoughnutsLegend = function DoughnutsLegend(_ref) {
  var i18n = _ref.i18n,
    type = _ref.type,
    studentName = _ref.studentName,
    truncatedName = _ref.truncatedName;
  var ClassLegend = function ClassLegend() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "legend-shell"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "class color-indi"
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
      icon: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["K" /* ClassIcon */]
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
      className: "text-indi",
      "data-testid": "group-text"
    }, i18n._(
    /*i18n*/
    {
      id: "doughnutClass",
      defaults: "Class"
    })));
  };
  var GroupLegend = function GroupLegend() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "legend-shell"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "group color-indi"
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
      icon: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["L" /* GroupIcon */]
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
      className: "text-indi",
      "data-testid": "class-text"
    }, i18n._(
    /*i18n*/
    {
      id: "doughnutGroup",
      defaults: "Group"
    })));
  };
  var StudentLegend = function StudentLegend() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "legend-shell"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: "student color-indi"
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__svg_icon_svg_icon__["a" /* default */], {
      icon: __WEBPACK_IMPORTED_MODULE_2__helpers_icon_dictionary__["E" /* StudentIcon */]
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p", {
      title: studentName,
      className: "text-indi",
      "data-testid": "student-name"
    }, truncatedName));
  };
  var items = [/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClassLegend, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__doughnut_legend_styled__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClassLegend, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GroupLegend, null)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StudentLegend, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__doughnut_legend_styled__["a" /* default */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(GroupLegend, null), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClassLegend, null)))];
  return items[type];
};
DoughnutsLegend.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  studentName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  truncatedName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};
/* harmony default export */ __webpack_exports__["a"] = (DoughnutsLegend);

/***/ }),

/***/ "vXY1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Wrapper; });
/* unused harmony export ExternalKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TopicName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Icon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StandardWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ActivityHeaderWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Info; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FixedWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CollapsedWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Wrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n\n    border-right: 2px solid ").concat(colours.grey[500], ";\n    box-sizing: border-box;\n    font-size: 12px;\n    position: relative;\n    height: fit-content;\n    margin-top: -1px;\n\n    &:last-child {\n      border-right: none;\n    }\n");
});
var FixedWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n  position: sticky;\n  top: 0;\n  z-index: 6;\n  border-top: 1px solid ".concat(colours.grey[400], ";\n");
});
var StandardWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var VERTICAL_WIDTH = 54;
  var activities = props.activities;
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'), ";\n\n    width: ").concat(activities * VERTICAL_WIDTH, "px;\n    min-height: 40px;\n    height: 40px;\n    background-color: #c3d5e1\n    border: ").concat(activities > 0 ? "1px solid ".concat(colours.grey[400]) : 'none', ";\n    border-right: ").concat(activities > 0 ? "1px solid ".concat(colours.grey[500]) : 'none', ";\n    border-top: none;\n    box-sizing: border-box;\n    font-size: 12px;\n    overflow: hidden;\n    cursor: pointer;\n\n    .leftAlign {\n      margin-left: 5px;\n    }\n\n    @media screen and (max-width: 1100px) {\n      min-height: 30px;\n      height: 30px;\n    }\n");
});
var ActivityHeaderWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n\n    height: 150px;\n    font-size: 12px;\n    background-color: #eaf9f9;\n    color: ").concat(colours.grey[800], ";\n");
});
var CollapsedWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n\n    width: 54px;\n    border-right: 1px solid ").concat(colours.grey[500], ";\n");
});
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].span(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n\n    width: calc(100% - 17px);\n    color: ").concat(colours.grey[800], ";\n");
});
var TopicName = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var palette = props.theme.palette;
  return "\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    color: ".concat(palette.primary.dark, ";\n");
});
var ExternalKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */])(TopicName)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-transform: uppercase;\n"])));
var Icon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  cursor: pointer;\n  height: 40px;\n\n  [class^='svgIconComponent'] {\n    width: 15px !important;\n  }\n\n  &:hover {\n    path {\n      fill: #3b4e5e !important;\n    }\n  }\n\n  &:active {\n    path {\n      fill: #000 !important;\n    }\n  }\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));
var Info = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  width: calc(100% - 22px);\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'));


/***/ }),

/***/ "viEY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basic_resources__ = __webpack_require__("iV3T");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


// The Resources class provides a set of static fields, one for each resource
// needed by the application. Users should generally call its initialise() method, to set
// up the environment and create all of the resources the application will use.

// In some (hopefully, rare) situations, it may be required that the environment is provided
// from a parent application. In these situations, call createResources(parentEnv) directly,
// and pass it the Resources.env object that is the environment required.
var Resources = /*#__PURE__*/function () {
  function Resources() {
    _classCallCheck(this, Resources);
  }
  return _createClass(Resources, null, [{
    key: "createResources",
    value: function createResources(parentEnv) {
      var CLASSROOM_REPORT_API = '@ClassroomReportApi';
      var USER_PORTAL_API = '@UserPortalGateway';
      if (parentEnv) {
        Resources.env = parentEnv;
      }
      Resources.getClassrooms = Resources.env.resource('getClassrooms').baseUrl(CLASSROOM_REPORT_API).service('classroll/product/{productId}');
      Resources.getResultsData = Resources.env.resource('getResultsData').baseUrl(CLASSROOM_REPORT_API).service('results-manager');
      Resources.classResultsData = Resources.env.resource('classResultsData').baseUrl(CLASSROOM_REPORT_API).service('results-manager/classes/{classId}');
      Resources.groupResultsData = Resources.env.resource('groupResultsData').baseUrl(CLASSROOM_REPORT_API).service('assigned-results/classroom/{classroomId}/groupId/{groupId}');
      Resources.topicResultsData = Resources.env.resource('topicResultsData').baseUrl(CLASSROOM_REPORT_API).service('results-manager/classes/{classId}/groups/{groupId}/topics/{topicId}');
      Resources.restrictActivities = Resources.env.resource('restrictActivities').baseUrl(CLASSROOM_REPORT_API).service('assign/restrict/{isRestricted}/classroom/{classId}/group/{groupId}');
      Resources.reassignActivities = Resources.env.resource('reassignActivities').baseUrl(CLASSROOM_REPORT_API).service('results-manager/students-and-activities/classroom/{classroomId}/group/{groupId}/topic/{topicId}');
      Resources.getcourseTopics = Resources.env.resource('getcourseTopics').baseUrl(CLASSROOM_REPORT_API).service('/course/{courseId}');
      Resources.getAssignments = Resources.env.resource('getAssignments').baseUrl(CLASSROOM_REPORT_API).service('assignments/classrooms/{classroomId}/groups/{groupId}');
      Resources.assign = Resources.env.resource('assign').baseUrl(CLASSROOM_REPORT_API).service('/assign/classroom/{classroomId}/group/{groupId}');
      Resources.unassign = Resources.env.resource('unassign').baseUrl(CLASSROOM_REPORT_API).service('/unassign/classroom/{classroomId}/group/{groupId}');
      Resources.unassignAll = Resources.env.resource('unassignAll').baseUrl(CLASSROOM_REPORT_API).service('/unassign-all/classroom/{classroomId}/group/{groupId}');
      Resources.getStartDatePreference = Resources.env.resource('getStartDatePreference').baseUrl(USER_PORTAL_API).service('preferences/activity-start-date');
      Resources.getDueDatePreference = Resources.env.resource('getEndDatePreference').baseUrl(USER_PORTAL_API).service('preferences/activity-due-date');
      Resources.getStudentActivitiesByActivityId = Resources.env.resource('getStudentActivitiesByActivityId').baseUrl(CLASSROOM_REPORT_API).service('report/student-single-activity-overview');
      Resources.getStudentResult = Resources.env.resource('getStudentResult').baseUrl(CLASSROOM_REPORT_API).service('report/student-course-activities-overview');
      Resources.getChartResult = Resources.env.resource('getChartResult').baseUrl(CLASSROOM_REPORT_API).service('/report/group-results-overview/classrooms/{classroomId}/groups/{groupId}');
    }

    // Initialise the environment and resources, based on the provided
    // environment name.  We return the environment so the caller has
    // access to everything, in particular the authToken if one was
    // passed in the query parameters.
  }, {
    key: "initialise",
    value: function initialise(envName, credentials) {
      Resources.env = __WEBPACK_IMPORTED_MODULE_0__basic_resources__["a" /* default */].initialise(envName, credentials);
      Resources.createResources();
      return Resources.env;
    }
  }]);
}();
/* harmony default export */ __webpack_exports__["a"] = (Resources);

/***/ }),

/***/ "w8NY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_use_analytics__ = __webpack_require__("dGCJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assign_later_styled__ = __webpack_require__("WyKg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_hooks_use_assignment_to_assign__ = __webpack_require__("O9G1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_resources__ = __webpack_require__("viEY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__containers_course_assign_course_assign_actions__ = __webpack_require__("+7+H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__toast_toast_action__ = __webpack_require__("fbOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_resources_helper__ = __webpack_require__("jhKF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_types__ = __webpack_require__("1E24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_assign_later_actions__ = __webpack_require__("CPWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__analytics__ = __webpack_require__("uVVs");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }















function AssignLaterModal(props) {
  var i18n = props.i18n;
  var _useAnalytics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_use_analytics__["b" /* useAnalytics */])(),
    track = _useAnalytics.track;
  var assignFlow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__analytics__["b" /* useAssignmentFlowTracking */])('assign');
  var isOpen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["c" /* useSelector */])(function (state) {
    return state.assignLaterReducer.isAssignLaterModalOpen;
  });
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])({
      startDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
      endDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'day').format('YYYY-MM-DD')
    }),
    _useState2 = _slicedToArray(_useState, 2),
    dateSelected = _useState2[0],
    setDateSelected = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(),
    _useState4 = _slicedToArray(_useState3, 2),
    timeSelected = _useState4[0],
    setTimeSelected = _useState4[1];
  var _useState5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),
    _useState6 = _slicedToArray(_useState5, 2),
    enableAccept = _useState6[0],
    setEnableAccept = _useState6[1];
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* useDispatch */])();
  var courseID = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeCourseID;
  });
  var classroomId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeClass;
  });
  var groupId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_redux__["c" /* useSelector */])(function (state) {
    return state.CourseAssignReducer.activeGroup;
  });
  var onDateChangeHandler = function onDateChangeHandler(startDate, endDate) {
    setDateSelected({
      startDate: startDate,
      endDate: endDate
    });
  };
  var onTimeChangeHandler = function onTimeChangeHandler(newTime) {
    return setTimeSelected(newTime);
  };
  var assignmentsToAssign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__helpers_hooks_use_assignment_to_assign__["a" /* default */])();
  function handleSuccess() {
    setEnableAccept(true);
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__containers_course_assign_course_assign_actions__["b" /* getTopics */])(classroomId, groupId));
    track('ActivityAssigned');
    assignFlow.confirm(_objectSpread({
      target: 'students'
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__analytics__["c" /* summarizeAssignments */])(assignmentsToAssign)));
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__toast_toast_action__["c" /* showToast */])(i18n._(
    /*i18n*/
    {
      id: "footer.assignSuccess",
      defaults: "Selected student activities have been assigned"
    }), 'success'));
    dispatch({
      type: 'SUBMIT_ASSIGN_LATER',
      payload: {
        timeSelected: timeSelected,
        dateSelected: dateSelected
      }
    });
  }

  // Adds space before period so moment can calculate correctly
  function splitPeriod(time) {
    return "".concat(time.slice(0, time.length - 2), " ").concat(time.slice(time.length - 2));
  }
  var defaultProps = {
    range: {
      startDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD'),
      endDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(1, 'year').format('YYYY-MM-DD')
    },
    closedOnLoad: true,
    initialDate: dateSelected,
    weeklyRangeOnly: false,
    includeTimeRange: true,
    enableAccept: enableAccept,
    onDatesPicked: onDateChangeHandler,
    onTimesPicked: onTimeChangeHandler,
    onClose: function onClose() {},
    onDateTimeSubmit: function onDateTimeSubmit() {
      return handleAssignLater();
    },
    onDateTimeClose: function onDateTimeClose() {
      return dispatch({
        type: __WEBPACK_IMPORTED_MODULE_13__store_assign_later_actions__["a" /* HIDE_ASSIGN_LATER */]
      });
    }
  };
  function handleAssignLater() {
    var MOMENT_DATE_FORMAT = 'DD-MMM-YYYY';
    var startDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(dateSelected.startDate).format(MOMENT_DATE_FORMAT);
    var endDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(dateSelected.endDate).format(MOMENT_DATE_FORMAT);
    assignFlow.start(_objectSpread({
      target: 'students'
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__analytics__["c" /* summarizeAssignments */])(assignmentsToAssign)));
    setEnableAccept(false);
    __WEBPACK_IMPORTED_MODULE_8__helpers_resources__["a" /* default */].assign.post({
      classroomId: classroomId,
      groupId: groupId
    }).withBody(_objectSpread({
      courseId: courseID,
      startDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()("".concat(startDate, " ").concat(splitPeriod(timeSelected[0]))).toISOString(),
      dueDate: __WEBPACK_IMPORTED_MODULE_2_moment___default()("".concat(endDate, " ").concat(splitPeriod(timeSelected[1]))).toISOString(),
      hasDueDate: true
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__helpers_resources_helper__["a" /* mapSelectedActivitiesToReq */])(assignmentsToAssign))).send().then(function () {
      return handleSuccess();
    }, function (err) {
      dispatch({
        type: __WEBPACK_IMPORTED_MODULE_12__containers_course_assign_course_assign_types__["e" /* ERROR_DETECTED */],
        payload: err
      });
    });
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, isOpen ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__assign_later_styled__["a" /* AssignLaterModalOuter */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__assign_later_styled__["b" /* AssignLaterModalInner */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__3plearning_react_components__["Calendar"], defaultProps))) : null);
}
AssignLaterModal.propTypes = {
  i18n: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
/* harmony default export */ __webpack_exports__["a"] = (AssignLaterModal);

/***/ }),

/***/ "wLwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Footer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssignedListItemWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var Footer = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  margin: 1em;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["f" /* alignSelf */])('flex-end'));
var AssignedListItemWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n\n  padding: 4px 8px;\n  div {\n    width: 15%;\n  }\n\n  > :first-child {\n    margin: 0;\n    width: auto;\n  }\n\n  > :nth-child(2) {\n    width: 40%;\n    text-align: left;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    margin-left: -10px;\n  }\n\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('space-between'));

/***/ }),

/***/ "wTCj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CourseNameWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CourseNameLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CourseNameTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var CourseNameWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  ", "\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'));
var CourseNameLabel = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 11px;\n"])));
var CourseNameTitle = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 14px;\n"])));

/***/ }),

/***/ "wY8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line_chart_styled__ = __webpack_require__("78xV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_utils__ = __webpack_require__("6QRH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hover_context_hover_context__ = __webpack_require__("4V9u");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }






var getColor = function getColor(score) {
  if (score < 50) {
    return '#900012';
  } else if (score > 85) {
    return '#008902';
  }
  return '#2452bb';
};
var RenderChartLines = function RenderChartLines(i18n, results) {
  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
    _useState2 = _slicedToArray(_useState, 2),
    showCallOutMenu = _useState2[0],
    setCallOutMenu = _useState2[1];
  var _useState3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentHoveredPoint = _useState4[0],
    setCurrentHoveredPoint = _useState4[1];
  var TOTAL_CHART_COLUMNS = 10;
  var COLUMN_WIDTH = 38;
  var COLUMN_HEIGHT = 130;
  var TOTAL_OFFSET = 5;
  var Columns = [];
  var showCallOut = function showCallOut(e, currentIndex) {
    if (parseInt(e.target.getAttribute('data-index'), 10) === currentIndex) {
      setCallOutMenu(true);
      setCurrentHoveredPoint(currentIndex);
    }
  };
  var hideCallOut = function hideCallOut() {
    setCallOutMenu(false);
  };
  var sortedResults = results.sort(function (a, b) {
    return a.attempts - b.attempts;
  });
  var _loop = function _loop(i) {
    var _sortedResults$i;
    var _ref = i <= results.length && sortedResults[i - 1],
      score = _ref.score,
      completionDate = _ref.completionDate;
    var nextScore = i <= results.length && ((_sortedResults$i = sortedResults[i]) === null || _sortedResults$i === void 0 ? void 0 : _sortedResults$i.score);
    var currentPosition = score / 100 * COLUMN_HEIGHT;
    var nextPosition = nextScore / 100 * COLUMN_HEIGHT;
    Columns.push(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__line_chart_styled__["a" /* ChartLinesWrapper */], {
      key: "".concat(score, "_").concat(i)
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__line_chart_styled__["b" /* ChartLine */], null, i <= results.length && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__line_chart_styled__["c" /* ChartPoint */], {
      "data-testid": "chartPoint",
      "data-index": i,
      position: currentPosition,
      color: getColor(score),
      role: "button",
      tabIndex: "-1",
      onMouseEnter: function onMouseEnter(e) {
        return showCallOut(e, i);
      },
      onMouseLeave: hideCallOut
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__hover_context_hover_context__["a" /* default */], {
      "data-testid": "hover-context",
      show: showCallOutMenu && i === currentHoveredPoint,
      date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(completionDate).format('DD MMM YYYY')
    })), i <= results.length - 1 && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", {
      height: "160",
      width: "100"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs", null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("linearGradient", {
      id: "e",
      x1: "0",
      y1: COLUMN_HEIGHT - currentPosition + TOTAL_OFFSET,
      x2: COLUMN_WIDTH,
      y2: COLUMN_HEIGHT - nextPosition + TOTAL_OFFSET,
      gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", {
      stopColor: getColor(score),
      offset: "0"
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop", {
      stopColor: getColor(nextScore),
      offset: "1"
    }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", {
      x1: "0",
      y1: COLUMN_HEIGHT - currentPosition + TOTAL_OFFSET,
      x2: COLUMN_WIDTH,
      y2: COLUMN_HEIGHT - nextPosition + TOTAL_OFFSET,
      stroke: "url(#e)",
      strokeWidth: "3"
    })))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__line_chart_styled__["d" /* Position */], {
      enabled: i <= results.length
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers_utils__["g" /* attachSuffix */])(i, i18n))));
  };
  for (var i = 1; i <= TOTAL_CHART_COLUMNS; i++) {
    _loop(i);
  }
  return Columns;
};
var LineChart = function LineChart(_ref2) {
  var i18n = _ref2.i18n,
    results = _ref2.results;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__line_chart_styled__["e" /* Wrapper */], {
    "data-testid": "lineChart"
  }, RenderChartLines(i18n, results)), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__line_chart_styled__["f" /* LineChartWrapper */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__line_chart_styled__["g" /* Section1 */], {
    "data-testid": "85to100"
  }, "85-100%"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__line_chart_styled__["h" /* Section2 */], {
    "data-testid": "50to85"
  }, "50-85%"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__line_chart_styled__["i" /* Section3 */], {
    "data-testid": "lessThan50"
  }, "<50%"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__line_chart_styled__["j" /* Footer */], {
    "data-testid": "attempt"
  }, i18n._(
  /*i18n*/
  {
    id: "chart.attempt",
    defaults: "Attempt"
  }))));
};
LineChart.propTypes = {
  results: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  i18n: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};
LineChart.defaultProps = {
  results: []
};
/* harmony default export */ __webpack_exports__["a"] = (LineChart);

/***/ }),

/***/ "x4K0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return EntryApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__("F8kA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lingui_react__ = __webpack_require__("QruM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lingui_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lingui_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_analytics__ = __webpack_require__("2yr5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__analytics_google_analytics__ = __webpack_require__("SSga");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_use_analytics__ = __webpack_require__("dGCJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_conserve_parameters__ = __webpack_require__("HW8V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_local_storage__ = __webpack_require__("//jD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__entry_app_scss__ = __webpack_require__("B7He");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__entry_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__entry_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__themes_course_assign_theme__ = __webpack_require__("FYON");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_core_scss__ = __webpack_require__("nIya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles_core_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__styles_core_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__basic_app__ = __webpack_require__("SgkA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__course_assign_course_assign__ = __webpack_require__("3Ct5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_filter_bar__ = __webpack_require__("jzvl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_switch_to_old_assign_switch_to_old_assign__ = __webpack_require__("4BBg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__analytics__ = __webpack_require__("uVVs");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* global window */



















__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__helpers_conserve_parameters__["a" /* default */])(['username', 'password', 'userToken']);
__WEBPACK_IMPORTED_MODULE_10__helpers_local_storage__["a" /* default */].namespace = 'course-assign';
var EntryApp = /*#__PURE__*/function (_BasicApp) {
  function EntryApp() {
    var _this;
    _classCallCheck(this, EntryApp);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EntryApp, [].concat(args));
    _defineProperty(_this, "render", function (store, i18n) {
      // TODO: 4. DEFINE THE TOP-LEVEL ROUTES FOR YOUR APPLICATION'S COMPONENTS HERE

      // When executing on demo, QA, or production, the host app will inject a property
      // called pppAppConfig into the global window variable.  This will provide the
      // base name of the app.  Most of the time that will be an empty string, but in
      // case it is not, we will extract it and pass it to the router, below.

      // eslint-disable-next-line no-underscore-dangle
      var appConfig = window._env_;
      var BASE_NAME = appConfig ? appConfig.BaseName : '';
      var showSwitchToOldAssign =
      // getConfiguration('showSwitchToOldAssign') ||
      false;
      /* Initialize analytics & load plugins */
      var analytics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_analytics__["a" /* default */])({
        app: 'course-assign',
        debug: false,
        plugins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__analytics_google_analytics__["a" /* default */])({
          trackingId: 'UA-74202440-35'
        })]
      });

      // NOTE: We have used a "render" attribute, rather than "component" to specify what
      //       should be rendered.  This allows us to pass options to the component. You
      //       can obviously simplify things if your components don't need any.
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__lingui_react__["I18nProvider"], {
        i18n: i18n
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */], {
        store: store
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_use_analytics__["a" /* AnalyticsProvider */], {
        instance: analytics
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__analytics__["a" /* MxAnalyticsProvider */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* BrowserRouter */], {
        basename: BASE_NAME
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__3plearning_react_components__["ThemeProvider"], {
        theme: __WEBPACK_IMPORTED_MODULE_12__themes_course_assign_theme__["a" /* default */]
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_styled_components__["a" /* ThemeProvider */], {
        theme: __WEBPACK_IMPORTED_MODULE_12__themes_course_assign_theme__["a" /* default */]
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_11__entry_app_scss___default.a.app
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__3plearning_react_components__["Header"], {
        title: i18n._(
        /*i18n*/
        {
          id: "entryapp.header.title",
          defaults: "Assign & Review"
        }),
        subtitle: i18n._(
        /*i18n*/
        {
          id: "entryapp.header.courses",
          defaults: "Courses (Activities)"
        }),
        className: __WEBPACK_IMPORTED_MODULE_11__entry_app_scss___default.a.header
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_11__entry_app_scss___default.a.buttonsContainer
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_filter_bar__["a" /* default */], {
        i18n: i18n
      }), showSwitchToOldAssign && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_switch_to_old_assign_switch_to_old_assign__["a" /* default */], {
        i18n: i18n
      }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__3plearning_react_components__["Container"], {
        className: __WEBPACK_IMPORTED_MODULE_11__entry_app_scss___default.a['container-wrapper']
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Switch */], null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Route */], {
        path: "/",
        render: function render() {
          return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__course_assign_course_assign__["a" /* default */], {
            i18n: i18n
          });
        }
      })))))))))));
    });
    return _this;
  }
  _inherits(EntryApp, _BasicApp);
  return _createClass(EntryApp);
}(__WEBPACK_IMPORTED_MODULE_14__basic_app__["a" /* default */]);

window.EntryApp = EntryApp;

/***/ }),

/***/ "x7/N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__("KSGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_icons_icon_calendar_svg__ = __webpack_require__("ZaYO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_icons_icon_calendar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_icons_icon_calendar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__ = __webpack_require__("fmgT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__3plearning_react_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__ = __webpack_require__("28rk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_date_helper__ = __webpack_require__("BiE+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styled__ = __webpack_require__("nqPn");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









/**
 * DatePicker component
 * Allows user to pick 'This week' 'Last week' 'This school year' or 'Custom date' from drop down
 * Loads Calendar component if user chooses custom date range
 * Calls onDateChange callback prop when selection changes
 */
var DatePicker = /*#__PURE__*/function (_Component) {
  function DatePicker(props) {
    var _this;
    _classCallCheck(this, DatePicker);
    _this = _callSuper(this, DatePicker, [props]);
    /**
     * Runs when user changes value in dropdown
     * Calls onDateChange prop with newly selected date range (unless user chose custom date)
     */
    _defineProperty(_this, "onDateChange", function (value) {
      _this.setState({
        selectedDateType: value,
        selectedCustomDates: false,
        selectedTimeRange: false,
        dateTimeSubmitted: false
      });
      var startDate;
      var endDate;
      switch (value) {
        case __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["a" /* THIS_WEEK */]:
          var _DateHelper$getThisWe = __WEBPACK_IMPORTED_MODULE_6__helpers_date_helper__["a" /* default */].getThisWeekStartEnd();
          startDate = _DateHelper$getThisWe.startDate;
          endDate = _DateHelper$getThisWe.endDate;
          break;
        case __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["b" /* LAST_WEEK */]:
          var _DateHelper$getLastWe = __WEBPACK_IMPORTED_MODULE_6__helpers_date_helper__["a" /* default */].getLastWeekStartEnd();
          startDate = _DateHelper$getLastWe.startDate;
          endDate = _DateHelper$getLastWe.endDate;
          break;
        case __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["c" /* THIS_SCHOOL_YEAR */]:
        case __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["d" /* LIFETIME */]:
          var _this$props$academicY = _this.props.academicYear;
          startDate = _this$props$academicY.startDate;
          endDate = _this$props$academicY.endDate;
          break;
        case __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["e" /* CUSTOM_DATE */]:
        case __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["f" /* CUSTOM_DATE_TIME */]:
          return;
        default:
          console.warn('Unhandled date type');
        // eslint-disable-line no-console
      }
      _this.props.onDateChange(value, startDate, endDate);
    });
    /**
     * Runs when user selects start & end dates in calendar component
     * Calls onDateChange prop with newly selected date range
     */
    _defineProperty(_this, "onCustomDateChange", function (startDate, endDate) {
      _this.props.onDateChange(_this.state.selectedDateType, startDate, endDate);
      _this.setState({
        selectedCustomDates: true
      });
    });
    _defineProperty(_this, "onTimeRangeChange", function (time) {
      _this.props.onTimeChange(time);
      _this.setState({
        selectedTimeRange: true,
        time: time
      });
    });
    /**
     * Reverts date to previous selection if user cancelled selecting custom dates in calendar
     */
    _defineProperty(_this, "onCustomDateClose", function () {
      // todo: i don't like this timeout but i couldn't get cancel functionality to
      // work without it
      setTimeout(function () {
        if (!_this.state.selectedCustomDates) {
          _this.setState({
            selectedDateType: _this.props.currentDate.type,
            selectedCustomDates: true,
            hideSelectedTime: true
          });
        }
      });
    });
    _defineProperty(_this, "onDateTimeSubmit", function () {
      _this.setState({
        selectedDateType: __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["f" /* CUSTOM_DATE_TIME */],
        selectedCustomDates: true,
        hideSelectedTime: true,
        dateTimeSubmitted: true
      });
    });
    /**
     * Generates the display text to show in the dropdown menu as the current selected option
     * Handles showing the date range if user chose custom date ie. 14 June 2018 - 28 June 2018
     */
    _defineProperty(_this, "getSelectedLabel", function () {
      var selectedDateType = _this.state.selectedDateType;
      if (selectedDateType === __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["e" /* CUSTOM_DATE */] || selectedDateType === __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["f" /* CUSTOM_DATE_TIME */]) {
        var time = _this.state.time;
        var _this$props$currentDa = _this.props.currentDate,
          startDate = _this$props$currentDa.startDate,
          endDate = _this$props$currentDa.endDate;
        var formatString = 'DD MMM YYYY';
        var formattedStartDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(startDate).format(formatString);
        var formattedEndDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(endDate).format(formatString);
        return selectedDateType === __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["e" /* CUSTOM_DATE */] ? "".concat(formattedStartDate, " - ").concat(formattedEndDate) : "".concat(formattedStartDate, " ").concat(time[0], " - ").concat(formattedEndDate, " ").concat(time[1]);
      }
      return selectedDateType;
    });
    _this.state = {
      weeklyRangeOnly: props.weeklyRangeOnly !== undefined ? props.weeklyRangeOnly : true,
      selectedDateType: props.currentDate.type,
      selectedCustomDates: props.currentDate.type === __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["e" /* CUSTOM_DATE */] || props.currentDate.type === __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["f" /* CUSTOM_DATE_TIME */],
      hideSelectedTime: true,
      time: ['9:00AM', '5:00PM'],
      dateTimeSubmitted: false
    };
    return _this;
  }

  /* eslint camelcase: "off" */
  _inherits(DatePicker, _Component);
  return _createClass(DatePicker, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.state.selectedDateType !== nextProps.currentDate.type) {
        this.setState({
          weeklyRangeOnly: nextProps.weeklyRangeOnly !== undefined ? nextProps.weeklyRangeOnly : true,
          selectedDateType: nextProps.currentDate.type,
          selectedCustomDates: nextProps.currentDate.type === __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["e" /* CUSTOM_DATE */]
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        selectedDateType = _this$state.selectedDateType,
        selectedCustomDates = _this$state.selectedCustomDates,
        hideSelectedTime = _this$state.hideSelectedTime,
        dateTimeSubmitted = _this$state.dateTimeSubmitted,
        weeklyRangeOnly = _this$state.weeklyRangeOnly;
      var _this$props = this.props,
        academicYear = _this$props.academicYear,
        reactDatesConfig = _this$props.reactDatesConfig,
        className = _this$props.className,
        options = _this$props.options,
        initialDate = _this$props.initialDate,
        labels = _this$props.labels;
      var selectedDateLabel = this.getSelectedLabel();
      var shouldDisplayCalendar = selectedDateType === __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["e" /* CUSTOM_DATE */] && !selectedCustomDates || selectedDateType === __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["f" /* CUSTOM_DATE_TIME */] && !dateTimeSubmitted && (!selectedCustomDates || hideSelectedTime);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styled__["a" /* default */], {
        className: className
      }, shouldDisplayCalendar && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__["Calendar"], {
        range: academicYear,
        reactDatesConfig: reactDatesConfig,
        onDatesPicked: this.onCustomDateChange,
        weeklyRangeOnly: weeklyRangeOnly,
        initialDate: initialDate,
        includeTimeRange: selectedDateType === __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["f" /* CUSTOM_DATE_TIME */],
        onTimesPicked: function onTimesPicked(time) {
          return _this2.onTimeRangeChange(time);
        },
        onClose: this.onCustomDateClose,
        onSubmit: this.onDateTimeSubmit
      }), !shouldDisplayCalendar && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__3plearning_react_components__["DropdownMenu"], {
        icon: __WEBPACK_IMPORTED_MODULE_3__3plearning_3p_teacheradmin_assets_assets_icons_icon_calendar_svg___default.a,
        options: options.map(function (option) {
          return {
            label: labels[option] ? labels[option] : option,
            value: option
          };
        }),
        selectedOption: {
          label: labels[selectedDateLabel] ? labels[selectedDateLabel] : selectedDateLabel,
          value: selectedDateType
        },
        onSelectOption: function onSelectOption(option) {
          return _this2.onDateChange(option.value);
        }
      }));
    }
  }]);
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
_defineProperty(DatePicker, "propTypes", {
  /** Range to limit the date selection to */
  academicYear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  /** Current selected date */
  currentDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["g" /* DATE_OPTIONS */]),
    startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }).isRequired,
  /** To show the Spanish or any passed language in the dropdown */
  labels: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["g" /* DATE_OPTIONS */])),
  /** Options to display in dropdown menu */
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["g" /* DATE_OPTIONS */])),
  /** Callback when a date selection is made */
  onDateChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  initialDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    startDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
    endDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
  }),
  /** Flag whether custom date range should be mon-sun
   *  enabled by default
   */
  weeklyRangeOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  /** Callback when a time selection is made
   */
  onTimeChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  /** Custom class to attach to parent div - use this to override any styles */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  /** Props overrides for react-dates component
   * @see <a href="https://github.com/airbnb/react-dates#make-some-awesome-datepickers">react-dates props</a>
   */
  reactDatesConfig: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
});
_defineProperty(DatePicker, "defaultProps", {
  labels: __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["h" /* DEFAULT_DATE_OPTIONS_LABELS */],
  options: __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["i" /* DEFAULT_DATE_OPTIONS */]
});
DatePicker.THIS_WEEK = __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["a" /* THIS_WEEK */];
DatePicker.LAST_WEEK = __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["b" /* LAST_WEEK */];
DatePicker.THIS_SCHOOL_YEAR = __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["c" /* THIS_SCHOOL_YEAR */];
DatePicker.CUSTOM_DATE = __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["e" /* CUSTOM_DATE */];
DatePicker.CUSTOM_DATE_TIME = __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["f" /* CUSTOM_DATE_TIME */];
DatePicker.LIFETIME = __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["d" /* LIFETIME */];
DatePicker.DEFAULT_DATE_OPTIONS = __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["i" /* DEFAULT_DATE_OPTIONS */];
DatePicker.DATE_OPTIONS = __WEBPACK_IMPORTED_MODULE_5__date_picker_constants__["g" /* DATE_OPTIONS */];
/* harmony default export */ __webpack_exports__["a"] = (DatePicker);

/***/ }),

/***/ "xOeK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return font; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fontWithBold; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return cellRightBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fontWithBoldGray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return headerFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return subHeaderFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return mergeCellAlign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return columnWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return columnHeightTopics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return studentDetailColWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cellTopBottomBorder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cellTopBottomRightBorder; });
var font = {
  name: 'Calibri',
  size: 8
};
var fontWithBold = {
  name: 'Calibri',
  size: 8,
  bold: true
};
var cellRightBorder = {
  right: {
    style: 'medium',
    color: {
      argb: '#000000'
    }
  }
};
var fontWithBoldGray = {
  name: 'Calibri',
  size: 8,
  color: {
    argb: '848484'
  }
};
var headerFont = {
  name: 'Calibri',
  size: 12,
  bold: true
};
var subHeaderFont = {
  color: {
    argb: '#FF00FF00'
  },
  size: 8,
  underline: true
};
var mergeCellAlign = {
  vertical: 'middle',
  horizontal: 'center'
};
var columnWidth = 5;
var columnHeightTopics = 35;
var studentDetailColWidth = 20;
var cellTopBottomBorder = {
  top: {
    style: 'thin',
    color: {
      argb: '#000000'
    }
  },
  bottom: {
    style: 'medium',
    color: {
      argb: '#000000'
    }
  }
};
var cellTopBottomRightBorder = {
  top: {
    style: 'thin',
    color: {
      argb: '#000000'
    }
  },
  bottom: {
    style: 'medium',
    color: {
      argb: '#000000'
    }
  },
  right: {
    style: 'medium',
    color: {
      argb: '#000000'
    }
  }
};

/***/ }),

/***/ "xfNU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__("GiK3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__("RH2O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss__ = __webpack_require__("s4Vw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toast_action__ = __webpack_require__("fbOh");




function Toast() {
  var dispatch = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* useDispatch */])();
  var isToastVisible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.toastReducer.isToastVisible;
  });
  var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.toastReducer.message;
  });
  var messageType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_redux__["c" /* useSelector */])(function (state) {
    return state.toastReducer.messageType;
  });
  var timeout = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);
  function cleanup() {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function () {
    var startTimer = function startTimer() {
      if (isToastVisible && timeout.current) {
        dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toast_action__["d" /* hideToast */])());
        clearTimeout(timeout.current);
      }
    };
    timeout.current = setTimeout(startTimer, 7000);
    return function () {
      return cleanup();
    };
  }, [isToastVisible, dispatch]);
  var hide = function hide() {
    dispatch(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toast_action__["d" /* hideToast */])());
    cleanup();
  };
  var setToastColor = function setToastColor() {
    var color = '';
    switch (messageType) {
      case 'success':
        color = '#5cb85c';
        break;
      case 'warning':
        color = '#e07e02';
        break;
      default:
        color = '#c53902';
        break;
    }
    return color;
  };
  if (isToastVisible) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_2__index_scss___default.a.toast,
      style: {
        background: setToastColor()
      }
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_2__index_scss___default.a.message,
      onClick: hide,
      role: "button",
      tabIndex: 0
    }, message));
  }
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: __WEBPACK_IMPORTED_MODULE_2__index_scss___default.a.empty
  });
}
/* harmony default export */ __webpack_exports__["a"] = (Toast);

/***/ }),

/***/ "xnkI":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("gdXn");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {"singleton":true});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./index.scss", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?modules&localIdentName=[local]---[hash:base64:5]!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/index.js!./index.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "y11q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QuickSelectorWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return QuickSelectorToggleButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return QuickSelectorRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QuickSelectorHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return QuickSelectorClearSelections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ColorBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AllCellsIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var QuickSelectorWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _colours$custom;
  var colours = props.theme.colours;
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n  width: 40px;\n  height: 100%;\n\n  &:hover {\n    path {\n      fill: ").concat((_colours$custom = colours.custom) === null || _colours$custom === void 0 ? void 0 : _colours$custom[800], " !important;\n    }\n  }\n");
});
var QuickSelectorToggleButton = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].button(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    background-color: ").concat(colours.grey[200], ";\n    border: none;\n    width: 100%;\n    height: 100%;\n  ");
});
var QuickSelectorRow = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    border-bottom: 1px solid ").concat(colours.grey[400], ";\n    padding-left: 10px;\n    color: ").concat(colours.grey[800], ";\n    height: 32px;\n    cursor: pointer;\n\n    &:hover {\n      font-weight: 900;\n    }\n  ");
});
var QuickSelectorHeader = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */])(QuickSelectorRow)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: 700;\n  cursor: default;\n\n  &:hover {\n    background-color: white !important;\n  }\n"])));
var QuickSelectorClearSelections = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */])(QuickSelectorRow)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border: none;\n"])));
var ColorBlock = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var color;
  switch (props.colorType) {
    case 'result50':
      color = '#900012';
      break;
    case 'result85':
      color = '#2452BB';
      break;
    case 'result100':
      color = '#008902';
      break;
    case 'allAssigned':
      color = '#dae7d3';
      break;
    default:
      color = '#fff';
  }
  return "\n    background-color: ".concat(color, " !important;\n    height: 20px;\n    width: 20px;\n    margin-right: 10px;\n  ");
});
var AllCellsIcon = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n\n  width: 20px;\n  height: 20px;\n  margin-right: 15px;\n  padding-top: 5px;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'));

/***/ }),

/***/ "y90/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ResultCellWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultContainerWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ContainerContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IconWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__("w2vo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__ = __webpack_require__("0uBZ");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }


var ResultCellWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var palette = props.theme.palette;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    width: 140px;\n    height: 70px;\n\n    color: ").concat(palette.primary.dark, ";\n  ");
});
var Title = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n\n  width: 100%;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: left;\n"])), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])());
var Content = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var colours = props.theme.colours;
  return "\n  ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["c" /* justifyContent */])('center'), ";\n  ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n  width: 100%;\n  height: 35px;\n  font-size: 12px;\n  border: 1px solid ").concat(colours.grey[300], ";\n  border-radius: 4px;\n  padding-top: 3px;\n");
});
var ResultContainerWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var palette = props.theme.palette;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    width: 140px;\n\n    color: ").concat(palette.primary.dark, ";\n    border-radius: 4px;\n    padding: 10px;\n  ");
});
var ContainerContent = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(function (props) {
  var _props$theme = props.theme,
    palette = _props$theme.palette,
    colours = _props$theme.colours;
  return "\n    ".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["a" /* flexbox */])(), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["d" /* flexDirection */])('column'), ";\n    ").concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__styles_helpers_flexbox__["b" /* alignItems */])('center'), ";\n\n    width: 170px;\n    min-height: 160px;\n\n    color: ").concat(palette.primary.dark, ";\n    border: 1px solid ").concat(colours.grey[300], ";\n    border-radius: 4px;\n    box-sizing: border-box;\n    padding: 10px;\n  ");
});
var IconWrapper = __WEBPACK_IMPORTED_MODULE_0_styled_components__["b" /* default */].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-right: 10px;\n  margin-bottom: 2px;\n  width: 20px;\n  height: 20px;\n"])));

/***/ })

},[2]);


// WEBPACK FOOTER //
// entry-app.e8e59284974c0d30c0fc.js